export const dataSankeyMock = {
	data: {
		links: [
			{
				source: 0,
				target: 1,
				transactions: [
					{
						amount: 46804.6,
						currency: 'USD',
						payments: [
							{
								id: 9209,
								source: null,
								amount: 46804.6,
								currency: 'USD',
								currencyReceived: null,
								metadata: {
									tax: null,
									hash: null,
									loan: 457,
									uuid: 'b488849f-4ed4-4f10-988a-328190534eee',
									amount: 46804.6,
									source: null,
									currency: 'USD',
									metadata: null,
									projectId: 318,
									toAccount: -1,
									toAddress: '0x8eC014ccccb81084CC90B8DFf5De93Fa5c9439a3',
									fromAccount: 1636,
									fromAddress: '0xF6379168Ba44cd6A7AB2E9106001Fde599a9EF08',
									transaction: 7363,
									taxEquivalent: null,
									amountReceived: null,
									blkTransaction: {
										id: null,
										status: 'STARTED',
									},
									revertedPayment: null,
									amountEquivalent: null,
									currencyReceived: null,
								},
								hash: '49b8abd287de0746713d18d984a2e6295f09b686e247d618a0926f2b0285931a',
								created: '2026-01-29T19:11:52.786Z',
								modified: null,
								tax: null,
								amountEquivalent: null,
								taxEquivalent: null,
								amountReceived: null,
								reimbursed: {
									amount: null,
								},
								blkTransaction: {
									id: '0xad61817cb423b0a4b527e6d247279ed6a817e4d90f97f38ed7201ca7764f1748',
									status: 'DONE',
								},
								revertedPayment: null,
								transaction: 7363,
								loan: {
									id: 457,
									idWbg: null,
									status: 'ENABLED',
									currency: 'XDR',
									amount: 38400000,
									disbursed: 730716.39,
									financier: 'IDA',
									name: 'IPF - Investment Project Financing',
									num: 'E4250',
									dateApproved: '2025-03-28T00:00:00.000Z',
									dateSigning: '2025-04-25T00:00:00.000Z',
									dateClosing: '2029-12-28T00:00:00.000Z',
									subLoanNum: null,
									created: '2026-01-29T13:35:46.971Z',
									modified: '2026-01-29T13:39:44.224Z',
									cancelled: null,
									code: 'IDAE4250',
								},
							},
						],
						tax: 0,
						total: 46804.6,
						id: 7363,
						status: 'COMPLETED',
						metadata: {
							uuid: '66279f96-a8ae-472b-8e87-ce065838f5c1',
							invoiceAmount: 6120927.22,
							invoiceCurrency: 'HTG',
						},
						traceability: {
							documents: {
								required: [1254, 1266],
								uploaded: [12740, 12741],
							},
							value: 100,
						},
						type: 'PAYMENT',
						date: '2025-12-19T00:00:00.000Z',
						created: '2026-01-29T19:11:52.773Z',
						modified: null,
						quantity: null,
						isReceived: null,
						amountReceived: null,
						benefit: null,
						category: 699,
						component: 1145,
						contract: null,
						designatedAccount: null,
						expenseType: {
							id: 2053,
							name: 'Dépenses opérationnelles',
							created: '2026-01-29T15:09:24.768Z',
							modified: '2026-01-29T16:25:03.495Z',
							status: 'ACTIVE',
							entity: null,
							project: 318,
						},
						fromAccount: {
							id: 1636,
							idWbg: '000000000010021601',
							name: 'DA-A',
							num: '111080980',
							institution: "BANQUE DE LA REPUBLIQUE D'HAITI",
							type: 'DESIGNATED',
							currency: 'USD',
							created: '2026-01-29T13:35:46.971Z',
							modified: null,
							status: 'ACTIVE',
							aba: null,
							holder: null,
							isReimbursement: false,
							postcode: null,
							routeCode: null,
							sortCode: null,
							state: null,
							street: null,
							swiftCode: null,
							town: null,
							country: null,
						},
						fromEntity: 2299,
						project: 318,
						toAccount: null,
						toEntity: 2305,
						user: 2026,
						withdrawalApplication: null,
					},
					{
						amount: 49555.21,
						currency: 'USD',
						payments: [
							{
								id: 9210,
								source: null,
								amount: 49555.21,
								currency: 'USD',
								currencyReceived: null,
								metadata: {
									tax: null,
									hash: null,
									loan: 457,
									uuid: '4f276a77-a01a-4b6b-bccf-53e34b5bd012',
									amount: 49555.21,
									source: null,
									currency: 'USD',
									metadata: null,
									projectId: 318,
									toAccount: -1,
									toAddress: '0x8eC014ccccb81084CC90B8DFf5De93Fa5c9439a3',
									fromAccount: 1636,
									fromAddress: '0xF6379168Ba44cd6A7AB2E9106001Fde599a9EF08',
									transaction: 7364,
									taxEquivalent: null,
									amountReceived: null,
									blkTransaction: {
										id: null,
										status: 'STARTED',
									},
									revertedPayment: null,
									amountEquivalent: null,
									currencyReceived: null,
								},
								hash: '615c9a1ab477b6ac2c21b8f727ca7d475ba47c8a7cb3f79f786acf6511f23711',
								created: '2026-01-29T19:42:24.172Z',
								modified: null,
								tax: null,
								amountEquivalent: null,
								taxEquivalent: null,
								amountReceived: null,
								reimbursed: {
									amount: null,
								},
								blkTransaction: {
									id: '0x207ac9415e37155882302933c703de9d8a009825b3e55eaf0035f9774e3366ad',
									status: 'DONE',
								},
								revertedPayment: null,
								transaction: 7364,
								loan: {
									id: 457,
									idWbg: null,
									status: 'ENABLED',
									currency: 'XDR',
									amount: 38400000,
									disbursed: 730716.39,
									financier: 'IDA',
									name: 'IPF - Investment Project Financing',
									num: 'E4250',
									dateApproved: '2025-03-28T00:00:00.000Z',
									dateSigning: '2025-04-25T00:00:00.000Z',
									dateClosing: '2029-12-28T00:00:00.000Z',
									subLoanNum: null,
									created: '2026-01-29T13:35:46.971Z',
									modified: '2026-01-29T13:39:44.224Z',
									cancelled: null,
									code: 'IDAE4250',
								},
							},
						],
						tax: 0,
						total: 49555.21,
						id: 7364,
						status: 'COMPLETED',
						metadata: {
							uuid: '015261ac-9703-43e0-b365-c9df50470a7a',
							invoiceAmount: 6480641.28,
							invoiceCurrency: 'HTG',
						},
						traceability: {
							documents: {
								required: [1254, 1266],
								uploaded: [12742, 12743],
							},
							value: 100,
						},
						type: 'PAYMENT',
						date: '2025-12-19T00:00:00.000Z',
						created: '2026-01-29T19:42:24.155Z',
						modified: null,
						quantity: null,
						isReceived: null,
						amountReceived: null,
						benefit: null,
						category: 699,
						component: 1145,
						contract: null,
						designatedAccount: null,
						expenseType: {
							id: 2053,
							name: 'Dépenses opérationnelles',
							created: '2026-01-29T15:09:24.768Z',
							modified: '2026-01-29T16:25:03.495Z',
							status: 'ACTIVE',
							entity: null,
							project: 318,
						},
						fromAccount: {
							id: 1636,
							idWbg: '000000000010021601',
							name: 'DA-A',
							num: '111080980',
							institution: "BANQUE DE LA REPUBLIQUE D'HAITI",
							type: 'DESIGNATED',
							currency: 'USD',
							created: '2026-01-29T13:35:46.971Z',
							modified: null,
							status: 'ACTIVE',
							aba: null,
							holder: null,
							isReimbursement: false,
							postcode: null,
							routeCode: null,
							sortCode: null,
							state: null,
							street: null,
							swiftCode: null,
							town: null,
							country: null,
						},
						fromEntity: 2299,
						project: 318,
						toAccount: null,
						toEntity: 2305,
						user: 2026,
						withdrawalApplication: null,
					},
					{
						amount: 1605.79,
						currency: 'USD',
						payments: [
							{
								id: 10916,
								source: null,
								amount: 1605.79,
								currency: 'USD',
								currencyReceived: null,
								metadata: {
									tax: null,
									hash: null,
									loan: 457,
									uuid: '6d6776f0-ce5e-424d-9154-570de9c55a65',
									amount: 1605.79,
									source: null,
									currency: 'USD',
									metadata: null,
									projectId: 318,
									toAccount: -1,
									toAddress: '0x8eC014ccccb81084CC90B8DFf5De93Fa5c9439a3',
									fromAccount: 1636,
									fromAddress: '0xF6379168Ba44cd6A7AB2E9106001Fde599a9EF08',
									transaction: 8845,
									taxEquivalent: null,
									amountReceived: null,
									blkTransaction: {
										id: null,
										status: 'STARTED',
									},
									revertedPayment: null,
									amountEquivalent: null,
									currencyReceived: null,
								},
								hash: '5a1ee1f8a425fabe097da8c16c125cce62755e7c92b3adc3769f71394c367a0a',
								created: '2026-02-22T23:05:14.182Z',
								modified: null,
								tax: null,
								amountEquivalent: null,
								taxEquivalent: null,
								amountReceived: null,
								reimbursed: {
									amount: null,
								},
								blkTransaction: {
									id: '0x2e1f94e099ca57c31685f0416adfd1ce15124d7e2fde774a0141d62463d65050',
									status: 'DONE',
								},
								revertedPayment: null,
								transaction: 8845,
								loan: {
									id: 457,
									idWbg: null,
									status: 'ENABLED',
									currency: 'XDR',
									amount: 38400000,
									disbursed: 730716.39,
									financier: 'IDA',
									name: 'IPF - Investment Project Financing',
									num: 'E4250',
									dateApproved: '2025-03-28T00:00:00.000Z',
									dateSigning: '2025-04-25T00:00:00.000Z',
									dateClosing: '2029-12-28T00:00:00.000Z',
									subLoanNum: null,
									created: '2026-01-29T13:35:46.971Z',
									modified: '2026-01-29T13:39:44.224Z',
									cancelled: null,
									code: 'IDAE4250',
								},
							},
						],
						tax: 0,
						total: 1605.79,
						id: 8845,
						status: 'COMPLETED',
						metadata: {
							uuid: '2b547eac-e148-4321-a7a0-62e5491617ef',
							invoiceAmount: 210000,
							invoiceCurrency: 'HTG',
						},
						traceability: {
							documents: {
								required: [1254, 1266],
								uploaded: [16635, 16636],
							},
							value: 100,
						},
						type: 'PAYMENT',
						date: '2025-12-19T00:00:00.000Z',
						created: '2026-02-22T23:05:14.164Z',
						modified: null,
						quantity: null,
						isReceived: null,
						amountReceived: null,
						benefit: null,
						category: 699,
						component: 1145,
						contract: null,
						designatedAccount: null,
						expenseType: {
							id: 2053,
							name: 'Dépenses opérationnelles',
							created: '2026-01-29T15:09:24.768Z',
							modified: '2026-01-29T16:25:03.495Z',
							status: 'ACTIVE',
							entity: null,
							project: 318,
						},
						fromAccount: {
							id: 1636,
							idWbg: '000000000010021601',
							name: 'DA-A',
							num: '111080980',
							institution: "BANQUE DE LA REPUBLIQUE D'HAITI",
							type: 'DESIGNATED',
							currency: 'USD',
							created: '2026-01-29T13:35:46.971Z',
							modified: null,
							status: 'ACTIVE',
							aba: null,
							holder: null,
							isReimbursement: false,
							postcode: null,
							routeCode: null,
							sortCode: null,
							state: null,
							street: null,
							swiftCode: null,
							town: null,
							country: null,
						},
						fromEntity: 2299,
						project: 318,
						toAccount: null,
						toEntity: 2305,
						user: 2026,
						withdrawalApplication: null,
					},
					{
						amount: 49555.21,
						currency: 'USD',
						payments: [
							{
								id: 10907,
								source: null,
								amount: 49555.21,
								currency: 'USD',
								currencyReceived: null,
								metadata: {
									tax: null,
									hash: null,
									loan: 457,
									uuid: '76d46184-67de-474b-860a-fb60bca81c0b',
									amount: 49555.21,
									source: null,
									currency: 'USD',
									metadata: null,
									projectId: 318,
									toAccount: -1,
									toAddress: '0x8eC014ccccb81084CC90B8DFf5De93Fa5c9439a3',
									fromAccount: 1636,
									fromAddress: '0xF6379168Ba44cd6A7AB2E9106001Fde599a9EF08',
									transaction: 8836,
									taxEquivalent: null,
									amountReceived: null,
									blkTransaction: {
										id: null,
										status: 'STARTED',
									},
									revertedPayment: null,
									amountEquivalent: null,
									currencyReceived: null,
								},
								hash: 'b01e990e021f3d9f9958ec188b9137cf6de4962c07357cafb587b6a7fd88de80',
								created: '2026-02-22T17:02:13.718Z',
								modified: null,
								tax: null,
								amountEquivalent: null,
								taxEquivalent: null,
								amountReceived: null,
								reimbursed: {
									amount: null,
								},
								blkTransaction: {
									id: '0x7059c6d2457d38fa6d7d996afc665404e3581f250362da64199960d6fa440c32',
									status: 'DONE',
								},
								revertedPayment: null,
								transaction: 8836,
								loan: {
									id: 457,
									idWbg: null,
									status: 'ENABLED',
									currency: 'XDR',
									amount: 38400000,
									disbursed: 730716.39,
									financier: 'IDA',
									name: 'IPF - Investment Project Financing',
									num: 'E4250',
									dateApproved: '2025-03-28T00:00:00.000Z',
									dateSigning: '2025-04-25T00:00:00.000Z',
									dateClosing: '2029-12-28T00:00:00.000Z',
									subLoanNum: null,
									created: '2026-01-29T13:35:46.971Z',
									modified: '2026-01-29T13:39:44.224Z',
									cancelled: null,
									code: 'IDAE4250',
								},
							},
						],
						tax: 0,
						total: 49555.21,
						id: 8836,
						status: 'IN_PROGRESS',
						metadata: {
							uuid: '500bdce6-2de2-4232-8b68-359759eeb428',
							invoiceAmount: 6480641.28,
							invoiceCurrency: 'HTG',
						},
						traceability: {
							documents: {
								required: [1254, 1266],
								uploaded: [16623, 16627],
							},
							value: 100,
						},
						type: 'PAYMENT',
						date: '2025-12-16T00:00:00.000Z',
						created: '2026-02-22T17:02:13.703Z',
						modified: null,
						quantity: null,
						isReceived: null,
						amountReceived: null,
						benefit: null,
						category: 699,
						component: 1145,
						contract: null,
						designatedAccount: null,
						expenseType: {
							id: 2053,
							name: 'Dépenses opérationnelles',
							created: '2026-01-29T15:09:24.768Z',
							modified: '2026-01-29T16:25:03.495Z',
							status: 'ACTIVE',
							entity: null,
							project: 318,
						},
						fromAccount: {
							id: 1636,
							idWbg: '000000000010021601',
							name: 'DA-A',
							num: '111080980',
							institution: "BANQUE DE LA REPUBLIQUE D'HAITI",
							type: 'DESIGNATED',
							currency: 'USD',
							created: '2026-01-29T13:35:46.971Z',
							modified: null,
							status: 'ACTIVE',
							aba: null,
							holder: null,
							isReimbursement: false,
							postcode: null,
							routeCode: null,
							sortCode: null,
							state: null,
							street: null,
							swiftCode: null,
							town: null,
							country: null,
						},
						fromEntity: 2299,
						project: 318,
						toAccount: null,
						toEntity: 2305,
						user: 2026,
						withdrawalApplication: null,
					},
					{
						amount: 1605.79,
						currency: 'USD',
						payments: [
							{
								id: 10914,
								source: null,
								amount: 1605.79,
								currency: 'USD',
								currencyReceived: null,
								metadata: {
									tax: null,
									hash: null,
									loan: 457,
									uuid: '3f2f36c7-614a-450f-84c8-9c9bc3a798f3',
									amount: 1605.79,
									source: null,
									currency: 'USD',
									metadata: null,
									projectId: 318,
									toAccount: -1,
									toAddress: '0x8eC014ccccb81084CC90B8DFf5De93Fa5c9439a3',
									fromAccount: 1636,
									fromAddress: '0xF6379168Ba44cd6A7AB2E9106001Fde599a9EF08',
									transaction: 8843,
									taxEquivalent: null,
									amountReceived: null,
									blkTransaction: {
										id: null,
										status: 'STARTED',
									},
									revertedPayment: null,
									amountEquivalent: null,
									currencyReceived: null,
								},
								hash: '80fb90cee02a7ab9e9617a23f16a5e7a63494edc4f6a79a698a93786a2a44f84',
								created: '2026-02-22T17:45:04.399Z',
								modified: null,
								tax: null,
								amountEquivalent: null,
								taxEquivalent: null,
								amountReceived: null,
								reimbursed: {
									amount: null,
								},
								blkTransaction: {
									id: '0x826828c10a7f0beee5ff3b561486d68369cec72db10e5202f060b3e59ccd6c78',
									status: 'DONE',
								},
								revertedPayment: null,
								transaction: 8843,
								loan: {
									id: 457,
									idWbg: null,
									status: 'ENABLED',
									currency: 'XDR',
									amount: 38400000,
									disbursed: 730716.39,
									financier: 'IDA',
									name: 'IPF - Investment Project Financing',
									num: 'E4250',
									dateApproved: '2025-03-28T00:00:00.000Z',
									dateSigning: '2025-04-25T00:00:00.000Z',
									dateClosing: '2029-12-28T00:00:00.000Z',
									subLoanNum: null,
									created: '2026-01-29T13:35:46.971Z',
									modified: '2026-01-29T13:39:44.224Z',
									cancelled: null,
									code: 'IDAE4250',
								},
							},
						],
						tax: 0,
						total: 1605.79,
						id: 8843,
						status: 'COMPLETED',
						metadata: {
							uuid: '2420f7ce-fa08-430c-9221-ceb560850c79',
							invoiceAmount: 210000,
							invoiceCurrency: 'HTG',
						},
						traceability: {
							documents: {
								required: [1254, 1266],
								uploaded: [16631, 16632],
							},
							value: 100,
						},
						type: 'PAYMENT',
						date: '2025-12-19T00:00:00.000Z',
						created: '2026-02-22T17:45:04.384Z',
						modified: null,
						quantity: null,
						isReceived: null,
						amountReceived: null,
						benefit: null,
						category: 699,
						component: 1145,
						contract: null,
						designatedAccount: null,
						expenseType: {
							id: 2053,
							name: 'Dépenses opérationnelles',
							created: '2026-01-29T15:09:24.768Z',
							modified: '2026-01-29T16:25:03.495Z',
							status: 'ACTIVE',
							entity: null,
							project: 318,
						},
						fromAccount: {
							id: 1636,
							idWbg: '000000000010021601',
							name: 'DA-A',
							num: '111080980',
							institution: "BANQUE DE LA REPUBLIQUE D'HAITI",
							type: 'DESIGNATED',
							currency: 'USD',
							created: '2026-01-29T13:35:46.971Z',
							modified: null,
							status: 'ACTIVE',
							aba: null,
							holder: null,
							isReimbursement: false,
							postcode: null,
							routeCode: null,
							sortCode: null,
							state: null,
							street: null,
							swiftCode: null,
							town: null,
							country: null,
						},
						fromEntity: 2299,
						project: 318,
						toAccount: null,
						toEntity: 2305,
						user: 2026,
						withdrawalApplication: null,
					},
					{
						amount: 1605.79,
						currency: 'USD',
						payments: [
							{
								id: 10915,
								source: null,
								amount: 1605.79,
								currency: 'USD',
								currencyReceived: null,
								metadata: {
									tax: null,
									hash: null,
									loan: 457,
									uuid: '007cad3f-9b04-46e0-b9f4-4ccccbd99f6a',
									amount: 1605.79,
									source: null,
									currency: 'USD',
									metadata: null,
									projectId: 318,
									toAccount: -1,
									toAddress: '0x8eC014ccccb81084CC90B8DFf5De93Fa5c9439a3',
									fromAccount: 1636,
									fromAddress: '0xF6379168Ba44cd6A7AB2E9106001Fde599a9EF08',
									transaction: 8844,
									taxEquivalent: null,
									amountReceived: null,
									blkTransaction: {
										id: null,
										status: 'STARTED',
									},
									revertedPayment: null,
									amountEquivalent: null,
									currencyReceived: null,
								},
								hash: '94802c8f79dd714c98805d592dfae88c12e25dba1f18a800080ef185848eb108',
								created: '2026-02-22T17:57:32.968Z',
								modified: null,
								tax: null,
								amountEquivalent: null,
								taxEquivalent: null,
								amountReceived: null,
								reimbursed: {
									amount: null,
								},
								blkTransaction: {
									id: '0x754dabbabf5194725b934b26d7cafd0a04acfd94eef002c82f21102e825a3cfe',
									status: 'DONE',
								},
								revertedPayment: null,
								transaction: 8844,
								loan: {
									id: 457,
									idWbg: null,
									status: 'ENABLED',
									currency: 'XDR',
									amount: 38400000,
									disbursed: 730716.39,
									financier: 'IDA',
									name: 'IPF - Investment Project Financing',
									num: 'E4250',
									dateApproved: '2025-03-28T00:00:00.000Z',
									dateSigning: '2025-04-25T00:00:00.000Z',
									dateClosing: '2029-12-28T00:00:00.000Z',
									subLoanNum: null,
									created: '2026-01-29T13:35:46.971Z',
									modified: '2026-01-29T13:39:44.224Z',
									cancelled: null,
									code: 'IDAE4250',
								},
							},
						],
						tax: 0,
						total: 1605.79,
						id: 8844,
						status: 'COMPLETED',
						metadata: {
							uuid: '0fe47860-e99c-4d5d-91b3-faf32d23ad77',
							invoiceAmount: 210000,
							invoiceCurrency: 'HTG',
						},
						traceability: {
							documents: {
								required: [1254, 1266],
								uploaded: [16633, 16634],
							},
							value: 100,
						},
						type: 'PAYMENT',
						date: '2025-12-19T00:00:00.000Z',
						created: '2026-02-22T17:57:32.953Z',
						modified: null,
						quantity: null,
						isReceived: null,
						amountReceived: null,
						benefit: null,
						category: 699,
						component: 1145,
						contract: null,
						designatedAccount: null,
						expenseType: {
							id: 2053,
							name: 'Dépenses opérationnelles',
							created: '2026-01-29T15:09:24.768Z',
							modified: '2026-01-29T16:25:03.495Z',
							status: 'ACTIVE',
							entity: null,
							project: 318,
						},
						fromAccount: {
							id: 1636,
							idWbg: '000000000010021601',
							name: 'DA-A',
							num: '111080980',
							institution: "BANQUE DE LA REPUBLIQUE D'HAITI",
							type: 'DESIGNATED',
							currency: 'USD',
							created: '2026-01-29T13:35:46.971Z',
							modified: null,
							status: 'ACTIVE',
							aba: null,
							holder: null,
							isReimbursement: false,
							postcode: null,
							routeCode: null,
							sortCode: null,
							state: null,
							street: null,
							swiftCode: null,
							town: null,
							country: null,
						},
						fromEntity: 2299,
						project: 318,
						toAccount: null,
						toEntity: 2305,
						user: 2026,
						withdrawalApplication: null,
					},
					{
						amount: 1607.88,
						currency: 'USD',
						payments: [
							{
								id: 16941,
								source: null,
								amount: 1607.88,
								currency: 'USD',
								currencyReceived: null,
								metadata: {
									tax: null,
									hash: null,
									loan: 457,
									uuid: '73caaf51-bb1f-4f87-871f-82e4dff3bc14',
									amount: 1607.88,
									source: null,
									currency: 'USD',
									metadata: null,
									projectId: 318,
									toAccount: -1,
									toAddress: '0x8eC014ccccb81084CC90B8DFf5De93Fa5c9439a3',
									reimbursed: {
										amount: null,
									},
									fromAccount: 1636,
									fromAddress: '0xF6379168Ba44cd6A7AB2E9106001Fde599a9EF08',
									transaction: 14068,
									taxEquivalent: null,
									amountReceived: null,
									blkTransaction: {
										id: null,
										status: 'STARTED',
									},
									revertedPayment: null,
									amountEquivalent: null,
									currencyReceived: null,
								},
								hash: '3209badbb5c4840e22c8cdca69f3533ad9f758e01a9925451b7cb60709b18200',
								created: '2026-03-16T20:36:46.792Z',
								modified: null,
								tax: null,
								amountEquivalent: null,
								taxEquivalent: null,
								amountReceived: null,
								reimbursed: {
									amount: null,
								},
								blkTransaction: {
									id: '0xa6cc4cb9da955fce57892bdd42c5171d85982160af50f547dede82e27c44e123',
									status: 'DONE',
								},
								revertedPayment: null,
								transaction: 14068,
								loan: {
									id: 457,
									idWbg: null,
									status: 'ENABLED',
									currency: 'XDR',
									amount: 38400000,
									disbursed: 730716.39,
									financier: 'IDA',
									name: 'IPF - Investment Project Financing',
									num: 'E4250',
									dateApproved: '2025-03-28T00:00:00.000Z',
									dateSigning: '2025-04-25T00:00:00.000Z',
									dateClosing: '2029-12-28T00:00:00.000Z',
									subLoanNum: null,
									created: '2026-01-29T13:35:46.971Z',
									modified: '2026-01-29T13:39:44.224Z',
									cancelled: null,
									code: 'IDAE4250',
								},
							},
						],
						tax: 0,
						total: 1607.88,
						id: 14068,
						status: 'COMPLETED',
						metadata: {
							uuid: '7e20c568-b641-40d8-b677-1de058a6c191',
							invoiceAmount: 210000,
							invoiceCurrency: 'HTG',
						},
						traceability: {
							documents: {
								required: [1254, 1266],
								uploaded: [24804, 24805],
							},
							value: 100,
						},
						type: 'PAYMENT',
						date: '2026-01-21T00:00:00.000Z',
						created: '2026-03-16T20:36:46.777Z',
						modified: '2026-05-20T09:24:50.363Z',
						quantity: null,
						isReceived: null,
						amountReceived: null,
						benefit: null,
						category: 699,
						component: 1145,
						contract: null,
						designatedAccount: null,
						expenseType: {
							id: 2053,
							name: 'Dépenses opérationnelles',
							created: '2026-01-29T15:09:24.768Z',
							modified: '2026-01-29T16:25:03.495Z',
							status: 'ACTIVE',
							entity: null,
							project: 318,
						},
						fromAccount: {
							id: 1636,
							idWbg: '000000000010021601',
							name: 'DA-A',
							num: '111080980',
							institution: "BANQUE DE LA REPUBLIQUE D'HAITI",
							type: 'DESIGNATED',
							currency: 'USD',
							created: '2026-01-29T13:35:46.971Z',
							modified: null,
							status: 'ACTIVE',
							aba: null,
							holder: null,
							isReimbursement: false,
							postcode: null,
							routeCode: null,
							sortCode: null,
							state: null,
							street: null,
							swiftCode: null,
							town: null,
							country: null,
						},
						fromEntity: 2299,
						project: 318,
						toAccount: null,
						toEntity: 2305,
						user: 2026,
						withdrawalApplication: 103,
					},
					{
						amount: 48888.94,
						currency: 'USD',
						payments: [
							{
								id: 16940,
								source: null,
								amount: 48888.94,
								currency: 'USD',
								currencyReceived: null,
								metadata: {
									tax: null,
									hash: null,
									loan: 457,
									uuid: '69bbfdf0-666a-4249-b825-1d2609c60c45',
									amount: 48888.94,
									source: null,
									currency: 'USD',
									metadata: null,
									projectId: 318,
									toAccount: -1,
									toAddress: '0x8eC014ccccb81084CC90B8DFf5De93Fa5c9439a3',
									reimbursed: {
										amount: null,
									},
									fromAccount: 1636,
									fromAddress: '0xF6379168Ba44cd6A7AB2E9106001Fde599a9EF08',
									transaction: 14067,
									taxEquivalent: null,
									amountReceived: null,
									blkTransaction: {
										id: null,
										status: 'STARTED',
									},
									revertedPayment: null,
									amountEquivalent: null,
									currencyReceived: null,
								},
								hash: '9c53049ac3b460a0cbd30c3d926284269a97781be4bf836f14fe28f5402b7e3c',
								created: '2026-03-16T20:32:39.255Z',
								modified: null,
								tax: null,
								amountEquivalent: null,
								taxEquivalent: null,
								amountReceived: null,
								reimbursed: {
									amount: null,
								},
								blkTransaction: {
									id: '0x39de141abeb9b048bc7d11f03afe8b5479b0b950d587656e02e01bb9c713be58',
									status: 'DONE',
								},
								revertedPayment: null,
								transaction: 14067,
								loan: {
									id: 457,
									idWbg: null,
									status: 'ENABLED',
									currency: 'XDR',
									amount: 38400000,
									disbursed: 730716.39,
									financier: 'IDA',
									name: 'IPF - Investment Project Financing',
									num: 'E4250',
									dateApproved: '2025-03-28T00:00:00.000Z',
									dateSigning: '2025-04-25T00:00:00.000Z',
									dateClosing: '2029-12-28T00:00:00.000Z',
									subLoanNum: null,
									created: '2026-01-29T13:35:46.971Z',
									modified: '2026-01-29T13:39:44.224Z',
									cancelled: null,
									code: 'IDAE4250',
								},
							},
						],
						tax: 0,
						total: 48888.94,
						id: 14067,
						status: 'COMPLETED',
						metadata: {
							uuid: 'a32eb8ed-97c8-41ed-84be-d80384919670',
							invoiceAmount: 6392213.95,
							invoiceCurrency: 'HTG',
						},
						traceability: {
							documents: {
								required: [1254, 1266],
								uploaded: [24802, 24803],
							},
							value: 100,
						},
						type: 'PAYMENT',
						date: '2026-01-23T00:00:00.000Z',
						created: '2026-03-16T20:32:39.241Z',
						modified: '2026-05-20T09:24:50.390Z',
						quantity: null,
						isReceived: null,
						amountReceived: null,
						benefit: null,
						category: 699,
						component: 1145,
						contract: null,
						designatedAccount: null,
						expenseType: {
							id: 2053,
							name: 'Dépenses opérationnelles',
							created: '2026-01-29T15:09:24.768Z',
							modified: '2026-01-29T16:25:03.495Z',
							status: 'ACTIVE',
							entity: null,
							project: 318,
						},
						fromAccount: {
							id: 1636,
							idWbg: '000000000010021601',
							name: 'DA-A',
							num: '111080980',
							institution: "BANQUE DE LA REPUBLIQUE D'HAITI",
							type: 'DESIGNATED',
							currency: 'USD',
							created: '2026-01-29T13:35:46.971Z',
							modified: null,
							status: 'ACTIVE',
							aba: null,
							holder: null,
							isReimbursement: false,
							postcode: null,
							routeCode: null,
							sortCode: null,
							state: null,
							street: null,
							swiftCode: null,
							town: null,
							country: null,
						},
						fromEntity: 2299,
						project: 318,
						toAccount: null,
						toEntity: 2305,
						user: 2026,
						withdrawalApplication: 103,
					},
					{
						amount: 3515.6,
						currency: 'USD',
						payments: [
							{
								id: 17653,
								source: null,
								amount: 3515.6,
								currency: 'USD',
								currencyReceived: null,
								metadata: {
									tax: null,
									hash: null,
									loan: 457,
									uuid: 'c917eabb-ddea-42b7-b962-46b2efc89732',
									amount: 3515.6,
									source: null,
									currency: 'USD',
									metadata: null,
									projectId: 318,
									toAccount: -1,
									toAddress: '0x8eC014ccccb81084CC90B8DFf5De93Fa5c9439a3',
									reimbursed: {
										amount: null,
									},
									fromAccount: 1636,
									fromAddress: '0xF6379168Ba44cd6A7AB2E9106001Fde599a9EF08',
									transaction: 14716,
									taxEquivalent: null,
									amountReceived: null,
									blkTransaction: {
										id: null,
										status: 'STARTED',
									},
									revertedPayment: null,
									amountEquivalent: null,
									currencyReceived: null,
								},
								hash: '3920401f7072c5c1787d424fdba35e473a3c8280ad03d52fc8fe7470577dd269',
								created: '2026-03-21T16:16:18.020Z',
								modified: null,
								tax: null,
								amountEquivalent: null,
								taxEquivalent: null,
								amountReceived: null,
								reimbursed: {
									amount: null,
								},
								blkTransaction: {
									id: '0x92c98f29ee87f571377df84dc7c8529251e7181ab4dbe543fd221392f1727a41',
									status: 'DONE',
								},
								revertedPayment: null,
								transaction: 14716,
								loan: {
									id: 457,
									idWbg: null,
									status: 'ENABLED',
									currency: 'XDR',
									amount: 38400000,
									disbursed: 730716.39,
									financier: 'IDA',
									name: 'IPF - Investment Project Financing',
									num: 'E4250',
									dateApproved: '2025-03-28T00:00:00.000Z',
									dateSigning: '2025-04-25T00:00:00.000Z',
									dateClosing: '2029-12-28T00:00:00.000Z',
									subLoanNum: null,
									created: '2026-01-29T13:35:46.971Z',
									modified: '2026-01-29T13:39:44.224Z',
									cancelled: null,
									code: 'IDAE4250',
								},
							},
						],
						tax: 0,
						total: 3515.6,
						id: 14716,
						status: 'COMPLETED',
						metadata: {
							uuid: 'cee24f41-39a9-431a-9e9f-2ab5447b447d',
							invoiceAmount: 460000,
							invoiceCurrency: 'HTG',
						},
						traceability: {
							documents: {
								required: [1254, 1266],
								uploaded: [26519, 26520],
							},
							value: 100,
						},
						type: 'PAYMENT',
						date: '2026-02-24T00:00:00.000Z',
						created: '2026-03-21T16:16:18.003Z',
						modified: '2026-05-20T09:24:49.883Z',
						quantity: null,
						isReceived: null,
						amountReceived: null,
						benefit: null,
						category: 699,
						component: 1145,
						contract: null,
						designatedAccount: null,
						expenseType: {
							id: 2053,
							name: 'Dépenses opérationnelles',
							created: '2026-01-29T15:09:24.768Z',
							modified: '2026-01-29T16:25:03.495Z',
							status: 'ACTIVE',
							entity: null,
							project: 318,
						},
						fromAccount: {
							id: 1636,
							idWbg: '000000000010021601',
							name: 'DA-A',
							num: '111080980',
							institution: "BANQUE DE LA REPUBLIQUE D'HAITI",
							type: 'DESIGNATED',
							currency: 'USD',
							created: '2026-01-29T13:35:46.971Z',
							modified: null,
							status: 'ACTIVE',
							aba: null,
							holder: null,
							isReimbursement: false,
							postcode: null,
							routeCode: null,
							sortCode: null,
							state: null,
							street: null,
							swiftCode: null,
							town: null,
							country: null,
						},
						fromEntity: 2299,
						project: 318,
						toAccount: null,
						toEntity: 2305,
						user: 2026,
						withdrawalApplication: 103,
					},
					{
						amount: 2430.76,
						currency: 'USD',
						payments: [
							{
								id: 16731,
								source: null,
								amount: 2430.76,
								currency: 'USD',
								currencyReceived: null,
								metadata: {
									tax: null,
									hash: null,
									loan: 457,
									uuid: '8eaab6a7-bb0a-4535-81ea-6a83fa0e64f7',
									amount: 2430.76,
									source: null,
									currency: 'USD',
									metadata: null,
									projectId: 318,
									toAccount: -1,
									toAddress: '0x8eC014ccccb81084CC90B8DFf5De93Fa5c9439a3',
									fromAccount: 1636,
									fromAddress: '0xF6379168Ba44cd6A7AB2E9106001Fde599a9EF08',
									transaction: 13865,
									taxEquivalent: null,
									amountReceived: null,
									blkTransaction: {
										id: null,
										status: 'STARTED',
									},
									revertedPayment: null,
									amountEquivalent: null,
									currencyReceived: null,
								},
								hash: 'e4210088e2f21b6b31ebec6ec72e3c3b5df6e23c93f211eb3eb163a414cca552',
								created: '2026-03-15T22:49:36.777Z',
								modified: null,
								tax: null,
								amountEquivalent: null,
								taxEquivalent: null,
								amountReceived: null,
								reimbursed: {
									amount: null,
								},
								blkTransaction: {
									id: '0x097c6ce79579a7e2a633251a677ce897bf9a9132048048618c7e86c46ab63e2a',
									status: 'DONE',
								},
								revertedPayment: null,
								transaction: 13865,
								loan: {
									id: 457,
									idWbg: null,
									status: 'ENABLED',
									currency: 'XDR',
									amount: 38400000,
									disbursed: 730716.39,
									financier: 'IDA',
									name: 'IPF - Investment Project Financing',
									num: 'E4250',
									dateApproved: '2025-03-28T00:00:00.000Z',
									dateSigning: '2025-04-25T00:00:00.000Z',
									dateClosing: '2029-12-28T00:00:00.000Z',
									subLoanNum: null,
									created: '2026-01-29T13:35:46.971Z',
									modified: '2026-01-29T13:39:44.224Z',
									cancelled: null,
									code: 'IDAE4250',
								},
							},
						],
						tax: 0,
						total: 2430.76,
						id: 13865,
						status: 'COMPLETED',
						metadata: {
							uuid: '21129822-6968-4fee-9074-448049495054',
							invoiceAmount: 317500,
							invoiceCurrency: 'HTG',
						},
						traceability: {
							documents: {
								required: [1254, 1266],
								uploaded: [24479, 31854],
							},
							value: 100,
						},
						type: 'PAYMENT',
						date: '2026-01-19T00:00:00.000Z',
						created: '2026-03-15T22:49:36.763Z',
						modified: '2026-05-20T09:24:50.639Z',
						quantity: null,
						isReceived: null,
						amountReceived: null,
						benefit: null,
						category: 699,
						component: 1148,
						contract: null,
						designatedAccount: null,
						expenseType: {
							id: 2053,
							name: 'Dépenses opérationnelles',
							created: '2026-01-29T15:09:24.768Z',
							modified: '2026-01-29T16:25:03.495Z',
							status: 'ACTIVE',
							entity: null,
							project: 318,
						},
						fromAccount: {
							id: 1636,
							idWbg: '000000000010021601',
							name: 'DA-A',
							num: '111080980',
							institution: "BANQUE DE LA REPUBLIQUE D'HAITI",
							type: 'DESIGNATED',
							currency: 'USD',
							created: '2026-01-29T13:35:46.971Z',
							modified: null,
							status: 'ACTIVE',
							aba: null,
							holder: null,
							isReimbursement: false,
							postcode: null,
							routeCode: null,
							sortCode: null,
							state: null,
							street: null,
							swiftCode: null,
							town: null,
							country: null,
						},
						fromEntity: 2299,
						project: 318,
						toAccount: null,
						toEntity: 2305,
						user: 2026,
						withdrawalApplication: 103,
					},
					{
						amount: 3827.97,
						currency: 'USD',
						payments: [
							{
								id: 16468,
								source: null,
								amount: 3827.97,
								currency: 'USD',
								currencyReceived: null,
								metadata: {
									tax: null,
									hash: null,
									loan: 457,
									uuid: '444dec98-34f0-4e54-a65a-facad794150e',
									amount: 3827.97,
									source: null,
									currency: 'USD',
									metadata: null,
									projectId: 318,
									toAccount: -1,
									toAddress: '0x8eC014ccccb81084CC90B8DFf5De93Fa5c9439a3',
									fromAccount: 1636,
									fromAddress: '0xF6379168Ba44cd6A7AB2E9106001Fde599a9EF08',
									transaction: 13617,
									taxEquivalent: null,
									amountReceived: null,
									blkTransaction: {
										id: null,
										status: 'STARTED',
									},
									revertedPayment: null,
									amountEquivalent: null,
									currencyReceived: null,
								},
								hash: '16bbfaf7dd2a7f1ad82cad44ce9f20bec30781c7753b60ffd14fe13a982a44c7',
								created: '2026-03-13T16:52:52.329Z',
								modified: null,
								tax: null,
								amountEquivalent: null,
								taxEquivalent: null,
								amountReceived: null,
								reimbursed: {
									amount: null,
								},
								blkTransaction: {
									id: '0xfea1dd9272e01bdd51dee45309f11fedbe4626ca147a692099a92794e0dda2ef',
									status: 'DONE',
								},
								revertedPayment: null,
								transaction: 13617,
								loan: {
									id: 457,
									idWbg: null,
									status: 'ENABLED',
									currency: 'XDR',
									amount: 38400000,
									disbursed: 730716.39,
									financier: 'IDA',
									name: 'IPF - Investment Project Financing',
									num: 'E4250',
									dateApproved: '2025-03-28T00:00:00.000Z',
									dateSigning: '2025-04-25T00:00:00.000Z',
									dateClosing: '2029-12-28T00:00:00.000Z',
									subLoanNum: null,
									created: '2026-01-29T13:35:46.971Z',
									modified: '2026-01-29T13:39:44.224Z',
									cancelled: null,
									code: 'IDAE4250',
								},
							},
						],
						tax: 0,
						total: 3827.97,
						id: 13617,
						status: 'COMPLETED',
						metadata: {
							uuid: 'dc868309-b696-4eb5-8932-6bdae1fbbed9',
							invoiceAmount: 500000,
							invoiceCurrency: 'HTG',
						},
						traceability: {
							documents: {
								required: [1254, 1266],
								uploaded: [24130, 31859],
							},
							value: 100,
						},
						type: 'PAYMENT',
						date: '2026-01-16T00:00:00.000Z',
						created: '2026-03-13T16:52:52.302Z',
						modified: '2026-05-20T09:24:50.763Z',
						quantity: null,
						isReceived: null,
						amountReceived: null,
						benefit: null,
						category: 699,
						component: 1148,
						contract: null,
						designatedAccount: null,
						expenseType: {
							id: 2053,
							name: 'Dépenses opérationnelles',
							created: '2026-01-29T15:09:24.768Z',
							modified: '2026-01-29T16:25:03.495Z',
							status: 'ACTIVE',
							entity: null,
							project: 318,
						},
						fromAccount: {
							id: 1636,
							idWbg: '000000000010021601',
							name: 'DA-A',
							num: '111080980',
							institution: "BANQUE DE LA REPUBLIQUE D'HAITI",
							type: 'DESIGNATED',
							currency: 'USD',
							created: '2026-01-29T13:35:46.971Z',
							modified: null,
							status: 'ACTIVE',
							aba: null,
							holder: null,
							isReimbursement: false,
							postcode: null,
							routeCode: null,
							sortCode: null,
							state: null,
							street: null,
							swiftCode: null,
							town: null,
							country: null,
						},
						fromEntity: 2299,
						project: 318,
						toAccount: null,
						toEntity: 2305,
						user: 2026,
						withdrawalApplication: 103,
					},
					{
						amount: 3158.38,
						currency: 'USD',
						payments: [
							{
								id: 30391,
								source: null,
								amount: 3158.38,
								currency: 'USD',
								currencyReceived: null,
								metadata: {
									tax: null,
									hash: null,
									loan: 457,
									uuid: '42f90732-66cb-4865-8f2d-e354eda6c6e1',
									amount: 3158.38,
									source: null,
									currency: 'USD',
									metadata: null,
									projectId: 318,
									toAccount: -1,
									toAddress: '0x8eC014ccccb81084CC90B8DFf5De93Fa5c9439a3',
									reimbursed: {
										amount: null,
									},
									fromAccount: 1636,
									fromAddress: '0xF6379168Ba44cd6A7AB2E9106001Fde599a9EF08',
									transaction: 25755,
									taxEquivalent: null,
									amountReceived: null,
									blkTransaction: {
										id: null,
										status: 'STARTED',
									},
									revertedPayment: null,
									amountEquivalent: null,
									currencyReceived: null,
								},
								hash: 'b734cda1fe019d267e709a18e4863bc157e3d487c0f8996999108858a4c91b53',
								created: '2026-05-10T16:32:51.743Z',
								modified: null,
								tax: null,
								amountEquivalent: null,
								taxEquivalent: null,
								amountReceived: null,
								reimbursed: {
									amount: null,
								},
								blkTransaction: {
									id: '0xbf212dcfcb35aa0adcb60e536b9475a0c2c51d908d6e5fc95f9ab2d7b8c91c33',
									status: 'DONE',
								},
								revertedPayment: null,
								transaction: 25755,
								loan: {
									id: 457,
									idWbg: null,
									status: 'ENABLED',
									currency: 'XDR',
									amount: 38400000,
									disbursed: 730716.39,
									financier: 'IDA',
									name: 'IPF - Investment Project Financing',
									num: 'E4250',
									dateApproved: '2025-03-28T00:00:00.000Z',
									dateSigning: '2025-04-25T00:00:00.000Z',
									dateClosing: '2029-12-28T00:00:00.000Z',
									subLoanNum: null,
									created: '2026-01-29T13:35:46.971Z',
									modified: '2026-01-29T13:39:44.224Z',
									cancelled: null,
									code: 'IDAE4250',
								},
							},
						],
						tax: 0,
						total: 3158.38,
						id: 25755,
						status: 'COMPLETED',
						metadata: {
							uuid: '1343183b-9eb0-4ff2-ae58-18a9e90b0432',
							invoiceAmount: 413500,
							invoiceCurrency: 'HTG',
						},
						traceability: {
							documents: {
								required: [1254, 1266],
								uploaded: [53779, 53780],
							},
							value: 100,
						},
						type: 'PAYMENT',
						date: '2026-03-20T00:00:00.000Z',
						created: '2026-05-10T16:32:51.719Z',
						modified: '2026-05-20T09:24:48.764Z',
						quantity: null,
						isReceived: null,
						amountReceived: null,
						benefit: null,
						category: 699,
						component: 1139,
						contract: null,
						designatedAccount: null,
						expenseType: {
							id: 2053,
							name: 'Dépenses opérationnelles',
							created: '2026-01-29T15:09:24.768Z',
							modified: '2026-01-29T16:25:03.495Z',
							status: 'ACTIVE',
							entity: null,
							project: 318,
						},
						fromAccount: {
							id: 1636,
							idWbg: '000000000010021601',
							name: 'DA-A',
							num: '111080980',
							institution: "BANQUE DE LA REPUBLIQUE D'HAITI",
							type: 'DESIGNATED',
							currency: 'USD',
							created: '2026-01-29T13:35:46.971Z',
							modified: null,
							status: 'ACTIVE',
							aba: null,
							holder: null,
							isReimbursement: false,
							postcode: null,
							routeCode: null,
							sortCode: null,
							state: null,
							street: null,
							swiftCode: null,
							town: null,
							country: null,
						},
						fromEntity: 2299,
						project: 318,
						toAccount: null,
						toEntity: 2305,
						user: 2026,
						withdrawalApplication: 103,
					},
					{
						amount: 99284.18,
						currency: 'USD',
						payments: [
							{
								id: 30464,
								source: null,
								amount: 49642.09,
								currency: 'USD',
								currencyReceived: null,
								metadata: {
									tax: null,
									hash: null,
									loan: 457,
									uuid: '95375331-f9d6-46b7-aeb3-b22b45ef16ef',
									amount: 49642.09,
									source: null,
									currency: 'USD',
									metadata: null,
									projectId: 318,
									toAccount: -1,
									toAddress: '0x8eC014ccccb81084CC90B8DFf5De93Fa5c9439a3',
									reimbursed: {
										amount: null,
									},
									fromAccount: 1636,
									fromAddress: '0xF6379168Ba44cd6A7AB2E9106001Fde599a9EF08',
									transaction: 25826,
									taxEquivalent: null,
									amountReceived: null,
									blkTransaction: {
										id: null,
										status: 'STARTED',
									},
									revertedPayment: null,
									amountEquivalent: null,
									currencyReceived: null,
								},
								hash: 'c81ddf025a707862c1980ab6adb37c107904b0fd412b6639421eac418d27fdf0',
								created: '2026-05-10T20:18:42.045Z',
								modified: null,
								tax: null,
								amountEquivalent: null,
								taxEquivalent: null,
								amountReceived: null,
								reimbursed: {
									amount: null,
								},
								blkTransaction: {
									id: '0x5a75e25d406573876dda77e8997b8455ce1a543647672ab389d24630dd5b09e3',
									status: 'DONE',
								},
								revertedPayment: null,
								transaction: 25826,
								loan: {
									id: 457,
									idWbg: null,
									status: 'ENABLED',
									currency: 'XDR',
									amount: 38400000,
									disbursed: 730716.39,
									financier: 'IDA',
									name: 'IPF - Investment Project Financing',
									num: 'E4250',
									dateApproved: '2025-03-28T00:00:00.000Z',
									dateSigning: '2025-04-25T00:00:00.000Z',
									dateClosing: '2029-12-28T00:00:00.000Z',
									subLoanNum: null,
									created: '2026-01-29T13:35:46.971Z',
									modified: '2026-01-29T13:39:44.224Z',
									cancelled: null,
									code: 'IDAE4250',
								},
							},
							{
								id: 30470,
								source: null,
								amount: 49642.09,
								currency: 'USD',
								currencyReceived: null,
								metadata: {
									tax: null,
									loan: 457,
									amount: 49642.09,
									currency: 'USD',
									isRevert: true,
									toAccount: 1636,
									toAddress: '0xF6379168Ba44cd6A7AB2E9106001Fde599a9EF08',
									fromAccount: -1,
									fromAddress: '0x8eC014ccccb81084CC90B8DFf5De93Fa5c9439a3',
									transaction: 25826,
									amountReceived: null,
									currencyReceived: null,
								},
								hash: '630d00f79c0605b6c8951a6887dfb5cae529e00a3633c662c51816384902f906',
								created: '2026-05-10T20:41:32.603Z',
								modified: null,
								tax: null,
								amountEquivalent: null,
								taxEquivalent: null,
								amountReceived: null,
								reimbursed: {
									amount: null,
								},
								blkTransaction: {
									id: '0x5e7a003edf4384b0e56a70927bdbca866eb54ea0f3c6b9b9bbb1de8d3ef28c47',
									status: 'DONE',
								},
								revertedPayment: 30464,
								transaction: 25826,
								loan: {
									id: 457,
									idWbg: null,
									status: 'ENABLED',
									currency: 'XDR',
									amount: 38400000,
									disbursed: 730716.39,
									financier: 'IDA',
									name: 'IPF - Investment Project Financing',
									num: 'E4250',
									dateApproved: '2025-03-28T00:00:00.000Z',
									dateSigning: '2025-04-25T00:00:00.000Z',
									dateClosing: '2029-12-28T00:00:00.000Z',
									subLoanNum: null,
									created: '2026-01-29T13:35:46.971Z',
									modified: '2026-01-29T13:39:44.224Z',
									cancelled: null,
									code: 'IDAE4250',
								},
							},
						],
						tax: 0,
						total: 99284.18,
						id: 25826,
						status: 'REVERTED',
						metadata: {
							uuid: 'aee1622b-26ba-4200-bf89-81c44be230cc',
							invoiceAmount: 6494754.66,
							invoiceCurrency: 'HTG',
						},
						traceability: {
							documents: {
								required: [1254, 1266],
								uploaded: [53880],
							},
							value: 50,
						},
						type: 'PAYMENT',
						date: '2026-03-26T00:00:00.000Z',
						created: '2026-05-10T20:18:42.029Z',
						modified: '2026-05-10T20:41:37.160Z',
						quantity: null,
						isReceived: null,
						amountReceived: null,
						benefit: null,
						category: 699,
						component: 1145,
						contract: null,
						designatedAccount: null,
						expenseType: {
							id: 2053,
							name: 'Dépenses opérationnelles',
							created: '2026-01-29T15:09:24.768Z',
							modified: '2026-01-29T16:25:03.495Z',
							status: 'ACTIVE',
							entity: null,
							project: 318,
						},
						fromAccount: {
							id: 1636,
							idWbg: '000000000010021601',
							name: 'DA-A',
							num: '111080980',
							institution: "BANQUE DE LA REPUBLIQUE D'HAITI",
							type: 'DESIGNATED',
							currency: 'USD',
							created: '2026-01-29T13:35:46.971Z',
							modified: null,
							status: 'ACTIVE',
							aba: null,
							holder: null,
							isReimbursement: false,
							postcode: null,
							routeCode: null,
							sortCode: null,
							state: null,
							street: null,
							swiftCode: null,
							town: null,
							country: null,
						},
						fromEntity: 2299,
						project: 318,
						toAccount: null,
						toEntity: 2305,
						user: 2026,
						withdrawalApplication: null,
					},
					{
						amount: 49642.09,
						currency: 'USD',
						payments: [
							{
								id: 30465,
								source: null,
								amount: 49642.09,
								currency: 'USD',
								currencyReceived: null,
								metadata: {
									tax: null,
									hash: null,
									loan: 457,
									uuid: 'eef2473c-dc89-49cf-ba48-0677457f9d63',
									amount: 49642.09,
									source: null,
									currency: 'USD',
									metadata: null,
									projectId: 318,
									toAccount: -1,
									toAddress: '0x8eC014ccccb81084CC90B8DFf5De93Fa5c9439a3',
									reimbursed: {
										amount: null,
									},
									fromAccount: 1636,
									fromAddress: '0xF6379168Ba44cd6A7AB2E9106001Fde599a9EF08',
									transaction: 25827,
									taxEquivalent: null,
									amountReceived: null,
									blkTransaction: {
										id: null,
										status: 'STARTED',
									},
									revertedPayment: null,
									amountEquivalent: null,
									currencyReceived: null,
								},
								hash: 'a0baf6267a41592ea23d5aebba06b37a3ed2503c980ad8b1811f72d3add9acc8',
								created: '2026-05-10T20:20:45.360Z',
								modified: null,
								tax: null,
								amountEquivalent: null,
								taxEquivalent: null,
								amountReceived: null,
								reimbursed: {
									amount: null,
								},
								blkTransaction: {
									id: '0xda61c598b0b58f3b3587e20d61deb73157073023c19a533c2615bc983a6455ef',
									status: 'DONE',
								},
								revertedPayment: null,
								transaction: 25827,
								loan: {
									id: 457,
									idWbg: null,
									status: 'ENABLED',
									currency: 'XDR',
									amount: 38400000,
									disbursed: 730716.39,
									financier: 'IDA',
									name: 'IPF - Investment Project Financing',
									num: 'E4250',
									dateApproved: '2025-03-28T00:00:00.000Z',
									dateSigning: '2025-04-25T00:00:00.000Z',
									dateClosing: '2029-12-28T00:00:00.000Z',
									subLoanNum: null,
									created: '2026-01-29T13:35:46.971Z',
									modified: '2026-01-29T13:39:44.224Z',
									cancelled: null,
									code: 'IDAE4250',
								},
							},
						],
						tax: 0,
						total: 49642.09,
						id: 25827,
						status: 'COMPLETED',
						metadata: {
							uuid: 'e0bedaab-9388-4b16-a8e4-9cf8808f26ee',
							invoiceAmount: 6494754.66,
							invoiceCurrency: 'HTG',
						},
						traceability: {
							documents: {
								required: [1254, 1266],
								uploaded: [53881, 53882],
							},
							value: 100,
						},
						type: 'PAYMENT',
						date: '2026-03-26T00:00:00.000Z',
						created: '2026-05-10T20:20:45.344Z',
						modified: '2026-05-20T09:24:48.446Z',
						quantity: null,
						isReceived: null,
						amountReceived: null,
						benefit: null,
						category: 699,
						component: 1145,
						contract: null,
						designatedAccount: null,
						expenseType: {
							id: 2053,
							name: 'Dépenses opérationnelles',
							created: '2026-01-29T15:09:24.768Z',
							modified: '2026-01-29T16:25:03.495Z',
							status: 'ACTIVE',
							entity: null,
							project: 318,
						},
						fromAccount: {
							id: 1636,
							idWbg: '000000000010021601',
							name: 'DA-A',
							num: '111080980',
							institution: "BANQUE DE LA REPUBLIQUE D'HAITI",
							type: 'DESIGNATED',
							currency: 'USD',
							created: '2026-01-29T13:35:46.971Z',
							modified: null,
							status: 'ACTIVE',
							aba: null,
							holder: null,
							isReimbursement: false,
							postcode: null,
							routeCode: null,
							sortCode: null,
							state: null,
							street: null,
							swiftCode: null,
							town: null,
							country: null,
						},
						fromEntity: 2299,
						project: 318,
						toAccount: null,
						toEntity: 2305,
						user: 2026,
						withdrawalApplication: 103,
					},
					{
						amount: 1528.68,
						currency: 'USD',
						payments: [
							{
								id: 30418,
								source: null,
								amount: 1528.68,
								currency: 'USD',
								currencyReceived: null,
								metadata: {
									tax: null,
									hash: null,
									loan: 457,
									uuid: '345104ff-2a9b-4344-9c71-7d96475799ff',
									amount: 1528.68,
									source: null,
									currency: 'USD',
									metadata: null,
									projectId: 318,
									toAccount: -1,
									toAddress: '0x8eC014ccccb81084CC90B8DFf5De93Fa5c9439a3',
									reimbursed: {
										amount: null,
									},
									fromAccount: 1636,
									fromAddress: '0xF6379168Ba44cd6A7AB2E9106001Fde599a9EF08',
									transaction: 25782,
									taxEquivalent: null,
									amountReceived: null,
									blkTransaction: {
										id: null,
										status: 'STARTED',
									},
									revertedPayment: null,
									amountEquivalent: null,
									currencyReceived: null,
								},
								hash: '2626e783452a762cc2572241695306f403a3905649b065d2c7a0d89b5d75b79a',
								created: '2026-05-10T17:42:09.953Z',
								modified: null,
								tax: null,
								amountEquivalent: null,
								taxEquivalent: null,
								amountReceived: null,
								reimbursed: {
									amount: null,
								},
								blkTransaction: {
									id: '0x8080af6ee950904ef4e02cb01578192d01129144c2786687fd2c9f2b4d7c765f',
									status: 'DONE',
								},
								revertedPayment: null,
								transaction: 25782,
								loan: {
									id: 457,
									idWbg: null,
									status: 'ENABLED',
									currency: 'XDR',
									amount: 38400000,
									disbursed: 730716.39,
									financier: 'IDA',
									name: 'IPF - Investment Project Financing',
									num: 'E4250',
									dateApproved: '2025-03-28T00:00:00.000Z',
									dateSigning: '2025-04-25T00:00:00.000Z',
									dateClosing: '2029-12-28T00:00:00.000Z',
									subLoanNum: null,
									created: '2026-01-29T13:35:46.971Z',
									modified: '2026-01-29T13:39:44.224Z',
									cancelled: null,
									code: 'IDAE4250',
								},
							},
						],
						tax: 0,
						total: 1528.68,
						id: 25782,
						status: 'COMPLETED',
						metadata: {
							uuid: '9f098a6b-35d4-4252-bbbd-5c30b73f71df',
							invoiceAmount: 200000,
							invoiceCurrency: 'HTG',
						},
						traceability: {
							documents: {
								required: [1254, 1266],
								uploaded: [53814, 53815],
							},
							value: 100,
						},
						type: 'PAYMENT',
						date: '2026-03-26T00:00:00.000Z',
						created: '2026-05-10T17:42:09.942Z',
						modified: '2026-05-20T09:24:48.470Z',
						quantity: null,
						isReceived: null,
						amountReceived: null,
						benefit: null,
						category: 699,
						component: 1145,
						contract: null,
						designatedAccount: null,
						expenseType: {
							id: 2053,
							name: 'Dépenses opérationnelles',
							created: '2026-01-29T15:09:24.768Z',
							modified: '2026-01-29T16:25:03.495Z',
							status: 'ACTIVE',
							entity: null,
							project: 318,
						},
						fromAccount: {
							id: 1636,
							idWbg: '000000000010021601',
							name: 'DA-A',
							num: '111080980',
							institution: "BANQUE DE LA REPUBLIQUE D'HAITI",
							type: 'DESIGNATED',
							currency: 'USD',
							created: '2026-01-29T13:35:46.971Z',
							modified: null,
							status: 'ACTIVE',
							aba: null,
							holder: null,
							isReimbursement: false,
							postcode: null,
							routeCode: null,
							sortCode: null,
							state: null,
							street: null,
							swiftCode: null,
							town: null,
							country: null,
						},
						fromEntity: 2299,
						project: 318,
						toAccount: null,
						toEntity: 2305,
						user: 2026,
						withdrawalApplication: 103,
					},
					{
						amount: 1605.11,
						currency: 'USD',
						payments: [
							{
								id: 30417,
								source: null,
								amount: 1605.11,
								currency: 'USD',
								currencyReceived: null,
								metadata: {
									tax: null,
									hash: null,
									loan: 457,
									uuid: '53797ef9-5a10-4d1b-b4dd-c7c7f483edad',
									amount: 1605.11,
									source: null,
									currency: 'USD',
									metadata: null,
									projectId: 318,
									toAccount: -1,
									toAddress: '0x8eC014ccccb81084CC90B8DFf5De93Fa5c9439a3',
									reimbursed: {
										amount: null,
									},
									fromAccount: 1636,
									fromAddress: '0xF6379168Ba44cd6A7AB2E9106001Fde599a9EF08',
									transaction: 25781,
									taxEquivalent: null,
									amountReceived: null,
									blkTransaction: {
										id: null,
										status: 'STARTED',
									},
									revertedPayment: null,
									amountEquivalent: null,
									currencyReceived: null,
								},
								hash: '105692e21b563f0b265b3999abeaa6e31d4fc2a23de50894142dfd2d41cc1d0b',
								created: '2026-05-10T17:39:08.319Z',
								modified: null,
								tax: null,
								amountEquivalent: null,
								taxEquivalent: null,
								amountReceived: null,
								reimbursed: {
									amount: null,
								},
								blkTransaction: {
									id: '0x9b496e2307a8759414a9468d40c0020779ebff145830a51c6d35a4fa4162ff22',
									status: 'DONE',
								},
								revertedPayment: null,
								transaction: 25781,
								loan: {
									id: 457,
									idWbg: null,
									status: 'ENABLED',
									currency: 'XDR',
									amount: 38400000,
									disbursed: 730716.39,
									financier: 'IDA',
									name: 'IPF - Investment Project Financing',
									num: 'E4250',
									dateApproved: '2025-03-28T00:00:00.000Z',
									dateSigning: '2025-04-25T00:00:00.000Z',
									dateClosing: '2029-12-28T00:00:00.000Z',
									subLoanNum: null,
									created: '2026-01-29T13:35:46.971Z',
									modified: '2026-01-29T13:39:44.224Z',
									cancelled: null,
									code: 'IDAE4250',
								},
							},
						],
						tax: 0,
						total: 1605.11,
						id: 25781,
						status: 'IN_PROGRESS',
						metadata: {
							uuid: '9fd916a4-793d-4ad2-98ea-bcb7732aa19a',
							invoiceAmount: 210000,
							invoiceCurrency: 'HTG',
						},
						traceability: {
							documents: {
								required: [1254, 1266],
								uploaded: [53812, 53813],
							},
							value: 100,
						},
						type: 'PAYMENT',
						date: '2026-03-26T00:00:00.000Z',
						created: '2026-05-10T17:39:08.304Z',
						modified: '2026-05-20T09:24:48.505Z',
						quantity: null,
						isReceived: null,
						amountReceived: null,
						benefit: null,
						category: 699,
						component: 1145,
						contract: null,
						designatedAccount: null,
						expenseType: {
							id: 2053,
							name: 'Dépenses opérationnelles',
							created: '2026-01-29T15:09:24.768Z',
							modified: '2026-01-29T16:25:03.495Z',
							status: 'ACTIVE',
							entity: null,
							project: 318,
						},
						fromAccount: {
							id: 1636,
							idWbg: '000000000010021601',
							name: 'DA-A',
							num: '111080980',
							institution: "BANQUE DE LA REPUBLIQUE D'HAITI",
							type: 'DESIGNATED',
							currency: 'USD',
							created: '2026-01-29T13:35:46.971Z',
							modified: null,
							status: 'ACTIVE',
							aba: null,
							holder: null,
							isReimbursement: false,
							postcode: null,
							routeCode: null,
							sortCode: null,
							state: null,
							street: null,
							swiftCode: null,
							town: null,
							country: null,
						},
						fromEntity: 2299,
						project: 318,
						toAccount: null,
						toEntity: 2305,
						user: 2026,
						withdrawalApplication: 103,
					},
					{
						amount: 4968.21,
						currency: 'USD',
						payments: [
							{
								id: 30416,
								source: null,
								amount: 4968.21,
								currency: 'USD',
								currencyReceived: null,
								metadata: {
									tax: null,
									hash: null,
									loan: 457,
									uuid: '11bb08e2-6b17-4841-8cfe-cace3d4e93af',
									amount: 4968.21,
									source: null,
									currency: 'USD',
									metadata: null,
									projectId: 318,
									toAccount: -1,
									toAddress: '0x8eC014ccccb81084CC90B8DFf5De93Fa5c9439a3',
									reimbursed: {
										amount: null,
									},
									fromAccount: 1636,
									fromAddress: '0xF6379168Ba44cd6A7AB2E9106001Fde599a9EF08',
									transaction: 25780,
									taxEquivalent: null,
									amountReceived: null,
									blkTransaction: {
										id: null,
										status: 'STARTED',
									},
									revertedPayment: null,
									amountEquivalent: null,
									currencyReceived: null,
								},
								hash: '93b45138b586d5686a2aeab3e30846765f2640c5d5a7d5eb10cbfeed6dfef404',
								created: '2026-05-10T17:35:13.881Z',
								modified: null,
								tax: null,
								amountEquivalent: null,
								taxEquivalent: null,
								amountReceived: null,
								reimbursed: {
									amount: null,
								},
								blkTransaction: {
									id: '0x28e925db100e6243c1b0861885c91e950db6beee557211cf6c01a6cdd6293dbf',
									status: 'DONE',
								},
								revertedPayment: null,
								transaction: 25780,
								loan: {
									id: 457,
									idWbg: null,
									status: 'ENABLED',
									currency: 'XDR',
									amount: 38400000,
									disbursed: 730716.39,
									financier: 'IDA',
									name: 'IPF - Investment Project Financing',
									num: 'E4250',
									dateApproved: '2025-03-28T00:00:00.000Z',
									dateSigning: '2025-04-25T00:00:00.000Z',
									dateClosing: '2029-12-28T00:00:00.000Z',
									subLoanNum: null,
									created: '2026-01-29T13:35:46.971Z',
									modified: '2026-01-29T13:39:44.224Z',
									cancelled: null,
									code: 'IDAE4250',
								},
							},
						],
						tax: 0,
						total: 4968.21,
						id: 25780,
						status: 'COMPLETED',
						metadata: {
							uuid: 'cb0a4e59-a3e7-49b6-aa20-93428a336879',
							invoiceAmount: 650000,
							invoiceCurrency: 'HTG',
						},
						traceability: {
							documents: {
								required: [1254, 1266],
								uploaded: [53810, 53811],
							},
							value: 100,
						},
						type: 'PAYMENT',
						date: '2026-03-26T00:00:00.000Z',
						created: '2026-05-10T17:35:13.869Z',
						modified: '2026-05-20T09:24:48.555Z',
						quantity: null,
						isReceived: null,
						amountReceived: null,
						benefit: null,
						category: 699,
						component: 1139,
						contract: null,
						designatedAccount: null,
						expenseType: {
							id: 2053,
							name: 'Dépenses opérationnelles',
							created: '2026-01-29T15:09:24.768Z',
							modified: '2026-01-29T16:25:03.495Z',
							status: 'ACTIVE',
							entity: null,
							project: 318,
						},
						fromAccount: {
							id: 1636,
							idWbg: '000000000010021601',
							name: 'DA-A',
							num: '111080980',
							institution: "BANQUE DE LA REPUBLIQUE D'HAITI",
							type: 'DESIGNATED',
							currency: 'USD',
							created: '2026-01-29T13:35:46.971Z',
							modified: null,
							status: 'ACTIVE',
							aba: null,
							holder: null,
							isReimbursement: false,
							postcode: null,
							routeCode: null,
							sortCode: null,
							state: null,
							street: null,
							swiftCode: null,
							town: null,
							country: null,
						},
						fromEntity: 2299,
						project: 318,
						toAccount: null,
						toEntity: 2305,
						user: 2026,
						withdrawalApplication: 103,
					},
					{
						amount: 3567.03,
						currency: 'USD',
						payments: [
							{
								id: 30395,
								source: null,
								amount: 3567.03,
								currency: 'USD',
								currencyReceived: null,
								metadata: {
									tax: null,
									hash: null,
									loan: 457,
									uuid: '086566b2-b0fb-4182-9ebd-6a7beb353045',
									amount: 3567.03,
									source: null,
									currency: 'USD',
									metadata: null,
									projectId: 318,
									toAccount: -1,
									toAddress: '0x8eC014ccccb81084CC90B8DFf5De93Fa5c9439a3',
									reimbursed: {
										amount: null,
									},
									fromAccount: 1636,
									fromAddress: '0xF6379168Ba44cd6A7AB2E9106001Fde599a9EF08',
									transaction: 25759,
									taxEquivalent: null,
									amountReceived: null,
									blkTransaction: {
										id: null,
										status: 'STARTED',
									},
									revertedPayment: null,
									amountEquivalent: null,
									currencyReceived: null,
								},
								hash: 'a0fbc835c5b92494ed0fa8c359a4fbbb53f165c98cae8c5e11b05d69e18c1782',
								created: '2026-05-10T16:44:44.931Z',
								modified: null,
								tax: null,
								amountEquivalent: null,
								taxEquivalent: null,
								amountReceived: null,
								reimbursed: {
									amount: null,
								},
								blkTransaction: {
									id: '0x4a8b7c6a8b9826e8a7052b1c763f618787995264ef325f9d27f50c5876a52339',
									status: 'DONE',
								},
								revertedPayment: null,
								transaction: 25759,
								loan: {
									id: 457,
									idWbg: null,
									status: 'ENABLED',
									currency: 'XDR',
									amount: 38400000,
									disbursed: 730716.39,
									financier: 'IDA',
									name: 'IPF - Investment Project Financing',
									num: 'E4250',
									dateApproved: '2025-03-28T00:00:00.000Z',
									dateSigning: '2025-04-25T00:00:00.000Z',
									dateClosing: '2029-12-28T00:00:00.000Z',
									subLoanNum: null,
									created: '2026-01-29T13:35:46.971Z',
									modified: '2026-01-29T13:39:44.224Z',
									cancelled: null,
									code: 'IDAE4250',
								},
							},
						],
						tax: 0,
						total: 3567.03,
						id: 25759,
						status: 'COMPLETED',
						metadata: {
							uuid: 'cc1ff678-ac52-410c-b33f-f60d0abb8017',
							invoiceAmount: 467000,
							invoiceCurrency: 'HTG',
						},
						traceability: {
							documents: {
								required: [1254, 1266],
								uploaded: [53783, 53784],
							},
							value: 100,
						},
						type: 'PAYMENT',
						date: '2026-03-20T00:00:00.000Z',
						created: '2026-05-10T16:44:44.916Z',
						modified: '2026-05-20T09:24:48.731Z',
						quantity: null,
						isReceived: null,
						amountReceived: null,
						benefit: null,
						category: 699,
						component: 1148,
						contract: null,
						designatedAccount: null,
						expenseType: {
							id: 2053,
							name: 'Dépenses opérationnelles',
							created: '2026-01-29T15:09:24.768Z',
							modified: '2026-01-29T16:25:03.495Z',
							status: 'ACTIVE',
							entity: null,
							project: 318,
						},
						fromAccount: {
							id: 1636,
							idWbg: '000000000010021601',
							name: 'DA-A',
							num: '111080980',
							institution: "BANQUE DE LA REPUBLIQUE D'HAITI",
							type: 'DESIGNATED',
							currency: 'USD',
							created: '2026-01-29T13:35:46.971Z',
							modified: null,
							status: 'ACTIVE',
							aba: null,
							holder: null,
							isReimbursement: false,
							postcode: null,
							routeCode: null,
							sortCode: null,
							state: null,
							street: null,
							swiftCode: null,
							town: null,
							country: null,
						},
						fromEntity: 2299,
						project: 318,
						toAccount: null,
						toEntity: 2305,
						user: 2026,
						withdrawalApplication: 103,
					},
					{
						amount: 2413.64,
						currency: 'USD',
						payments: [
							{
								id: 30365,
								source: null,
								amount: 2413.64,
								currency: 'USD',
								currencyReceived: null,
								metadata: {
									tax: null,
									hash: null,
									loan: 457,
									uuid: '96b0ccfa-b709-4c0f-bfef-d4fb88a2a806',
									amount: 2413.64,
									source: null,
									currency: 'USD',
									metadata: null,
									projectId: 318,
									toAccount: -1,
									toAddress: '0x8eC014ccccb81084CC90B8DFf5De93Fa5c9439a3',
									reimbursed: {
										amount: null,
									},
									fromAccount: 1636,
									fromAddress: '0xF6379168Ba44cd6A7AB2E9106001Fde599a9EF08',
									transaction: 25729,
									taxEquivalent: null,
									amountReceived: null,
									blkTransaction: {
										id: null,
										status: 'STARTED',
									},
									revertedPayment: null,
									amountEquivalent: null,
									currencyReceived: null,
								},
								hash: '86ac3fc07dfd5edd6eba4f23aba144dae44229218915cf24bbb1ec0dcd489d1a',
								created: '2026-05-10T15:27:51.348Z',
								modified: null,
								tax: null,
								amountEquivalent: null,
								taxEquivalent: null,
								amountReceived: null,
								reimbursed: {
									amount: null,
								},
								blkTransaction: {
									id: '0xb7982c885bf4b9cc838d3c788cd6881f5a37e7da6e93bd90eff6f156babf40c7',
									status: 'DONE',
								},
								revertedPayment: null,
								transaction: 25729,
								loan: {
									id: 457,
									idWbg: null,
									status: 'ENABLED',
									currency: 'XDR',
									amount: 38400000,
									disbursed: 730716.39,
									financier: 'IDA',
									name: 'IPF - Investment Project Financing',
									num: 'E4250',
									dateApproved: '2025-03-28T00:00:00.000Z',
									dateSigning: '2025-04-25T00:00:00.000Z',
									dateClosing: '2029-12-28T00:00:00.000Z',
									subLoanNum: null,
									created: '2026-01-29T13:35:46.971Z',
									modified: '2026-01-29T13:39:44.224Z',
									cancelled: null,
									code: 'IDAE4250',
								},
							},
						],
						tax: 0,
						total: 2413.64,
						id: 25729,
						status: 'COMPLETED',
						metadata: {
							uuid: '292eefd7-ecd1-4bdc-8137-37975d912cb6',
							invoiceAmount: 316000,
							invoiceCurrency: 'HTG',
						},
						traceability: {
							documents: {
								required: [1254, 1266],
								uploaded: [53727, 53729],
							},
							value: 100,
						},
						type: 'PAYMENT',
						date: '2026-03-11T00:00:00.000Z',
						created: '2026-05-10T15:27:51.337Z',
						modified: '2026-05-20T09:24:49.036Z',
						quantity: null,
						isReceived: null,
						amountReceived: null,
						benefit: null,
						category: 699,
						component: 1148,
						contract: null,
						designatedAccount: null,
						expenseType: {
							id: 2053,
							name: 'Dépenses opérationnelles',
							created: '2026-01-29T15:09:24.768Z',
							modified: '2026-01-29T16:25:03.495Z',
							status: 'ACTIVE',
							entity: null,
							project: 318,
						},
						fromAccount: {
							id: 1636,
							idWbg: '000000000010021601',
							name: 'DA-A',
							num: '111080980',
							institution: "BANQUE DE LA REPUBLIQUE D'HAITI",
							type: 'DESIGNATED',
							currency: 'USD',
							created: '2026-01-29T13:35:46.971Z',
							modified: null,
							status: 'ACTIVE',
							aba: null,
							holder: null,
							isReimbursement: false,
							postcode: null,
							routeCode: null,
							sortCode: null,
							state: null,
							street: null,
							swiftCode: null,
							town: null,
							country: null,
						},
						fromEntity: 2299,
						project: 318,
						toAccount: null,
						toEntity: 2305,
						user: 2026,
						withdrawalApplication: 103,
					},
					{
						amount: 1604.95,
						currency: 'USD',
						payments: [
							{
								id: 17634,
								source: null,
								amount: 1604.95,
								currency: 'USD',
								currencyReceived: null,
								metadata: {
									tax: null,
									hash: null,
									loan: 457,
									uuid: '7901cd3a-0567-45a5-a283-2eb344bbe537',
									amount: 1604.95,
									source: null,
									currency: 'USD',
									metadata: null,
									projectId: 318,
									toAccount: -1,
									toAddress: '0x8eC014ccccb81084CC90B8DFf5De93Fa5c9439a3',
									reimbursed: {
										amount: null,
									},
									fromAccount: 1636,
									fromAddress: '0xF6379168Ba44cd6A7AB2E9106001Fde599a9EF08',
									transaction: 14704,
									taxEquivalent: null,
									amountReceived: null,
									blkTransaction: {
										id: null,
										status: 'STARTED',
									},
									revertedPayment: null,
									amountEquivalent: null,
									currencyReceived: null,
								},
								hash: 'c65832e45409cb91640bc43f31684ba0e204b3b5704fb75fedbcd76159c8126f',
								created: '2026-03-21T15:25:26.617Z',
								modified: null,
								tax: null,
								amountEquivalent: null,
								taxEquivalent: null,
								amountReceived: null,
								reimbursed: {
									amount: null,
								},
								blkTransaction: {
									id: '0x508a8ab24312e01f0fcbcf861fc4f1435c4ae9ccde15c95543dbe546ebe6c1e4',
									status: 'DONE',
								},
								revertedPayment: null,
								transaction: 14704,
								loan: {
									id: 457,
									idWbg: null,
									status: 'ENABLED',
									currency: 'XDR',
									amount: 38400000,
									disbursed: 730716.39,
									financier: 'IDA',
									name: 'IPF - Investment Project Financing',
									num: 'E4250',
									dateApproved: '2025-03-28T00:00:00.000Z',
									dateSigning: '2025-04-25T00:00:00.000Z',
									dateClosing: '2029-12-28T00:00:00.000Z',
									subLoanNum: null,
									created: '2026-01-29T13:35:46.971Z',
									modified: '2026-01-29T13:39:44.224Z',
									cancelled: null,
									code: 'IDAE4250',
								},
							},
						],
						tax: 0,
						total: 1604.95,
						id: 14704,
						status: 'COMPLETED',
						metadata: {
							uuid: '7c902afd-c3ea-4596-b3a1-2b6502124fd6',
							invoiceAmount: 210000,
							invoiceCurrency: 'HTG',
						},
						traceability: {
							documents: {
								required: [1254, 1266],
								uploaded: [26515, 26516],
							},
							value: 100,
						},
						type: 'PAYMENT',
						date: '2026-02-24T00:00:00.000Z',
						created: '2026-03-21T15:25:26.602Z',
						modified: '2026-05-20T09:24:49.931Z',
						quantity: null,
						isReceived: null,
						amountReceived: null,
						benefit: null,
						category: 699,
						component: 1145,
						contract: null,
						designatedAccount: null,
						expenseType: {
							id: 2053,
							name: 'Dépenses opérationnelles',
							created: '2026-01-29T15:09:24.768Z',
							modified: '2026-01-29T16:25:03.495Z',
							status: 'ACTIVE',
							entity: null,
							project: 318,
						},
						fromAccount: {
							id: 1636,
							idWbg: '000000000010021601',
							name: 'DA-A',
							num: '111080980',
							institution: "BANQUE DE LA REPUBLIQUE D'HAITI",
							type: 'DESIGNATED',
							currency: 'USD',
							created: '2026-01-29T13:35:46.971Z',
							modified: null,
							status: 'ACTIVE',
							aba: null,
							holder: null,
							isReimbursement: false,
							postcode: null,
							routeCode: null,
							sortCode: null,
							state: null,
							street: null,
							swiftCode: null,
							town: null,
							country: null,
						},
						fromEntity: 2299,
						project: 318,
						toAccount: null,
						toEntity: 2305,
						user: 2026,
						withdrawalApplication: 103,
					},
					{
						amount: 49604.36,
						currency: 'USD',
						payments: [
							{
								id: 17633,
								source: null,
								amount: 49604.36,
								currency: 'USD',
								currencyReceived: null,
								metadata: {
									tax: null,
									hash: null,
									loan: 457,
									uuid: 'ee262a38-dff4-4675-9513-27b106a2e4e0',
									amount: 49604.36,
									source: null,
									currency: 'USD',
									metadata: null,
									projectId: 318,
									toAccount: -1,
									toAddress: '0x8eC014ccccb81084CC90B8DFf5De93Fa5c9439a3',
									reimbursed: {
										amount: null,
									},
									fromAccount: 1636,
									fromAddress: '0xF6379168Ba44cd6A7AB2E9106001Fde599a9EF08',
									transaction: 14703,
									taxEquivalent: null,
									amountReceived: null,
									blkTransaction: {
										id: null,
										status: 'STARTED',
									},
									revertedPayment: null,
									amountEquivalent: null,
									currencyReceived: null,
								},
								hash: 'd352ea382d9dc7f583e733c20dba4832d559810ba5fa563b9920a612a39df879',
								created: '2026-03-21T15:15:33.236Z',
								modified: null,
								tax: null,
								amountEquivalent: null,
								taxEquivalent: null,
								amountReceived: null,
								reimbursed: {
									amount: null,
								},
								blkTransaction: {
									id: '0x2472a7acf8d683272fae49af3e373cd93538353af5a961616ed86f237d6a0b74',
									status: 'DONE',
								},
								revertedPayment: null,
								transaction: 14703,
								loan: {
									id: 457,
									idWbg: null,
									status: 'ENABLED',
									currency: 'XDR',
									amount: 38400000,
									disbursed: 730716.39,
									financier: 'IDA',
									name: 'IPF - Investment Project Financing',
									num: 'E4250',
									dateApproved: '2025-03-28T00:00:00.000Z',
									dateSigning: '2025-04-25T00:00:00.000Z',
									dateClosing: '2029-12-28T00:00:00.000Z',
									subLoanNum: null,
									created: '2026-01-29T13:35:46.971Z',
									modified: '2026-01-29T13:39:44.224Z',
									cancelled: null,
									code: 'IDAE4250',
								},
							},
						],
						tax: 0,
						total: 49604.36,
						id: 14703,
						status: 'COMPLETED',
						metadata: {
							uuid: '57ad3eca-a349-4fb9-975d-30b39fd385e7',
							invoiceAmount: 6490874.46,
							invoiceCurrency: 'HTG',
						},
						traceability: {
							documents: {
								required: [1254, 1266],
								uploaded: [26513, 26514],
							},
							value: 100,
						},
						type: 'PAYMENT',
						date: '2026-02-26T00:00:00.000Z',
						created: '2026-03-21T15:15:33.225Z',
						modified: '2026-05-20T09:24:49.964Z',
						quantity: null,
						isReceived: null,
						amountReceived: null,
						benefit: null,
						category: 699,
						component: 1145,
						contract: null,
						designatedAccount: null,
						expenseType: {
							id: 2053,
							name: 'Dépenses opérationnelles',
							created: '2026-01-29T15:09:24.768Z',
							modified: '2026-01-29T16:25:03.495Z',
							status: 'ACTIVE',
							entity: null,
							project: 318,
						},
						fromAccount: {
							id: 1636,
							idWbg: '000000000010021601',
							name: 'DA-A',
							num: '111080980',
							institution: "BANQUE DE LA REPUBLIQUE D'HAITI",
							type: 'DESIGNATED',
							currency: 'USD',
							created: '2026-01-29T13:35:46.971Z',
							modified: null,
							status: 'ACTIVE',
							aba: null,
							holder: null,
							isReimbursement: false,
							postcode: null,
							routeCode: null,
							sortCode: null,
							state: null,
							street: null,
							swiftCode: null,
							town: null,
							country: null,
						},
						fromEntity: 2299,
						project: 318,
						toAccount: null,
						toEntity: 2305,
						user: 2026,
						withdrawalApplication: 103,
					},
					{
						amount: 2880,
						currency: 'USD',
						payments: [
							{
								id: 16735,
								source: null,
								amount: 2880,
								currency: 'USD',
								currencyReceived: null,
								metadata: {
									tax: null,
									hash: null,
									loan: 457,
									uuid: '0632b697-bc61-4d91-b61e-9657f24e72e3',
									amount: 2880,
									source: null,
									currency: 'USD',
									metadata: null,
									projectId: 318,
									toAccount: -1,
									toAddress: '0x8eC014ccccb81084CC90B8DFf5De93Fa5c9439a3',
									fromAccount: 1636,
									fromAddress: '0xF6379168Ba44cd6A7AB2E9106001Fde599a9EF08',
									transaction: 13869,
									taxEquivalent: null,
									amountReceived: null,
									blkTransaction: {
										id: null,
										status: 'STARTED',
									},
									revertedPayment: null,
									amountEquivalent: null,
									currencyReceived: null,
								},
								hash: '89298a615f97150cd2e24a40298ef07211d0b68bb480324c34c371681cc2c03e',
								created: '2026-03-15T23:20:01.662Z',
								modified: null,
								tax: null,
								amountEquivalent: null,
								taxEquivalent: null,
								amountReceived: null,
								reimbursed: {
									amount: null,
								},
								blkTransaction: {
									id: '0xa684d423ba62bff166698ec2dca23b40e33e84a15e912fb15f24d123a9685982',
									status: 'DONE',
								},
								revertedPayment: null,
								transaction: 13869,
								loan: {
									id: 457,
									idWbg: null,
									status: 'ENABLED',
									currency: 'XDR',
									amount: 38400000,
									disbursed: 730716.39,
									financier: 'IDA',
									name: 'IPF - Investment Project Financing',
									num: 'E4250',
									dateApproved: '2025-03-28T00:00:00.000Z',
									dateSigning: '2025-04-25T00:00:00.000Z',
									dateClosing: '2029-12-28T00:00:00.000Z',
									subLoanNum: null,
									created: '2026-01-29T13:35:46.971Z',
									modified: '2026-01-29T13:39:44.224Z',
									cancelled: null,
									code: 'IDAE4250',
								},
							},
						],
						tax: 0,
						total: 2880,
						id: 13869,
						status: 'COMPLETED',
						metadata: {
							uuid: '3b93c6c5-73cd-48ab-8be3-251caa414729',
							invoiceAmount: 2880,
							invoiceCurrency: 'USD',
						},
						traceability: {
							documents: {
								required: [1254, 1266],
								uploaded: [25254, 25256],
							},
							value: 100,
						},
						type: 'PAYMENT',
						date: '2026-01-19T00:00:00.000Z',
						created: '2026-03-15T23:20:01.640Z',
						modified: '2026-05-20T09:24:50.549Z',
						quantity: null,
						isReceived: null,
						amountReceived: null,
						benefit: null,
						category: 699,
						component: 1148,
						contract: null,
						designatedAccount: null,
						expenseType: {
							id: 2053,
							name: 'Dépenses opérationnelles',
							created: '2026-01-29T15:09:24.768Z',
							modified: '2026-01-29T16:25:03.495Z',
							status: 'ACTIVE',
							entity: null,
							project: 318,
						},
						fromAccount: {
							id: 1636,
							idWbg: '000000000010021601',
							name: 'DA-A',
							num: '111080980',
							institution: "BANQUE DE LA REPUBLIQUE D'HAITI",
							type: 'DESIGNATED',
							currency: 'USD',
							created: '2026-01-29T13:35:46.971Z',
							modified: null,
							status: 'ACTIVE',
							aba: null,
							holder: null,
							isReimbursement: false,
							postcode: null,
							routeCode: null,
							sortCode: null,
							state: null,
							street: null,
							swiftCode: null,
							town: null,
							country: null,
						},
						fromEntity: 2299,
						project: 318,
						toAccount: null,
						toEntity: 2305,
						user: 2026,
						withdrawalApplication: 103,
					},
					{
						amount: 3705.48,
						currency: 'USD',
						payments: [
							{
								id: 16467,
								source: null,
								amount: 3705.48,
								currency: 'USD',
								currencyReceived: null,
								metadata: {
									tax: null,
									hash: null,
									loan: 457,
									uuid: '9c4bc9de-080f-46e5-85e9-026f3b8bba2d',
									amount: 3705.48,
									source: null,
									currency: 'USD',
									metadata: null,
									projectId: 318,
									toAccount: -1,
									toAddress: '0x8eC014ccccb81084CC90B8DFf5De93Fa5c9439a3',
									fromAccount: 1636,
									fromAddress: '0xF6379168Ba44cd6A7AB2E9106001Fde599a9EF08',
									transaction: 13616,
									taxEquivalent: null,
									amountReceived: null,
									blkTransaction: {
										id: null,
										status: 'STARTED',
									},
									revertedPayment: null,
									amountEquivalent: null,
									currencyReceived: null,
								},
								hash: 'af9b662d6f6873b409ab48b5e01ebe7c7e7377d32806f5d3a5b1fa587f3b4cd3',
								created: '2026-03-13T16:41:20.503Z',
								modified: null,
								tax: null,
								amountEquivalent: null,
								taxEquivalent: null,
								amountReceived: null,
								reimbursed: {
									amount: null,
								},
								blkTransaction: {
									id: '0x9041288da9b741e09de8f5dd797da4c8e00edbb5856f768cef32b9aa2117b936',
									status: 'DONE',
								},
								revertedPayment: null,
								transaction: 13616,
								loan: {
									id: 457,
									idWbg: null,
									status: 'ENABLED',
									currency: 'XDR',
									amount: 38400000,
									disbursed: 730716.39,
									financier: 'IDA',
									name: 'IPF - Investment Project Financing',
									num: 'E4250',
									dateApproved: '2025-03-28T00:00:00.000Z',
									dateSigning: '2025-04-25T00:00:00.000Z',
									dateClosing: '2029-12-28T00:00:00.000Z',
									subLoanNum: null,
									created: '2026-01-29T13:35:46.971Z',
									modified: '2026-01-29T13:39:44.224Z',
									cancelled: null,
									code: 'IDAE4250',
								},
							},
						],
						tax: 0,
						total: 3705.48,
						id: 13616,
						status: 'COMPLETED',
						metadata: {
							uuid: '0aba6e82-7905-4f52-a16f-63cb1e0f0470',
							invoiceAmount: 484000,
							invoiceCurrency: 'HTG',
						},
						traceability: {
							documents: {
								required: [1254, 1266],
								uploaded: [24129, 31860],
							},
							value: 100,
						},
						type: 'PAYMENT',
						date: '2026-01-16T00:00:00.000Z',
						created: '2026-03-13T16:41:20.487Z',
						modified: '2026-05-20T09:24:50.786Z',
						quantity: null,
						isReceived: null,
						amountReceived: null,
						benefit: null,
						category: 699,
						component: 1148,
						contract: null,
						designatedAccount: null,
						expenseType: {
							id: 2053,
							name: 'Dépenses opérationnelles',
							created: '2026-01-29T15:09:24.768Z',
							modified: '2026-01-29T16:25:03.495Z',
							status: 'ACTIVE',
							entity: null,
							project: 318,
						},
						fromAccount: {
							id: 1636,
							idWbg: '000000000010021601',
							name: 'DA-A',
							num: '111080980',
							institution: "BANQUE DE LA REPUBLIQUE D'HAITI",
							type: 'DESIGNATED',
							currency: 'USD',
							created: '2026-01-29T13:35:46.971Z',
							modified: null,
							status: 'ACTIVE',
							aba: null,
							holder: null,
							isReimbursement: false,
							postcode: null,
							routeCode: null,
							sortCode: null,
							state: null,
							street: null,
							swiftCode: null,
							town: null,
							country: null,
						},
						fromEntity: 2299,
						project: 318,
						toAccount: null,
						toEntity: 2305,
						user: 2026,
						withdrawalApplication: 103,
					},
				],
				value: 434965.6500000001,
			},
			{
				source: 0,
				target: 2,
				transactions: [
					{
						amount: 1323.13,
						currency: 'USD',
						payments: [
							{
								id: 11129,
								source: null,
								amount: 1323.13,
								currency: 'USD',
								currencyReceived: null,
								metadata: {
									tax: null,
									hash: null,
									loan: 457,
									uuid: '2243459e-e49e-4c00-965f-06aa0986b732',
									amount: 1323.13,
									source: null,
									currency: 'USD',
									metadata: null,
									projectId: 318,
									toAccount: -1,
									toAddress: '0x362A16eD794C148Bb2277BF72002c92B36dFB1C2',
									fromAccount: 1636,
									fromAddress: '0xF6379168Ba44cd6A7AB2E9106001Fde599a9EF08',
									transaction: 9039,
									taxEquivalent: null,
									amountReceived: null,
									blkTransaction: {
										id: null,
										status: 'STARTED',
									},
									revertedPayment: null,
									amountEquivalent: null,
									currencyReceived: null,
								},
								hash: '99e5ae28f4384809db17d1676f706fc9b535565454296d12f78a4b1428562ab6',
								created: '2026-02-24T00:41:15.852Z',
								modified: null,
								tax: null,
								amountEquivalent: null,
								taxEquivalent: null,
								amountReceived: null,
								reimbursed: {
									amount: null,
								},
								blkTransaction: {
									id: '0x218b92e2618a342193a8294191599178f01321913d0951a4d8248e011c87e5bf',
									status: 'DONE',
								},
								revertedPayment: null,
								transaction: 9039,
								loan: {
									id: 457,
									idWbg: null,
									status: 'ENABLED',
									currency: 'XDR',
									amount: 38400000,
									disbursed: 730716.39,
									financier: 'IDA',
									name: 'IPF - Investment Project Financing',
									num: 'E4250',
									dateApproved: '2025-03-28T00:00:00.000Z',
									dateSigning: '2025-04-25T00:00:00.000Z',
									dateClosing: '2029-12-28T00:00:00.000Z',
									subLoanNum: null,
									created: '2026-01-29T13:35:46.971Z',
									modified: '2026-01-29T13:39:44.224Z',
									cancelled: null,
									code: 'IDAE4250',
								},
							},
						],
						tax: 0,
						total: 1323.13,
						id: 9039,
						status: 'COMPLETED',
						metadata: {
							uuid: '3a943e37-0514-4b7b-aac9-2a702659e2af',
							invoiceAmount: 157200,
							invoiceCurrency: 'HTG',
						},
						traceability: {
							documents: {
								required: [1254, 1266],
								uploaded: [16978, 16979],
							},
							value: 100,
						},
						type: 'PAYMENT',
						date: '2025-12-31T00:00:00.000Z',
						created: '2026-02-24T00:41:15.839Z',
						modified: null,
						quantity: null,
						isReceived: null,
						amountReceived: null,
						benefit: null,
						category: 699,
						component: 1146,
						contract: null,
						designatedAccount: null,
						expenseType: {
							id: 2053,
							name: 'Dépenses opérationnelles',
							created: '2026-01-29T15:09:24.768Z',
							modified: '2026-01-29T16:25:03.495Z',
							status: 'ACTIVE',
							entity: null,
							project: 318,
						},
						fromAccount: {
							id: 1636,
							idWbg: '000000000010021601',
							name: 'DA-A',
							num: '111080980',
							institution: "BANQUE DE LA REPUBLIQUE D'HAITI",
							type: 'DESIGNATED',
							currency: 'USD',
							created: '2026-01-29T13:35:46.971Z',
							modified: null,
							status: 'ACTIVE',
							aba: null,
							holder: null,
							isReimbursement: false,
							postcode: null,
							routeCode: null,
							sortCode: null,
							state: null,
							street: null,
							swiftCode: null,
							town: null,
							country: null,
						},
						fromEntity: 2299,
						project: 318,
						toAccount: null,
						toEntity: 2980,
						user: 2026,
						withdrawalApplication: null,
					},
					{
						amount: 1294.52,
						currency: 'USD',
						payments: [
							{
								id: 17657,
								source: null,
								amount: 1294.52,
								currency: 'USD',
								currencyReceived: null,
								metadata: {
									tax: null,
									hash: null,
									loan: 457,
									uuid: '2a2db7fa-7995-4af3-8d7e-a22ae072f841',
									amount: 1294.52,
									source: null,
									currency: 'USD',
									metadata: null,
									projectId: 318,
									toAccount: -1,
									toAddress: '0x362A16eD794C148Bb2277BF72002c92B36dFB1C2',
									reimbursed: {
										amount: null,
									},
									fromAccount: 1636,
									fromAddress: '0xF6379168Ba44cd6A7AB2E9106001Fde599a9EF08',
									transaction: 14720,
									taxEquivalent: null,
									amountReceived: null,
									blkTransaction: {
										id: null,
										status: 'STARTED',
									},
									revertedPayment: null,
									amountEquivalent: null,
									currencyReceived: null,
								},
								hash: '2086eaa137989e3d3a140f2a06828f6c36ed44f22a4e658a93bedd95b59a1cda',
								created: '2026-03-21T16:47:02.354Z',
								modified: null,
								tax: null,
								amountEquivalent: null,
								taxEquivalent: null,
								amountReceived: null,
								reimbursed: {
									amount: null,
								},
								blkTransaction: {
									id: '0x06f6517733c98657bc14dfb9c066cfab81658963c98117c65bf25a5a67038200',
									status: 'DONE',
								},
								revertedPayment: null,
								transaction: 14720,
								loan: {
									id: 457,
									idWbg: null,
									status: 'ENABLED',
									currency: 'XDR',
									amount: 38400000,
									disbursed: 730716.39,
									financier: 'IDA',
									name: 'IPF - Investment Project Financing',
									num: 'E4250',
									dateApproved: '2025-03-28T00:00:00.000Z',
									dateSigning: '2025-04-25T00:00:00.000Z',
									dateClosing: '2029-12-28T00:00:00.000Z',
									subLoanNum: null,
									created: '2026-01-29T13:35:46.971Z',
									modified: '2026-01-29T13:39:44.224Z',
									cancelled: null,
									code: 'IDAE4250',
								},
							},
						],
						tax: 0,
						total: 1294.52,
						id: 14720,
						status: 'COMPLETED',
						metadata: {
							uuid: '8265aeaf-2127-4bee-8f87-5b218a553f81',
							invoiceAmount: 169290,
							invoiceCurrency: 'HTG',
						},
						traceability: {
							documents: {
								required: [1254, 1266],
								uploaded: [26527, 26528],
							},
							value: 100,
						},
						type: 'PAYMENT',
						date: '2026-02-27T00:00:00.000Z',
						created: '2026-03-21T16:47:02.343Z',
						modified: '2026-05-20T09:24:49.748Z',
						quantity: null,
						isReceived: null,
						amountReceived: null,
						benefit: null,
						category: 699,
						component: 1146,
						contract: null,
						designatedAccount: null,
						expenseType: {
							id: 2053,
							name: 'Dépenses opérationnelles',
							created: '2026-01-29T15:09:24.768Z',
							modified: '2026-01-29T16:25:03.495Z',
							status: 'ACTIVE',
							entity: null,
							project: 318,
						},
						fromAccount: {
							id: 1636,
							idWbg: '000000000010021601',
							name: 'DA-A',
							num: '111080980',
							institution: "BANQUE DE LA REPUBLIQUE D'HAITI",
							type: 'DESIGNATED',
							currency: 'USD',
							created: '2026-01-29T13:35:46.971Z',
							modified: null,
							status: 'ACTIVE',
							aba: null,
							holder: null,
							isReimbursement: false,
							postcode: null,
							routeCode: null,
							sortCode: null,
							state: null,
							street: null,
							swiftCode: null,
							town: null,
							country: null,
						},
						fromEntity: 2299,
						project: 318,
						toAccount: null,
						toEntity: 2980,
						user: 2026,
						withdrawalApplication: 103,
					},
				],
				value: 2617.65,
			},
			{
				source: 0,
				target: 3,
				transactions: [
					{
						amount: 1317.04,
						currency: 'USD',
						payments: [
							{
								id: 11126,
								source: null,
								amount: 1317.04,
								currency: 'USD',
								currencyReceived: null,
								metadata: {
									tax: null,
									hash: null,
									loan: 457,
									uuid: '011ecafe-c302-4f4d-9d9a-6e0f857230b0',
									amount: 1317.04,
									source: null,
									currency: 'USD',
									metadata: null,
									projectId: 318,
									toAccount: -1,
									toAddress: '0xCF878dC0e180A51bD30A5881505298B31d0Ef575',
									fromAccount: 1636,
									fromAddress: '0xF6379168Ba44cd6A7AB2E9106001Fde599a9EF08',
									transaction: 9036,
									taxEquivalent: null,
									amountReceived: null,
									blkTransaction: {
										id: null,
										status: 'STARTED',
									},
									revertedPayment: null,
									amountEquivalent: null,
									currencyReceived: null,
								},
								hash: '7263426f456bd2339e3e72c025c431c0c03a2effbbffe6df28ecf56285bb395c',
								created: '2026-02-23T23:56:07.220Z',
								modified: null,
								tax: null,
								amountEquivalent: null,
								taxEquivalent: null,
								amountReceived: null,
								reimbursed: {
									amount: null,
								},
								blkTransaction: {
									id: '0x4e1c9e1831b0ac7e4f851f24be703ece88ed1ae6bc108459b93970457f5cdd47',
									status: 'DONE',
								},
								revertedPayment: null,
								transaction: 9036,
								loan: {
									id: 457,
									idWbg: null,
									status: 'ENABLED',
									currency: 'XDR',
									amount: 38400000,
									disbursed: 730716.39,
									financier: 'IDA',
									name: 'IPF - Investment Project Financing',
									num: 'E4250',
									dateApproved: '2025-03-28T00:00:00.000Z',
									dateSigning: '2025-04-25T00:00:00.000Z',
									dateClosing: '2029-12-28T00:00:00.000Z',
									subLoanNum: null,
									created: '2026-01-29T13:35:46.971Z',
									modified: '2026-01-29T13:39:44.224Z',
									cancelled: null,
									code: 'IDAE4250',
								},
							},
						],
						tax: 0,
						total: 1317.04,
						id: 9036,
						status: 'COMPLETED',
						metadata: {
							uuid: '12d05875-1fb0-44f6-810a-f4b2c0f31c8d',
							invoiceAmount: 172125,
							invoiceCurrency: 'HTG',
						},
						traceability: {
							documents: {
								required: [1254, 1266],
								uploaded: [16972, 16973],
							},
							value: 100,
						},
						type: 'PAYMENT',
						date: '2025-12-31T00:00:00.000Z',
						created: '2026-02-23T23:56:07.199Z',
						modified: null,
						quantity: null,
						isReceived: null,
						amountReceived: null,
						benefit: null,
						category: 699,
						component: 1145,
						contract: null,
						designatedAccount: null,
						expenseType: {
							id: 2053,
							name: 'Dépenses opérationnelles',
							created: '2026-01-29T15:09:24.768Z',
							modified: '2026-01-29T16:25:03.495Z',
							status: 'ACTIVE',
							entity: null,
							project: 318,
						},
						fromAccount: {
							id: 1636,
							idWbg: '000000000010021601',
							name: 'DA-A',
							num: '111080980',
							institution: "BANQUE DE LA REPUBLIQUE D'HAITI",
							type: 'DESIGNATED',
							currency: 'USD',
							created: '2026-01-29T13:35:46.971Z',
							modified: null,
							status: 'ACTIVE',
							aba: null,
							holder: null,
							isReimbursement: false,
							postcode: null,
							routeCode: null,
							sortCode: null,
							state: null,
							street: null,
							swiftCode: null,
							town: null,
							country: null,
						},
						fromEntity: 2299,
						project: 318,
						toAccount: null,
						toEntity: 2976,
						user: 2026,
						withdrawalApplication: null,
					},
					{
						amount: 438.73,
						currency: 'USD',
						payments: [
							{
								id: 18742,
								source: null,
								amount: 438.73,
								currency: 'USD',
								currencyReceived: null,
								metadata: {
									tax: null,
									hash: null,
									loan: 457,
									uuid: '01c46e21-550a-46d5-a20c-246d8c2d1b7e',
									amount: 438.73,
									source: null,
									currency: 'USD',
									metadata: null,
									projectId: 318,
									toAccount: -1,
									toAddress: '0xCF878dC0e180A51bD30A5881505298B31d0Ef575',
									reimbursed: {
										amount: null,
									},
									fromAccount: 1636,
									fromAddress: '0xF6379168Ba44cd6A7AB2E9106001Fde599a9EF08',
									transaction: 15643,
									taxEquivalent: null,
									amountReceived: null,
									blkTransaction: {
										id: null,
										status: 'STARTED',
									},
									revertedPayment: null,
									amountEquivalent: null,
									currencyReceived: null,
								},
								hash: 'b0c38c1bb916d436aef29733d5bee98b2ffc7fc79fd98353964b5516f02f6e61',
								created: '2026-03-25T17:36:21.167Z',
								modified: null,
								tax: null,
								amountEquivalent: null,
								taxEquivalent: null,
								amountReceived: null,
								reimbursed: {
									amount: null,
								},
								blkTransaction: {
									id: '0xc404391b3249ba637393b7509c45fbdb43d41150c81410867ffb3044c265c8c5',
									status: 'DONE',
								},
								revertedPayment: null,
								transaction: 15643,
								loan: {
									id: 457,
									idWbg: null,
									status: 'ENABLED',
									currency: 'XDR',
									amount: 38400000,
									disbursed: 730716.39,
									financier: 'IDA',
									name: 'IPF - Investment Project Financing',
									num: 'E4250',
									dateApproved: '2025-03-28T00:00:00.000Z',
									dateSigning: '2025-04-25T00:00:00.000Z',
									dateClosing: '2029-12-28T00:00:00.000Z',
									subLoanNum: null,
									created: '2026-01-29T13:35:46.971Z',
									modified: '2026-01-29T13:39:44.224Z',
									cancelled: null,
									code: 'IDAE4250',
								},
							},
						],
						tax: 0,
						total: 438.73,
						id: 15643,
						status: 'COMPLETED',
						metadata: {
							uuid: '33551cf1-82e0-474d-98b5-5ca7b539a035',
							invoiceAmount: 57375,
							invoiceCurrency: 'HTG',
						},
						traceability: {
							documents: {
								required: [1254, 1266],
								uploaded: [28805, 28806],
							},
							value: 100,
						},
						type: 'PAYMENT',
						date: '2026-02-27T00:00:00.000Z',
						created: '2026-03-25T17:36:21.154Z',
						modified: '2026-05-20T09:24:49.612Z',
						quantity: null,
						isReceived: null,
						amountReceived: null,
						benefit: null,
						category: 699,
						component: 1145,
						contract: null,
						designatedAccount: null,
						expenseType: {
							id: 2053,
							name: 'Dépenses opérationnelles',
							created: '2026-01-29T15:09:24.768Z',
							modified: '2026-01-29T16:25:03.495Z',
							status: 'ACTIVE',
							entity: null,
							project: 318,
						},
						fromAccount: {
							id: 1636,
							idWbg: '000000000010021601',
							name: 'DA-A',
							num: '111080980',
							institution: "BANQUE DE LA REPUBLIQUE D'HAITI",
							type: 'DESIGNATED',
							currency: 'USD',
							created: '2026-01-29T13:35:46.971Z',
							modified: null,
							status: 'ACTIVE',
							aba: null,
							holder: null,
							isReimbursement: false,
							postcode: null,
							routeCode: null,
							sortCode: null,
							state: null,
							street: null,
							swiftCode: null,
							town: null,
							country: null,
						},
						fromEntity: 2299,
						project: 318,
						toAccount: null,
						toEntity: 2976,
						user: 2026,
						withdrawalApplication: 103,
					},
					{
						amount: 402.91,
						currency: 'USD',
						payments: [
							{
								id: 30368,
								source: null,
								amount: 402.91,
								currency: 'USD',
								currencyReceived: null,
								metadata: {
									tax: null,
									hash: null,
									loan: 457,
									uuid: 'a7b3ee17-5185-4729-877f-f25ad0e731b7',
									amount: 402.91,
									source: null,
									currency: 'USD',
									metadata: null,
									projectId: 318,
									toAccount: -1,
									toAddress: '0xCF878dC0e180A51bD30A5881505298B31d0Ef575',
									reimbursed: {
										amount: null,
									},
									fromAccount: 1636,
									fromAddress: '0xF6379168Ba44cd6A7AB2E9106001Fde599a9EF08',
									transaction: 25732,
									taxEquivalent: null,
									amountReceived: null,
									blkTransaction: {
										id: null,
										status: 'STARTED',
									},
									revertedPayment: null,
									amountEquivalent: null,
									currencyReceived: null,
								},
								hash: 'd2541dde54978b31d11a30c147755806c88495935c277490d32ba95439b767ae',
								created: '2026-05-10T15:31:21.440Z',
								modified: null,
								tax: null,
								amountEquivalent: null,
								taxEquivalent: null,
								amountReceived: null,
								reimbursed: {
									amount: null,
								},
								blkTransaction: {
									id: '0x8f4c37452fac5698e2cf978f5ca37c56ca2a36c993d46a4a7edd8f9cc1d2d1ef',
									status: 'DONE',
								},
								revertedPayment: null,
								transaction: 25732,
								loan: {
									id: 457,
									idWbg: null,
									status: 'ENABLED',
									currency: 'XDR',
									amount: 38400000,
									disbursed: 730716.39,
									financier: 'IDA',
									name: 'IPF - Investment Project Financing',
									num: 'E4250',
									dateApproved: '2025-03-28T00:00:00.000Z',
									dateSigning: '2025-04-25T00:00:00.000Z',
									dateClosing: '2029-12-28T00:00:00.000Z',
									subLoanNum: null,
									created: '2026-01-29T13:35:46.971Z',
									modified: '2026-01-29T13:39:44.224Z',
									cancelled: null,
									code: 'IDAE4250',
								},
							},
						],
						tax: 0,
						total: 402.91,
						id: 25732,
						status: 'COMPLETED',
						metadata: {
							uuid: '98e1f4b7-c272-4abd-b3ca-24721af93756',
							invoiceAmount: 52750,
							invoiceCurrency: 'HTG',
						},
						traceability: {
							documents: {
								required: [1254, 1266],
								uploaded: [53734, 53735],
							},
							value: 100,
						},
						type: 'PAYMENT',
						date: '2026-03-11T00:00:00.000Z',
						created: '2026-05-10T15:31:21.424Z',
						modified: '2026-05-20T09:24:49.007Z',
						quantity: null,
						isReceived: null,
						amountReceived: null,
						benefit: null,
						category: 699,
						component: 1145,
						contract: null,
						designatedAccount: null,
						expenseType: {
							id: 2053,
							name: 'Dépenses opérationnelles',
							created: '2026-01-29T15:09:24.768Z',
							modified: '2026-01-29T16:25:03.495Z',
							status: 'ACTIVE',
							entity: null,
							project: 318,
						},
						fromAccount: {
							id: 1636,
							idWbg: '000000000010021601',
							name: 'DA-A',
							num: '111080980',
							institution: "BANQUE DE LA REPUBLIQUE D'HAITI",
							type: 'DESIGNATED',
							currency: 'USD',
							created: '2026-01-29T13:35:46.971Z',
							modified: null,
							status: 'ACTIVE',
							aba: null,
							holder: null,
							isReimbursement: false,
							postcode: null,
							routeCode: null,
							sortCode: null,
							state: null,
							street: null,
							swiftCode: null,
							town: null,
							country: null,
						},
						fromEntity: 2299,
						project: 318,
						toAccount: null,
						toEntity: 2976,
						user: 2026,
						withdrawalApplication: 103,
					},
				],
				value: 2158.68,
			},
			{
				source: 0,
				target: 4,
				transactions: [
					{
						amount: 62479.65,
						currency: 'USD',
						payments: [
							{
								id: 11124,
								source: null,
								amount: 62479.65,
								currency: 'USD',
								currencyReceived: null,
								metadata: {
									tax: null,
									hash: null,
									loan: 457,
									uuid: '9c0e3f72-ff8a-4ca9-9d3d-5bfee199def1',
									amount: 62479.65,
									source: null,
									currency: 'USD',
									metadata: null,
									projectId: 318,
									toAccount: -1,
									toAddress: '0x4e9d128E791dd47dE57BB2014986038D67826721',
									fromAccount: 1636,
									fromAddress: '0xF6379168Ba44cd6A7AB2E9106001Fde599a9EF08',
									transaction: 9034,
									taxEquivalent: null,
									amountReceived: null,
									blkTransaction: {
										id: null,
										status: 'STARTED',
									},
									revertedPayment: null,
									amountEquivalent: null,
									currencyReceived: null,
								},
								hash: 'ec67be5d3a57192156db07240e496b69e8e6a8ba58ed3d923d8182626f171953',
								created: '2026-02-23T23:04:42.496Z',
								modified: null,
								tax: null,
								amountEquivalent: null,
								taxEquivalent: null,
								amountReceived: null,
								reimbursed: {
									amount: null,
								},
								blkTransaction: {
									id: '0x521132eef033b4f4e108447684ea4c23c58608ce3d828f6b72dc83d86c90bb1e',
									status: 'DONE',
								},
								revertedPayment: null,
								transaction: 9034,
								loan: {
									id: 457,
									idWbg: null,
									status: 'ENABLED',
									currency: 'XDR',
									amount: 38400000,
									disbursed: 730716.39,
									financier: 'IDA',
									name: 'IPF - Investment Project Financing',
									num: 'E4250',
									dateApproved: '2025-03-28T00:00:00.000Z',
									dateSigning: '2025-04-25T00:00:00.000Z',
									dateClosing: '2029-12-28T00:00:00.000Z',
									subLoanNum: null,
									created: '2026-01-29T13:35:46.971Z',
									modified: '2026-01-29T13:39:44.224Z',
									cancelled: null,
									code: 'IDAE4250',
								},
							},
						],
						tax: 0,
						total: 62479.65,
						id: 9034,
						status: 'COMPLETED',
						metadata: {
							uuid: 'cbd011e3-12a5-44ab-8dd6-7eef1ba34b95',
							invoiceAmount: 8160140.81,
							invoiceCurrency: 'HTG',
						},
						traceability: {
							documents: {
								required: [1254, 1266],
								uploaded: [16968, 16969],
							},
							value: 100,
						},
						type: 'PAYMENT',
						date: '2025-12-26T00:00:00.000Z',
						created: '2026-02-23T23:04:42.481Z',
						modified: null,
						quantity: null,
						isReceived: null,
						amountReceived: null,
						benefit: null,
						category: 699,
						component: 1145,
						contract: null,
						designatedAccount: null,
						expenseType: {
							id: 2053,
							name: 'Dépenses opérationnelles',
							created: '2026-01-29T15:09:24.768Z',
							modified: '2026-01-29T16:25:03.495Z',
							status: 'ACTIVE',
							entity: null,
							project: 318,
						},
						fromAccount: {
							id: 1636,
							idWbg: '000000000010021601',
							name: 'DA-A',
							num: '111080980',
							institution: "BANQUE DE LA REPUBLIQUE D'HAITI",
							type: 'DESIGNATED',
							currency: 'USD',
							created: '2026-01-29T13:35:46.971Z',
							modified: null,
							status: 'ACTIVE',
							aba: null,
							holder: null,
							isReimbursement: false,
							postcode: null,
							routeCode: null,
							sortCode: null,
							state: null,
							street: null,
							swiftCode: null,
							town: null,
							country: null,
						},
						fromEntity: 2299,
						project: 318,
						toAccount: null,
						toEntity: 2975,
						user: 2026,
						withdrawalApplication: null,
					},
					{
						amount: 179.65,
						currency: 'USD',
						payments: [
							{
								id: 17614,
								source: null,
								amount: 179.65,
								currency: 'USD',
								currencyReceived: null,
								metadata: {
									tax: null,
									hash: null,
									loan: 457,
									uuid: 'e3155b14-84de-4739-b332-c6cb9b30e274',
									amount: 179.65,
									source: null,
									currency: 'USD',
									metadata: null,
									projectId: 318,
									toAccount: -1,
									toAddress: '0x4e9d128E791dd47dE57BB2014986038D67826721',
									reimbursed: {
										amount: null,
									},
									fromAccount: 1636,
									fromAddress: '0xF6379168Ba44cd6A7AB2E9106001Fde599a9EF08',
									transaction: 14684,
									taxEquivalent: null,
									amountReceived: null,
									blkTransaction: {
										id: null,
										status: 'STARTED',
									},
									revertedPayment: null,
									amountEquivalent: null,
									currencyReceived: null,
								},
								hash: 'b361a7a2643a5dadf2a41059ff408159a031e566a8904cda231ffb1bc091702d',
								created: '2026-03-21T13:41:15.301Z',
								modified: null,
								tax: null,
								amountEquivalent: null,
								taxEquivalent: null,
								amountReceived: null,
								reimbursed: {
									amount: null,
								},
								blkTransaction: {
									id: '0x501a6c51d534cce4cca77153a9f368807f2a25c764241be3548cc88ba6e2f203',
									status: 'DONE',
								},
								revertedPayment: null,
								transaction: 14684,
								loan: {
									id: 457,
									idWbg: null,
									status: 'ENABLED',
									currency: 'XDR',
									amount: 38400000,
									disbursed: 730716.39,
									financier: 'IDA',
									name: 'IPF - Investment Project Financing',
									num: 'E4250',
									dateApproved: '2025-03-28T00:00:00.000Z',
									dateSigning: '2025-04-25T00:00:00.000Z',
									dateClosing: '2029-12-28T00:00:00.000Z',
									subLoanNum: null,
									created: '2026-01-29T13:35:46.971Z',
									modified: '2026-01-29T13:39:44.224Z',
									cancelled: null,
									code: 'IDAE4250',
								},
							},
						],
						tax: 0,
						total: 179.65,
						id: 14684,
						status: 'IN_PROGRESS',
						metadata: {
							uuid: '60411949-310a-434c-b676-bf5a45bf397f',
							invoiceAmount: 23490,
							invoiceCurrency: 'HTG',
						},
						traceability: {
							documents: {
								required: [1254, 1266],
								uploaded: [26480, 26481],
							},
							value: 100,
						},
						type: 'PAYMENT',
						date: '2026-02-11T00:00:00.000Z',
						created: '2026-03-21T13:41:15.286Z',
						modified: '2026-05-20T09:24:50.232Z',
						quantity: null,
						isReceived: null,
						amountReceived: null,
						benefit: null,
						category: 699,
						component: 1146,
						contract: null,
						designatedAccount: null,
						expenseType: {
							id: 2053,
							name: 'Dépenses opérationnelles',
							created: '2026-01-29T15:09:24.768Z',
							modified: '2026-01-29T16:25:03.495Z',
							status: 'ACTIVE',
							entity: null,
							project: 318,
						},
						fromAccount: {
							id: 1636,
							idWbg: '000000000010021601',
							name: 'DA-A',
							num: '111080980',
							institution: "BANQUE DE LA REPUBLIQUE D'HAITI",
							type: 'DESIGNATED',
							currency: 'USD',
							created: '2026-01-29T13:35:46.971Z',
							modified: null,
							status: 'ACTIVE',
							aba: null,
							holder: null,
							isReimbursement: false,
							postcode: null,
							routeCode: null,
							sortCode: null,
							state: null,
							street: null,
							swiftCode: null,
							town: null,
							country: null,
						},
						fromEntity: 2299,
						project: 318,
						toAccount: null,
						toEntity: 2975,
						user: 2026,
						withdrawalApplication: 103,
					},
					{
						amount: 89.82,
						currency: 'USD',
						payments: [
							{
								id: 17618,
								source: null,
								amount: 89.82,
								currency: 'USD',
								currencyReceived: null,
								metadata: {
									tax: null,
									hash: null,
									loan: 457,
									uuid: 'b8e5abc8-c4de-4d49-b380-b04eabff54c0',
									amount: 89.82,
									source: null,
									currency: 'USD',
									metadata: null,
									projectId: 318,
									toAccount: -1,
									toAddress: '0x4e9d128E791dd47dE57BB2014986038D67826721',
									reimbursed: {
										amount: null,
									},
									fromAccount: 1636,
									fromAddress: '0xF6379168Ba44cd6A7AB2E9106001Fde599a9EF08',
									transaction: 14688,
									taxEquivalent: null,
									amountReceived: null,
									blkTransaction: {
										id: null,
										status: 'STARTED',
									},
									revertedPayment: null,
									amountEquivalent: null,
									currencyReceived: null,
								},
								hash: 'ab846824a61c9c0780d9939cff962be642d77fda3a062e296e027e361f1e7bdc',
								created: '2026-03-21T13:49:16.136Z',
								modified: null,
								tax: null,
								amountEquivalent: null,
								taxEquivalent: null,
								amountReceived: null,
								reimbursed: {
									amount: null,
								},
								blkTransaction: {
									id: '0x3061612866cca72b89e26c95501e3ecf405bc3b5c434d96c3ca789e4bc99acf4',
									status: 'DONE',
								},
								revertedPayment: null,
								transaction: 14688,
								loan: {
									id: 457,
									idWbg: null,
									status: 'ENABLED',
									currency: 'XDR',
									amount: 38400000,
									disbursed: 730716.39,
									financier: 'IDA',
									name: 'IPF - Investment Project Financing',
									num: 'E4250',
									dateApproved: '2025-03-28T00:00:00.000Z',
									dateSigning: '2025-04-25T00:00:00.000Z',
									dateClosing: '2029-12-28T00:00:00.000Z',
									subLoanNum: null,
									created: '2026-01-29T13:35:46.971Z',
									modified: '2026-01-29T13:39:44.224Z',
									cancelled: null,
									code: 'IDAE4250',
								},
							},
						],
						tax: 0,
						total: 89.82,
						id: 14688,
						status: 'COMPLETED',
						metadata: {
							uuid: '0991a389-20ff-4234-aabf-09c8160d586c',
							invoiceAmount: 11745,
							invoiceCurrency: 'HTG',
						},
						traceability: {
							documents: {
								required: [1254, 1266],
								uploaded: [26486, 26487],
							},
							value: 100,
						},
						type: 'PAYMENT',
						date: '2026-02-11T00:00:00.000Z',
						created: '2026-03-21T13:49:16.124Z',
						modified: '2026-05-20T09:24:50.187Z',
						quantity: null,
						isReceived: null,
						amountReceived: null,
						benefit: null,
						category: 699,
						component: 1146,
						contract: null,
						designatedAccount: null,
						expenseType: {
							id: 2053,
							name: 'Dépenses opérationnelles',
							created: '2026-01-29T15:09:24.768Z',
							modified: '2026-01-29T16:25:03.495Z',
							status: 'ACTIVE',
							entity: null,
							project: 318,
						},
						fromAccount: {
							id: 1636,
							idWbg: '000000000010021601',
							name: 'DA-A',
							num: '111080980',
							institution: "BANQUE DE LA REPUBLIQUE D'HAITI",
							type: 'DESIGNATED',
							currency: 'USD',
							created: '2026-01-29T13:35:46.971Z',
							modified: null,
							status: 'ACTIVE',
							aba: null,
							holder: null,
							isReimbursement: false,
							postcode: null,
							routeCode: null,
							sortCode: null,
							state: null,
							street: null,
							swiftCode: null,
							town: null,
							country: null,
						},
						fromEntity: 2299,
						project: 318,
						toAccount: null,
						toEntity: 2975,
						user: 2026,
						withdrawalApplication: 103,
					},
					{
						amount: 50,
						currency: 'USD',
						payments: [
							{
								id: 30350,
								source: null,
								amount: 50,
								currency: 'USD',
								currencyReceived: null,
								metadata: {
									tax: null,
									hash: null,
									loan: 457,
									uuid: '1a70d789-0813-4339-a08c-3cab517caa24',
									amount: 50,
									source: null,
									currency: 'USD',
									metadata: null,
									projectId: 318,
									toAccount: -1,
									toAddress: '0x4e9d128E791dd47dE57BB2014986038D67826721',
									reimbursed: {
										amount: null,
									},
									fromAccount: 1636,
									fromAddress: '0xF6379168Ba44cd6A7AB2E9106001Fde599a9EF08',
									transaction: 25714,
									taxEquivalent: null,
									amountReceived: null,
									blkTransaction: {
										id: null,
										status: 'STARTED',
									},
									revertedPayment: null,
									amountEquivalent: null,
									currencyReceived: null,
								},
								hash: 'c859f79ed92ed2fe1ed20cf8cd9a90fa592ee0234ffd3815845f36076b5c8219',
								created: '2026-05-10T15:03:41.320Z',
								modified: null,
								tax: null,
								amountEquivalent: null,
								taxEquivalent: null,
								amountReceived: null,
								reimbursed: {
									amount: null,
								},
								blkTransaction: {
									id: '0x858beaca155c92acd5591bbe36f4ae6fc8c1799fe8c8204bca60439b9cbdaf1a',
									status: 'DONE',
								},
								revertedPayment: null,
								transaction: 25714,
								loan: {
									id: 457,
									idWbg: null,
									status: 'ENABLED',
									currency: 'XDR',
									amount: 38400000,
									disbursed: 730716.39,
									financier: 'IDA',
									name: 'IPF - Investment Project Financing',
									num: 'E4250',
									dateApproved: '2025-03-28T00:00:00.000Z',
									dateSigning: '2025-04-25T00:00:00.000Z',
									dateClosing: '2029-12-28T00:00:00.000Z',
									subLoanNum: null,
									created: '2026-01-29T13:35:46.971Z',
									modified: '2026-01-29T13:39:44.224Z',
									cancelled: null,
									code: 'IDAE4250',
								},
							},
						],
						tax: 0,
						total: 50,
						id: 25714,
						status: 'COMPLETED',
						metadata: {
							uuid: '3d2460ac-0a06-4241-a2a5-8241b43ea5c3',
							invoiceAmount: 50,
							invoiceCurrency: 'USD',
						},
						traceability: {
							documents: {
								required: [1254, 1266],
								uploaded: [53695, 53696],
							},
							value: 100,
						},
						type: 'PAYMENT',
						date: '2026-03-03T00:00:00.000Z',
						created: '2026-05-10T15:03:41.295Z',
						modified: '2026-05-20T09:24:49.225Z',
						quantity: null,
						isReceived: null,
						amountReceived: null,
						benefit: null,
						category: 699,
						component: 1146,
						contract: null,
						designatedAccount: null,
						expenseType: {
							id: 2053,
							name: 'Dépenses opérationnelles',
							created: '2026-01-29T15:09:24.768Z',
							modified: '2026-01-29T16:25:03.495Z',
							status: 'ACTIVE',
							entity: null,
							project: 318,
						},
						fromAccount: {
							id: 1636,
							idWbg: '000000000010021601',
							name: 'DA-A',
							num: '111080980',
							institution: "BANQUE DE LA REPUBLIQUE D'HAITI",
							type: 'DESIGNATED',
							currency: 'USD',
							created: '2026-01-29T13:35:46.971Z',
							modified: null,
							status: 'ACTIVE',
							aba: null,
							holder: null,
							isReimbursement: false,
							postcode: null,
							routeCode: null,
							sortCode: null,
							state: null,
							street: null,
							swiftCode: null,
							town: null,
							country: null,
						},
						fromEntity: 2299,
						project: 318,
						toAccount: null,
						toEntity: 2975,
						user: 2026,
						withdrawalApplication: 103,
					},
					{
						amount: 89.74,
						currency: 'USD',
						payments: [
							{
								id: 30353,
								source: null,
								amount: 89.74,
								currency: 'USD',
								currencyReceived: null,
								metadata: {
									tax: null,
									hash: null,
									loan: 457,
									uuid: '70ccad36-2a29-4a2b-97b5-b01196291e50',
									amount: 89.74,
									source: null,
									currency: 'USD',
									metadata: null,
									projectId: 318,
									toAccount: -1,
									toAddress: '0x4e9d128E791dd47dE57BB2014986038D67826721',
									reimbursed: {
										amount: null,
									},
									fromAccount: 1636,
									fromAddress: '0xF6379168Ba44cd6A7AB2E9106001Fde599a9EF08',
									transaction: 25717,
									taxEquivalent: null,
									amountReceived: null,
									blkTransaction: {
										id: null,
										status: 'STARTED',
									},
									revertedPayment: null,
									amountEquivalent: null,
									currencyReceived: null,
								},
								hash: '67aee348cf40f5f64246a313b1252b3fd9287ab040892d8d5ea3fcbbec415e98',
								created: '2026-05-10T15:07:13.354Z',
								modified: null,
								tax: null,
								amountEquivalent: null,
								taxEquivalent: null,
								amountReceived: null,
								reimbursed: {
									amount: null,
								},
								blkTransaction: {
									id: '0x32dcf06ed53b084ffc12b726a46619a665f6bf1d4dd37dd605777bd2fdaf7c30',
									status: 'DONE',
								},
								revertedPayment: null,
								transaction: 25717,
								loan: {
									id: 457,
									idWbg: null,
									status: 'ENABLED',
									currency: 'XDR',
									amount: 38400000,
									disbursed: 730716.39,
									financier: 'IDA',
									name: 'IPF - Investment Project Financing',
									num: 'E4250',
									dateApproved: '2025-03-28T00:00:00.000Z',
									dateSigning: '2025-04-25T00:00:00.000Z',
									dateClosing: '2029-12-28T00:00:00.000Z',
									subLoanNum: null,
									created: '2026-01-29T13:35:46.971Z',
									modified: '2026-01-29T13:39:44.224Z',
									cancelled: null,
									code: 'IDAE4250',
								},
							},
						],
						tax: 0,
						total: 89.74,
						id: 25717,
						status: 'COMPLETED',
						metadata: {
							uuid: '73037f61-6f65-4c5e-8061-53c82f252140',
							invoiceAmount: 11745,
							invoiceCurrency: 'HTG',
						},
						traceability: {
							documents: {
								required: [1254, 1266],
								uploaded: [53702, 53703],
							},
							value: 100,
						},
						type: 'PAYMENT',
						date: '2026-03-03T00:00:00.000Z',
						created: '2026-05-10T15:07:13.343Z',
						modified: '2026-05-20T09:24:49.191Z',
						quantity: null,
						isReceived: null,
						amountReceived: null,
						benefit: null,
						category: 699,
						component: 1146,
						contract: null,
						designatedAccount: null,
						expenseType: {
							id: 2053,
							name: 'Dépenses opérationnelles',
							created: '2026-01-29T15:09:24.768Z',
							modified: '2026-01-29T16:25:03.495Z',
							status: 'ACTIVE',
							entity: null,
							project: 318,
						},
						fromAccount: {
							id: 1636,
							idWbg: '000000000010021601',
							name: 'DA-A',
							num: '111080980',
							institution: "BANQUE DE LA REPUBLIQUE D'HAITI",
							type: 'DESIGNATED',
							currency: 'USD',
							created: '2026-01-29T13:35:46.971Z',
							modified: null,
							status: 'ACTIVE',
							aba: null,
							holder: null,
							isReimbursement: false,
							postcode: null,
							routeCode: null,
							sortCode: null,
							state: null,
							street: null,
							swiftCode: null,
							town: null,
							country: null,
						},
						fromEntity: 2299,
						project: 318,
						toAccount: null,
						toEntity: 2975,
						user: 2026,
						withdrawalApplication: 103,
					},
					{
						amount: 40.31,
						currency: 'USD',
						payments: [
							{
								id: 30364,
								source: null,
								amount: 40.31,
								currency: 'USD',
								currencyReceived: null,
								metadata: {
									tax: null,
									hash: null,
									loan: 457,
									uuid: '560f6628-6384-467d-9a70-58649f212b42',
									amount: 40.31,
									source: null,
									currency: 'USD',
									metadata: null,
									projectId: 318,
									toAccount: -1,
									toAddress: '0x4e9d128E791dd47dE57BB2014986038D67826721',
									reimbursed: {
										amount: null,
									},
									fromAccount: 1636,
									fromAddress: '0xF6379168Ba44cd6A7AB2E9106001Fde599a9EF08',
									transaction: 25728,
									taxEquivalent: null,
									amountReceived: null,
									blkTransaction: {
										id: null,
										status: 'STARTED',
									},
									revertedPayment: null,
									amountEquivalent: null,
									currencyReceived: null,
								},
								hash: '7a298848934cdcf6e8e757bb40cade171b2f0e9e198ce957dcc53bd3410a6b01',
								created: '2026-05-10T15:23:15.664Z',
								modified: null,
								tax: null,
								amountEquivalent: null,
								taxEquivalent: null,
								amountReceived: null,
								reimbursed: {
									amount: null,
								},
								blkTransaction: {
									id: '0x76fbe0044b37fa4a05d5557062512eb5c5c2305d4e52fbfa5466a750f00ddd6c',
									status: 'DONE',
								},
								revertedPayment: null,
								transaction: 25728,
								loan: {
									id: 457,
									idWbg: null,
									status: 'ENABLED',
									currency: 'XDR',
									amount: 38400000,
									disbursed: 730716.39,
									financier: 'IDA',
									name: 'IPF - Investment Project Financing',
									num: 'E4250',
									dateApproved: '2025-03-28T00:00:00.000Z',
									dateSigning: '2025-04-25T00:00:00.000Z',
									dateClosing: '2029-12-28T00:00:00.000Z',
									subLoanNum: null,
									created: '2026-01-29T13:35:46.971Z',
									modified: '2026-01-29T13:39:44.224Z',
									cancelled: null,
									code: 'IDAE4250',
								},
							},
						],
						tax: 0,
						total: 40.31,
						id: 25728,
						status: 'COMPLETED',
						metadata: {
							uuid: 'edb7e857-802f-4387-bb86-5e7c46e9c310',
							invoiceAmount: 5275,
							invoiceCurrency: 'HTG',
						},
						traceability: {
							documents: {
								required: [1254, 1266],
								uploaded: [53722, 53723],
							},
							value: 100,
						},
						type: 'PAYMENT',
						date: '2026-03-10T00:00:00.000Z',
						created: '2026-05-10T15:23:15.651Z',
						modified: '2026-05-20T09:24:49.087Z',
						quantity: null,
						isReceived: null,
						amountReceived: null,
						benefit: null,
						category: 699,
						component: 1145,
						contract: null,
						designatedAccount: null,
						expenseType: {
							id: 2053,
							name: 'Dépenses opérationnelles',
							created: '2026-01-29T15:09:24.768Z',
							modified: '2026-01-29T16:25:03.495Z',
							status: 'ACTIVE',
							entity: null,
							project: 318,
						},
						fromAccount: {
							id: 1636,
							idWbg: '000000000010021601',
							name: 'DA-A',
							num: '111080980',
							institution: "BANQUE DE LA REPUBLIQUE D'HAITI",
							type: 'DESIGNATED',
							currency: 'USD',
							created: '2026-01-29T13:35:46.971Z',
							modified: null,
							status: 'ACTIVE',
							aba: null,
							holder: null,
							isReimbursement: false,
							postcode: null,
							routeCode: null,
							sortCode: null,
							state: null,
							street: null,
							swiftCode: null,
							town: null,
							country: null,
						},
						fromEntity: 2299,
						project: 318,
						toAccount: null,
						toEntity: 2975,
						user: 2026,
						withdrawalApplication: 103,
					},
					{
						amount: 1005,
						currency: 'USD',
						payments: [
							{
								id: 30347,
								source: null,
								amount: 1005,
								currency: 'USD',
								currencyReceived: null,
								metadata: {
									tax: null,
									hash: null,
									loan: 457,
									uuid: 'a84fd0ef-bfdd-483f-b870-b56ab6d7654d',
									amount: 1005,
									source: null,
									currency: 'USD',
									metadata: null,
									projectId: 318,
									toAccount: -1,
									toAddress: '0x4e9d128E791dd47dE57BB2014986038D67826721',
									reimbursed: {
										amount: null,
									},
									fromAccount: 1636,
									fromAddress: '0xF6379168Ba44cd6A7AB2E9106001Fde599a9EF08',
									transaction: 25711,
									taxEquivalent: null,
									amountReceived: null,
									blkTransaction: {
										id: null,
										status: 'STARTED',
									},
									revertedPayment: null,
									amountEquivalent: null,
									currencyReceived: null,
								},
								hash: '40c0221065e5074c85e625ebe018689f45136728d90783278b6dbc6753916e42',
								created: '2026-05-10T14:59:22.139Z',
								modified: null,
								tax: null,
								amountEquivalent: null,
								taxEquivalent: null,
								amountReceived: null,
								reimbursed: {
									amount: null,
								},
								blkTransaction: {
									id: '0x994f611a72bdc86cdf22bd40ab0cc847e95c370e252a0bb90d83ff6fcc7bfc4d',
									status: 'DONE',
								},
								revertedPayment: null,
								transaction: 25711,
								loan: {
									id: 457,
									idWbg: null,
									status: 'ENABLED',
									currency: 'XDR',
									amount: 38400000,
									disbursed: 730716.39,
									financier: 'IDA',
									name: 'IPF - Investment Project Financing',
									num: 'E4250',
									dateApproved: '2025-03-28T00:00:00.000Z',
									dateSigning: '2025-04-25T00:00:00.000Z',
									dateClosing: '2029-12-28T00:00:00.000Z',
									subLoanNum: null,
									created: '2026-01-29T13:35:46.971Z',
									modified: '2026-01-29T13:39:44.224Z',
									cancelled: null,
									code: 'IDAE4250',
								},
							},
						],
						tax: 0,
						total: 1005,
						id: 25711,
						status: 'IN_PROGRESS',
						metadata: {
							uuid: '277dcebe-ac1b-4701-b8a7-0f42d4ca94c2',
							invoiceAmount: 1005,
							invoiceCurrency: 'USD',
						},
						traceability: {
							documents: {
								required: [1252, 1254, 1259],
								uploaded: [53689, 53690],
							},
							value: 66.66666666666666,
						},
						type: 'PAYMENT',
						date: '2026-03-03T00:00:00.000Z',
						created: '2026-05-10T14:59:22.124Z',
						modified: '2026-05-20T09:24:49.263Z',
						quantity: null,
						isReceived: null,
						amountReceived: null,
						benefit: null,
						category: 699,
						component: 1137,
						contract: null,
						designatedAccount: null,
						expenseType: {
							id: 2049,
							name: 'Travaux',
							created: '2026-01-29T15:03:07.088Z',
							modified: '2026-01-29T16:25:03.543Z',
							status: 'ACTIVE',
							entity: null,
							project: 318,
						},
						fromAccount: {
							id: 1636,
							idWbg: '000000000010021601',
							name: 'DA-A',
							num: '111080980',
							institution: "BANQUE DE LA REPUBLIQUE D'HAITI",
							type: 'DESIGNATED',
							currency: 'USD',
							created: '2026-01-29T13:35:46.971Z',
							modified: null,
							status: 'ACTIVE',
							aba: null,
							holder: null,
							isReimbursement: false,
							postcode: null,
							routeCode: null,
							sortCode: null,
							state: null,
							street: null,
							swiftCode: null,
							town: null,
							country: null,
						},
						fromEntity: 2299,
						project: 318,
						toAccount: null,
						toEntity: 2975,
						user: 2026,
						withdrawalApplication: 103,
					},
					{
						amount: 229.63,
						currency: 'USD',
						payments: [
							{
								id: 30369,
								source: null,
								amount: 229.63,
								currency: 'USD',
								currencyReceived: null,
								metadata: {
									tax: null,
									hash: null,
									loan: 457,
									uuid: '536d0dc9-3f7e-464d-936a-9e49b26b6277',
									amount: 229.63,
									source: null,
									currency: 'USD',
									metadata: null,
									projectId: 318,
									toAccount: -1,
									toAddress: '0x4e9d128E791dd47dE57BB2014986038D67826721',
									reimbursed: {
										amount: null,
									},
									fromAccount: 1636,
									fromAddress: '0xF6379168Ba44cd6A7AB2E9106001Fde599a9EF08',
									transaction: 25733,
									taxEquivalent: null,
									amountReceived: null,
									blkTransaction: {
										id: null,
										status: 'STARTED',
									},
									revertedPayment: null,
									amountEquivalent: null,
									currencyReceived: null,
								},
								hash: '874dfbb4a24c6cdde1bfe24a1043b14182abf776e0b880241e5a03a48bff0ef9',
								created: '2026-05-10T15:42:37.485Z',
								modified: null,
								tax: null,
								amountEquivalent: null,
								taxEquivalent: null,
								amountReceived: null,
								reimbursed: {
									amount: null,
								},
								blkTransaction: {
									id: '0xc28efac13fa5607797f2c102dfd5557da31baec02f7b5529918ccf09319b17a6',
									status: 'DONE',
								},
								revertedPayment: null,
								transaction: 25733,
								loan: {
									id: 457,
									idWbg: null,
									status: 'ENABLED',
									currency: 'XDR',
									amount: 38400000,
									disbursed: 730716.39,
									financier: 'IDA',
									name: 'IPF - Investment Project Financing',
									num: 'E4250',
									dateApproved: '2025-03-28T00:00:00.000Z',
									dateSigning: '2025-04-25T00:00:00.000Z',
									dateClosing: '2029-12-28T00:00:00.000Z',
									subLoanNum: null,
									created: '2026-01-29T13:35:46.971Z',
									modified: '2026-01-29T13:39:44.224Z',
									cancelled: null,
									code: 'IDAE4250',
								},
							},
						],
						tax: 0,
						total: 229.63,
						id: 25733,
						status: 'COMPLETED',
						metadata: {
							uuid: 'acf64a08-5eb2-4a4b-87a7-5f691d218aad',
							invoiceAmount: 30064.5,
							invoiceCurrency: 'HTG',
						},
						traceability: {
							documents: {
								required: [1254, 1266],
								uploaded: [53736, 53737],
							},
							value: 100,
						},
						type: 'PAYMENT',
						date: '2026-03-11T00:00:00.000Z',
						created: '2026-05-10T15:42:37.471Z',
						modified: '2026-05-20T09:24:48.978Z',
						quantity: null,
						isReceived: null,
						amountReceived: null,
						benefit: null,
						category: 699,
						component: 1139,
						contract: null,
						designatedAccount: null,
						expenseType: {
							id: 2053,
							name: 'Dépenses opérationnelles',
							created: '2026-01-29T15:09:24.768Z',
							modified: '2026-01-29T16:25:03.495Z',
							status: 'ACTIVE',
							entity: null,
							project: 318,
						},
						fromAccount: {
							id: 1636,
							idWbg: '000000000010021601',
							name: 'DA-A',
							num: '111080980',
							institution: "BANQUE DE LA REPUBLIQUE D'HAITI",
							type: 'DESIGNATED',
							currency: 'USD',
							created: '2026-01-29T13:35:46.971Z',
							modified: null,
							status: 'ACTIVE',
							aba: null,
							holder: null,
							isReimbursement: false,
							postcode: null,
							routeCode: null,
							sortCode: null,
							state: null,
							street: null,
							swiftCode: null,
							town: null,
							country: null,
						},
						fromEntity: 2299,
						project: 318,
						toAccount: null,
						toEntity: 2975,
						user: 2026,
						withdrawalApplication: 103,
					},
					{
						amount: 21259.77,
						currency: 'USD',
						payments: [
							{
								id: 30308,
								source: null,
								amount: 21259.77,
								currency: 'USD',
								currencyReceived: null,
								metadata: {
									tax: null,
									hash: null,
									loan: 457,
									uuid: '75a8e8e7-70ba-4b24-8f4e-64b695d2c617',
									amount: 21259.77,
									source: null,
									currency: 'USD',
									metadata: null,
									projectId: 318,
									toAccount: -1,
									toAddress: '0x4e9d128E791dd47dE57BB2014986038D67826721',
									reimbursed: {
										amount: null,
									},
									fromAccount: 1636,
									fromAddress: '0xF6379168Ba44cd6A7AB2E9106001Fde599a9EF08',
									transaction: 25673,
									taxEquivalent: null,
									amountReceived: null,
									blkTransaction: {
										id: null,
										status: 'STARTED',
									},
									revertedPayment: null,
									amountEquivalent: null,
									currencyReceived: null,
								},
								hash: '4555e50a2962a281d6210e19636f2156f2b98cc6ccc254b9ce3471d232dd2ecc',
								created: '2026-05-10T13:53:39.432Z',
								modified: null,
								tax: null,
								amountEquivalent: null,
								taxEquivalent: null,
								amountReceived: null,
								reimbursed: {
									amount: null,
								},
								blkTransaction: {
									id: '0xd2729a281d33b78c2e9cff0040bf1ab5b43145093b9ca7a06dc8d214ebfd4163',
									status: 'DONE',
								},
								revertedPayment: null,
								transaction: 25673,
								loan: {
									id: 457,
									idWbg: null,
									status: 'ENABLED',
									currency: 'XDR',
									amount: 38400000,
									disbursed: 730716.39,
									financier: 'IDA',
									name: 'IPF - Investment Project Financing',
									num: 'E4250',
									dateApproved: '2025-03-28T00:00:00.000Z',
									dateSigning: '2025-04-25T00:00:00.000Z',
									dateClosing: '2029-12-28T00:00:00.000Z',
									subLoanNum: null,
									created: '2026-01-29T13:35:46.971Z',
									modified: '2026-01-29T13:39:44.224Z',
									cancelled: null,
									code: 'IDAE4250',
								},
							},
						],
						tax: 0,
						total: 21259.77,
						id: 25673,
						status: 'COMPLETED',
						metadata: {
							uuid: '0c2d3e10-ae92-47d1-bbb7-ed0d2d1ba3fb',
							invoiceAmount: 2779409.81,
							invoiceCurrency: 'HTG',
						},
						traceability: {
							documents: {
								required: [1254, 1266],
								uploaded: [53628, 53629],
							},
							value: 100,
						},
						type: 'PAYMENT',
						date: '2026-03-02T00:00:00.000Z',
						created: '2026-05-10T13:53:39.420Z',
						modified: '2026-05-20T09:24:49.437Z',
						quantity: null,
						isReceived: null,
						amountReceived: null,
						benefit: null,
						category: 699,
						component: 1145,
						contract: null,
						designatedAccount: null,
						expenseType: {
							id: 2053,
							name: 'Dépenses opérationnelles',
							created: '2026-01-29T15:09:24.768Z',
							modified: '2026-01-29T16:25:03.495Z',
							status: 'ACTIVE',
							entity: null,
							project: 318,
						},
						fromAccount: {
							id: 1636,
							idWbg: '000000000010021601',
							name: 'DA-A',
							num: '111080980',
							institution: "BANQUE DE LA REPUBLIQUE D'HAITI",
							type: 'DESIGNATED',
							currency: 'USD',
							created: '2026-01-29T13:35:46.971Z',
							modified: null,
							status: 'ACTIVE',
							aba: null,
							holder: null,
							isReimbursement: false,
							postcode: null,
							routeCode: null,
							sortCode: null,
							state: null,
							street: null,
							swiftCode: null,
							town: null,
							country: null,
						},
						fromEntity: 2299,
						project: 318,
						toAccount: null,
						toEntity: 2975,
						user: 2026,
						withdrawalApplication: 103,
					},
					{
						amount: 102.49,
						currency: 'USD',
						payments: [
							{
								id: 30306,
								source: null,
								amount: 102.49,
								currency: 'USD',
								currencyReceived: null,
								metadata: {
									tax: null,
									hash: null,
									loan: 457,
									uuid: 'ceb1d0d9-80d9-486b-bbcd-f30848d81f00',
									amount: 102.49,
									source: null,
									currency: 'USD',
									metadata: null,
									projectId: 318,
									toAccount: -1,
									toAddress: '0x4e9d128E791dd47dE57BB2014986038D67826721',
									reimbursed: {
										amount: null,
									},
									fromAccount: 1636,
									fromAddress: '0xF6379168Ba44cd6A7AB2E9106001Fde599a9EF08',
									transaction: 25671,
									taxEquivalent: null,
									amountReceived: null,
									blkTransaction: {
										id: null,
										status: 'STARTED',
									},
									revertedPayment: null,
									amountEquivalent: null,
									currencyReceived: null,
								},
								hash: '5f5fc379e50ac59aa11b896ed81812b5a6946e815c8d51a982c84387e1b0479f',
								created: '2026-05-10T13:48:59.508Z',
								modified: null,
								tax: null,
								amountEquivalent: null,
								taxEquivalent: null,
								amountReceived: null,
								reimbursed: {
									amount: null,
								},
								blkTransaction: {
									id: '0xbdabffa844296da32e9132e1a75f695f500a2782a6f27af103328caba1436b8e',
									status: 'DONE',
								},
								revertedPayment: null,
								transaction: 25671,
								loan: {
									id: 457,
									idWbg: null,
									status: 'ENABLED',
									currency: 'XDR',
									amount: 38400000,
									disbursed: 730716.39,
									financier: 'IDA',
									name: 'IPF - Investment Project Financing',
									num: 'E4250',
									dateApproved: '2025-03-28T00:00:00.000Z',
									dateSigning: '2025-04-25T00:00:00.000Z',
									dateClosing: '2029-12-28T00:00:00.000Z',
									subLoanNum: null,
									created: '2026-01-29T13:35:46.971Z',
									modified: '2026-01-29T13:39:44.224Z',
									cancelled: null,
									code: 'IDAE4250',
								},
							},
						],
						tax: 0,
						total: 102.49,
						id: 25671,
						status: 'COMPLETED',
						metadata: {
							uuid: '1e7a9e0d-5e24-4ec3-b9db-1189caf30fc7',
							invoiceAmount: 13400,
							invoiceCurrency: 'HTG',
						},
						traceability: {
							documents: {
								required: [1254, 1266],
								uploaded: [53625, 53626],
							},
							value: 100,
						},
						type: 'PAYMENT',
						date: '2026-03-02T00:00:00.000Z',
						created: '2026-05-10T13:48:59.493Z',
						modified: '2026-05-20T09:24:49.461Z',
						quantity: null,
						isReceived: null,
						amountReceived: null,
						benefit: null,
						category: 699,
						component: 1149,
						contract: null,
						designatedAccount: null,
						expenseType: {
							id: 2053,
							name: 'Dépenses opérationnelles',
							created: '2026-01-29T15:09:24.768Z',
							modified: '2026-01-29T16:25:03.495Z',
							status: 'ACTIVE',
							entity: null,
							project: 318,
						},
						fromAccount: {
							id: 1636,
							idWbg: '000000000010021601',
							name: 'DA-A',
							num: '111080980',
							institution: "BANQUE DE LA REPUBLIQUE D'HAITI",
							type: 'DESIGNATED',
							currency: 'USD',
							created: '2026-01-29T13:35:46.971Z',
							modified: null,
							status: 'ACTIVE',
							aba: null,
							holder: null,
							isReimbursement: false,
							postcode: null,
							routeCode: null,
							sortCode: null,
							state: null,
							street: null,
							swiftCode: null,
							town: null,
							country: null,
						},
						fromEntity: 2299,
						project: 318,
						toAccount: null,
						toEntity: 2975,
						user: 2026,
						withdrawalApplication: 103,
					},
					{
						amount: 322.25,
						currency: 'USD',
						payments: [
							{
								id: 30303,
								source: null,
								amount: 322.25,
								currency: 'USD',
								currencyReceived: null,
								metadata: {
									tax: null,
									hash: null,
									loan: 457,
									uuid: '987d280b-cc61-47b1-a931-c207c904a75e',
									amount: 322.25,
									source: null,
									currency: 'USD',
									metadata: null,
									projectId: 318,
									toAccount: -1,
									toAddress: '0x4e9d128E791dd47dE57BB2014986038D67826721',
									reimbursed: {
										amount: null,
									},
									fromAccount: 1636,
									fromAddress: '0xF6379168Ba44cd6A7AB2E9106001Fde599a9EF08',
									transaction: 25668,
									taxEquivalent: null,
									amountReceived: null,
									blkTransaction: {
										id: null,
										status: 'STARTED',
									},
									revertedPayment: null,
									amountEquivalent: null,
									currencyReceived: null,
								},
								hash: '55e1bef80bb999ec35e170f20ec2f88f5f545f5a31910060d58d8c93c7d6800e',
								created: '2026-05-10T13:44:36.006Z',
								modified: null,
								tax: null,
								amountEquivalent: null,
								taxEquivalent: null,
								amountReceived: null,
								reimbursed: {
									amount: null,
								},
								blkTransaction: {
									id: '0x06ca96cd77c9e616ff557eaee949ffec0996d18501bb8e3960002cb350badd39',
									status: 'DONE',
								},
								revertedPayment: null,
								transaction: 25668,
								loan: {
									id: 457,
									idWbg: null,
									status: 'ENABLED',
									currency: 'XDR',
									amount: 38400000,
									disbursed: 730716.39,
									financier: 'IDA',
									name: 'IPF - Investment Project Financing',
									num: 'E4250',
									dateApproved: '2025-03-28T00:00:00.000Z',
									dateSigning: '2025-04-25T00:00:00.000Z',
									dateClosing: '2029-12-28T00:00:00.000Z',
									subLoanNum: null,
									created: '2026-01-29T13:35:46.971Z',
									modified: '2026-01-29T13:39:44.224Z',
									cancelled: null,
									code: 'IDAE4250',
								},
							},
						],
						tax: 0,
						total: 322.25,
						id: 25668,
						status: 'COMPLETED',
						metadata: {
							uuid: 'f2b1fd83-eb67-4006-bbb7-46170e58f661',
							invoiceAmount: 42129.96,
							invoiceCurrency: 'HTG',
						},
						traceability: {
							documents: {
								required: [1254, 1266],
								uploaded: [53620, 53621],
							},
							value: 100,
						},
						type: 'PAYMENT',
						date: '2026-03-02T00:00:00.000Z',
						created: '2026-05-10T13:44:35.991Z',
						modified: '2026-05-20T09:24:49.498Z',
						quantity: null,
						isReceived: null,
						amountReceived: null,
						benefit: null,
						category: 699,
						component: 1149,
						contract: null,
						designatedAccount: null,
						expenseType: {
							id: 2053,
							name: 'Dépenses opérationnelles',
							created: '2026-01-29T15:09:24.768Z',
							modified: '2026-01-29T16:25:03.495Z',
							status: 'ACTIVE',
							entity: null,
							project: 318,
						},
						fromAccount: {
							id: 1636,
							idWbg: '000000000010021601',
							name: 'DA-A',
							num: '111080980',
							institution: "BANQUE DE LA REPUBLIQUE D'HAITI",
							type: 'DESIGNATED',
							currency: 'USD',
							created: '2026-01-29T13:35:46.971Z',
							modified: null,
							status: 'ACTIVE',
							aba: null,
							holder: null,
							isReimbursement: false,
							postcode: null,
							routeCode: null,
							sortCode: null,
							state: null,
							street: null,
							swiftCode: null,
							town: null,
							country: null,
						},
						fromEntity: 2299,
						project: 318,
						toAccount: null,
						toEntity: 2975,
						user: 2026,
						withdrawalApplication: 103,
					},
					{
						amount: 428.94,
						currency: 'USD',
						payments: [
							{
								id: 30301,
								source: null,
								amount: 428.94,
								currency: 'USD',
								currencyReceived: null,
								metadata: {
									tax: null,
									hash: null,
									loan: 457,
									uuid: '17954973-e10c-4b05-81bf-7264177d82ef',
									amount: 428.94,
									source: null,
									currency: 'USD',
									metadata: null,
									projectId: 318,
									toAccount: -1,
									toAddress: '0x4e9d128E791dd47dE57BB2014986038D67826721',
									reimbursed: {
										amount: null,
									},
									fromAccount: 1636,
									fromAddress: '0xF6379168Ba44cd6A7AB2E9106001Fde599a9EF08',
									transaction: 25666,
									taxEquivalent: null,
									amountReceived: null,
									blkTransaction: {
										id: null,
										status: 'STARTED',
									},
									revertedPayment: null,
									amountEquivalent: null,
									currencyReceived: null,
								},
								hash: '8822a1cd5590046ae9e6da93ab7fa6384c1b6f85c7ea78a750997470c9991549',
								created: '2026-05-10T13:38:19.338Z',
								modified: null,
								tax: null,
								amountEquivalent: null,
								taxEquivalent: null,
								amountReceived: null,
								reimbursed: {
									amount: null,
								},
								blkTransaction: {
									id: '0x81d161c77590b54c7e56ea9b815033ddb0bcc38b2e0d01b4315ffa12e3db6393',
									status: 'DONE',
								},
								revertedPayment: null,
								transaction: 25666,
								loan: {
									id: 457,
									idWbg: null,
									status: 'ENABLED',
									currency: 'XDR',
									amount: 38400000,
									disbursed: 730716.39,
									financier: 'IDA',
									name: 'IPF - Investment Project Financing',
									num: 'E4250',
									dateApproved: '2025-03-28T00:00:00.000Z',
									dateSigning: '2025-04-25T00:00:00.000Z',
									dateClosing: '2029-12-28T00:00:00.000Z',
									subLoanNum: null,
									created: '2026-01-29T13:35:46.971Z',
									modified: '2026-01-29T13:39:44.224Z',
									cancelled: null,
									code: 'IDAE4250',
								},
							},
						],
						tax: 0,
						total: 428.94,
						id: 25666,
						status: 'COMPLETED',
						metadata: {
							uuid: '354bec8f-17e5-454e-b13f-06d15d21cf8a',
							invoiceAmount: 56078.06,
							invoiceCurrency: 'HTG',
						},
						traceability: {
							documents: {
								required: [1254, 1266],
								uploaded: [53614, 53615],
							},
							value: 100,
						},
						type: 'PAYMENT',
						date: '2026-03-02T00:00:00.000Z',
						created: '2026-05-10T13:38:19.324Z',
						modified: '2026-05-20T09:24:49.527Z',
						quantity: null,
						isReceived: null,
						amountReceived: null,
						benefit: null,
						category: 699,
						component: 1147,
						contract: null,
						designatedAccount: null,
						expenseType: {
							id: 2053,
							name: 'Dépenses opérationnelles',
							created: '2026-01-29T15:09:24.768Z',
							modified: '2026-01-29T16:25:03.495Z',
							status: 'ACTIVE',
							entity: null,
							project: 318,
						},
						fromAccount: {
							id: 1636,
							idWbg: '000000000010021601',
							name: 'DA-A',
							num: '111080980',
							institution: "BANQUE DE LA REPUBLIQUE D'HAITI",
							type: 'DESIGNATED',
							currency: 'USD',
							created: '2026-01-29T13:35:46.971Z',
							modified: null,
							status: 'ACTIVE',
							aba: null,
							holder: null,
							isReimbursement: false,
							postcode: null,
							routeCode: null,
							sortCode: null,
							state: null,
							street: null,
							swiftCode: null,
							town: null,
							country: null,
						},
						fromEntity: 2299,
						project: 318,
						toAccount: null,
						toEntity: 2975,
						user: 2026,
						withdrawalApplication: 103,
					},
					{
						amount: 43.88,
						currency: 'USD',
						payments: [
							{
								id: 30293,
								source: null,
								amount: 43.88,
								currency: 'USD',
								currencyReceived: null,
								metadata: {
									tax: null,
									hash: null,
									loan: 457,
									uuid: 'aa87531f-d148-4ab3-8be5-4704a5fdb5f4',
									amount: 43.88,
									source: null,
									currency: 'USD',
									metadata: null,
									projectId: 318,
									toAccount: -1,
									toAddress: '0x4e9d128E791dd47dE57BB2014986038D67826721',
									reimbursed: {
										amount: null,
									},
									fromAccount: 1636,
									fromAddress: '0xF6379168Ba44cd6A7AB2E9106001Fde599a9EF08',
									transaction: 25658,
									taxEquivalent: null,
									amountReceived: null,
									blkTransaction: {
										id: null,
										status: 'STARTED',
									},
									revertedPayment: null,
									amountEquivalent: null,
									currencyReceived: null,
								},
								hash: '7151a1302be637ab3257553997c4355248d9cbfb5c47266bb4ad13d3fc2dad94',
								created: '2026-05-10T13:27:54.918Z',
								modified: null,
								tax: null,
								amountEquivalent: null,
								taxEquivalent: null,
								amountReceived: null,
								reimbursed: {
									amount: null,
								},
								blkTransaction: {
									id: '0xb6afe043d15f83da888a373231721eb2aded2dbfd254dad64d8c15acd6f821f3',
									status: 'DONE',
								},
								revertedPayment: null,
								transaction: 25658,
								loan: {
									id: 457,
									idWbg: null,
									status: 'ENABLED',
									currency: 'XDR',
									amount: 38400000,
									disbursed: 730716.39,
									financier: 'IDA',
									name: 'IPF - Investment Project Financing',
									num: 'E4250',
									dateApproved: '2025-03-28T00:00:00.000Z',
									dateSigning: '2025-04-25T00:00:00.000Z',
									dateClosing: '2029-12-28T00:00:00.000Z',
									subLoanNum: null,
									created: '2026-01-29T13:35:46.971Z',
									modified: '2026-01-29T13:39:44.224Z',
									cancelled: null,
									code: 'IDAE4250',
								},
							},
						],
						tax: 0,
						total: 43.88,
						id: 25658,
						status: 'COMPLETED',
						metadata: {
							uuid: '60f0a1b4-f3a5-45ce-b09f-a96d10b4af69',
							invoiceAmount: 5737.5,
							invoiceCurrency: 'HTG',
						},
						traceability: {
							documents: {
								required: [1254, 1266],
								uploaded: [53605, 53606],
							},
							value: 100,
						},
						type: 'PAYMENT',
						date: '2026-03-02T00:00:00.000Z',
						created: '2026-05-10T13:27:54.901Z',
						modified: '2026-05-20T09:24:49.565Z',
						quantity: null,
						isReceived: null,
						amountReceived: null,
						benefit: null,
						category: 699,
						component: 1145,
						contract: null,
						designatedAccount: null,
						expenseType: {
							id: 2053,
							name: 'Dépenses opérationnelles',
							created: '2026-01-29T15:09:24.768Z',
							modified: '2026-01-29T16:25:03.495Z',
							status: 'ACTIVE',
							entity: null,
							project: 318,
						},
						fromAccount: {
							id: 1636,
							idWbg: '000000000010021601',
							name: 'DA-A',
							num: '111080980',
							institution: "BANQUE DE LA REPUBLIQUE D'HAITI",
							type: 'DESIGNATED',
							currency: 'USD',
							created: '2026-01-29T13:35:46.971Z',
							modified: null,
							status: 'ACTIVE',
							aba: null,
							holder: null,
							isReimbursement: false,
							postcode: null,
							routeCode: null,
							sortCode: null,
							state: null,
							street: null,
							swiftCode: null,
							town: null,
							country: null,
						},
						fromEntity: 2299,
						project: 318,
						toAccount: null,
						toEntity: 2975,
						user: 2026,
						withdrawalApplication: 103,
					},
					{
						amount: 21031.13,
						currency: 'USD',
						payments: [
							{
								id: 16944,
								source: null,
								amount: 21031.13,
								currency: 'USD',
								currencyReceived: null,
								metadata: {
									tax: null,
									hash: null,
									loan: 457,
									uuid: 'f6947524-0cc5-4a94-851a-b687c4f8bb7c',
									amount: 21031.13,
									source: null,
									currency: 'USD',
									metadata: null,
									projectId: 318,
									toAccount: -1,
									toAddress: '0x4e9d128E791dd47dE57BB2014986038D67826721',
									reimbursed: {
										amount: null,
									},
									fromAccount: 1636,
									fromAddress: '0xF6379168Ba44cd6A7AB2E9106001Fde599a9EF08',
									transaction: 14071,
									taxEquivalent: null,
									amountReceived: null,
									blkTransaction: {
										id: null,
										status: 'STARTED',
									},
									revertedPayment: null,
									amountEquivalent: null,
									currencyReceived: null,
								},
								hash: 'bab4019d21e331923d1f6a147f2a6fe376b7aad646c8648d8698e54c9772a124',
								created: '2026-03-16T20:51:57.140Z',
								modified: null,
								tax: null,
								amountEquivalent: null,
								taxEquivalent: null,
								amountReceived: null,
								reimbursed: {
									amount: null,
								},
								blkTransaction: {
									id: '0xf17754305d601c6d083d667842a89a39f8fbec8fb9c1c727b6b0f5a9521af9f6',
									status: 'DONE',
								},
								revertedPayment: null,
								transaction: 14071,
								loan: {
									id: 457,
									idWbg: null,
									status: 'ENABLED',
									currency: 'XDR',
									amount: 38400000,
									disbursed: 730716.39,
									financier: 'IDA',
									name: 'IPF - Investment Project Financing',
									num: 'E4250',
									dateApproved: '2025-03-28T00:00:00.000Z',
									dateSigning: '2025-04-25T00:00:00.000Z',
									dateClosing: '2029-12-28T00:00:00.000Z',
									subLoanNum: null,
									created: '2026-01-29T13:35:46.971Z',
									modified: '2026-01-29T13:39:44.224Z',
									cancelled: null,
									code: 'IDAE4250',
								},
							},
						],
						tax: 0,
						total: 21031.13,
						id: 14071,
						status: 'COMPLETED',
						metadata: {
							uuid: 'ebd30510-cb79-426f-80cd-1a3c6a3be3db',
							invoiceAmount: 2745219.53,
							invoiceCurrency: 'HTG',
						},
						traceability: {
							documents: {
								required: [1254, 1266],
								uploaded: [24808, 24809],
							},
							value: 100,
						},
						type: 'PAYMENT',
						date: '2026-01-20T00:00:00.000Z',
						created: '2026-03-16T20:51:57.125Z',
						modified: '2026-05-20T09:24:50.334Z',
						quantity: null,
						isReceived: null,
						amountReceived: null,
						benefit: null,
						category: 699,
						component: 1145,
						contract: null,
						designatedAccount: null,
						expenseType: {
							id: 2053,
							name: 'Dépenses opérationnelles',
							created: '2026-01-29T15:09:24.768Z',
							modified: '2026-01-29T16:25:03.495Z',
							status: 'ACTIVE',
							entity: null,
							project: 318,
						},
						fromAccount: {
							id: 1636,
							idWbg: '000000000010021601',
							name: 'DA-A',
							num: '111080980',
							institution: "BANQUE DE LA REPUBLIQUE D'HAITI",
							type: 'DESIGNATED',
							currency: 'USD',
							created: '2026-01-29T13:35:46.971Z',
							modified: null,
							status: 'ACTIVE',
							aba: null,
							holder: null,
							isReimbursement: false,
							postcode: null,
							routeCode: null,
							sortCode: null,
							state: null,
							street: null,
							swiftCode: null,
							town: null,
							country: null,
						},
						fromEntity: 2299,
						project: 318,
						toAccount: null,
						toEntity: 2975,
						user: 2026,
						withdrawalApplication: 103,
					},
					{
						amount: 1246.47,
						currency: 'USD',
						payments: [
							{
								id: 16733,
								source: null,
								amount: 1246.47,
								currency: 'USD',
								currencyReceived: null,
								metadata: {
									tax: null,
									hash: null,
									loan: 457,
									uuid: 'a0b0f55b-684d-4fb5-8584-ffb4de3a720a',
									amount: 1246.47,
									source: null,
									currency: 'USD',
									metadata: null,
									projectId: 318,
									toAccount: -1,
									toAddress: '0x4e9d128E791dd47dE57BB2014986038D67826721',
									fromAccount: 1636,
									fromAddress: '0xF6379168Ba44cd6A7AB2E9106001Fde599a9EF08',
									transaction: 13867,
									taxEquivalent: null,
									amountReceived: null,
									blkTransaction: {
										id: null,
										status: 'STARTED',
									},
									revertedPayment: null,
									amountEquivalent: null,
									currencyReceived: null,
								},
								hash: '9a475e4ca2aacb62a7af72719fb5951bd6bb419b095568ed69f30556b17aeb9d',
								created: '2026-03-15T23:09:36.861Z',
								modified: null,
								tax: null,
								amountEquivalent: null,
								taxEquivalent: null,
								amountReceived: null,
								reimbursed: {
									amount: null,
								},
								blkTransaction: {
									id: '0x775bd640e15dafc42e4f66eaaa8d80df254ad44c313852d3082fa1657c48918e',
									status: 'DONE',
								},
								revertedPayment: null,
								transaction: 13867,
								loan: {
									id: 457,
									idWbg: null,
									status: 'ENABLED',
									currency: 'XDR',
									amount: 38400000,
									disbursed: 730716.39,
									financier: 'IDA',
									name: 'IPF - Investment Project Financing',
									num: 'E4250',
									dateApproved: '2025-03-28T00:00:00.000Z',
									dateSigning: '2025-04-25T00:00:00.000Z',
									dateClosing: '2029-12-28T00:00:00.000Z',
									subLoanNum: null,
									created: '2026-01-29T13:35:46.971Z',
									modified: '2026-01-29T13:39:44.224Z',
									cancelled: null,
									code: 'IDAE4250',
								},
							},
						],
						tax: 0,
						total: 1246.47,
						id: 13867,
						status: 'COMPLETED',
						metadata: {
							uuid: '1349f09c-e32b-4907-afc0-5d44f325d6e7',
							invoiceAmount: 162810,
							invoiceCurrency: 'HTG',
						},
						traceability: {
							documents: {
								required: [1254, 1266],
								uploaded: [24482, 24483],
							},
							value: 100,
						},
						type: 'PAYMENT',
						date: '2026-01-16T00:00:00.000Z',
						created: '2026-03-15T23:09:36.845Z',
						modified: '2026-05-20T09:24:50.581Z',
						quantity: null,
						isReceived: null,
						amountReceived: null,
						benefit: null,
						category: 699,
						component: 1149,
						contract: null,
						designatedAccount: null,
						expenseType: {
							id: 2053,
							name: 'Dépenses opérationnelles',
							created: '2026-01-29T15:09:24.768Z',
							modified: '2026-01-29T16:25:03.495Z',
							status: 'ACTIVE',
							entity: null,
							project: 318,
						},
						fromAccount: {
							id: 1636,
							idWbg: '000000000010021601',
							name: 'DA-A',
							num: '111080980',
							institution: "BANQUE DE LA REPUBLIQUE D'HAITI",
							type: 'DESIGNATED',
							currency: 'USD',
							created: '2026-01-29T13:35:46.971Z',
							modified: null,
							status: 'ACTIVE',
							aba: null,
							holder: null,
							isReimbursement: false,
							postcode: null,
							routeCode: null,
							sortCode: null,
							state: null,
							street: null,
							swiftCode: null,
							town: null,
							country: null,
						},
						fromEntity: 2299,
						project: 318,
						toAccount: null,
						toEntity: 2975,
						user: 2026,
						withdrawalApplication: 103,
					},
				],
				value: 108598.73000000001,
			},
			{
				source: 0,
				target: 5,
				transactions: [
					{
						amount: 200,
						currency: 'USD',
						payments: [
							{
								id: 11125,
								source: null,
								amount: 200,
								currency: 'USD',
								currencyReceived: null,
								metadata: {
									tax: null,
									hash: null,
									loan: 457,
									uuid: 'c8c2bb25-3059-442d-9e22-63abd91fa537',
									amount: 200,
									source: null,
									currency: 'USD',
									metadata: null,
									projectId: 318,
									toAccount: -1,
									toAddress: '0x424bdB1Fe8E96309Af8f41Cc5effa098df0776fe',
									fromAccount: 1636,
									fromAddress: '0xF6379168Ba44cd6A7AB2E9106001Fde599a9EF08',
									transaction: 9035,
									taxEquivalent: null,
									amountReceived: null,
									blkTransaction: {
										id: null,
										status: 'STARTED',
									},
									revertedPayment: null,
									amountEquivalent: null,
									currencyReceived: null,
								},
								hash: '65e1890f3eeeed337c1e65b32b1a8f708c2ccf8baa9b7a31a27f858f6097f074',
								created: '2026-02-23T23:47:23.626Z',
								modified: null,
								tax: null,
								amountEquivalent: null,
								taxEquivalent: null,
								amountReceived: null,
								reimbursed: {
									amount: null,
								},
								blkTransaction: {
									id: '0x6a1cb64d43b6ed21d62ea041e8c87ca43220df7127a49d9a0f475a5ab85b60ac',
									status: 'DONE',
								},
								revertedPayment: null,
								transaction: 9035,
								loan: {
									id: 457,
									idWbg: null,
									status: 'ENABLED',
									currency: 'XDR',
									amount: 38400000,
									disbursed: 730716.39,
									financier: 'IDA',
									name: 'IPF - Investment Project Financing',
									num: 'E4250',
									dateApproved: '2025-03-28T00:00:00.000Z',
									dateSigning: '2025-04-25T00:00:00.000Z',
									dateClosing: '2029-12-28T00:00:00.000Z',
									subLoanNum: null,
									created: '2026-01-29T13:35:46.971Z',
									modified: '2026-01-29T13:39:44.224Z',
									cancelled: null,
									code: 'IDAE4250',
								},
							},
						],
						tax: 0,
						total: 200,
						id: 9035,
						status: 'COMPLETED',
						metadata: {
							uuid: 'f4b0032e-9f15-4b36-b32c-3015d0469c32',
							invoiceAmount: 200,
							invoiceCurrency: 'USD',
						},
						traceability: {
							documents: {
								required: [1254, 1266],
								uploaded: [16970, 16971],
							},
							value: 100,
						},
						type: 'PAYMENT',
						date: '2025-12-24T00:00:00.000Z',
						created: '2026-02-23T23:47:23.610Z',
						modified: null,
						quantity: null,
						isReceived: null,
						amountReceived: null,
						benefit: null,
						category: 699,
						component: 1149,
						contract: null,
						designatedAccount: null,
						expenseType: {
							id: 2053,
							name: 'Dépenses opérationnelles',
							created: '2026-01-29T15:09:24.768Z',
							modified: '2026-01-29T16:25:03.495Z',
							status: 'ACTIVE',
							entity: null,
							project: 318,
						},
						fromAccount: {
							id: 1636,
							idWbg: '000000000010021601',
							name: 'DA-A',
							num: '111080980',
							institution: "BANQUE DE LA REPUBLIQUE D'HAITI",
							type: 'DESIGNATED',
							currency: 'USD',
							created: '2026-01-29T13:35:46.971Z',
							modified: null,
							status: 'ACTIVE',
							aba: null,
							holder: null,
							isReimbursement: false,
							postcode: null,
							routeCode: null,
							sortCode: null,
							state: null,
							street: null,
							swiftCode: null,
							town: null,
							country: null,
						},
						fromEntity: 2299,
						project: 318,
						toAccount: null,
						toEntity: 2977,
						user: 2026,
						withdrawalApplication: null,
					},
					{
						amount: 3120.73,
						currency: 'USD',
						payments: [
							{
								id: 17655,
								source: null,
								amount: 3120.73,
								currency: 'USD',
								currencyReceived: null,
								metadata: {
									tax: null,
									hash: null,
									loan: 457,
									uuid: '25be2cfd-023c-4bcf-b091-6617c194d5a5',
									amount: 3120.73,
									source: null,
									currency: 'USD',
									metadata: null,
									projectId: 318,
									toAccount: -1,
									toAddress: '0x424bdB1Fe8E96309Af8f41Cc5effa098df0776fe',
									reimbursed: {
										amount: null,
									},
									fromAccount: 1636,
									fromAddress: '0xF6379168Ba44cd6A7AB2E9106001Fde599a9EF08',
									transaction: 14718,
									taxEquivalent: null,
									amountReceived: null,
									blkTransaction: {
										id: null,
										status: 'STARTED',
									},
									revertedPayment: null,
									amountEquivalent: null,
									currencyReceived: null,
								},
								hash: '987d06def438a6a44ab6a44af44d148143469a6e9cc02c47dd439a72e7137940',
								created: '2026-03-21T16:29:28.882Z',
								modified: null,
								tax: null,
								amountEquivalent: null,
								taxEquivalent: null,
								amountReceived: null,
								reimbursed: {
									amount: null,
								},
								blkTransaction: {
									id: '0x84b3fb178f16383137f63f8475573d2a3e677043c70ef2b812062a8afd868927',
									status: 'DONE',
								},
								revertedPayment: null,
								transaction: 14718,
								loan: {
									id: 457,
									idWbg: null,
									status: 'ENABLED',
									currency: 'XDR',
									amount: 38400000,
									disbursed: 730716.39,
									financier: 'IDA',
									name: 'IPF - Investment Project Financing',
									num: 'E4250',
									dateApproved: '2025-03-28T00:00:00.000Z',
									dateSigning: '2025-04-25T00:00:00.000Z',
									dateClosing: '2029-12-28T00:00:00.000Z',
									subLoanNum: null,
									created: '2026-01-29T13:35:46.971Z',
									modified: '2026-01-29T13:39:44.224Z',
									cancelled: null,
									code: 'IDAE4250',
								},
							},
						],
						tax: 0,
						total: 3120.73,
						id: 14718,
						status: 'COMPLETED',
						metadata: {
							uuid: '22b83179-21a3-4ddc-98ae-3d0cc25ba43f',
							invoiceAmount: 3120.73,
							invoiceCurrency: 'USD',
						},
						traceability: {
							documents: {
								required: [1254, 1266],
								uploaded: [26523, 26524],
							},
							value: 100,
						},
						type: 'PAYMENT',
						date: '2026-02-25T00:00:00.000Z',
						created: '2026-03-21T16:29:28.870Z',
						modified: '2026-05-20T09:24:49.815Z',
						quantity: null,
						isReceived: null,
						amountReceived: null,
						benefit: null,
						category: 699,
						component: 1149,
						contract: null,
						designatedAccount: null,
						expenseType: {
							id: 2053,
							name: 'Dépenses opérationnelles',
							created: '2026-01-29T15:09:24.768Z',
							modified: '2026-01-29T16:25:03.495Z',
							status: 'ACTIVE',
							entity: null,
							project: 318,
						},
						fromAccount: {
							id: 1636,
							idWbg: '000000000010021601',
							name: 'DA-A',
							num: '111080980',
							institution: "BANQUE DE LA REPUBLIQUE D'HAITI",
							type: 'DESIGNATED',
							currency: 'USD',
							created: '2026-01-29T13:35:46.971Z',
							modified: null,
							status: 'ACTIVE',
							aba: null,
							holder: null,
							isReimbursement: false,
							postcode: null,
							routeCode: null,
							sortCode: null,
							state: null,
							street: null,
							swiftCode: null,
							town: null,
							country: null,
						},
						fromEntity: 2299,
						project: 318,
						toAccount: null,
						toEntity: 2977,
						user: 2026,
						withdrawalApplication: 103,
					},
				],
				value: 3320.73,
			},
			{
				source: 0,
				target: 6,
				transactions: [
					{
						amount: 1797.38,
						currency: 'USD',
						payments: [
							{
								id: 11127,
								source: null,
								amount: 1797.38,
								currency: 'USD',
								currencyReceived: null,
								metadata: {
									tax: null,
									hash: null,
									loan: 457,
									uuid: '81492185-ebc0-4a92-82d3-2370485b3e8d',
									amount: 1797.38,
									source: null,
									currency: 'USD',
									metadata: null,
									projectId: 318,
									toAccount: -1,
									toAddress: '0xaE33a84414a8Db4Aacf4E7242F790400D19Ad6e0',
									fromAccount: 1636,
									fromAddress: '0xF6379168Ba44cd6A7AB2E9106001Fde599a9EF08',
									transaction: 9037,
									taxEquivalent: null,
									amountReceived: null,
									blkTransaction: {
										id: null,
										status: 'STARTED',
									},
									revertedPayment: null,
									amountEquivalent: null,
									currencyReceived: null,
								},
								hash: 'eaf18699e3927b026838b4cfb863dc26682de5a7751cb3969998352cd2404fb3',
								created: '2026-02-24T00:11:43.641Z',
								modified: null,
								tax: null,
								amountEquivalent: null,
								taxEquivalent: null,
								amountReceived: null,
								reimbursed: {
									amount: null,
								},
								blkTransaction: {
									id: '0x2f9acfdfe6a71ed0b0e08312c0d6241ae8bdfb504946d9cef737a9c3a14120b1',
									status: 'DONE',
								},
								revertedPayment: null,
								transaction: 9037,
								loan: {
									id: 457,
									idWbg: null,
									status: 'ENABLED',
									currency: 'XDR',
									amount: 38400000,
									disbursed: 730716.39,
									financier: 'IDA',
									name: 'IPF - Investment Project Financing',
									num: 'E4250',
									dateApproved: '2025-03-28T00:00:00.000Z',
									dateSigning: '2025-04-25T00:00:00.000Z',
									dateClosing: '2029-12-28T00:00:00.000Z',
									subLoanNum: null,
									created: '2026-01-29T13:35:46.971Z',
									modified: '2026-01-29T13:39:44.224Z',
									cancelled: null,
									code: 'IDAE4250',
								},
							},
						],
						tax: 0,
						total: 1797.38,
						id: 9037,
						status: 'COMPLETED',
						metadata: {
							uuid: 'e64e1732-9944-4d95-b7a1-a29fe95d613c',
							invoiceAmount: 234900,
							invoiceCurrency: 'HTG',
						},
						traceability: {
							documents: {
								required: [1254, 1266],
								uploaded: [16974, 16975],
							},
							value: 100,
						},
						type: 'PAYMENT',
						date: '2025-12-31T00:00:00.000Z',
						created: '2026-02-24T00:11:43.626Z',
						modified: null,
						quantity: null,
						isReceived: null,
						amountReceived: null,
						benefit: null,
						category: 699,
						component: 1138,
						contract: null,
						designatedAccount: null,
						expenseType: {
							id: 2053,
							name: 'Dépenses opérationnelles',
							created: '2026-01-29T15:09:24.768Z',
							modified: '2026-01-29T16:25:03.495Z',
							status: 'ACTIVE',
							entity: null,
							project: 318,
						},
						fromAccount: {
							id: 1636,
							idWbg: '000000000010021601',
							name: 'DA-A',
							num: '111080980',
							institution: "BANQUE DE LA REPUBLIQUE D'HAITI",
							type: 'DESIGNATED',
							currency: 'USD',
							created: '2026-01-29T13:35:46.971Z',
							modified: null,
							status: 'ACTIVE',
							aba: null,
							holder: null,
							isReimbursement: false,
							postcode: null,
							routeCode: null,
							sortCode: null,
							state: null,
							street: null,
							swiftCode: null,
							town: null,
							country: null,
						},
						fromEntity: 2299,
						project: 318,
						toAccount: null,
						toEntity: 2978,
						user: 2026,
						withdrawalApplication: null,
					},
					{
						amount: 898.64,
						currency: 'USD',
						payments: [
							{
								id: 17609,
								source: null,
								amount: 898.64,
								currency: 'USD',
								currencyReceived: null,
								metadata: {
									tax: null,
									hash: null,
									loan: 457,
									uuid: '4618aac7-b063-4cb7-808a-ad141272a206',
									amount: 898.64,
									source: null,
									currency: 'USD',
									metadata: null,
									projectId: 318,
									toAccount: -1,
									toAddress: '0xaE33a84414a8Db4Aacf4E7242F790400D19Ad6e0',
									reimbursed: {
										amount: null,
									},
									fromAccount: 1636,
									fromAddress: '0xF6379168Ba44cd6A7AB2E9106001Fde599a9EF08',
									transaction: 14679,
									taxEquivalent: null,
									amountReceived: null,
									blkTransaction: {
										id: null,
										status: 'STARTED',
									},
									revertedPayment: null,
									amountEquivalent: null,
									currencyReceived: null,
								},
								hash: 'b45854e2b5caab734bd179843490f4f35c5f22322bfa55ad39bce9cfaf15062a',
								created: '2026-03-21T13:32:35.195Z',
								modified: null,
								tax: null,
								amountEquivalent: null,
								taxEquivalent: null,
								amountReceived: null,
								reimbursed: {
									amount: null,
								},
								blkTransaction: {
									id: '0xa3aca17697c7d30b128a5898b31a8860d29125e8b19331e01f4e654114f1c25c',
									status: 'DONE',
								},
								revertedPayment: null,
								transaction: 14679,
								loan: {
									id: 457,
									idWbg: null,
									status: 'ENABLED',
									currency: 'XDR',
									amount: 38400000,
									disbursed: 730716.39,
									financier: 'IDA',
									name: 'IPF - Investment Project Financing',
									num: 'E4250',
									dateApproved: '2025-03-28T00:00:00.000Z',
									dateSigning: '2025-04-25T00:00:00.000Z',
									dateClosing: '2029-12-28T00:00:00.000Z',
									subLoanNum: null,
									created: '2026-01-29T13:35:46.971Z',
									modified: '2026-01-29T13:39:44.224Z',
									cancelled: null,
									code: 'IDAE4250',
								},
							},
						],
						tax: 0,
						total: 898.64,
						id: 14679,
						status: 'COMPLETED',
						metadata: {
							uuid: '11ba71a6-f6e0-4b3a-9537-62bb9623cbb7',
							invoiceAmount: 117450,
							invoiceCurrency: 'HTG',
						},
						traceability: {
							documents: {
								required: [1254, 1266],
								uploaded: [26475, 26476],
							},
							value: 100,
						},
						type: 'PAYMENT',
						date: '2026-02-12T00:00:00.000Z',
						created: '2026-03-21T13:32:35.180Z',
						modified: '2026-05-20T09:24:50.264Z',
						quantity: null,
						isReceived: null,
						amountReceived: null,
						benefit: null,
						category: 699,
						component: 1146,
						contract: null,
						designatedAccount: null,
						expenseType: {
							id: 2053,
							name: 'Dépenses opérationnelles',
							created: '2026-01-29T15:09:24.768Z',
							modified: '2026-01-29T16:25:03.495Z',
							status: 'ACTIVE',
							entity: null,
							project: 318,
						},
						fromAccount: {
							id: 1636,
							idWbg: '000000000010021601',
							name: 'DA-A',
							num: '111080980',
							institution: "BANQUE DE LA REPUBLIQUE D'HAITI",
							type: 'DESIGNATED',
							currency: 'USD',
							created: '2026-01-29T13:35:46.971Z',
							modified: null,
							status: 'ACTIVE',
							aba: null,
							holder: null,
							isReimbursement: false,
							postcode: null,
							routeCode: null,
							sortCode: null,
							state: null,
							street: null,
							swiftCode: null,
							town: null,
							country: null,
						},
						fromEntity: 2299,
						project: 318,
						toAccount: null,
						toEntity: 2978,
						user: 2026,
						withdrawalApplication: 103,
					},
					{
						amount: 897.94,
						currency: 'USD',
						payments: [
							{
								id: 30356,
								source: null,
								amount: 897.94,
								currency: 'USD',
								currencyReceived: null,
								metadata: {
									tax: null,
									hash: null,
									loan: 457,
									uuid: '59d632fa-665e-4d44-8380-ddf2dc558877',
									amount: 897.94,
									source: null,
									currency: 'USD',
									metadata: null,
									projectId: 318,
									toAccount: -1,
									toAddress: '0xaE33a84414a8Db4Aacf4E7242F790400D19Ad6e0',
									reimbursed: {
										amount: null,
									},
									fromAccount: 1636,
									fromAddress: '0xF6379168Ba44cd6A7AB2E9106001Fde599a9EF08',
									transaction: 25720,
									taxEquivalent: null,
									amountReceived: null,
									blkTransaction: {
										id: null,
										status: 'STARTED',
									},
									revertedPayment: null,
									amountEquivalent: null,
									currencyReceived: null,
								},
								hash: '7865421eace323d2c239cc09d7e0211b7f74042247f87acd54e0db08e024c427',
								created: '2026-05-10T15:11:16.879Z',
								modified: null,
								tax: null,
								amountEquivalent: null,
								taxEquivalent: null,
								amountReceived: null,
								reimbursed: {
									amount: null,
								},
								blkTransaction: {
									id: '0x592e690fd1faf8829863f6abb2d850ff25cc959b57bd1f8aa65a361dec28946c',
									status: 'DONE',
								},
								revertedPayment: null,
								transaction: 25720,
								loan: {
									id: 457,
									idWbg: null,
									status: 'ENABLED',
									currency: 'XDR',
									amount: 38400000,
									disbursed: 730716.39,
									financier: 'IDA',
									name: 'IPF - Investment Project Financing',
									num: 'E4250',
									dateApproved: '2025-03-28T00:00:00.000Z',
									dateSigning: '2025-04-25T00:00:00.000Z',
									dateClosing: '2029-12-28T00:00:00.000Z',
									subLoanNum: null,
									created: '2026-01-29T13:35:46.971Z',
									modified: '2026-01-29T13:39:44.224Z',
									cancelled: null,
									code: 'IDAE4250',
								},
							},
						],
						tax: 0,
						total: 897.94,
						id: 25720,
						status: 'COMPLETED',
						metadata: {
							uuid: '1371d641-f86e-4e2f-90cf-b66e091398c4',
							invoiceAmount: 117450,
							invoiceCurrency: 'HTG',
						},
						traceability: {
							documents: {
								required: [1254, 1266],
								uploaded: [53707, 53709],
							},
							value: 100,
						},
						type: 'PAYMENT',
						date: '2026-03-04T00:00:00.000Z',
						created: '2026-05-10T15:11:16.864Z',
						modified: '2026-05-20T09:24:49.157Z',
						quantity: null,
						isReceived: null,
						amountReceived: null,
						benefit: null,
						category: 699,
						component: 1146,
						contract: null,
						designatedAccount: null,
						expenseType: {
							id: 2053,
							name: 'Dépenses opérationnelles',
							created: '2026-01-29T15:09:24.768Z',
							modified: '2026-01-29T16:25:03.495Z',
							status: 'ACTIVE',
							entity: null,
							project: 318,
						},
						fromAccount: {
							id: 1636,
							idWbg: '000000000010021601',
							name: 'DA-A',
							num: '111080980',
							institution: "BANQUE DE LA REPUBLIQUE D'HAITI",
							type: 'DESIGNATED',
							currency: 'USD',
							created: '2026-01-29T13:35:46.971Z',
							modified: null,
							status: 'ACTIVE',
							aba: null,
							holder: null,
							isReimbursement: false,
							postcode: null,
							routeCode: null,
							sortCode: null,
							state: null,
							street: null,
							swiftCode: null,
							town: null,
							country: null,
						},
						fromEntity: 2299,
						project: 318,
						toAccount: null,
						toEntity: 2978,
						user: 2026,
						withdrawalApplication: 103,
					},
				],
				value: 3593.96,
			},
			{
				source: 0,
				target: 7,
				transactions: [
					{
						amount: 2934.11,
						currency: 'USD',
						payments: [
							{
								id: 11128,
								source: null,
								amount: 2934.11,
								currency: 'USD',
								currencyReceived: null,
								metadata: {
									tax: null,
									hash: null,
									loan: 457,
									uuid: '824bd271-ba5e-41d1-a88a-01b280442773',
									amount: 2934.11,
									source: null,
									currency: 'USD',
									metadata: null,
									projectId: 318,
									toAccount: -1,
									toAddress: '0x16BBae4f89bB47671D59A746A35199ea95f227aE',
									fromAccount: 1636,
									fromAddress: '0xF6379168Ba44cd6A7AB2E9106001Fde599a9EF08',
									transaction: 9038,
									taxEquivalent: null,
									amountReceived: null,
									blkTransaction: {
										id: null,
										status: 'STARTED',
									},
									revertedPayment: null,
									amountEquivalent: null,
									currencyReceived: null,
								},
								hash: 'dde8852f719f6a955a85a72055354e6655b69c24cbfdfd1fda9cd15e88723638',
								created: '2026-02-24T00:32:08.111Z',
								modified: null,
								tax: null,
								amountEquivalent: null,
								taxEquivalent: null,
								amountReceived: null,
								reimbursed: {
									amount: null,
								},
								blkTransaction: {
									id: '0xe1a39b63dfbacde84e5ed99558fd0d888735e6039957f7483b35085c4be3e01c',
									status: 'DONE',
								},
								revertedPayment: null,
								transaction: 9038,
								loan: {
									id: 457,
									idWbg: null,
									status: 'ENABLED',
									currency: 'XDR',
									amount: 38400000,
									disbursed: 730716.39,
									financier: 'IDA',
									name: 'IPF - Investment Project Financing',
									num: 'E4250',
									dateApproved: '2025-03-28T00:00:00.000Z',
									dateSigning: '2025-04-25T00:00:00.000Z',
									dateClosing: '2029-12-28T00:00:00.000Z',
									subLoanNum: null,
									created: '2026-01-29T13:35:46.971Z',
									modified: '2026-01-29T13:39:44.224Z',
									cancelled: null,
									code: 'IDAE4250',
								},
							},
						],
						tax: 0,
						total: 2934.11,
						id: 9038,
						status: 'COMPLETED',
						metadata: {
							uuid: '0f694baa-da89-47b0-ae95-b98fe65596c2',
							invoiceAmount: 348600,
							invoiceCurrency: 'HTG',
						},
						traceability: {
							documents: {
								required: [1254, 1266],
								uploaded: [16976, 16977],
							},
							value: 100,
						},
						type: 'PAYMENT',
						date: '2025-12-31T00:00:00.000Z',
						created: '2026-02-24T00:32:08.094Z',
						modified: null,
						quantity: null,
						isReceived: null,
						amountReceived: null,
						benefit: null,
						category: 699,
						component: 1146,
						contract: null,
						designatedAccount: null,
						expenseType: {
							id: 2053,
							name: 'Dépenses opérationnelles',
							created: '2026-01-29T15:09:24.768Z',
							modified: '2026-01-29T16:25:03.495Z',
							status: 'ACTIVE',
							entity: null,
							project: 318,
						},
						fromAccount: {
							id: 1636,
							idWbg: '000000000010021601',
							name: 'DA-A',
							num: '111080980',
							institution: "BANQUE DE LA REPUBLIQUE D'HAITI",
							type: 'DESIGNATED',
							currency: 'USD',
							created: '2026-01-29T13:35:46.971Z',
							modified: null,
							status: 'ACTIVE',
							aba: null,
							holder: null,
							isReimbursement: false,
							postcode: null,
							routeCode: null,
							sortCode: null,
							state: null,
							street: null,
							swiftCode: null,
							town: null,
							country: null,
						},
						fromEntity: 2299,
						project: 318,
						toAccount: null,
						toEntity: 2979,
						user: 2026,
						withdrawalApplication: null,
					},
					{
						amount: 2748.02,
						currency: 'USD',
						payments: [
							{
								id: 17656,
								source: null,
								amount: 2748.02,
								currency: 'USD',
								currencyReceived: null,
								metadata: {
									tax: null,
									hash: null,
									loan: 457,
									uuid: '63a9fdb4-396c-4bee-b416-b4b8550b43a3',
									amount: 2748.02,
									source: null,
									currency: 'USD',
									metadata: null,
									projectId: 318,
									toAccount: -1,
									toAddress: '0x16BBae4f89bB47671D59A746A35199ea95f227aE',
									reimbursed: {
										amount: null,
									},
									fromAccount: 1636,
									fromAddress: '0xF6379168Ba44cd6A7AB2E9106001Fde599a9EF08',
									transaction: 14719,
									taxEquivalent: null,
									amountReceived: null,
									blkTransaction: {
										id: null,
										status: 'STARTED',
									},
									revertedPayment: null,
									amountEquivalent: null,
									currencyReceived: null,
								},
								hash: 'd082404d7511cf0bc23f47daa7e0b41de1e61077fdf7dac580e81f5d392b4c1b',
								created: '2026-03-21T16:43:06.843Z',
								modified: null,
								tax: null,
								amountEquivalent: null,
								taxEquivalent: null,
								amountReceived: null,
								reimbursed: {
									amount: null,
								},
								blkTransaction: {
									id: '0x5045efd9dce11659e18ecda368e7dd728a16df2546cb88c7d55d9e8f071239ec',
									status: 'DONE',
								},
								revertedPayment: null,
								transaction: 14719,
								loan: {
									id: 457,
									idWbg: null,
									status: 'ENABLED',
									currency: 'XDR',
									amount: 38400000,
									disbursed: 730716.39,
									financier: 'IDA',
									name: 'IPF - Investment Project Financing',
									num: 'E4250',
									dateApproved: '2025-03-28T00:00:00.000Z',
									dateSigning: '2025-04-25T00:00:00.000Z',
									dateClosing: '2029-12-28T00:00:00.000Z',
									subLoanNum: null,
									created: '2026-01-29T13:35:46.971Z',
									modified: '2026-01-29T13:39:44.224Z',
									cancelled: null,
									code: 'IDAE4250',
								},
							},
						],
						tax: 0,
						total: 2748.02,
						id: 14719,
						status: 'COMPLETED',
						metadata: {
							uuid: '8e100aff-10cf-4553-8411-e007689096b6',
							invoiceAmount: 359370,
							invoiceCurrency: 'HTG',
						},
						traceability: {
							documents: {
								required: [1254, 1266],
								uploaded: [26525, 26526],
							},
							value: 100,
						},
						type: 'PAYMENT',
						date: '2026-02-27T00:00:00.000Z',
						created: '2026-03-21T16:43:06.829Z',
						modified: '2026-05-20T09:24:49.787Z',
						quantity: null,
						isReceived: null,
						amountReceived: null,
						benefit: null,
						category: 699,
						component: 1146,
						contract: null,
						designatedAccount: null,
						expenseType: {
							id: 2053,
							name: 'Dépenses opérationnelles',
							created: '2026-01-29T15:09:24.768Z',
							modified: '2026-01-29T16:25:03.495Z',
							status: 'ACTIVE',
							entity: null,
							project: 318,
						},
						fromAccount: {
							id: 1636,
							idWbg: '000000000010021601',
							name: 'DA-A',
							num: '111080980',
							institution: "BANQUE DE LA REPUBLIQUE D'HAITI",
							type: 'DESIGNATED',
							currency: 'USD',
							created: '2026-01-29T13:35:46.971Z',
							modified: null,
							status: 'ACTIVE',
							aba: null,
							holder: null,
							isReimbursement: false,
							postcode: null,
							routeCode: null,
							sortCode: null,
							state: null,
							street: null,
							swiftCode: null,
							town: null,
							country: null,
						},
						fromEntity: 2299,
						project: 318,
						toAccount: null,
						toEntity: 2979,
						user: 2026,
						withdrawalApplication: 103,
					},
				],
				value: 5682.13,
			},
			{
				source: 8,
				target: 0,
				transactions: [
					{
						amount: 221188.7,
						currency: 'USD',
						payments: [
							{
								id: 13532,
								source: null,
								amount: 221188.7,
								currency: 'USD',
								currencyReceived: null,
								metadata: {
									loan: 457,
									uuid: '4b1e79f5-c8eb-4cac-ad77-0cc5f5fc630e',
									amount: 221188.7,
									currency: 'USD',
									toAccount: 1636,
									toAddress: '0xF6379168Ba44cd6A7AB2E9106001Fde599a9EF08',
									fromAccount: -1,
									fromAddress: '0x0c2f45F3d0822945e787FE461C3257119B8532F1',
								},
								hash: '6a849268153bf2562f9f37ae637b8398d6e7789f228b61f50e277733b7f03552',
								created: '2026-03-03T17:34:10.089Z',
								modified: null,
								tax: null,
								amountEquivalent: null,
								taxEquivalent: null,
								amountReceived: null,
								reimbursed: {
									amount: null,
								},
								blkTransaction: {
									id: '0x70104cde9abd935661feb2fe9f5c2e262202ec2c6c0cdc315c1261daf36b66e3',
									status: 'DONE',
								},
								revertedPayment: null,
								transaction: 11204,
								loan: {
									id: 457,
									idWbg: null,
									status: 'ENABLED',
									currency: 'XDR',
									amount: 38400000,
									disbursed: 730716.39,
									financier: 'IDA',
									name: 'IPF - Investment Project Financing',
									num: 'E4250',
									dateApproved: '2025-03-28T00:00:00.000Z',
									dateSigning: '2025-04-25T00:00:00.000Z',
									dateClosing: '2029-12-28T00:00:00.000Z',
									subLoanNum: null,
									created: '2026-01-29T13:35:46.971Z',
									modified: '2026-01-29T13:39:44.224Z',
									cancelled: null,
									code: 'IDAE4250',
								},
							},
						],
						tax: 0,
						total: 221188.7,
						id: 11204,
						status: 'COMPLETED',
						metadata: null,
						traceability: {
							documents: {
								required: [],
								uploaded: [],
							},
							value: 0,
						},
						type: 'ADVANCE',
						date: '2026-03-03T17:34:08.000Z',
						created: '2026-03-03T17:34:10.089Z',
						modified: null,
						quantity: null,
						isReceived: null,
						amountReceived: null,
						benefit: null,
						category: null,
						component: null,
						contract: null,
						designatedAccount: null,
						expenseType: null,
						fromAccount: null,
						fromEntity: null,
						project: 318,
						toAccount: {
							id: 1636,
							idWbg: '000000000010021601',
							name: 'DA-A',
							num: '111080980',
							institution: "BANQUE DE LA REPUBLIQUE D'HAITI",
							type: 'DESIGNATED',
							currency: 'USD',
							created: '2026-01-29T13:35:46.971Z',
							modified: null,
							status: 'ACTIVE',
							aba: null,
							holder: null,
							isReimbursement: false,
							postcode: null,
							routeCode: null,
							sortCode: null,
							state: null,
							street: null,
							swiftCode: null,
							town: null,
							country: null,
						},
						toEntity: 2299,
						user: null,
						withdrawalApplication: null,
					},
					{
						amount: 191482.74,
						currency: 'USD',
						payments: [
							{
								id: 22835,
								source: null,
								amount: 191482.74,
								currency: 'USD',
								currencyReceived: null,
								metadata: {
									loan: 457,
									uuid: 'fe5d824c-e7e2-4c25-96c9-a6c41dfa4542',
									amount: 191482.74,
									currency: 'USD',
									toAccount: 1636,
									toAddress: '0xF6379168Ba44cd6A7AB2E9106001Fde599a9EF08',
									fromAccount: -1,
									fromAddress: '0x0c2f45F3d0822945e787FE461C3257119B8532F1',
								},
								hash: '1e954d41655ad01b974715b69ddc3c26ad939477eb1c18cf967ed84642e64f95',
								created: '2026-04-13T16:33:37.889Z',
								modified: null,
								tax: null,
								amountEquivalent: null,
								taxEquivalent: null,
								amountReceived: null,
								reimbursed: {
									amount: null,
								},
								blkTransaction: {
									id: '0xf72b5ded4e5cb572b9990cd37758591832aac7471a7bb306f78fc2a89f45ed6d',
									status: 'DONE',
								},
								revertedPayment: null,
								transaction: 18892,
								loan: {
									id: 457,
									idWbg: null,
									status: 'ENABLED',
									currency: 'XDR',
									amount: 38400000,
									disbursed: 730716.39,
									financier: 'IDA',
									name: 'IPF - Investment Project Financing',
									num: 'E4250',
									dateApproved: '2025-03-28T00:00:00.000Z',
									dateSigning: '2025-04-25T00:00:00.000Z',
									dateClosing: '2029-12-28T00:00:00.000Z',
									subLoanNum: null,
									created: '2026-01-29T13:35:46.971Z',
									modified: '2026-01-29T13:39:44.224Z',
									cancelled: null,
									code: 'IDAE4250',
								},
							},
						],
						tax: 0,
						total: 191482.74,
						id: 18892,
						status: 'COMPLETED',
						metadata: null,
						traceability: {
							documents: {
								required: [],
								uploaded: [],
							},
							value: 0,
						},
						type: 'ADVANCE',
						date: '2026-04-13T16:33:36.000Z',
						created: '2026-04-13T16:33:37.889Z',
						modified: null,
						quantity: null,
						isReceived: null,
						amountReceived: null,
						benefit: null,
						category: null,
						component: null,
						contract: null,
						designatedAccount: null,
						expenseType: null,
						fromAccount: null,
						fromEntity: null,
						project: 318,
						toAccount: {
							id: 1636,
							idWbg: '000000000010021601',
							name: 'DA-A',
							num: '111080980',
							institution: "BANQUE DE LA REPUBLIQUE D'HAITI",
							type: 'DESIGNATED',
							currency: 'USD',
							created: '2026-01-29T13:35:46.971Z',
							modified: null,
							status: 'ACTIVE',
							aba: null,
							holder: null,
							isReimbursement: false,
							postcode: null,
							routeCode: null,
							sortCode: null,
							state: null,
							street: null,
							swiftCode: null,
							town: null,
							country: null,
						},
						toEntity: 2299,
						user: null,
						withdrawalApplication: null,
					},
					{
						amount: 412551.71,
						currency: 'USD',
						payments: [
							{
								id: 41509,
								source: null,
								amount: 412551.71,
								currency: 'USD',
								currencyReceived: null,
								metadata: {
									loan: 457,
									uuid: '065e80e7-a7e0-4a06-9b18-266769824ab1',
									amount: 412551.71,
									currency: 'USD',
									toAccount: 1636,
									toAddress: '0xF6379168Ba44cd6A7AB2E9106001Fde599a9EF08',
									fromAccount: -1,
									fromAddress: '0x0c2f45F3d0822945e787FE461C3257119B8532F1',
								},
								hash: '2543ba80de8b43df1d219ac17961e7e49e6d2d3d5a22e4aeffc85d00b85e0e0a',
								created: '2026-06-02T16:33:18.910Z',
								modified: null,
								tax: null,
								amountEquivalent: null,
								taxEquivalent: null,
								amountReceived: null,
								reimbursed: {
									amount: null,
								},
								blkTransaction: {
									id: '0x5b681a47ac95f7cbc2ab5d90bd3bea28e46641cdd06deefd58b7a0d2af9dc943',
									status: 'DONE',
								},
								revertedPayment: null,
								transaction: 35348,
								loan: {
									id: 457,
									idWbg: null,
									status: 'ENABLED',
									currency: 'XDR',
									amount: 38400000,
									disbursed: 730716.39,
									financier: 'IDA',
									name: 'IPF - Investment Project Financing',
									num: 'E4250',
									dateApproved: '2025-03-28T00:00:00.000Z',
									dateSigning: '2025-04-25T00:00:00.000Z',
									dateClosing: '2029-12-28T00:00:00.000Z',
									subLoanNum: null,
									created: '2026-01-29T13:35:46.971Z',
									modified: '2026-01-29T13:39:44.224Z',
									cancelled: null,
									code: 'IDAE4250',
								},
							},
						],
						tax: 0,
						total: 412551.71,
						id: 35348,
						status: 'COMPLETED',
						metadata: null,
						traceability: {
							documents: {
								required: [],
								uploaded: [],
							},
							value: 0,
						},
						type: 'ADVANCE',
						date: '2026-06-02T16:33:17.000Z',
						created: '2026-06-02T16:33:18.910Z',
						modified: null,
						quantity: null,
						isReceived: null,
						amountReceived: null,
						benefit: null,
						category: null,
						component: null,
						contract: null,
						designatedAccount: null,
						expenseType: null,
						fromAccount: null,
						fromEntity: null,
						project: 318,
						toAccount: {
							id: 1636,
							idWbg: '000000000010021601',
							name: 'DA-A',
							num: '111080980',
							institution: "BANQUE DE LA REPUBLIQUE D'HAITI",
							type: 'DESIGNATED',
							currency: 'USD',
							created: '2026-01-29T13:35:46.971Z',
							modified: null,
							status: 'ACTIVE',
							aba: null,
							holder: null,
							isReimbursement: false,
							postcode: null,
							routeCode: null,
							sortCode: null,
							state: null,
							street: null,
							swiftCode: null,
							town: null,
							country: null,
						},
						toEntity: 2299,
						user: null,
						withdrawalApplication: null,
					},
					{
						amount: 263060.47,
						currency: 'USD',
						payments: [
							{
								id: 29318,
								source: null,
								amount: 263060.47,
								currency: 'USD',
								currencyReceived: null,
								metadata: {
									loan: 457,
									uuid: '68c10905-5d94-45a7-90ea-e43845b19894',
									amount: 263060.47,
									currency: 'USD',
									toAccount: 1636,
									toAddress: '0xF6379168Ba44cd6A7AB2E9106001Fde599a9EF08',
									fromAccount: -1,
									fromAddress: '0x0c2f45F3d0822945e787FE461C3257119B8532F1',
								},
								hash: '389b65b38ab9fbea09f94df300e2a8b6669f9d2c8d0e57efde576fa5a7d4f4ac',
								created: '2026-05-06T16:33:23.890Z',
								modified: null,
								tax: null,
								amountEquivalent: null,
								taxEquivalent: null,
								amountReceived: null,
								reimbursed: {
									amount: null,
								},
								blkTransaction: {
									id: '0x9e64a2d22be1d3ba8e168addab4c1e20daa873545b6f57b7632396885500746d',
									status: 'DONE',
								},
								revertedPayment: null,
								transaction: 24741,
								loan: {
									id: 457,
									idWbg: null,
									status: 'ENABLED',
									currency: 'XDR',
									amount: 38400000,
									disbursed: 730716.39,
									financier: 'IDA',
									name: 'IPF - Investment Project Financing',
									num: 'E4250',
									dateApproved: '2025-03-28T00:00:00.000Z',
									dateSigning: '2025-04-25T00:00:00.000Z',
									dateClosing: '2029-12-28T00:00:00.000Z',
									subLoanNum: null,
									created: '2026-01-29T13:35:46.971Z',
									modified: '2026-01-29T13:39:44.224Z',
									cancelled: null,
									code: 'IDAE4250',
								},
							},
						],
						tax: 0,
						total: 263060.47,
						id: 24741,
						status: 'COMPLETED',
						metadata: null,
						traceability: {
							documents: {
								required: [],
								uploaded: [],
							},
							value: 0,
						},
						type: 'ADVANCE',
						date: '2026-05-06T16:33:22.000Z',
						created: '2026-05-06T16:33:23.890Z',
						modified: null,
						quantity: null,
						isReceived: null,
						amountReceived: null,
						benefit: null,
						category: null,
						component: null,
						contract: null,
						designatedAccount: null,
						expenseType: null,
						fromAccount: null,
						fromEntity: null,
						project: 318,
						toAccount: {
							id: 1636,
							idWbg: '000000000010021601',
							name: 'DA-A',
							num: '111080980',
							institution: "BANQUE DE LA REPUBLIQUE D'HAITI",
							type: 'DESIGNATED',
							currency: 'USD',
							created: '2026-01-29T13:35:46.971Z',
							modified: null,
							status: 'ACTIVE',
							aba: null,
							holder: null,
							isReimbursement: false,
							postcode: null,
							routeCode: null,
							sortCode: null,
							state: null,
							street: null,
							swiftCode: null,
							town: null,
							country: null,
						},
						toEntity: 2299,
						user: null,
						withdrawalApplication: null,
					},
				],
				value: 1088283.62,
			},
			{
				source: 0,
				target: 9,
				transactions: [
					{
						amount: 405,
						currency: 'USD',
						payments: [
							{
								id: 12512,
								source: null,
								amount: 405,
								currency: 'USD',
								currencyReceived: null,
								metadata: {
									tax: null,
									hash: null,
									loan: 457,
									uuid: 'deab5a70-80d3-400a-9205-402807b81688',
									amount: 405,
									source: null,
									currency: 'USD',
									metadata: null,
									projectId: 318,
									toAccount: -1,
									toAddress: '0x10b711fBd5ee7dC1d74dAd8aE05a18A2F6D2b18b',
									fromAccount: 1636,
									fromAddress: '0xF6379168Ba44cd6A7AB2E9106001Fde599a9EF08',
									transaction: 10274,
									taxEquivalent: null,
									amountReceived: null,
									blkTransaction: {
										id: null,
										status: 'STARTED',
									},
									revertedPayment: null,
									amountEquivalent: null,
									currencyReceived: null,
								},
								hash: 'c84cf00daefa363e25335549636e1691b6bcb1b501aa5bc7fdfaf0ec54c0ab3e',
								created: '2026-02-28T01:35:30.626Z',
								modified: null,
								tax: null,
								amountEquivalent: null,
								taxEquivalent: null,
								amountReceived: null,
								reimbursed: {
									amount: null,
								},
								blkTransaction: {
									id: '0x65425bc4d3c92ec09a10461aeccbb56f12f4e9485bfde045c85dddf19bd791cd',
									status: 'DONE',
								},
								revertedPayment: null,
								transaction: 10274,
								loan: {
									id: 457,
									idWbg: null,
									status: 'ENABLED',
									currency: 'XDR',
									amount: 38400000,
									disbursed: 730716.39,
									financier: 'IDA',
									name: 'IPF - Investment Project Financing',
									num: 'E4250',
									dateApproved: '2025-03-28T00:00:00.000Z',
									dateSigning: '2025-04-25T00:00:00.000Z',
									dateClosing: '2029-12-28T00:00:00.000Z',
									subLoanNum: null,
									created: '2026-01-29T13:35:46.971Z',
									modified: '2026-01-29T13:39:44.224Z',
									cancelled: null,
									code: 'IDAE4250',
								},
							},
						],
						tax: 0,
						total: 405,
						id: 10274,
						status: 'IN_PROGRESS',
						metadata: {
							uuid: 'ce0a0d82-e200-4bfe-8d9d-f4d841e2b67e',
							invoiceAmount: 405,
							invoiceCurrency: 'USD',
						},
						traceability: {
							documents: {
								required: [1254, 1266],
								uploaded: [19033],
							},
							value: 50,
						},
						type: 'PAYMENT',
						date: '2025-12-31T00:00:00.000Z',
						created: '2026-02-28T01:35:30.610Z',
						modified: null,
						quantity: null,
						isReceived: null,
						amountReceived: null,
						benefit: null,
						category: 699,
						component: 1146,
						contract: null,
						designatedAccount: null,
						expenseType: {
							id: 2053,
							name: 'Dépenses opérationnelles',
							created: '2026-01-29T15:09:24.768Z',
							modified: '2026-01-29T16:25:03.495Z',
							status: 'ACTIVE',
							entity: null,
							project: 318,
						},
						fromAccount: {
							id: 1636,
							idWbg: '000000000010021601',
							name: 'DA-A',
							num: '111080980',
							institution: "BANQUE DE LA REPUBLIQUE D'HAITI",
							type: 'DESIGNATED',
							currency: 'USD',
							created: '2026-01-29T13:35:46.971Z',
							modified: null,
							status: 'ACTIVE',
							aba: null,
							holder: null,
							isReimbursement: false,
							postcode: null,
							routeCode: null,
							sortCode: null,
							state: null,
							street: null,
							swiftCode: null,
							town: null,
							country: null,
						},
						fromEntity: 2299,
						project: 318,
						toAccount: null,
						toEntity: 3106,
						user: 2026,
						withdrawalApplication: null,
					},
					{
						amount: 679.67,
						currency: 'USD',
						payments: [
							{
								id: 30469,
								source: null,
								amount: 679.67,
								currency: 'USD',
								currencyReceived: null,
								metadata: {
									tax: null,
									hash: null,
									loan: 457,
									uuid: '590323b6-9727-47af-837f-75f6e1c7c790',
									amount: 679.67,
									source: null,
									currency: 'USD',
									metadata: null,
									projectId: 318,
									toAccount: -1,
									toAddress: '0x10b711fBd5ee7dC1d74dAd8aE05a18A2F6D2b18b',
									reimbursed: {
										amount: null,
									},
									fromAccount: 1636,
									fromAddress: '0xF6379168Ba44cd6A7AB2E9106001Fde599a9EF08',
									transaction: 25831,
									taxEquivalent: null,
									amountReceived: null,
									blkTransaction: {
										id: null,
										status: 'STARTED',
									},
									revertedPayment: null,
									amountEquivalent: null,
									currencyReceived: null,
								},
								hash: '8d672674dd1be8637124baea59714da499b7762afc19d8bcb4e26da9a9b1dbc4',
								created: '2026-05-10T20:33:21.526Z',
								modified: null,
								tax: null,
								amountEquivalent: null,
								taxEquivalent: null,
								amountReceived: null,
								reimbursed: {
									amount: null,
								},
								blkTransaction: {
									id: '0x9c92ee06ee631244fa8713f1447a28d5707c8d6524c8057a7921bd9121b0c98c',
									status: 'DONE',
								},
								revertedPayment: null,
								transaction: 25831,
								loan: {
									id: 457,
									idWbg: null,
									status: 'ENABLED',
									currency: 'XDR',
									amount: 38400000,
									disbursed: 730716.39,
									financier: 'IDA',
									name: 'IPF - Investment Project Financing',
									num: 'E4250',
									dateApproved: '2025-03-28T00:00:00.000Z',
									dateSigning: '2025-04-25T00:00:00.000Z',
									dateClosing: '2029-12-28T00:00:00.000Z',
									subLoanNum: null,
									created: '2026-01-29T13:35:46.971Z',
									modified: '2026-01-29T13:39:44.224Z',
									cancelled: null,
									code: 'IDAE4250',
								},
							},
						],
						tax: 0,
						total: 679.67,
						id: 25831,
						status: 'IN_PROGRESS',
						metadata: {
							uuid: '1bf0ee77-dbed-4367-8753-4c0e5db8ea02',
							invoiceAmount: 679.67,
							invoiceCurrency: 'USD',
						},
						traceability: {
							documents: {
								required: [1254, 1266],
								uploaded: [53893],
							},
							value: 50,
						},
						type: 'PAYMENT',
						date: '2026-03-31T00:00:00.000Z',
						created: '2026-05-10T20:33:21.513Z',
						modified: '2026-05-20T09:24:48.306Z',
						quantity: null,
						isReceived: null,
						amountReceived: null,
						benefit: null,
						category: 699,
						component: 1146,
						contract: null,
						designatedAccount: null,
						expenseType: {
							id: 2053,
							name: 'Dépenses opérationnelles',
							created: '2026-01-29T15:09:24.768Z',
							modified: '2026-01-29T16:25:03.495Z',
							status: 'ACTIVE',
							entity: null,
							project: 318,
						},
						fromAccount: {
							id: 1636,
							idWbg: '000000000010021601',
							name: 'DA-A',
							num: '111080980',
							institution: "BANQUE DE LA REPUBLIQUE D'HAITI",
							type: 'DESIGNATED',
							currency: 'USD',
							created: '2026-01-29T13:35:46.971Z',
							modified: null,
							status: 'ACTIVE',
							aba: null,
							holder: null,
							isReimbursement: false,
							postcode: null,
							routeCode: null,
							sortCode: null,
							state: null,
							street: null,
							swiftCode: null,
							town: null,
							country: null,
						},
						fromEntity: 2299,
						project: 318,
						toAccount: null,
						toEntity: 3106,
						user: 2026,
						withdrawalApplication: 103,
					},
					{
						amount: 211,
						currency: 'USD',
						payments: [
							{
								id: 17658,
								source: null,
								amount: 211,
								currency: 'USD',
								currencyReceived: null,
								metadata: {
									tax: null,
									hash: null,
									loan: 457,
									uuid: '174dafab-9818-4f27-942f-c0ae2a9413e0',
									amount: 211,
									source: null,
									currency: 'USD',
									metadata: null,
									projectId: 318,
									toAccount: -1,
									toAddress: '0x10b711fBd5ee7dC1d74dAd8aE05a18A2F6D2b18b',
									reimbursed: {
										amount: null,
									},
									fromAccount: 1636,
									fromAddress: '0xF6379168Ba44cd6A7AB2E9106001Fde599a9EF08',
									transaction: 14721,
									taxEquivalent: null,
									amountReceived: null,
									blkTransaction: {
										id: null,
										status: 'STARTED',
									},
									revertedPayment: null,
									amountEquivalent: null,
									currencyReceived: null,
								},
								hash: '21092db54daeead98f0fa7b817a1e8782929455048bc7cedd197160a16d6cadb',
								created: '2026-03-21T17:19:09.917Z',
								modified: null,
								tax: null,
								amountEquivalent: null,
								taxEquivalent: null,
								amountReceived: null,
								reimbursed: {
									amount: null,
								},
								blkTransaction: {
									id: '0x960a1cc3c2545f7f72b85aeaae24b74783d35483e8c40a5ac2ce84e4331fb9cf',
									status: 'DONE',
								},
								revertedPayment: null,
								transaction: 14721,
								loan: {
									id: 457,
									idWbg: null,
									status: 'ENABLED',
									currency: 'XDR',
									amount: 38400000,
									disbursed: 730716.39,
									financier: 'IDA',
									name: 'IPF - Investment Project Financing',
									num: 'E4250',
									dateApproved: '2025-03-28T00:00:00.000Z',
									dateSigning: '2025-04-25T00:00:00.000Z',
									dateClosing: '2029-12-28T00:00:00.000Z',
									subLoanNum: null,
									created: '2026-01-29T13:35:46.971Z',
									modified: '2026-01-29T13:39:44.224Z',
									cancelled: null,
									code: 'IDAE4250',
								},
							},
						],
						tax: 0,
						total: 211,
						id: 14721,
						status: 'IN_PROGRESS',
						metadata: {
							uuid: 'd0e18d57-4af1-4a7d-a94e-8bf6bd587270',
							invoiceAmount: 211,
							invoiceCurrency: 'USD',
						},
						traceability: {
							documents: {
								required: [1254, 1266],
								uploaded: [26529],
							},
							value: 50,
						},
						type: 'PAYMENT',
						date: '2026-02-27T00:00:00.000Z',
						created: '2026-03-21T17:19:09.901Z',
						modified: '2026-05-20T09:24:49.713Z',
						quantity: null,
						isReceived: null,
						amountReceived: null,
						benefit: null,
						category: 699,
						component: 1146,
						contract: null,
						designatedAccount: null,
						expenseType: {
							id: 2053,
							name: 'Dépenses opérationnelles',
							created: '2026-01-29T15:09:24.768Z',
							modified: '2026-01-29T16:25:03.495Z',
							status: 'ACTIVE',
							entity: null,
							project: 318,
						},
						fromAccount: {
							id: 1636,
							idWbg: '000000000010021601',
							name: 'DA-A',
							num: '111080980',
							institution: "BANQUE DE LA REPUBLIQUE D'HAITI",
							type: 'DESIGNATED',
							currency: 'USD',
							created: '2026-01-29T13:35:46.971Z',
							modified: null,
							status: 'ACTIVE',
							aba: null,
							holder: null,
							isReimbursement: false,
							postcode: null,
							routeCode: null,
							sortCode: null,
							state: null,
							street: null,
							swiftCode: null,
							town: null,
							country: null,
						},
						fromEntity: 2299,
						project: 318,
						toAccount: null,
						toEntity: 3106,
						user: 2026,
						withdrawalApplication: 103,
					},
					{
						amount: 182,
						currency: 'USD',
						payments: [
							{
								id: 16946,
								source: null,
								amount: 182,
								currency: 'USD',
								currencyReceived: null,
								metadata: {
									tax: null,
									hash: null,
									loan: 457,
									uuid: 'b2b00f49-92eb-4083-b23c-4ef86c6ee158',
									amount: 182,
									source: null,
									currency: 'USD',
									metadata: null,
									projectId: 318,
									toAccount: -1,
									toAddress: '0x10b711fBd5ee7dC1d74dAd8aE05a18A2F6D2b18b',
									reimbursed: {
										amount: null,
									},
									fromAccount: 1636,
									fromAddress: '0xF6379168Ba44cd6A7AB2E9106001Fde599a9EF08',
									transaction: 14073,
									taxEquivalent: null,
									amountReceived: null,
									blkTransaction: {
										id: null,
										status: 'STARTED',
									},
									revertedPayment: null,
									amountEquivalent: null,
									currencyReceived: null,
								},
								hash: '249369abf25b546f68f38b1ade2d2520152bf84c3015ce3ee9bb0d2557487890',
								created: '2026-03-16T21:27:36.943Z',
								modified: null,
								tax: null,
								amountEquivalent: null,
								taxEquivalent: null,
								amountReceived: null,
								reimbursed: {
									amount: null,
								},
								blkTransaction: {
									id: '0x45aedf26c2634424f7753c498cdf29f47b3552eda5bb276ae485531c23d0f14e',
									status: 'DONE',
								},
								revertedPayment: null,
								transaction: 14073,
								loan: {
									id: 457,
									idWbg: null,
									status: 'ENABLED',
									currency: 'XDR',
									amount: 38400000,
									disbursed: 730716.39,
									financier: 'IDA',
									name: 'IPF - Investment Project Financing',
									num: 'E4250',
									dateApproved: '2025-03-28T00:00:00.000Z',
									dateSigning: '2025-04-25T00:00:00.000Z',
									dateClosing: '2029-12-28T00:00:00.000Z',
									subLoanNum: null,
									created: '2026-01-29T13:35:46.971Z',
									modified: '2026-01-29T13:39:44.224Z',
									cancelled: null,
									code: 'IDAE4250',
								},
							},
						],
						tax: 0,
						total: 182,
						id: 14073,
						status: 'IN_PROGRESS',
						metadata: {
							uuid: 'ac7cdcdf-5d73-49f6-a9c2-113868b7cf3c',
							invoiceAmount: 182,
							invoiceCurrency: 'USD',
						},
						traceability: {
							documents: {
								required: [1254, 1266],
								uploaded: [24811],
							},
							value: 50,
						},
						type: 'PAYMENT',
						date: '2026-01-23T00:00:00.000Z',
						created: '2026-03-16T21:27:36.927Z',
						modified: '2026-05-20T09:24:50.304Z',
						quantity: null,
						isReceived: null,
						amountReceived: null,
						benefit: null,
						category: 699,
						component: 1146,
						contract: null,
						designatedAccount: null,
						expenseType: {
							id: 2053,
							name: 'Dépenses opérationnelles',
							created: '2026-01-29T15:09:24.768Z',
							modified: '2026-01-29T16:25:03.495Z',
							status: 'ACTIVE',
							entity: null,
							project: 318,
						},
						fromAccount: {
							id: 1636,
							idWbg: '000000000010021601',
							name: 'DA-A',
							num: '111080980',
							institution: "BANQUE DE LA REPUBLIQUE D'HAITI",
							type: 'DESIGNATED',
							currency: 'USD',
							created: '2026-01-29T13:35:46.971Z',
							modified: null,
							status: 'ACTIVE',
							aba: null,
							holder: null,
							isReimbursement: false,
							postcode: null,
							routeCode: null,
							sortCode: null,
							state: null,
							street: null,
							swiftCode: null,
							town: null,
							country: null,
						},
						fromEntity: 2299,
						project: 318,
						toAccount: null,
						toEntity: 3106,
						user: 2026,
						withdrawalApplication: 103,
					},
				],
				value: 1477.67,
			},
			{
				source: 0,
				target: 10,
				transactions: [
					{
						amount: 1875.7,
						currency: 'USD',
						payments: [
							{
								id: 16730,
								source: null,
								amount: 1875.7,
								currency: 'USD',
								currencyReceived: null,
								metadata: {
									tax: null,
									hash: null,
									loan: 457,
									uuid: '002350fe-0de9-4591-831f-36327e6e34ad',
									amount: 1875.7,
									source: null,
									currency: 'USD',
									metadata: null,
									projectId: 318,
									toAccount: -1,
									toAddress: '0xf321Aee8618304774435176a4E14644E7f316888',
									fromAccount: 1636,
									fromAddress: '0xF6379168Ba44cd6A7AB2E9106001Fde599a9EF08',
									transaction: 13864,
									taxEquivalent: null,
									amountReceived: null,
									blkTransaction: {
										id: null,
										status: 'STARTED',
									},
									revertedPayment: null,
									amountEquivalent: null,
									currencyReceived: null,
								},
								hash: 'c1b74c2de7b8f32a05c95457fceb8e13f483a8640d8c6585e2b3f7cedd779149',
								created: '2026-03-15T22:38:16.011Z',
								modified: null,
								tax: null,
								amountEquivalent: null,
								taxEquivalent: null,
								amountReceived: null,
								reimbursed: {
									amount: null,
								},
								blkTransaction: {
									id: '0x233b4da023c94504942899a6d15dc6309247d3c57b5ac5c904bd4bf230443789',
									status: 'DONE',
								},
								revertedPayment: null,
								transaction: 13864,
								loan: {
									id: 457,
									idWbg: null,
									status: 'ENABLED',
									currency: 'XDR',
									amount: 38400000,
									disbursed: 730716.39,
									financier: 'IDA',
									name: 'IPF - Investment Project Financing',
									num: 'E4250',
									dateApproved: '2025-03-28T00:00:00.000Z',
									dateSigning: '2025-04-25T00:00:00.000Z',
									dateClosing: '2029-12-28T00:00:00.000Z',
									subLoanNum: null,
									created: '2026-01-29T13:35:46.971Z',
									modified: '2026-01-29T13:39:44.224Z',
									cancelled: null,
									code: 'IDAE4250',
								},
							},
						],
						tax: 0,
						total: 1875.7,
						id: 13864,
						status: 'COMPLETED',
						metadata: {
							uuid: 'a7dadc25-a976-4158-a1db-1230883d9bb5',
							invoiceAmount: 245000,
							invoiceCurrency: 'HTG',
						},
						traceability: {
							documents: {
								required: [1254, 1266],
								uploaded: [24477, 24478],
							},
							value: 100,
						},
						type: 'PAYMENT',
						date: '2026-01-19T00:00:00.000Z',
						created: '2026-03-15T22:38:15.996Z',
						modified: '2026-05-20T09:24:50.663Z',
						quantity: null,
						isReceived: null,
						amountReceived: null,
						benefit: null,
						category: 699,
						component: 1148,
						contract: null,
						designatedAccount: null,
						expenseType: {
							id: 2053,
							name: 'Dépenses opérationnelles',
							created: '2026-01-29T15:09:24.768Z',
							modified: '2026-01-29T16:25:03.495Z',
							status: 'ACTIVE',
							entity: null,
							project: 318,
						},
						fromAccount: {
							id: 1636,
							idWbg: '000000000010021601',
							name: 'DA-A',
							num: '111080980',
							institution: "BANQUE DE LA REPUBLIQUE D'HAITI",
							type: 'DESIGNATED',
							currency: 'USD',
							created: '2026-01-29T13:35:46.971Z',
							modified: null,
							status: 'ACTIVE',
							aba: null,
							holder: null,
							isReimbursement: false,
							postcode: null,
							routeCode: null,
							sortCode: null,
							state: null,
							street: null,
							swiftCode: null,
							town: null,
							country: null,
						},
						fromEntity: 2299,
						project: 318,
						toAccount: null,
						toEntity: 3117,
						user: 2026,
						withdrawalApplication: 103,
					},
					{
						amount: 8103.66,
						currency: 'USD',
						payments: [
							{
								id: 30408,
								source: null,
								amount: 8103.66,
								currency: 'USD',
								currencyReceived: null,
								metadata: {
									tax: null,
									hash: null,
									loan: 457,
									uuid: 'dab1bd97-d719-4fab-8339-bb59f4df0137',
									amount: 8103.66,
									source: null,
									currency: 'USD',
									metadata: null,
									projectId: 318,
									toAccount: -1,
									toAddress: '0xf321Aee8618304774435176a4E14644E7f316888',
									reimbursed: {
										amount: null,
									},
									fromAccount: 1636,
									fromAddress: '0xF6379168Ba44cd6A7AB2E9106001Fde599a9EF08',
									transaction: 25772,
									taxEquivalent: null,
									amountReceived: null,
									blkTransaction: {
										id: null,
										status: 'STARTED',
									},
									revertedPayment: null,
									amountEquivalent: null,
									currencyReceived: null,
								},
								hash: 'ea3fe2a831197746bd9c87a6aefa542e60c9207c5739ee4da19fdbad055f026b',
								created: '2026-05-10T17:11:50.199Z',
								modified: null,
								tax: null,
								amountEquivalent: null,
								taxEquivalent: null,
								amountReceived: null,
								reimbursed: {
									amount: null,
								},
								blkTransaction: {
									id: '0xaab1d3e6ecfcdaa13a4f3534ffb476abb9cfb664e6118720bab95661c6b7124c',
									status: 'DONE',
								},
								revertedPayment: null,
								transaction: 25772,
								loan: {
									id: 457,
									idWbg: null,
									status: 'ENABLED',
									currency: 'XDR',
									amount: 38400000,
									disbursed: 730716.39,
									financier: 'IDA',
									name: 'IPF - Investment Project Financing',
									num: 'E4250',
									dateApproved: '2025-03-28T00:00:00.000Z',
									dateSigning: '2025-04-25T00:00:00.000Z',
									dateClosing: '2029-12-28T00:00:00.000Z',
									subLoanNum: null,
									created: '2026-01-29T13:35:46.971Z',
									modified: '2026-01-29T13:39:44.224Z',
									cancelled: null,
									code: 'IDAE4250',
								},
							},
						],
						tax: 0,
						total: 8103.66,
						id: 25772,
						status: 'COMPLETED',
						metadata: {
							uuid: 'e04f474d-2649-472e-b756-8a5e86524ab4',
							invoiceAmount: 1060000,
							invoiceCurrency: 'HTG',
						},
						traceability: {
							documents: {
								required: [1254, 1266],
								uploaded: [53797, 53799],
							},
							value: 100,
						},
						type: 'PAYMENT',
						date: '2026-03-23T00:00:00.000Z',
						created: '2026-05-10T17:11:50.185Z',
						modified: '2026-05-20T09:24:48.698Z',
						quantity: null,
						isReceived: null,
						amountReceived: null,
						benefit: null,
						category: 699,
						component: 1139,
						contract: null,
						designatedAccount: null,
						expenseType: {
							id: 2053,
							name: 'Dépenses opérationnelles',
							created: '2026-01-29T15:09:24.768Z',
							modified: '2026-01-29T16:25:03.495Z',
							status: 'ACTIVE',
							entity: null,
							project: 318,
						},
						fromAccount: {
							id: 1636,
							idWbg: '000000000010021601',
							name: 'DA-A',
							num: '111080980',
							institution: "BANQUE DE LA REPUBLIQUE D'HAITI",
							type: 'DESIGNATED',
							currency: 'USD',
							created: '2026-01-29T13:35:46.971Z',
							modified: null,
							status: 'ACTIVE',
							aba: null,
							holder: null,
							isReimbursement: false,
							postcode: null,
							routeCode: null,
							sortCode: null,
							state: null,
							street: null,
							swiftCode: null,
							town: null,
							country: null,
						},
						fromEntity: 2299,
						project: 318,
						toAccount: null,
						toEntity: 3117,
						user: 2026,
						withdrawalApplication: 103,
					},
				],
				value: 9979.36,
			},
			{
				source: 0,
				target: 11,
				transactions: [
					{
						amount: 1107.7,
						currency: 'USD',
						payments: [
							{
								id: 16728,
								source: null,
								amount: 1107.7,
								currency: 'USD',
								currencyReceived: null,
								metadata: {
									tax: null,
									hash: null,
									loan: 457,
									uuid: 'edaf6024-3a94-461e-b9b8-039b73e5059e',
									amount: 1107.7,
									source: null,
									currency: 'USD',
									metadata: null,
									projectId: 318,
									toAccount: -1,
									toAddress: '0x08072413203829f835F3aFe3060A73D0890851D7',
									fromAccount: 1636,
									fromAddress: '0xF6379168Ba44cd6A7AB2E9106001Fde599a9EF08',
									transaction: 13862,
									taxEquivalent: null,
									amountReceived: null,
									blkTransaction: {
										id: null,
										status: 'STARTED',
									},
									revertedPayment: null,
									amountEquivalent: null,
									currencyReceived: null,
								},
								hash: '5ca52ecee20f209f22600285cc17359989d50e5f4fdca3c526e162191c1ea346',
								created: '2026-03-15T22:14:50.126Z',
								modified: null,
								tax: null,
								amountEquivalent: null,
								taxEquivalent: null,
								amountReceived: null,
								reimbursed: {
									amount: null,
								},
								blkTransaction: {
									id: '0x5ec9fed0cec0b769264a3fb73e096b7974acf6c39064cd0a2b4b9fdb11ad8a19',
									status: 'DONE',
								},
								revertedPayment: null,
								transaction: 13862,
								loan: {
									id: 457,
									idWbg: null,
									status: 'ENABLED',
									currency: 'XDR',
									amount: 38400000,
									disbursed: 730716.39,
									financier: 'IDA',
									name: 'IPF - Investment Project Financing',
									num: 'E4250',
									dateApproved: '2025-03-28T00:00:00.000Z',
									dateSigning: '2025-04-25T00:00:00.000Z',
									dateClosing: '2029-12-28T00:00:00.000Z',
									subLoanNum: null,
									created: '2026-01-29T13:35:46.971Z',
									modified: '2026-01-29T13:39:44.224Z',
									cancelled: null,
									code: 'IDAE4250',
								},
							},
						],
						tax: 0,
						total: 1107.7,
						id: 13862,
						status: 'COMPLETED',
						metadata: {
							uuid: 'f8bc83cc-39a2-430c-9af2-2d29721ea9e1',
							invoiceAmount: 1107.7,
							invoiceCurrency: 'USD',
						},
						traceability: {
							documents: {
								required: [1254, 1266],
								uploaded: [24470, 24471],
							},
							value: 100,
						},
						type: 'PAYMENT',
						date: '2026-01-19T00:00:00.000Z',
						created: '2026-03-15T22:14:50.111Z',
						modified: '2026-05-20T09:24:50.725Z',
						quantity: null,
						isReceived: null,
						amountReceived: null,
						benefit: null,
						category: 699,
						component: 1148,
						contract: null,
						designatedAccount: null,
						expenseType: {
							id: 2053,
							name: 'Dépenses opérationnelles',
							created: '2026-01-29T15:09:24.768Z',
							modified: '2026-01-29T16:25:03.495Z',
							status: 'ACTIVE',
							entity: null,
							project: 318,
						},
						fromAccount: {
							id: 1636,
							idWbg: '000000000010021601',
							name: 'DA-A',
							num: '111080980',
							institution: "BANQUE DE LA REPUBLIQUE D'HAITI",
							type: 'DESIGNATED',
							currency: 'USD',
							created: '2026-01-29T13:35:46.971Z',
							modified: null,
							status: 'ACTIVE',
							aba: null,
							holder: null,
							isReimbursement: false,
							postcode: null,
							routeCode: null,
							sortCode: null,
							state: null,
							street: null,
							swiftCode: null,
							town: null,
							country: null,
						},
						fromEntity: 2299,
						project: 318,
						toAccount: null,
						toEntity: 3118,
						user: 2026,
						withdrawalApplication: 103,
					},
					{
						amount: 1089.55,
						currency: 'USD',
						payments: [
							{
								id: 16729,
								source: null,
								amount: 1089.55,
								currency: 'USD',
								currencyReceived: null,
								metadata: {
									tax: null,
									hash: null,
									loan: 457,
									uuid: 'ee7f6c75-bf7c-4c8d-9c21-92512ddaa670',
									amount: 1089.55,
									source: null,
									currency: 'USD',
									metadata: null,
									projectId: 318,
									toAccount: -1,
									toAddress: '0x08072413203829f835F3aFe3060A73D0890851D7',
									fromAccount: 1636,
									fromAddress: '0xF6379168Ba44cd6A7AB2E9106001Fde599a9EF08',
									transaction: 13863,
									taxEquivalent: null,
									amountReceived: null,
									blkTransaction: {
										id: null,
										status: 'STARTED',
									},
									revertedPayment: null,
									amountEquivalent: null,
									currencyReceived: null,
								},
								hash: 'ae4a4acd83ce320f6a8483a01967d5e8ed83f18181a8e94e31380080806c9e82',
								created: '2026-03-15T22:20:34.474Z',
								modified: null,
								tax: null,
								amountEquivalent: null,
								taxEquivalent: null,
								amountReceived: null,
								reimbursed: {
									amount: null,
								},
								blkTransaction: {
									id: '0xbac5af7688a2f16b2954bdce16afa9d3ef8906fb07f6153fd13c77d8177644a1',
									status: 'DONE',
								},
								revertedPayment: null,
								transaction: 13863,
								loan: {
									id: 457,
									idWbg: null,
									status: 'ENABLED',
									currency: 'XDR',
									amount: 38400000,
									disbursed: 730716.39,
									financier: 'IDA',
									name: 'IPF - Investment Project Financing',
									num: 'E4250',
									dateApproved: '2025-03-28T00:00:00.000Z',
									dateSigning: '2025-04-25T00:00:00.000Z',
									dateClosing: '2029-12-28T00:00:00.000Z',
									subLoanNum: null,
									created: '2026-01-29T13:35:46.971Z',
									modified: '2026-01-29T13:39:44.224Z',
									cancelled: null,
									code: 'IDAE4250',
								},
							},
						],
						tax: 0,
						total: 1089.55,
						id: 13863,
						status: 'COMPLETED',
						metadata: {
							uuid: '99fc7bde-5112-4f58-8f74-3f0450d073df',
							invoiceAmount: 1089.55,
							invoiceCurrency: 'USD',
						},
						traceability: {
							documents: {
								required: [1254, 1266],
								uploaded: [24472, 24473],
							},
							value: 100,
						},
						type: 'PAYMENT',
						date: '2026-01-19T00:00:00.000Z',
						created: '2026-03-15T22:20:34.459Z',
						modified: '2026-05-20T09:24:50.698Z',
						quantity: null,
						isReceived: null,
						amountReceived: null,
						benefit: null,
						category: 699,
						component: 1148,
						contract: null,
						designatedAccount: null,
						expenseType: {
							id: 2053,
							name: 'Dépenses opérationnelles',
							created: '2026-01-29T15:09:24.768Z',
							modified: '2026-01-29T16:25:03.495Z',
							status: 'ACTIVE',
							entity: null,
							project: 318,
						},
						fromAccount: {
							id: 1636,
							idWbg: '000000000010021601',
							name: 'DA-A',
							num: '111080980',
							institution: "BANQUE DE LA REPUBLIQUE D'HAITI",
							type: 'DESIGNATED',
							currency: 'USD',
							created: '2026-01-29T13:35:46.971Z',
							modified: null,
							status: 'ACTIVE',
							aba: null,
							holder: null,
							isReimbursement: false,
							postcode: null,
							routeCode: null,
							sortCode: null,
							state: null,
							street: null,
							swiftCode: null,
							town: null,
							country: null,
						},
						fromEntity: 2299,
						project: 318,
						toAccount: null,
						toEntity: 3118,
						user: 2026,
						withdrawalApplication: 103,
					},
				],
				value: 2197.25,
			},
			{
				source: 0,
				target: 12,
				transactions: [
					{
						amount: 1630,
						currency: 'USD',
						payments: [
							{
								id: 16936,
								source: null,
								amount: 1630,
								currency: 'USD',
								currencyReceived: null,
								metadata: {
									tax: null,
									hash: null,
									loan: 457,
									uuid: 'bdd70613-8788-4008-bf8a-b7b148e486d6',
									amount: 1630,
									source: null,
									currency: 'USD',
									metadata: null,
									projectId: 318,
									toAccount: -1,
									toAddress: '0x88fc29Ca7A39F1A5cF3350A92FB18b6c5A7Be56a',
									fromAccount: 1636,
									fromAddress: '0xF6379168Ba44cd6A7AB2E9106001Fde599a9EF08',
									transaction: 14063,
									taxEquivalent: null,
									amountReceived: null,
									blkTransaction: {
										id: null,
										status: 'STARTED',
									},
									revertedPayment: null,
									amountEquivalent: null,
									amountReimbursed: null,
									currencyReceived: null,
								},
								hash: '78bfd4510a404df8e5cd5940bf34a8fb0280f6481336be600d724cc5247457f6',
								created: '2026-03-16T20:12:23.586Z',
								modified: null,
								tax: null,
								amountEquivalent: null,
								taxEquivalent: null,
								amountReceived: null,
								reimbursed: {
									amount: null,
								},
								blkTransaction: {
									id: '0x294e2ec8450bfa4179831f16d27608257ff22004e24b965a0914538029f15a21',
									status: 'DONE',
								},
								revertedPayment: null,
								transaction: 14063,
								loan: {
									id: 457,
									idWbg: null,
									status: 'ENABLED',
									currency: 'XDR',
									amount: 38400000,
									disbursed: 730716.39,
									financier: 'IDA',
									name: 'IPF - Investment Project Financing',
									num: 'E4250',
									dateApproved: '2025-03-28T00:00:00.000Z',
									dateSigning: '2025-04-25T00:00:00.000Z',
									dateClosing: '2029-12-28T00:00:00.000Z',
									subLoanNum: null,
									created: '2026-01-29T13:35:46.971Z',
									modified: '2026-01-29T13:39:44.224Z',
									cancelled: null,
									code: 'IDAE4250',
								},
							},
						],
						tax: 0,
						total: 1630,
						id: 14063,
						status: 'COMPLETED',
						metadata: {
							uuid: '89dc03e4-7ca5-4c20-a9cb-a88afc1e2de2',
							invoiceAmount: 1630,
							invoiceCurrency: 'USD',
						},
						traceability: {
							documents: {
								required: [1254, 1266],
								uploaded: [24790, 24791],
							},
							value: 100,
						},
						type: 'PAYMENT',
						date: '2026-01-26T00:00:00.000Z',
						created: '2026-03-16T20:12:23.572Z',
						modified: '2026-05-20T09:24:50.493Z',
						quantity: null,
						isReceived: null,
						amountReceived: null,
						benefit: null,
						category: 699,
						component: 1146,
						contract: null,
						designatedAccount: null,
						expenseType: {
							id: 2053,
							name: 'Dépenses opérationnelles',
							created: '2026-01-29T15:09:24.768Z',
							modified: '2026-01-29T16:25:03.495Z',
							status: 'ACTIVE',
							entity: null,
							project: 318,
						},
						fromAccount: {
							id: 1636,
							idWbg: '000000000010021601',
							name: 'DA-A',
							num: '111080980',
							institution: "BANQUE DE LA REPUBLIQUE D'HAITI",
							type: 'DESIGNATED',
							currency: 'USD',
							created: '2026-01-29T13:35:46.971Z',
							modified: null,
							status: 'ACTIVE',
							aba: null,
							holder: null,
							isReimbursement: false,
							postcode: null,
							routeCode: null,
							sortCode: null,
							state: null,
							street: null,
							swiftCode: null,
							town: null,
							country: null,
						},
						fromEntity: 2299,
						project: 318,
						toAccount: null,
						toEntity: 3123,
						user: 2026,
						withdrawalApplication: 103,
					},
					{
						amount: 1350,
						currency: 'USD',
						payments: [
							{
								id: 16937,
								source: null,
								amount: 1350,
								currency: 'USD',
								currencyReceived: null,
								metadata: {
									tax: null,
									hash: null,
									loan: 457,
									uuid: 'b4443c62-0116-4dd7-a797-a05477a9ea08',
									amount: 1350,
									source: null,
									currency: 'USD',
									metadata: null,
									projectId: 318,
									toAccount: -1,
									toAddress: '0x88fc29Ca7A39F1A5cF3350A92FB18b6c5A7Be56a',
									reimbursed: {
										amount: null,
									},
									fromAccount: 1636,
									fromAddress: '0xF6379168Ba44cd6A7AB2E9106001Fde599a9EF08',
									transaction: 14064,
									taxEquivalent: null,
									amountReceived: null,
									blkTransaction: {
										id: null,
										status: 'STARTED',
									},
									revertedPayment: null,
									amountEquivalent: null,
									currencyReceived: null,
								},
								hash: '31e76b67c8cbfe37d6a0ad8d4fe6a6bf694652b7a45ea44322e43f81c6195e0f',
								created: '2026-03-16T20:15:51.856Z',
								modified: null,
								tax: null,
								amountEquivalent: null,
								taxEquivalent: null,
								amountReceived: null,
								reimbursed: {
									amount: null,
								},
								blkTransaction: {
									id: '0x9057bf8c5cc82339b7f11f4a84e915925d4d0087aba44b97f51512ed055823ab',
									status: 'DONE',
								},
								revertedPayment: null,
								transaction: 14064,
								loan: {
									id: 457,
									idWbg: null,
									status: 'ENABLED',
									currency: 'XDR',
									amount: 38400000,
									disbursed: 730716.39,
									financier: 'IDA',
									name: 'IPF - Investment Project Financing',
									num: 'E4250',
									dateApproved: '2025-03-28T00:00:00.000Z',
									dateSigning: '2025-04-25T00:00:00.000Z',
									dateClosing: '2029-12-28T00:00:00.000Z',
									subLoanNum: null,
									created: '2026-01-29T13:35:46.971Z',
									modified: '2026-01-29T13:39:44.224Z',
									cancelled: null,
									code: 'IDAE4250',
								},
							},
						],
						tax: 0,
						total: 1350,
						id: 14064,
						status: 'COMPLETED',
						metadata: {
							uuid: '0da7f8a9-867a-4f9b-95f2-6e3da98864ac',
							invoiceAmount: 1350,
							invoiceCurrency: 'USD',
						},
						traceability: {
							documents: {
								required: [1254, 1266],
								uploaded: [24794, 24795],
							},
							value: 100,
						},
						type: 'PAYMENT',
						date: '2026-01-26T00:00:00.000Z',
						created: '2026-03-16T20:15:51.843Z',
						modified: '2026-05-20T09:24:50.472Z',
						quantity: null,
						isReceived: null,
						amountReceived: null,
						benefit: null,
						category: 699,
						component: 1146,
						contract: null,
						designatedAccount: null,
						expenseType: {
							id: 2053,
							name: 'Dépenses opérationnelles',
							created: '2026-01-29T15:09:24.768Z',
							modified: '2026-01-29T16:25:03.495Z',
							status: 'ACTIVE',
							entity: null,
							project: 318,
						},
						fromAccount: {
							id: 1636,
							idWbg: '000000000010021601',
							name: 'DA-A',
							num: '111080980',
							institution: "BANQUE DE LA REPUBLIQUE D'HAITI",
							type: 'DESIGNATED',
							currency: 'USD',
							created: '2026-01-29T13:35:46.971Z',
							modified: null,
							status: 'ACTIVE',
							aba: null,
							holder: null,
							isReimbursement: false,
							postcode: null,
							routeCode: null,
							sortCode: null,
							state: null,
							street: null,
							swiftCode: null,
							town: null,
							country: null,
						},
						fromEntity: 2299,
						project: 318,
						toAccount: null,
						toEntity: 3123,
						user: 2026,
						withdrawalApplication: 103,
					},
				],
				value: 2980,
			},
			{
				source: 0,
				target: 13,
				transactions: [
					{
						amount: 1543.54,
						currency: 'USD',
						payments: [
							{
								id: 17630,
								source: null,
								amount: 1543.54,
								currency: 'USD',
								currencyReceived: null,
								metadata: {
									tax: null,
									hash: null,
									loan: 457,
									uuid: '82c2abc0-cf85-4425-8495-fa2a1c701c7c',
									amount: 1543.54,
									source: null,
									currency: 'USD',
									metadata: null,
									projectId: 318,
									toAccount: -1,
									toAddress: '0x4d4502Aee5150078624DDdc5965EA96ad470e595',
									reimbursed: {
										amount: null,
									},
									fromAccount: 1636,
									fromAddress: '0xF6379168Ba44cd6A7AB2E9106001Fde599a9EF08',
									transaction: 14700,
									taxEquivalent: null,
									amountReceived: null,
									blkTransaction: {
										id: null,
										status: 'STARTED',
									},
									revertedPayment: null,
									amountEquivalent: null,
									currencyReceived: null,
								},
								hash: '87d2fc795c639c685a4c128a7d70002dcbc0c8154ec273f50ee78669479efd2c',
								created: '2026-03-21T14:44:12.200Z',
								modified: null,
								tax: null,
								amountEquivalent: null,
								taxEquivalent: null,
								amountReceived: null,
								reimbursed: {
									amount: null,
								},
								blkTransaction: {
									id: '0x95da8f501b685da1765f1d7d92be85568c9e08ceea09d08b8abb6debb24e0c2c',
									status: 'DONE',
								},
								revertedPayment: null,
								transaction: 14700,
								loan: {
									id: 457,
									idWbg: null,
									status: 'ENABLED',
									currency: 'XDR',
									amount: 38400000,
									disbursed: 730716.39,
									financier: 'IDA',
									name: 'IPF - Investment Project Financing',
									num: 'E4250',
									dateApproved: '2025-03-28T00:00:00.000Z',
									dateSigning: '2025-04-25T00:00:00.000Z',
									dateClosing: '2029-12-28T00:00:00.000Z',
									subLoanNum: null,
									created: '2026-01-29T13:35:46.971Z',
									modified: '2026-01-29T13:39:44.224Z',
									cancelled: null,
									code: 'IDAE4250',
								},
							},
						],
						tax: 0,
						total: 1543.54,
						id: 14700,
						status: 'COMPLETED',
						metadata: {
							uuid: 'a27c7522-d077-44f9-9079-5ee57bdab7c9',
							invoiceAmount: 201760,
							invoiceCurrency: 'HTG',
						},
						traceability: {
							documents: {
								required: [1254, 1266],
								uploaded: [26507, 26508],
							},
							value: 100,
						},
						type: 'PAYMENT',
						date: '2026-02-16T00:00:00.000Z',
						created: '2026-03-21T14:44:12.177Z',
						modified: '2026-05-20T09:24:50.045Z',
						quantity: null,
						isReceived: null,
						amountReceived: null,
						benefit: null,
						category: 699,
						component: 1148,
						contract: null,
						designatedAccount: null,
						expenseType: {
							id: 2053,
							name: 'Dépenses opérationnelles',
							created: '2026-01-29T15:09:24.768Z',
							modified: '2026-01-29T16:25:03.495Z',
							status: 'ACTIVE',
							entity: null,
							project: 318,
						},
						fromAccount: {
							id: 1636,
							idWbg: '000000000010021601',
							name: 'DA-A',
							num: '111080980',
							institution: "BANQUE DE LA REPUBLIQUE D'HAITI",
							type: 'DESIGNATED',
							currency: 'USD',
							created: '2026-01-29T13:35:46.971Z',
							modified: null,
							status: 'ACTIVE',
							aba: null,
							holder: null,
							isReimbursement: false,
							postcode: null,
							routeCode: null,
							sortCode: null,
							state: null,
							street: null,
							swiftCode: null,
							town: null,
							country: null,
						},
						fromEntity: 2299,
						project: 318,
						toAccount: null,
						toEntity: 3851,
						user: 2026,
						withdrawalApplication: 103,
					},
					{
						amount: 1541.08,
						currency: 'USD',
						payments: [
							{
								id: 30390,
								source: null,
								amount: 1541.08,
								currency: 'USD',
								currencyReceived: null,
								metadata: {
									tax: null,
									hash: null,
									loan: 457,
									uuid: '532073b9-06ea-42b0-b780-02061a7a80ae',
									amount: 1541.08,
									source: null,
									currency: 'USD',
									metadata: null,
									projectId: 318,
									toAccount: -1,
									toAddress: '0x4d4502Aee5150078624DDdc5965EA96ad470e595',
									reimbursed: {
										amount: null,
									},
									fromAccount: 1636,
									fromAddress: '0xF6379168Ba44cd6A7AB2E9106001Fde599a9EF08',
									transaction: 25754,
									taxEquivalent: null,
									amountReceived: null,
									blkTransaction: {
										id: null,
										status: 'STARTED',
									},
									revertedPayment: null,
									amountEquivalent: null,
									currencyReceived: null,
								},
								hash: '427f4d347a8efeceb978702118ff94c1a58239b4cc686926958702220417d3d2',
								created: '2026-05-10T16:28:01.040Z',
								modified: null,
								tax: null,
								amountEquivalent: null,
								taxEquivalent: null,
								amountReceived: null,
								reimbursed: {
									amount: null,
								},
								blkTransaction: {
									id: '0xd41c6acf07a6a11799afd0a5cd7f4144d811aa75e2c82eb66898d25e196224b9',
									status: 'DONE',
								},
								revertedPayment: null,
								transaction: 25754,
								loan: {
									id: 457,
									idWbg: null,
									status: 'ENABLED',
									currency: 'XDR',
									amount: 38400000,
									disbursed: 730716.39,
									financier: 'IDA',
									name: 'IPF - Investment Project Financing',
									num: 'E4250',
									dateApproved: '2025-03-28T00:00:00.000Z',
									dateSigning: '2025-04-25T00:00:00.000Z',
									dateClosing: '2029-12-28T00:00:00.000Z',
									subLoanNum: null,
									created: '2026-01-29T13:35:46.971Z',
									modified: '2026-01-29T13:39:44.224Z',
									cancelled: null,
									code: 'IDAE4250',
								},
							},
						],
						tax: 0,
						total: 1541.08,
						id: 25754,
						status: 'COMPLETED',
						metadata: {
							uuid: 'e95aa8fb-d583-4ff0-9ed1-f793a6d8da37',
							invoiceAmount: 201760,
							invoiceCurrency: 'HTG',
						},
						traceability: {
							documents: {
								required: [1254, 1266],
								uploaded: [53777, 53778],
							},
							value: 100,
						},
						type: 'PAYMENT',
						date: '2026-03-20T00:00:00.000Z',
						created: '2026-05-10T16:28:01.029Z',
						modified: '2026-05-20T09:24:48.800Z',
						quantity: null,
						isReceived: null,
						amountReceived: null,
						benefit: null,
						category: 699,
						component: 1148,
						contract: null,
						designatedAccount: null,
						expenseType: {
							id: 2053,
							name: 'Dépenses opérationnelles',
							created: '2026-01-29T15:09:24.768Z',
							modified: '2026-01-29T16:25:03.495Z',
							status: 'ACTIVE',
							entity: null,
							project: 318,
						},
						fromAccount: {
							id: 1636,
							idWbg: '000000000010021601',
							name: 'DA-A',
							num: '111080980',
							institution: "BANQUE DE LA REPUBLIQUE D'HAITI",
							type: 'DESIGNATED',
							currency: 'USD',
							created: '2026-01-29T13:35:46.971Z',
							modified: null,
							status: 'ACTIVE',
							aba: null,
							holder: null,
							isReimbursement: false,
							postcode: null,
							routeCode: null,
							sortCode: null,
							state: null,
							street: null,
							swiftCode: null,
							town: null,
							country: null,
						},
						fromEntity: 2299,
						project: 318,
						toAccount: null,
						toEntity: 3851,
						user: 2026,
						withdrawalApplication: 103,
					},
				],
				value: 3084.62,
			},
			{
				source: 0,
				target: 14,
				transactions: [
					{
						amount: 4330.73,
						currency: 'USD',
						payments: [
							{
								id: 17629,
								source: null,
								amount: 4330.73,
								currency: 'USD',
								currencyReceived: null,
								metadata: {
									tax: null,
									hash: null,
									loan: 457,
									uuid: '782fa1d7-ec0b-4289-8852-ed9598d8f709',
									amount: 4330.73,
									source: null,
									currency: 'USD',
									metadata: null,
									projectId: 318,
									toAccount: -1,
									toAddress: '0x607dfDda192b61D5a4338250FDf9E9BcFd36a179',
									reimbursed: {
										amount: null,
									},
									fromAccount: 1636,
									fromAddress: '0xF6379168Ba44cd6A7AB2E9106001Fde599a9EF08',
									transaction: 14699,
									taxEquivalent: null,
									amountReceived: null,
									blkTransaction: {
										id: null,
										status: 'STARTED',
									},
									revertedPayment: null,
									amountEquivalent: null,
									currencyReceived: null,
								},
								hash: '7c3030d3a25ebd1e67e1b764495e2eb46c931e8e8f50c612f7bb66b4e9e194b6',
								created: '2026-03-21T14:33:05.456Z',
								modified: null,
								tax: null,
								amountEquivalent: null,
								taxEquivalent: null,
								amountReceived: null,
								reimbursed: {
									amount: null,
								},
								blkTransaction: {
									id: '0x007b04cbf2a678ac3353522d75c289339ff9d2bb431f153db4d96e4060eacab4',
									status: 'DONE',
								},
								revertedPayment: null,
								transaction: 14699,
								loan: {
									id: 457,
									idWbg: null,
									status: 'ENABLED',
									currency: 'XDR',
									amount: 38400000,
									disbursed: 730716.39,
									financier: 'IDA',
									name: 'IPF - Investment Project Financing',
									num: 'E4250',
									dateApproved: '2025-03-28T00:00:00.000Z',
									dateSigning: '2025-04-25T00:00:00.000Z',
									dateClosing: '2029-12-28T00:00:00.000Z',
									subLoanNum: null,
									created: '2026-01-29T13:35:46.971Z',
									modified: '2026-01-29T13:39:44.224Z',
									cancelled: null,
									code: 'IDAE4250',
								},
							},
						],
						tax: 0,
						total: 4330.73,
						id: 14699,
						status: 'COMPLETED',
						metadata: {
							uuid: '58f05dfb-a019-46df-a1df-1b35f4f1c21c',
							invoiceAmount: 4330.73,
							invoiceCurrency: 'USD',
						},
						traceability: {
							documents: {
								required: [1254, 1266],
								uploaded: [26506, 26505],
							},
							value: 100,
						},
						type: 'PAYMENT',
						date: '2026-02-16T00:00:00.000Z',
						created: '2026-03-21T14:33:05.440Z',
						modified: '2026-05-20T09:24:50.070Z',
						quantity: null,
						isReceived: null,
						amountReceived: null,
						benefit: null,
						category: 699,
						component: 1147,
						contract: null,
						designatedAccount: null,
						expenseType: {
							id: 2053,
							name: 'Dépenses opérationnelles',
							created: '2026-01-29T15:09:24.768Z',
							modified: '2026-01-29T16:25:03.495Z',
							status: 'ACTIVE',
							entity: null,
							project: 318,
						},
						fromAccount: {
							id: 1636,
							idWbg: '000000000010021601',
							name: 'DA-A',
							num: '111080980',
							institution: "BANQUE DE LA REPUBLIQUE D'HAITI",
							type: 'DESIGNATED',
							currency: 'USD',
							created: '2026-01-29T13:35:46.971Z',
							modified: null,
							status: 'ACTIVE',
							aba: null,
							holder: null,
							isReimbursement: false,
							postcode: null,
							routeCode: null,
							sortCode: null,
							state: null,
							street: null,
							swiftCode: null,
							town: null,
							country: null,
						},
						fromEntity: 2299,
						project: 318,
						toAccount: null,
						toEntity: 3850,
						user: 2026,
						withdrawalApplication: 103,
					},
					{
						amount: 4285.83,
						currency: 'USD',
						payments: [
							{
								id: 17652,
								source: null,
								amount: 4285.83,
								currency: 'USD',
								currencyReceived: null,
								metadata: {
									tax: null,
									hash: null,
									loan: 457,
									uuid: 'a0461b4d-1820-49e9-a281-19c6d6d301a3',
									amount: 4285.83,
									source: null,
									currency: 'USD',
									metadata: null,
									projectId: 318,
									toAccount: -1,
									toAddress: '0x607dfDda192b61D5a4338250FDf9E9BcFd36a179',
									reimbursed: {
										amount: null,
									},
									fromAccount: 1636,
									fromAddress: '0xF6379168Ba44cd6A7AB2E9106001Fde599a9EF08',
									transaction: 14715,
									taxEquivalent: null,
									amountReceived: null,
									blkTransaction: {
										id: null,
										status: 'STARTED',
									},
									revertedPayment: null,
									amountEquivalent: null,
									currencyReceived: null,
								},
								hash: '1bc3256b646d79dcab774cdf81ffc2fb42f67fd05e5ce8c6ce90412e216d960f',
								created: '2026-03-21T15:58:01.206Z',
								modified: null,
								tax: null,
								amountEquivalent: null,
								taxEquivalent: null,
								amountReceived: null,
								reimbursed: {
									amount: null,
								},
								blkTransaction: {
									id: '0xfc3f7ae792422aec8d176f8ad6bf2e782aaeac143470addd93524f7e2cf601a3',
									status: 'DONE',
								},
								revertedPayment: null,
								transaction: 14715,
								loan: {
									id: 457,
									idWbg: null,
									status: 'ENABLED',
									currency: 'XDR',
									amount: 38400000,
									disbursed: 730716.39,
									financier: 'IDA',
									name: 'IPF - Investment Project Financing',
									num: 'E4250',
									dateApproved: '2025-03-28T00:00:00.000Z',
									dateSigning: '2025-04-25T00:00:00.000Z',
									dateClosing: '2029-12-28T00:00:00.000Z',
									subLoanNum: null,
									created: '2026-01-29T13:35:46.971Z',
									modified: '2026-01-29T13:39:44.224Z',
									cancelled: null,
									code: 'IDAE4250',
								},
							},
						],
						tax: 0,
						total: 4285.83,
						id: 14715,
						status: 'COMPLETED',
						metadata: {
							uuid: 'ff8cb139-2d9a-49b5-827e-3bd43d899d63',
							invoiceAmount: 560780.6,
							invoiceCurrency: 'HTG',
						},
						traceability: {
							documents: {
								required: [1254, 1266],
								uploaded: [26517, 26518],
							},
							value: 100,
						},
						type: 'PAYMENT',
						date: '2026-02-24T00:00:00.000Z',
						created: '2026-03-21T15:58:01.188Z',
						modified: '2026-05-20T09:24:49.905Z',
						quantity: null,
						isReceived: null,
						amountReceived: null,
						benefit: null,
						category: 699,
						component: 1147,
						contract: null,
						designatedAccount: null,
						expenseType: {
							id: 2053,
							name: 'Dépenses opérationnelles',
							created: '2026-01-29T15:09:24.768Z',
							modified: '2026-01-29T16:25:03.495Z',
							status: 'ACTIVE',
							entity: null,
							project: 318,
						},
						fromAccount: {
							id: 1636,
							idWbg: '000000000010021601',
							name: 'DA-A',
							num: '111080980',
							institution: "BANQUE DE LA REPUBLIQUE D'HAITI",
							type: 'DESIGNATED',
							currency: 'USD',
							created: '2026-01-29T13:35:46.971Z',
							modified: null,
							status: 'ACTIVE',
							aba: null,
							holder: null,
							isReimbursement: false,
							postcode: null,
							routeCode: null,
							sortCode: null,
							state: null,
							street: null,
							swiftCode: null,
							town: null,
							country: null,
						},
						fromEntity: 2299,
						project: 318,
						toAccount: null,
						toEntity: 3850,
						user: 2026,
						withdrawalApplication: 103,
					},
				],
				value: 8616.56,
			},
			{
				source: 0,
				target: 15,
				transactions: [
					{
						amount: 354.4,
						currency: 'USD',
						payments: [
							{
								id: 17626,
								source: null,
								amount: 354.4,
								currency: 'USD',
								currencyReceived: null,
								metadata: {
									tax: null,
									hash: null,
									loan: 457,
									uuid: '466419a9-3c8f-445e-988e-8f336009e6c8',
									amount: 354.4,
									source: null,
									currency: 'USD',
									metadata: null,
									projectId: 318,
									toAccount: -1,
									toAddress: '0x2a11F568F292EA1489Fc577cD445A81150F60cDd',
									reimbursed: {
										amount: null,
									},
									fromAccount: 1636,
									fromAddress: '0xF6379168Ba44cd6A7AB2E9106001Fde599a9EF08',
									transaction: 14696,
									taxEquivalent: null,
									amountReceived: null,
									blkTransaction: {
										id: null,
										status: 'STARTED',
									},
									revertedPayment: null,
									amountEquivalent: null,
									currencyReceived: null,
								},
								hash: 'abf2b7556a41d0a66fd3baab9825889e2077a80ba20dd0480bbe832ee1c50ba4',
								created: '2026-03-21T14:13:30.357Z',
								modified: null,
								tax: null,
								amountEquivalent: null,
								taxEquivalent: null,
								amountReceived: null,
								reimbursed: {
									amount: null,
								},
								blkTransaction: {
									id: '0x9991ed5ee622ec0a53a5539abf8fed9ee18aacee5af751f675ec8d7c963ec1d0',
									status: 'DONE',
								},
								revertedPayment: null,
								transaction: 14696,
								loan: {
									id: 457,
									idWbg: null,
									status: 'ENABLED',
									currency: 'XDR',
									amount: 38400000,
									disbursed: 730716.39,
									financier: 'IDA',
									name: 'IPF - Investment Project Financing',
									num: 'E4250',
									dateApproved: '2025-03-28T00:00:00.000Z',
									dateSigning: '2025-04-25T00:00:00.000Z',
									dateClosing: '2029-12-28T00:00:00.000Z',
									subLoanNum: null,
									created: '2026-01-29T13:35:46.971Z',
									modified: '2026-01-29T13:39:44.224Z',
									cancelled: null,
									code: 'IDAE4250',
								},
							},
						],
						tax: 0,
						total: 354.4,
						id: 14696,
						status: 'COMPLETED',
						metadata: {
							uuid: 'fb2181e3-5e5a-41f2-b42a-2a349e5ad742',
							invoiceAmount: 46325,
							invoiceCurrency: 'HTG',
						},
						traceability: {
							documents: {
								required: [1254, 1266],
								uploaded: [26500, 26501],
							},
							value: 100,
						},
						type: 'PAYMENT',
						date: '2026-02-16T00:00:00.000Z',
						created: '2026-03-21T14:13:30.340Z',
						modified: '2026-05-20T09:24:50.125Z',
						quantity: null,
						isReceived: null,
						amountReceived: null,
						benefit: null,
						category: 699,
						component: 1149,
						contract: null,
						designatedAccount: null,
						expenseType: {
							id: 2053,
							name: 'Dépenses opérationnelles',
							created: '2026-01-29T15:09:24.768Z',
							modified: '2026-01-29T16:25:03.495Z',
							status: 'ACTIVE',
							entity: null,
							project: 318,
						},
						fromAccount: {
							id: 1636,
							idWbg: '000000000010021601',
							name: 'DA-A',
							num: '111080980',
							institution: "BANQUE DE LA REPUBLIQUE D'HAITI",
							type: 'DESIGNATED',
							currency: 'USD',
							created: '2026-01-29T13:35:46.971Z',
							modified: null,
							status: 'ACTIVE',
							aba: null,
							holder: null,
							isReimbursement: false,
							postcode: null,
							routeCode: null,
							sortCode: null,
							state: null,
							street: null,
							swiftCode: null,
							town: null,
							country: null,
						},
						fromEntity: 2299,
						project: 318,
						toAccount: null,
						toEntity: 3124,
						user: 2026,
						withdrawalApplication: 103,
					},
					{
						amount: 708.8,
						currency: 'USD',
						payments: [
							{
								id: 17624,
								source: null,
								amount: 354.4,
								currency: 'USD',
								currencyReceived: null,
								metadata: {
									tax: null,
									hash: null,
									loan: 457,
									uuid: 'b6b91671-6a4c-4be1-912e-def73a819127',
									amount: 354.4,
									source: null,
									currency: 'USD',
									metadata: null,
									projectId: 318,
									toAccount: -1,
									toAddress: '0x2a11F568F292EA1489Fc577cD445A81150F60cDd',
									reimbursed: {
										amount: null,
									},
									fromAccount: 1636,
									fromAddress: '0xF6379168Ba44cd6A7AB2E9106001Fde599a9EF08',
									transaction: 14694,
									taxEquivalent: null,
									amountReceived: null,
									blkTransaction: {
										id: null,
										status: 'STARTED',
									},
									revertedPayment: null,
									amountEquivalent: null,
									currencyReceived: null,
								},
								hash: '8364f479e586aaa84da0bc6aefd2ffbb56dd376b59137f820ef326f4f28db92c',
								created: '2026-03-21T14:06:29.917Z',
								modified: null,
								tax: null,
								amountEquivalent: null,
								taxEquivalent: null,
								amountReceived: null,
								reimbursed: {
									amount: null,
								},
								blkTransaction: {
									id: '0xc8c2bb247d37fee7b2c44a97ee965b218bec1a408f08b6a5a053e0717feeacfc',
									status: 'DONE',
								},
								revertedPayment: null,
								transaction: 14694,
								loan: {
									id: 457,
									idWbg: null,
									status: 'ENABLED',
									currency: 'XDR',
									amount: 38400000,
									disbursed: 730716.39,
									financier: 'IDA',
									name: 'IPF - Investment Project Financing',
									num: 'E4250',
									dateApproved: '2025-03-28T00:00:00.000Z',
									dateSigning: '2025-04-25T00:00:00.000Z',
									dateClosing: '2029-12-28T00:00:00.000Z',
									subLoanNum: null,
									created: '2026-01-29T13:35:46.971Z',
									modified: '2026-01-29T13:39:44.224Z',
									cancelled: null,
									code: 'IDAE4250',
								},
							},
							{
								id: 20860,
								source: null,
								amount: 354.4,
								currency: 'USD',
								currencyReceived: null,
								metadata: {
									tax: null,
									loan: 457,
									amount: 354.4,
									currency: 'USD',
									isRevert: true,
									toAccount: 1636,
									toAddress: '0xF6379168Ba44cd6A7AB2E9106001Fde599a9EF08',
									fromAccount: -1,
									fromAddress: '0x2a11F568F292EA1489Fc577cD445A81150F60cDd',
									transaction: 14694,
									amountReceived: null,
									currencyReceived: null,
								},
								hash: '4cbdf8993ba9161633c6fed888f97423d336dd674818ab879522aea513894d30',
								created: '2026-04-02T15:52:25.865Z',
								modified: null,
								tax: null,
								amountEquivalent: null,
								taxEquivalent: null,
								amountReceived: null,
								reimbursed: {
									amount: null,
								},
								blkTransaction: {
									id: '0xf488577f72f29b4d637de2344020ed72d00ed1a69d846b6198d1f545cc670194',
									status: 'DONE',
								},
								revertedPayment: 17624,
								transaction: 14694,
								loan: {
									id: 457,
									idWbg: null,
									status: 'ENABLED',
									currency: 'XDR',
									amount: 38400000,
									disbursed: 730716.39,
									financier: 'IDA',
									name: 'IPF - Investment Project Financing',
									num: 'E4250',
									dateApproved: '2025-03-28T00:00:00.000Z',
									dateSigning: '2025-04-25T00:00:00.000Z',
									dateClosing: '2029-12-28T00:00:00.000Z',
									subLoanNum: null,
									created: '2026-01-29T13:35:46.971Z',
									modified: '2026-01-29T13:39:44.224Z',
									cancelled: null,
									code: 'IDAE4250',
								},
							},
						],
						tax: 0,
						total: 708.8,
						id: 14694,
						status: 'REVERTED',
						metadata: {
							uuid: '1067656a-576c-44a4-9451-b88fd2ef22c6',
							invoiceAmount: 46325,
							invoiceCurrency: 'HTG',
						},
						traceability: {
							documents: {
								required: [1254, 1266],
								uploaded: [],
							},
							value: 0,
						},
						type: 'PAYMENT',
						date: '2026-02-16T00:00:00.000Z',
						created: '2026-03-21T14:06:29.903Z',
						modified: '2026-04-02T15:52:30.567Z',
						quantity: null,
						isReceived: null,
						amountReceived: null,
						benefit: null,
						category: 699,
						component: 1149,
						contract: null,
						designatedAccount: null,
						expenseType: {
							id: 2053,
							name: 'Dépenses opérationnelles',
							created: '2026-01-29T15:09:24.768Z',
							modified: '2026-01-29T16:25:03.495Z',
							status: 'ACTIVE',
							entity: null,
							project: 318,
						},
						fromAccount: {
							id: 1636,
							idWbg: '000000000010021601',
							name: 'DA-A',
							num: '111080980',
							institution: "BANQUE DE LA REPUBLIQUE D'HAITI",
							type: 'DESIGNATED',
							currency: 'USD',
							created: '2026-01-29T13:35:46.971Z',
							modified: null,
							status: 'ACTIVE',
							aba: null,
							holder: null,
							isReimbursement: false,
							postcode: null,
							routeCode: null,
							sortCode: null,
							state: null,
							street: null,
							swiftCode: null,
							town: null,
							country: null,
						},
						fromEntity: 2299,
						project: 318,
						toAccount: null,
						toEntity: 3124,
						user: 2026,
						withdrawalApplication: null,
					},
					{
						amount: 114.67,
						currency: 'USD',
						payments: [
							{
								id: 30415,
								source: null,
								amount: 114.67,
								currency: 'USD',
								currencyReceived: null,
								metadata: {
									tax: null,
									hash: null,
									loan: 457,
									uuid: '58332c2b-9dbe-408f-acfd-923f4fc65478',
									amount: 114.67,
									source: null,
									currency: 'USD',
									metadata: null,
									projectId: 318,
									toAccount: -1,
									toAddress: '0x2a11F568F292EA1489Fc577cD445A81150F60cDd',
									reimbursed: {
										amount: null,
									},
									fromAccount: 1636,
									fromAddress: '0xF6379168Ba44cd6A7AB2E9106001Fde599a9EF08',
									transaction: 25779,
									taxEquivalent: null,
									amountReceived: null,
									blkTransaction: {
										id: null,
										status: 'STARTED',
									},
									revertedPayment: null,
									amountEquivalent: null,
									currencyReceived: null,
								},
								hash: '189e94e5dfc79f94606e187bdb1599aad3c2f453524d83208f002d210fd1f33b',
								created: '2026-05-10T17:30:29.054Z',
								modified: null,
								tax: null,
								amountEquivalent: null,
								taxEquivalent: null,
								amountReceived: null,
								reimbursed: {
									amount: null,
								},
								blkTransaction: {
									id: '0xf07aa680c869c5238cc2dae5f5e5edb1a990b074e25ba80807c47369556aa715',
									status: 'DONE',
								},
								revertedPayment: null,
								transaction: 25779,
								loan: {
									id: 457,
									idWbg: null,
									status: 'ENABLED',
									currency: 'XDR',
									amount: 38400000,
									disbursed: 730716.39,
									financier: 'IDA',
									name: 'IPF - Investment Project Financing',
									num: 'E4250',
									dateApproved: '2025-03-28T00:00:00.000Z',
									dateSigning: '2025-04-25T00:00:00.000Z',
									dateClosing: '2029-12-28T00:00:00.000Z',
									subLoanNum: null,
									created: '2026-01-29T13:35:46.971Z',
									modified: '2026-01-29T13:39:44.224Z',
									cancelled: null,
									code: 'IDAE4250',
								},
							},
						],
						tax: 0,
						total: 114.67,
						id: 25779,
						status: 'COMPLETED',
						metadata: {
							uuid: 'f70d028f-d846-4515-a27e-d2f710286fa7',
							invoiceAmount: 15000,
							invoiceCurrency: 'HTG',
						},
						traceability: {
							documents: {
								required: [1254, 1266],
								uploaded: [53808, 53809],
							},
							value: 100,
						},
						type: 'PAYMENT',
						date: '2026-03-26T00:00:00.000Z',
						created: '2026-05-10T17:30:29.039Z',
						modified: '2026-05-20T09:24:48.584Z',
						quantity: null,
						isReceived: null,
						amountReceived: null,
						benefit: null,
						category: 699,
						component: 1150,
						contract: null,
						designatedAccount: null,
						expenseType: {
							id: 2053,
							name: 'Dépenses opérationnelles',
							created: '2026-01-29T15:09:24.768Z',
							modified: '2026-01-29T16:25:03.495Z',
							status: 'ACTIVE',
							entity: null,
							project: 318,
						},
						fromAccount: {
							id: 1636,
							idWbg: '000000000010021601',
							name: 'DA-A',
							num: '111080980',
							institution: "BANQUE DE LA REPUBLIQUE D'HAITI",
							type: 'DESIGNATED',
							currency: 'USD',
							created: '2026-01-29T13:35:46.971Z',
							modified: null,
							status: 'ACTIVE',
							aba: null,
							holder: null,
							isReimbursement: false,
							postcode: null,
							routeCode: null,
							sortCode: null,
							state: null,
							street: null,
							swiftCode: null,
							town: null,
							country: null,
						},
						fromEntity: 2299,
						project: 318,
						toAccount: null,
						toEntity: 3124,
						user: 2026,
						withdrawalApplication: 103,
					},
					{
						amount: 764.18,
						currency: 'USD',
						payments: [
							{
								id: 30375,
								source: null,
								amount: 764.18,
								currency: 'USD',
								currencyReceived: null,
								metadata: {
									tax: null,
									hash: null,
									loan: 457,
									uuid: '9f00195d-84d8-40bd-8bd7-ec233d364f43',
									amount: 764.18,
									source: null,
									currency: 'USD',
									metadata: null,
									projectId: 318,
									toAccount: -1,
									toAddress: '0x2a11F568F292EA1489Fc577cD445A81150F60cDd',
									reimbursed: {
										amount: null,
									},
									fromAccount: 1636,
									fromAddress: '0xF6379168Ba44cd6A7AB2E9106001Fde599a9EF08',
									transaction: 25739,
									taxEquivalent: null,
									amountReceived: null,
									blkTransaction: {
										id: null,
										status: 'STARTED',
									},
									revertedPayment: null,
									amountEquivalent: null,
									currencyReceived: null,
								},
								hash: '04117a8adc6fc0b4f23e002cbd4535c8c93650556b3ce79fed7c6235646f0380',
								created: '2026-05-10T16:05:27.938Z',
								modified: null,
								tax: null,
								amountEquivalent: null,
								taxEquivalent: null,
								amountReceived: null,
								reimbursed: {
									amount: null,
								},
								blkTransaction: {
									id: '0xec7ccb503bafd8b6704724ed170de3e9b6ea0924b39f6a2c37a2c72500f644ec',
									status: 'DONE',
								},
								revertedPayment: null,
								transaction: 25739,
								loan: {
									id: 457,
									idWbg: null,
									status: 'ENABLED',
									currency: 'XDR',
									amount: 38400000,
									disbursed: 730716.39,
									financier: 'IDA',
									name: 'IPF - Investment Project Financing',
									num: 'E4250',
									dateApproved: '2025-03-28T00:00:00.000Z',
									dateSigning: '2025-04-25T00:00:00.000Z',
									dateClosing: '2029-12-28T00:00:00.000Z',
									subLoanNum: null,
									created: '2026-01-29T13:35:46.971Z',
									modified: '2026-01-29T13:39:44.224Z',
									cancelled: null,
									code: 'IDAE4250',
								},
							},
						],
						tax: 0,
						total: 764.18,
						id: 25739,
						status: 'COMPLETED',
						metadata: {
							uuid: '1e400464-83db-4388-b937-5fcd52c923f6',
							invoiceAmount: 100000,
							invoiceCurrency: 'HTG',
						},
						traceability: {
							documents: {
								required: [1254, 1266],
								uploaded: [53750, 53751],
							},
							value: 100,
						},
						type: 'PAYMENT',
						date: '2026-03-18T00:00:00.000Z',
						created: '2026-05-10T16:05:27.918Z',
						modified: '2026-05-20T09:24:48.873Z',
						quantity: null,
						isReceived: null,
						amountReceived: null,
						benefit: null,
						category: 699,
						component: 1141,
						contract: null,
						designatedAccount: null,
						expenseType: {
							id: 2053,
							name: 'Dépenses opérationnelles',
							created: '2026-01-29T15:09:24.768Z',
							modified: '2026-01-29T16:25:03.495Z',
							status: 'ACTIVE',
							entity: null,
							project: 318,
						},
						fromAccount: {
							id: 1636,
							idWbg: '000000000010021601',
							name: 'DA-A',
							num: '111080980',
							institution: "BANQUE DE LA REPUBLIQUE D'HAITI",
							type: 'DESIGNATED',
							currency: 'USD',
							created: '2026-01-29T13:35:46.971Z',
							modified: null,
							status: 'ACTIVE',
							aba: null,
							holder: null,
							isReimbursement: false,
							postcode: null,
							routeCode: null,
							sortCode: null,
							state: null,
							street: null,
							swiftCode: null,
							town: null,
							country: null,
						},
						fromEntity: 2299,
						project: 318,
						toAccount: null,
						toEntity: 3124,
						user: 2026,
						withdrawalApplication: 103,
					},
					{
						amount: 916.62,
						currency: 'USD',
						payments: [
							{
								id: 17632,
								source: null,
								amount: 916.62,
								currency: 'USD',
								currencyReceived: null,
								metadata: {
									tax: null,
									hash: null,
									loan: 457,
									uuid: '25d1ac38-2a37-49f4-bcb3-ee5a6c081ca4',
									amount: 916.62,
									source: null,
									currency: 'USD',
									metadata: null,
									projectId: 318,
									toAccount: -1,
									toAddress: '0x2a11F568F292EA1489Fc577cD445A81150F60cDd',
									reimbursed: {
										amount: null,
									},
									fromAccount: 1636,
									fromAddress: '0xF6379168Ba44cd6A7AB2E9106001Fde599a9EF08',
									transaction: 14702,
									taxEquivalent: null,
									amountReceived: null,
									blkTransaction: {
										id: null,
										status: 'STARTED',
									},
									revertedPayment: null,
									amountEquivalent: null,
									currencyReceived: null,
								},
								hash: '69f9e0aed0c8734935285c370bc63634f77d685db9dde5f46d7d39ad650ca6a3',
								created: '2026-03-21T15:09:51.798Z',
								modified: null,
								tax: null,
								amountEquivalent: null,
								taxEquivalent: null,
								amountReceived: null,
								reimbursed: {
									amount: null,
								},
								blkTransaction: {
									id: '0x71a54cba61ff6a28d110742ee4135408519930523f591b46b37ecf46ff819122',
									status: 'DONE',
								},
								revertedPayment: null,
								transaction: 14702,
								loan: {
									id: 457,
									idWbg: null,
									status: 'ENABLED',
									currency: 'XDR',
									amount: 38400000,
									disbursed: 730716.39,
									financier: 'IDA',
									name: 'IPF - Investment Project Financing',
									num: 'E4250',
									dateApproved: '2025-03-28T00:00:00.000Z',
									dateSigning: '2025-04-25T00:00:00.000Z',
									dateClosing: '2029-12-28T00:00:00.000Z',
									subLoanNum: null,
									created: '2026-01-29T13:35:46.971Z',
									modified: '2026-01-29T13:39:44.224Z',
									cancelled: null,
									code: 'IDAE4250',
								},
							},
						],
						tax: 0,
						total: 916.62,
						id: 14702,
						status: 'COMPLETED',
						metadata: {
							uuid: 'e5ef9fae-0990-4eab-ae52-a1d551118a6d',
							invoiceAmount: 120000,
							invoiceCurrency: 'HTG',
						},
						traceability: {
							documents: {
								required: [1254, 1266],
								uploaded: [26511, 26512],
							},
							value: 100,
						},
						type: 'PAYMENT',
						date: '2026-02-23T00:00:00.000Z',
						created: '2026-03-21T15:09:51.782Z',
						modified: '2026-05-20T09:24:49.985Z',
						quantity: null,
						isReceived: null,
						amountReceived: null,
						benefit: null,
						category: 699,
						component: 1141,
						contract: null,
						designatedAccount: null,
						expenseType: {
							id: 2053,
							name: 'Dépenses opérationnelles',
							created: '2026-01-29T15:09:24.768Z',
							modified: '2026-01-29T16:25:03.495Z',
							status: 'ACTIVE',
							entity: null,
							project: 318,
						},
						fromAccount: {
							id: 1636,
							idWbg: '000000000010021601',
							name: 'DA-A',
							num: '111080980',
							institution: "BANQUE DE LA REPUBLIQUE D'HAITI",
							type: 'DESIGNATED',
							currency: 'USD',
							created: '2026-01-29T13:35:46.971Z',
							modified: null,
							status: 'ACTIVE',
							aba: null,
							holder: null,
							isReimbursement: false,
							postcode: null,
							routeCode: null,
							sortCode: null,
							state: null,
							street: null,
							swiftCode: null,
							town: null,
							country: null,
						},
						fromEntity: 2299,
						project: 318,
						toAccount: null,
						toEntity: 3124,
						user: 2026,
						withdrawalApplication: 103,
					},
					{
						amount: 159.9,
						currency: 'USD',
						payments: [
							{
								id: 16736,
								source: null,
								amount: 159.9,
								currency: 'USD',
								currencyReceived: null,
								metadata: {
									tax: null,
									hash: null,
									loan: 457,
									uuid: 'c961c1b9-b723-4155-b340-b6f7b498b272',
									amount: 159.9,
									source: null,
									currency: 'USD',
									metadata: null,
									projectId: 318,
									toAccount: -1,
									toAddress: '0x2a11F568F292EA1489Fc577cD445A81150F60cDd',
									fromAccount: 1636,
									fromAddress: '0xF6379168Ba44cd6A7AB2E9106001Fde599a9EF08',
									transaction: 13870,
									taxEquivalent: null,
									amountReceived: null,
									blkTransaction: {
										id: null,
										status: 'STARTED',
									},
									revertedPayment: null,
									amountEquivalent: null,
									currencyReceived: null,
								},
								hash: 'aae81639b3c3b968b9df12ef88a87a9259241f52f5c47e867f996ce17637560f',
								created: '2026-03-15T23:29:21.513Z',
								modified: null,
								tax: null,
								amountEquivalent: null,
								taxEquivalent: null,
								amountReceived: null,
								reimbursed: {
									amount: null,
								},
								blkTransaction: {
									id: '0x83bce807ce4cd2ce567f85a40586cd2c4622754a64bf21ff29d2664be53be6df',
									status: 'DONE',
								},
								revertedPayment: null,
								transaction: 13870,
								loan: {
									id: 457,
									idWbg: null,
									status: 'ENABLED',
									currency: 'XDR',
									amount: 38400000,
									disbursed: 730716.39,
									financier: 'IDA',
									name: 'IPF - Investment Project Financing',
									num: 'E4250',
									dateApproved: '2025-03-28T00:00:00.000Z',
									dateSigning: '2025-04-25T00:00:00.000Z',
									dateClosing: '2029-12-28T00:00:00.000Z',
									subLoanNum: null,
									created: '2026-01-29T13:35:46.971Z',
									modified: '2026-01-29T13:39:44.224Z',
									cancelled: null,
									code: 'IDAE4250',
								},
							},
						],
						tax: 0,
						total: 159.9,
						id: 13870,
						status: 'COMPLETED',
						metadata: {
							uuid: 'a4e60947-859f-4c6d-b7c0-5fe2c057d3cb',
							invoiceAmount: 159.9,
							invoiceCurrency: 'USD',
						},
						traceability: {
							documents: {
								required: [1254, 1266],
								uploaded: [24489, 24490],
							},
							value: 100,
						},
						type: 'PAYMENT',
						date: '2026-01-21T00:00:00.000Z',
						created: '2026-03-15T23:29:21.497Z',
						modified: '2026-05-20T09:24:50.513Z',
						quantity: null,
						isReceived: null,
						amountReceived: null,
						benefit: null,
						category: 699,
						component: 1146,
						contract: null,
						designatedAccount: null,
						expenseType: {
							id: 2053,
							name: 'Dépenses opérationnelles',
							created: '2026-01-29T15:09:24.768Z',
							modified: '2026-01-29T16:25:03.495Z',
							status: 'ACTIVE',
							entity: null,
							project: 318,
						},
						fromAccount: {
							id: 1636,
							idWbg: '000000000010021601',
							name: 'DA-A',
							num: '111080980',
							institution: "BANQUE DE LA REPUBLIQUE D'HAITI",
							type: 'DESIGNATED',
							currency: 'USD',
							created: '2026-01-29T13:35:46.971Z',
							modified: null,
							status: 'ACTIVE',
							aba: null,
							holder: null,
							isReimbursement: false,
							postcode: null,
							routeCode: null,
							sortCode: null,
							state: null,
							street: null,
							swiftCode: null,
							town: null,
							country: null,
						},
						fromEntity: 2299,
						project: 318,
						toAccount: null,
						toEntity: 3124,
						user: 2026,
						withdrawalApplication: 103,
					},
				],
				value: 3018.5699999999997,
			},
			{
				source: 0,
				target: 16,
				transactions: [
					{
						amount: 1319.69,
						currency: 'USD',
						payments: [
							{
								id: 17621,
								source: null,
								amount: 1319.69,
								currency: 'USD',
								currencyReceived: null,
								metadata: {
									tax: null,
									hash: null,
									loan: 457,
									uuid: '702f456e-6b09-40f1-92d2-f012ed35a5aa',
									amount: 1319.69,
									source: null,
									currency: 'USD',
									metadata: null,
									projectId: 318,
									toAccount: -1,
									toAddress: '0xE20090573077604ba30d0E317BB5B02840e27FeE',
									reimbursed: {
										amount: null,
									},
									fromAccount: 1636,
									fromAddress: '0xF6379168Ba44cd6A7AB2E9106001Fde599a9EF08',
									transaction: 14691,
									taxEquivalent: null,
									amountReceived: null,
									blkTransaction: {
										id: null,
										status: 'STARTED',
									},
									revertedPayment: null,
									amountEquivalent: null,
									currencyReceived: null,
								},
								hash: '3e793f2bc731f753ed4535bae0aaf9588c115e358a9e5d1f4a07525c6b0eb354',
								created: '2026-03-21T13:57:30.205Z',
								modified: null,
								tax: null,
								amountEquivalent: null,
								taxEquivalent: null,
								amountReceived: null,
								reimbursed: {
									amount: null,
								},
								blkTransaction: {
									id: '0x91acec66828aa79531be19355b253275a01c2c49d3b0f462d8ee5b35108ce7b5',
									status: 'DONE',
								},
								revertedPayment: null,
								transaction: 14691,
								loan: {
									id: 457,
									idWbg: null,
									status: 'ENABLED',
									currency: 'XDR',
									amount: 38400000,
									disbursed: 730716.39,
									financier: 'IDA',
									name: 'IPF - Investment Project Financing',
									num: 'E4250',
									dateApproved: '2025-03-28T00:00:00.000Z',
									dateSigning: '2025-04-25T00:00:00.000Z',
									dateClosing: '2029-12-28T00:00:00.000Z',
									subLoanNum: null,
									created: '2026-01-29T13:35:46.971Z',
									modified: '2026-01-29T13:39:44.224Z',
									cancelled: null,
									code: 'IDAE4250',
								},
							},
						],
						tax: 0,
						total: 1319.69,
						id: 14691,
						status: 'COMPLETED',
						metadata: {
							uuid: '16f446b9-be21-4b18-b787-cd69c4f275e1',
							invoiceAmount: 172500,
							invoiceCurrency: 'HTG',
						},
						traceability: {
							documents: {
								required: [1254, 1266],
								uploaded: [26492, 26493],
							},
							value: 100,
						},
						type: 'PAYMENT',
						date: '2026-02-16T00:00:00.000Z',
						created: '2026-03-21T13:57:30.179Z',
						modified: '2026-05-20T09:24:50.159Z',
						quantity: null,
						isReceived: null,
						amountReceived: null,
						benefit: null,
						category: 699,
						component: 1147,
						contract: null,
						designatedAccount: null,
						expenseType: {
							id: 2053,
							name: 'Dépenses opérationnelles',
							created: '2026-01-29T15:09:24.768Z',
							modified: '2026-01-29T16:25:03.495Z',
							status: 'ACTIVE',
							entity: null,
							project: 318,
						},
						fromAccount: {
							id: 1636,
							idWbg: '000000000010021601',
							name: 'DA-A',
							num: '111080980',
							institution: "BANQUE DE LA REPUBLIQUE D'HAITI",
							type: 'DESIGNATED',
							currency: 'USD',
							created: '2026-01-29T13:35:46.971Z',
							modified: null,
							status: 'ACTIVE',
							aba: null,
							holder: null,
							isReimbursement: false,
							postcode: null,
							routeCode: null,
							sortCode: null,
							state: null,
							street: null,
							swiftCode: null,
							town: null,
							country: null,
						},
						fromEntity: 2299,
						project: 318,
						toAccount: null,
						toEntity: 3848,
						user: 2026,
						withdrawalApplication: 103,
					},
				],
				value: 1319.69,
			},
			{
				source: 0,
				target: 17,
				transactions: [
					{
						amount: 1060,
						currency: 'USD',
						payments: [
							{
								id: 17628,
								source: null,
								amount: 1060,
								currency: 'USD',
								currencyReceived: null,
								metadata: {
									tax: null,
									hash: null,
									loan: 457,
									uuid: '72e9407e-7669-4014-85be-a354ac8f7bbd',
									amount: 1060,
									source: null,
									currency: 'USD',
									metadata: null,
									projectId: 318,
									toAccount: -1,
									toAddress: '0x5D152746ccB2585Ca0937728129bC26870BdCC0F',
									reimbursed: {
										amount: null,
									},
									fromAccount: 1636,
									fromAddress: '0xF6379168Ba44cd6A7AB2E9106001Fde599a9EF08',
									transaction: 14698,
									taxEquivalent: null,
									amountReceived: null,
									blkTransaction: {
										id: null,
										status: 'STARTED',
									},
									revertedPayment: null,
									amountEquivalent: null,
									currencyReceived: null,
								},
								hash: '2d0f09602dc6801772ae96d89d2f132e21c23c9a31797039cffdf4922bc8a255',
								created: '2026-03-21T14:27:27.850Z',
								modified: null,
								tax: null,
								amountEquivalent: null,
								taxEquivalent: null,
								amountReceived: null,
								reimbursed: {
									amount: null,
								},
								blkTransaction: {
									id: '0x5767443b836c87ca37c065601fe60f620ae4c663939ba5ddf328d29fa563a9be',
									status: 'DONE',
								},
								revertedPayment: null,
								transaction: 14698,
								loan: {
									id: 457,
									idWbg: null,
									status: 'ENABLED',
									currency: 'XDR',
									amount: 38400000,
									disbursed: 730716.39,
									financier: 'IDA',
									name: 'IPF - Investment Project Financing',
									num: 'E4250',
									dateApproved: '2025-03-28T00:00:00.000Z',
									dateSigning: '2025-04-25T00:00:00.000Z',
									dateClosing: '2029-12-28T00:00:00.000Z',
									subLoanNum: null,
									created: '2026-01-29T13:35:46.971Z',
									modified: '2026-01-29T13:39:44.224Z',
									cancelled: null,
									code: 'IDAE4250',
								},
							},
						],
						tax: 0,
						total: 1060,
						id: 14698,
						status: 'COMPLETED',
						metadata: {
							uuid: '4a697185-15ba-4866-baa6-be874306c007',
							invoiceAmount: 1060,
							invoiceCurrency: 'USD',
						},
						traceability: {
							documents: {
								required: [1254, 1266],
								uploaded: [26502, 26503],
							},
							value: 100,
						},
						type: 'PAYMENT',
						date: '2026-02-16T00:00:00.000Z',
						created: '2026-03-21T14:27:27.834Z',
						modified: '2026-05-20T09:24:50.099Z',
						quantity: null,
						isReceived: null,
						amountReceived: null,
						benefit: null,
						category: 699,
						component: 1149,
						contract: null,
						designatedAccount: null,
						expenseType: {
							id: 2053,
							name: 'Dépenses opérationnelles',
							created: '2026-01-29T15:09:24.768Z',
							modified: '2026-01-29T16:25:03.495Z',
							status: 'ACTIVE',
							entity: null,
							project: 318,
						},
						fromAccount: {
							id: 1636,
							idWbg: '000000000010021601',
							name: 'DA-A',
							num: '111080980',
							institution: "BANQUE DE LA REPUBLIQUE D'HAITI",
							type: 'DESIGNATED',
							currency: 'USD',
							created: '2026-01-29T13:35:46.971Z',
							modified: null,
							status: 'ACTIVE',
							aba: null,
							holder: null,
							isReimbursement: false,
							postcode: null,
							routeCode: null,
							sortCode: null,
							state: null,
							street: null,
							swiftCode: null,
							town: null,
							country: null,
						},
						fromEntity: 2299,
						project: 318,
						toAccount: null,
						toEntity: 3849,
						user: 2026,
						withdrawalApplication: 103,
					},
				],
				value: 1060,
			},
			{
				source: 0,
				target: 18,
				transactions: [
					{
						amount: 27577.2,
						currency: 'USD',
						payments: [
							{
								id: 30329,
								source: null,
								amount: 13788.6,
								currency: 'USD',
								currencyReceived: null,
								metadata: {
									tax: null,
									hash: null,
									loan: 457,
									uuid: '6ec893ca-0746-4625-99f3-28560ced487a',
									amount: 13788.6,
									source: null,
									currency: 'USD',
									metadata: null,
									projectId: 318,
									toAccount: -1,
									toAddress: '0xBfa893024ed2881630be2F2B9dAe4b920ACd147e',
									reimbursed: {
										amount: null,
									},
									fromAccount: 1636,
									fromAddress: '0xF6379168Ba44cd6A7AB2E9106001Fde599a9EF08',
									transaction: 25694,
									taxEquivalent: null,
									amountReceived: null,
									blkTransaction: {
										id: null,
										status: 'STARTED',
									},
									revertedPayment: null,
									amountEquivalent: null,
									currencyReceived: null,
								},
								hash: 'e3000981f5e44ca0d489937e46662f35f511c2f50cd52e2fa17a74a9e8c99271',
								created: '2026-05-10T14:29:45.633Z',
								modified: null,
								tax: null,
								amountEquivalent: null,
								taxEquivalent: null,
								amountReceived: null,
								reimbursed: {
									amount: null,
								},
								blkTransaction: {
									id: '0x4b73294e9764080317dea760558e634f7e6362b114138bfaba38c62b1bf72f6e',
									status: 'DONE',
								},
								revertedPayment: null,
								transaction: 25694,
								loan: {
									id: 457,
									idWbg: null,
									status: 'ENABLED',
									currency: 'XDR',
									amount: 38400000,
									disbursed: 730716.39,
									financier: 'IDA',
									name: 'IPF - Investment Project Financing',
									num: 'E4250',
									dateApproved: '2025-03-28T00:00:00.000Z',
									dateSigning: '2025-04-25T00:00:00.000Z',
									dateClosing: '2029-12-28T00:00:00.000Z',
									subLoanNum: null,
									created: '2026-01-29T13:35:46.971Z',
									modified: '2026-01-29T13:39:44.224Z',
									cancelled: null,
									code: 'IDAE4250',
								},
							},
							{
								id: 30335,
								source: null,
								amount: 13788.6,
								currency: 'USD',
								currencyReceived: null,
								metadata: {
									tax: null,
									loan: 457,
									amount: 13788.6,
									currency: 'USD',
									isRevert: true,
									toAccount: 1636,
									toAddress: '0xF6379168Ba44cd6A7AB2E9106001Fde599a9EF08',
									fromAccount: -1,
									fromAddress: '0xBfa893024ed2881630be2F2B9dAe4b920ACd147e',
									transaction: 25694,
									amountReceived: null,
									currencyReceived: null,
								},
								hash: '7b85abfec82b17cb95a22414ea34a274572c2173b0c72091e58639e731a0ced8',
								created: '2026-05-10T14:37:49.589Z',
								modified: null,
								tax: null,
								amountEquivalent: null,
								taxEquivalent: null,
								amountReceived: null,
								reimbursed: {
									amount: null,
								},
								blkTransaction: {
									id: '0x574b7d92722fe4913a6d308021970187ed74833bd6801902143366d3aa188162',
									status: 'DONE',
								},
								revertedPayment: 30329,
								transaction: 25694,
								loan: {
									id: 457,
									idWbg: null,
									status: 'ENABLED',
									currency: 'XDR',
									amount: 38400000,
									disbursed: 730716.39,
									financier: 'IDA',
									name: 'IPF - Investment Project Financing',
									num: 'E4250',
									dateApproved: '2025-03-28T00:00:00.000Z',
									dateSigning: '2025-04-25T00:00:00.000Z',
									dateClosing: '2029-12-28T00:00:00.000Z',
									subLoanNum: null,
									created: '2026-01-29T13:35:46.971Z',
									modified: '2026-01-29T13:39:44.224Z',
									cancelled: null,
									code: 'IDAE4250',
								},
							},
						],
						tax: 0,
						total: 27577.2,
						id: 25694,
						status: 'REVERTED',
						metadata: {
							uuid: '183751db-e0e8-403e-b0fa-25db0c6558ed',
							invoiceAmount: 13788.6,
							invoiceCurrency: 'USD',
						},
						traceability: {
							documents: {
								required: [1252, 1254, 1259],
								uploaded: [53662],
							},
							value: 33.33333333333333,
						},
						type: 'PAYMENT',
						date: '2026-03-03T00:00:00.000Z',
						created: '2026-05-10T14:29:45.618Z',
						modified: '2026-05-10T14:37:54.129Z',
						quantity: null,
						isReceived: null,
						amountReceived: null,
						benefit: null,
						category: 699,
						component: 1137,
						contract: null,
						designatedAccount: null,
						expenseType: {
							id: 2049,
							name: 'Travaux',
							created: '2026-01-29T15:03:07.088Z',
							modified: '2026-01-29T16:25:03.543Z',
							status: 'ACTIVE',
							entity: null,
							project: 318,
						},
						fromAccount: {
							id: 1636,
							idWbg: '000000000010021601',
							name: 'DA-A',
							num: '111080980',
							institution: "BANQUE DE LA REPUBLIQUE D'HAITI",
							type: 'DESIGNATED',
							currency: 'USD',
							created: '2026-01-29T13:35:46.971Z',
							modified: null,
							status: 'ACTIVE',
							aba: null,
							holder: null,
							isReimbursement: false,
							postcode: null,
							routeCode: null,
							sortCode: null,
							state: null,
							street: null,
							swiftCode: null,
							town: null,
							country: null,
						},
						fromEntity: 2299,
						project: 318,
						toAccount: null,
						toEntity: 5681,
						user: 2026,
						withdrawalApplication: null,
					},
					{
						amount: 13788.6,
						currency: 'USD',
						payments: [
							{
								id: 30334,
								source: null,
								amount: 13788.6,
								currency: 'USD',
								currencyReceived: null,
								metadata: {
									tax: null,
									hash: null,
									loan: 457,
									uuid: 'a5b635fd-107a-4fec-88c7-fd6923ffcab9',
									amount: 13788.6,
									source: null,
									currency: 'USD',
									metadata: null,
									projectId: 318,
									toAccount: -1,
									toAddress: '0xBfa893024ed2881630be2F2B9dAe4b920ACd147e',
									reimbursed: {
										amount: null,
									},
									fromAccount: 1636,
									fromAddress: '0xF6379168Ba44cd6A7AB2E9106001Fde599a9EF08',
									transaction: 25699,
									taxEquivalent: null,
									amountReceived: null,
									blkTransaction: {
										id: null,
										status: 'STARTED',
									},
									revertedPayment: null,
									amountEquivalent: null,
									currencyReceived: null,
								},
								hash: '4d3b7d7fa27c5c227e84369117bcf2699f93a4257070d31d2039e617cba2dc9b',
								created: '2026-05-10T14:35:13.217Z',
								modified: null,
								tax: null,
								amountEquivalent: null,
								taxEquivalent: null,
								amountReceived: null,
								reimbursed: {
									amount: null,
								},
								blkTransaction: {
									id: '0xe5edc16b14c3c7bf42160db5da318d6c61d76cadbeaf2f66c9765bd7e256db5e',
									status: 'DONE',
								},
								revertedPayment: null,
								transaction: 25699,
								loan: {
									id: 457,
									idWbg: null,
									status: 'ENABLED',
									currency: 'XDR',
									amount: 38400000,
									disbursed: 730716.39,
									financier: 'IDA',
									name: 'IPF - Investment Project Financing',
									num: 'E4250',
									dateApproved: '2025-03-28T00:00:00.000Z',
									dateSigning: '2025-04-25T00:00:00.000Z',
									dateClosing: '2029-12-28T00:00:00.000Z',
									subLoanNum: null,
									created: '2026-01-29T13:35:46.971Z',
									modified: '2026-01-29T13:39:44.224Z',
									cancelled: null,
									code: 'IDAE4250',
								},
							},
						],
						tax: 0,
						total: 13788.6,
						id: 25699,
						status: 'COMPLETED',
						metadata: {
							uuid: 'f421ea31-19f3-4dc7-a835-3fea2f7eecaa',
							invoiceAmount: 13788.6,
							invoiceCurrency: 'USD',
						},
						traceability: {
							documents: {
								required: [1252, 1254, 1259],
								uploaded: [53667, 53669, 53670],
							},
							value: 100,
						},
						type: 'PAYMENT',
						date: '2026-03-03T00:00:00.000Z',
						created: '2026-05-10T14:35:13.204Z',
						modified: '2026-05-20T09:24:49.357Z',
						quantity: null,
						isReceived: null,
						amountReceived: null,
						benefit: null,
						category: 699,
						component: 1137,
						contract: null,
						designatedAccount: null,
						expenseType: {
							id: 2049,
							name: 'Travaux',
							created: '2026-01-29T15:03:07.088Z',
							modified: '2026-01-29T16:25:03.543Z',
							status: 'ACTIVE',
							entity: null,
							project: 318,
						},
						fromAccount: {
							id: 1636,
							idWbg: '000000000010021601',
							name: 'DA-A',
							num: '111080980',
							institution: "BANQUE DE LA REPUBLIQUE D'HAITI",
							type: 'DESIGNATED',
							currency: 'USD',
							created: '2026-01-29T13:35:46.971Z',
							modified: null,
							status: 'ACTIVE',
							aba: null,
							holder: null,
							isReimbursement: false,
							postcode: null,
							routeCode: null,
							sortCode: null,
							state: null,
							street: null,
							swiftCode: null,
							town: null,
							country: null,
						},
						fromEntity: 2299,
						project: 318,
						toAccount: null,
						toEntity: 5681,
						user: 2026,
						withdrawalApplication: 103,
					},
				],
				value: 41365.8,
			},
			{
				source: 0,
				target: 19,
				transactions: [
					{
						amount: 500,
						currency: 'USD',
						payments: [
							{
								id: 30361,
								source: null,
								amount: 500,
								currency: 'USD',
								currencyReceived: null,
								metadata: {
									tax: null,
									hash: null,
									loan: 457,
									uuid: '212772de-1b59-4a0e-a8b1-27b4670264fd',
									amount: 500,
									source: null,
									currency: 'USD',
									metadata: null,
									projectId: 318,
									toAccount: -1,
									toAddress: '0xa6a4192527B874F3Aec5e42a67f20986D8CA5b1B',
									reimbursed: {
										amount: null,
									},
									fromAccount: 1636,
									fromAddress: '0xF6379168Ba44cd6A7AB2E9106001Fde599a9EF08',
									transaction: 25725,
									taxEquivalent: null,
									amountReceived: null,
									blkTransaction: {
										id: null,
										status: 'STARTED',
									},
									revertedPayment: null,
									amountEquivalent: null,
									currencyReceived: null,
								},
								hash: '5749b5040dbd7426b1b2eea9f584694dffaedd895ac4bbd4ccacffd8292ecc7b',
								created: '2026-05-10T15:18:42.457Z',
								modified: null,
								tax: null,
								amountEquivalent: null,
								taxEquivalent: null,
								amountReceived: null,
								reimbursed: {
									amount: null,
								},
								blkTransaction: {
									id: '0x573c6940232a6a3b8cb0ff10efa137bdd2f7c67f70aae847614f74ae0c355a5e',
									status: 'DONE',
								},
								revertedPayment: null,
								transaction: 25725,
								loan: {
									id: 457,
									idWbg: null,
									status: 'ENABLED',
									currency: 'XDR',
									amount: 38400000,
									disbursed: 730716.39,
									financier: 'IDA',
									name: 'IPF - Investment Project Financing',
									num: 'E4250',
									dateApproved: '2025-03-28T00:00:00.000Z',
									dateSigning: '2025-04-25T00:00:00.000Z',
									dateClosing: '2029-12-28T00:00:00.000Z',
									subLoanNum: null,
									created: '2026-01-29T13:35:46.971Z',
									modified: '2026-01-29T13:39:44.224Z',
									cancelled: null,
									code: 'IDAE4250',
								},
							},
						],
						tax: 0,
						total: 500,
						id: 25725,
						status: 'COMPLETED',
						metadata: {
							uuid: 'cc153d6c-6d5b-4053-b0aa-d5ada72f3ad6',
							invoiceAmount: 500,
							invoiceCurrency: 'USD',
						},
						traceability: {
							documents: {
								required: [1254, 1266],
								uploaded: [53716, 53717],
							},
							value: 100,
						},
						type: 'PAYMENT',
						date: '2026-03-04T00:00:00.000Z',
						created: '2026-05-10T15:18:42.445Z',
						modified: '2026-05-20T09:24:49.133Z',
						quantity: null,
						isReceived: null,
						amountReceived: null,
						benefit: null,
						category: 699,
						component: 1146,
						contract: null,
						designatedAccount: null,
						expenseType: {
							id: 2053,
							name: 'Dépenses opérationnelles',
							created: '2026-01-29T15:09:24.768Z',
							modified: '2026-01-29T16:25:03.495Z',
							status: 'ACTIVE',
							entity: null,
							project: 318,
						},
						fromAccount: {
							id: 1636,
							idWbg: '000000000010021601',
							name: 'DA-A',
							num: '111080980',
							institution: "BANQUE DE LA REPUBLIQUE D'HAITI",
							type: 'DESIGNATED',
							currency: 'USD',
							created: '2026-01-29T13:35:46.971Z',
							modified: null,
							status: 'ACTIVE',
							aba: null,
							holder: null,
							isReimbursement: false,
							postcode: null,
							routeCode: null,
							sortCode: null,
							state: null,
							street: null,
							swiftCode: null,
							town: null,
							country: null,
						},
						fromEntity: 2299,
						project: 318,
						toAccount: null,
						toEntity: 5689,
						user: 2026,
						withdrawalApplication: 103,
					},
				],
				value: 500,
			},
			{
				source: 0,
				target: 20,
				transactions: [
					{
						amount: 5909.4,
						currency: 'USD',
						payments: [
							{
								id: 30344,
								source: null,
								amount: 5909.4,
								currency: 'USD',
								currencyReceived: null,
								metadata: {
									tax: null,
									hash: null,
									loan: 457,
									uuid: 'c3d5877b-5f2c-4225-84a7-b9b024fb9cdf',
									amount: 5909.4,
									source: null,
									currency: 'USD',
									metadata: null,
									projectId: 318,
									toAccount: -1,
									toAddress: '0x311C8f7c133B12c3A05aFAFBdBA5d46A644Be4DD',
									reimbursed: {
										amount: null,
									},
									fromAccount: 1636,
									fromAddress: '0xF6379168Ba44cd6A7AB2E9106001Fde599a9EF08',
									transaction: 25708,
									taxEquivalent: null,
									amountReceived: null,
									blkTransaction: {
										id: null,
										status: 'STARTED',
									},
									revertedPayment: null,
									amountEquivalent: null,
									currencyReceived: null,
								},
								hash: '63f52f7f32606b26478fac2578eec0ae1f264eccec6a496273b64673f37a1d65',
								created: '2026-05-10T14:53:22.620Z',
								modified: null,
								tax: null,
								amountEquivalent: null,
								taxEquivalent: null,
								amountReceived: null,
								reimbursed: {
									amount: null,
								},
								blkTransaction: {
									id: '0xf3f50bd46842532c7bc2adea58b935dfeffd26cca0fa543e8c9078245b26c18a',
									status: 'DONE',
								},
								revertedPayment: null,
								transaction: 25708,
								loan: {
									id: 457,
									idWbg: null,
									status: 'ENABLED',
									currency: 'XDR',
									amount: 38400000,
									disbursed: 730716.39,
									financier: 'IDA',
									name: 'IPF - Investment Project Financing',
									num: 'E4250',
									dateApproved: '2025-03-28T00:00:00.000Z',
									dateSigning: '2025-04-25T00:00:00.000Z',
									dateClosing: '2029-12-28T00:00:00.000Z',
									subLoanNum: null,
									created: '2026-01-29T13:35:46.971Z',
									modified: '2026-01-29T13:39:44.224Z',
									cancelled: null,
									code: 'IDAE4250',
								},
							},
						],
						tax: 0,
						total: 5909.4,
						id: 25708,
						status: 'COMPLETED',
						metadata: {
							uuid: 'b3835be4-4f3a-495a-bc88-03de6a8097b8',
							invoiceAmount: 5909.4,
							invoiceCurrency: 'USD',
						},
						traceability: {
							documents: {
								required: [1252, 1254, 1259],
								uploaded: [53684, 53685, 53686],
							},
							value: 100,
						},
						type: 'PAYMENT',
						date: '2026-03-03T00:00:00.000Z',
						created: '2026-05-10T14:53:22.606Z',
						modified: '2026-05-20T09:24:49.291Z',
						quantity: null,
						isReceived: null,
						amountReceived: null,
						benefit: null,
						category: 699,
						component: 1137,
						contract: null,
						designatedAccount: null,
						expenseType: {
							id: 2049,
							name: 'Travaux',
							created: '2026-01-29T15:03:07.088Z',
							modified: '2026-01-29T16:25:03.543Z',
							status: 'ACTIVE',
							entity: null,
							project: 318,
						},
						fromAccount: {
							id: 1636,
							idWbg: '000000000010021601',
							name: 'DA-A',
							num: '111080980',
							institution: "BANQUE DE LA REPUBLIQUE D'HAITI",
							type: 'DESIGNATED',
							currency: 'USD',
							created: '2026-01-29T13:35:46.971Z',
							modified: null,
							status: 'ACTIVE',
							aba: null,
							holder: null,
							isReimbursement: false,
							postcode: null,
							routeCode: null,
							sortCode: null,
							state: null,
							street: null,
							swiftCode: null,
							town: null,
							country: null,
						},
						fromEntity: 2299,
						project: 318,
						toAccount: null,
						toEntity: 5683,
						user: 2026,
						withdrawalApplication: 103,
					},
				],
				value: 5909.4,
			},
			{
				source: 0,
				target: 21,
				transactions: [
					{
						amount: 13788.6,
						currency: 'USD',
						payments: [
							{
								id: 30339,
								source: null,
								amount: 13788.6,
								currency: 'USD',
								currencyReceived: null,
								metadata: {
									tax: null,
									hash: null,
									loan: 457,
									uuid: 'a6ce11ca-28b0-4f1c-b930-caaeee41baf8',
									amount: 13788.6,
									source: null,
									currency: 'USD',
									metadata: null,
									projectId: 318,
									toAccount: -1,
									toAddress: '0x91eE5E2d4ce3cc8a0448d3Be5C3Ba279EE8e2BDc',
									reimbursed: {
										amount: null,
									},
									fromAccount: 1636,
									fromAddress: '0xF6379168Ba44cd6A7AB2E9106001Fde599a9EF08',
									transaction: 25703,
									taxEquivalent: null,
									amountReceived: null,
									blkTransaction: {
										id: null,
										status: 'STARTED',
									},
									revertedPayment: null,
									amountEquivalent: null,
									currencyReceived: null,
								},
								hash: 'aab846eb582ca4e6eb05034ed41ed86e9b923426fb0d8f0a4a6cc6e9f5cfb22b',
								created: '2026-05-10T14:44:29.117Z',
								modified: null,
								tax: null,
								amountEquivalent: null,
								taxEquivalent: null,
								amountReceived: null,
								reimbursed: {
									amount: null,
								},
								blkTransaction: {
									id: '0x53eeb86616c39991be18e673e11c43c8ec52ad0663623e75e0dae41ce7736948',
									status: 'DONE',
								},
								revertedPayment: null,
								transaction: 25703,
								loan: {
									id: 457,
									idWbg: null,
									status: 'ENABLED',
									currency: 'XDR',
									amount: 38400000,
									disbursed: 730716.39,
									financier: 'IDA',
									name: 'IPF - Investment Project Financing',
									num: 'E4250',
									dateApproved: '2025-03-28T00:00:00.000Z',
									dateSigning: '2025-04-25T00:00:00.000Z',
									dateClosing: '2029-12-28T00:00:00.000Z',
									subLoanNum: null,
									created: '2026-01-29T13:35:46.971Z',
									modified: '2026-01-29T13:39:44.224Z',
									cancelled: null,
									code: 'IDAE4250',
								},
							},
						],
						tax: 0,
						total: 13788.6,
						id: 25703,
						status: 'COMPLETED',
						metadata: {
							uuid: '5ecfc036-b475-446a-8c09-dc47158992bc',
							invoiceAmount: 13788.6,
							invoiceCurrency: 'USD',
						},
						traceability: {
							documents: {
								required: [1252, 1254, 1259],
								uploaded: [53675, 53676, 53677],
							},
							value: 100,
						},
						type: 'PAYMENT',
						date: '2026-03-03T00:00:00.000Z',
						created: '2026-05-10T14:44:29.103Z',
						modified: '2026-05-20T09:24:49.323Z',
						quantity: null,
						isReceived: null,
						amountReceived: null,
						benefit: null,
						category: 699,
						component: 1137,
						contract: null,
						designatedAccount: null,
						expenseType: {
							id: 2049,
							name: 'Travaux',
							created: '2026-01-29T15:03:07.088Z',
							modified: '2026-01-29T16:25:03.543Z',
							status: 'ACTIVE',
							entity: null,
							project: 318,
						},
						fromAccount: {
							id: 1636,
							idWbg: '000000000010021601',
							name: 'DA-A',
							num: '111080980',
							institution: "BANQUE DE LA REPUBLIQUE D'HAITI",
							type: 'DESIGNATED',
							currency: 'USD',
							created: '2026-01-29T13:35:46.971Z',
							modified: null,
							status: 'ACTIVE',
							aba: null,
							holder: null,
							isReimbursement: false,
							postcode: null,
							routeCode: null,
							sortCode: null,
							state: null,
							street: null,
							swiftCode: null,
							town: null,
							country: null,
						},
						fromEntity: 2299,
						project: 318,
						toAccount: null,
						toEntity: 5682,
						user: 2026,
						withdrawalApplication: 103,
					},
				],
				value: 13788.6,
			},
			{
				source: 0,
				target: 22,
				transactions: [
					{
						amount: 974,
						currency: 'USD',
						payments: [
							{
								id: 30388,
								source: null,
								amount: 974,
								currency: 'USD',
								currencyReceived: null,
								metadata: {
									tax: null,
									hash: null,
									loan: 457,
									uuid: '9fc6e103-1ebb-483a-b836-ca552e06abe3',
									amount: 974,
									source: null,
									currency: 'USD',
									metadata: null,
									projectId: 318,
									toAccount: -1,
									toAddress: '0xe838F7f9d7B414C353536414f416303fA901f5Ae',
									reimbursed: {
										amount: null,
									},
									fromAccount: 1636,
									fromAddress: '0xF6379168Ba44cd6A7AB2E9106001Fde599a9EF08',
									transaction: 25752,
									taxEquivalent: null,
									amountReceived: null,
									blkTransaction: {
										id: null,
										status: 'STARTED',
									},
									revertedPayment: null,
									amountEquivalent: null,
									currencyReceived: null,
								},
								hash: '19bb2b1aa0eaf19d9f1b86f43c88f462f49e82bdce320f865901caaf1d75b61f',
								created: '2026-05-10T16:22:02.380Z',
								modified: null,
								tax: null,
								amountEquivalent: null,
								taxEquivalent: null,
								amountReceived: null,
								reimbursed: {
									amount: null,
								},
								blkTransaction: {
									id: '0x5ac04aaa0a8014c2fc79c3da55d5bb19a803171930f497ad431f9e1e0a91997d',
									status: 'DONE',
								},
								revertedPayment: null,
								transaction: 25752,
								loan: {
									id: 457,
									idWbg: null,
									status: 'ENABLED',
									currency: 'XDR',
									amount: 38400000,
									disbursed: 730716.39,
									financier: 'IDA',
									name: 'IPF - Investment Project Financing',
									num: 'E4250',
									dateApproved: '2025-03-28T00:00:00.000Z',
									dateSigning: '2025-04-25T00:00:00.000Z',
									dateClosing: '2029-12-28T00:00:00.000Z',
									subLoanNum: null,
									created: '2026-01-29T13:35:46.971Z',
									modified: '2026-01-29T13:39:44.224Z',
									cancelled: null,
									code: 'IDAE4250',
								},
							},
						],
						tax: 0,
						total: 974,
						id: 25752,
						status: 'COMPLETED',
						metadata: {
							uuid: '89fa580b-f4a3-4a47-8e65-badb978756a5',
							invoiceAmount: 974,
							invoiceCurrency: 'USD',
						},
						traceability: {
							documents: {
								required: [1254, 1266],
								uploaded: [53775, 53776],
							},
							value: 100,
						},
						type: 'PAYMENT',
						date: '2026-03-18T00:00:00.000Z',
						created: '2026-05-10T16:22:02.352Z',
						modified: '2026-05-20T09:24:48.823Z',
						quantity: null,
						isReceived: null,
						amountReceived: null,
						benefit: null,
						category: 699,
						component: 1148,
						contract: null,
						designatedAccount: null,
						expenseType: {
							id: 2053,
							name: 'Dépenses opérationnelles',
							created: '2026-01-29T15:09:24.768Z',
							modified: '2026-01-29T16:25:03.495Z',
							status: 'ACTIVE',
							entity: null,
							project: 318,
						},
						fromAccount: {
							id: 1636,
							idWbg: '000000000010021601',
							name: 'DA-A',
							num: '111080980',
							institution: "BANQUE DE LA REPUBLIQUE D'HAITI",
							type: 'DESIGNATED',
							currency: 'USD',
							created: '2026-01-29T13:35:46.971Z',
							modified: null,
							status: 'ACTIVE',
							aba: null,
							holder: null,
							isReimbursement: false,
							postcode: null,
							routeCode: null,
							sortCode: null,
							state: null,
							street: null,
							swiftCode: null,
							town: null,
							country: null,
						},
						fromEntity: 2299,
						project: 318,
						toAccount: null,
						toEntity: 3121,
						user: 2026,
						withdrawalApplication: 103,
					},
					{
						amount: 1472,
						currency: 'USD',
						payments: [
							{
								id: 30468,
								source: null,
								amount: 1472,
								currency: 'USD',
								currencyReceived: null,
								metadata: {
									tax: null,
									hash: null,
									loan: 457,
									uuid: 'db162dc2-0690-4afd-b813-35450addecfa',
									amount: 1472,
									source: null,
									currency: 'USD',
									metadata: null,
									projectId: 318,
									toAccount: -1,
									toAddress: '0xe838F7f9d7B414C353536414f416303fA901f5Ae',
									reimbursed: {
										amount: null,
									},
									fromAccount: 1636,
									fromAddress: '0xF6379168Ba44cd6A7AB2E9106001Fde599a9EF08',
									transaction: 25830,
									taxEquivalent: null,
									amountReceived: null,
									blkTransaction: {
										id: null,
										status: 'STARTED',
									},
									revertedPayment: null,
									amountEquivalent: null,
									currencyReceived: null,
								},
								hash: 'df66307e63cb9260b2ccce7b19df4f63b609d90a2a689a53a99bc697e72a4aff',
								created: '2026-05-10T20:30:06.107Z',
								modified: null,
								tax: null,
								amountEquivalent: null,
								taxEquivalent: null,
								amountReceived: null,
								reimbursed: {
									amount: null,
								},
								blkTransaction: {
									id: '0xe52c5ca54f1a0f6f913fa63c63a1476105cbb42f1bd7f1125d1c1b29fd585d88',
									status: 'DONE',
								},
								revertedPayment: null,
								transaction: 25830,
								loan: {
									id: 457,
									idWbg: null,
									status: 'ENABLED',
									currency: 'XDR',
									amount: 38400000,
									disbursed: 730716.39,
									financier: 'IDA',
									name: 'IPF - Investment Project Financing',
									num: 'E4250',
									dateApproved: '2025-03-28T00:00:00.000Z',
									dateSigning: '2025-04-25T00:00:00.000Z',
									dateClosing: '2029-12-28T00:00:00.000Z',
									subLoanNum: null,
									created: '2026-01-29T13:35:46.971Z',
									modified: '2026-01-29T13:39:44.224Z',
									cancelled: null,
									code: 'IDAE4250',
								},
							},
						],
						tax: 0,
						total: 1472,
						id: 25830,
						status: 'COMPLETED',
						metadata: {
							uuid: 'fb4c0b01-b58c-4e9b-ae62-2d01a353d30f',
							invoiceAmount: 1472,
							invoiceCurrency: 'USD',
						},
						traceability: {
							documents: {
								required: [1254, 1266],
								uploaded: [53891, 53892],
							},
							value: 100,
						},
						type: 'PAYMENT',
						date: '2026-03-30T00:00:00.000Z',
						created: '2026-05-10T20:30:06.091Z',
						modified: '2026-05-20T09:24:48.378Z',
						quantity: null,
						isReceived: null,
						amountReceived: null,
						benefit: null,
						category: 699,
						component: 1148,
						contract: null,
						designatedAccount: null,
						expenseType: {
							id: 2053,
							name: 'Dépenses opérationnelles',
							created: '2026-01-29T15:09:24.768Z',
							modified: '2026-01-29T16:25:03.495Z',
							status: 'ACTIVE',
							entity: null,
							project: 318,
						},
						fromAccount: {
							id: 1636,
							idWbg: '000000000010021601',
							name: 'DA-A',
							num: '111080980',
							institution: "BANQUE DE LA REPUBLIQUE D'HAITI",
							type: 'DESIGNATED',
							currency: 'USD',
							created: '2026-01-29T13:35:46.971Z',
							modified: null,
							status: 'ACTIVE',
							aba: null,
							holder: null,
							isReimbursement: false,
							postcode: null,
							routeCode: null,
							sortCode: null,
							state: null,
							street: null,
							swiftCode: null,
							town: null,
							country: null,
						},
						fromEntity: 2299,
						project: 318,
						toAccount: null,
						toEntity: 3121,
						user: 2026,
						withdrawalApplication: 103,
					},
					{
						amount: 234,
						currency: 'USD',
						payments: [
							{
								id: 18740,
								source: null,
								amount: 234,
								currency: 'USD',
								currencyReceived: null,
								metadata: {
									tax: null,
									hash: null,
									loan: 457,
									uuid: '2cbe3b82-7518-41da-9538-15ea10d0f696',
									amount: 234,
									source: null,
									currency: 'USD',
									metadata: null,
									projectId: 318,
									toAccount: -1,
									toAddress: '0xe838F7f9d7B414C353536414f416303fA901f5Ae',
									reimbursed: {
										amount: null,
									},
									fromAccount: 1636,
									fromAddress: '0xF6379168Ba44cd6A7AB2E9106001Fde599a9EF08',
									transaction: 15641,
									taxEquivalent: null,
									amountReceived: null,
									blkTransaction: {
										id: null,
										status: 'STARTED',
									},
									revertedPayment: null,
									amountEquivalent: null,
									currencyReceived: null,
								},
								hash: '8260e58880eab95fed405ea30138fb228bf6c858923ec0e39f51e6f859f015cb',
								created: '2026-03-25T17:14:00.692Z',
								modified: null,
								tax: null,
								amountEquivalent: null,
								taxEquivalent: null,
								amountReceived: null,
								reimbursed: {
									amount: null,
								},
								blkTransaction: {
									id: '0x9c59fe2ceea1172f80fce0b8aeaeca735faffc483175c23ad7494bd986d8951c',
									status: 'DONE',
								},
								revertedPayment: null,
								transaction: 15641,
								loan: {
									id: 457,
									idWbg: null,
									status: 'ENABLED',
									currency: 'XDR',
									amount: 38400000,
									disbursed: 730716.39,
									financier: 'IDA',
									name: 'IPF - Investment Project Financing',
									num: 'E4250',
									dateApproved: '2025-03-28T00:00:00.000Z',
									dateSigning: '2025-04-25T00:00:00.000Z',
									dateClosing: '2029-12-28T00:00:00.000Z',
									subLoanNum: null,
									created: '2026-01-29T13:35:46.971Z',
									modified: '2026-01-29T13:39:44.224Z',
									cancelled: null,
									code: 'IDAE4250',
								},
							},
						],
						tax: 0,
						total: 234,
						id: 15641,
						status: 'COMPLETED',
						metadata: {
							uuid: '08b7e868-2bfa-4bb1-92d5-2ac7aafcfb1d',
							invoiceAmount: 34580,
							invoiceCurrency: 'HTG',
						},
						traceability: {
							documents: {
								required: [1254, 1266],
								uploaded: [28801, 28802],
							},
							value: 100,
						},
						type: 'PAYMENT',
						date: '2026-02-04T00:00:00.000Z',
						created: '2026-03-25T17:14:00.676Z',
						modified: '2026-05-20T09:24:49.688Z',
						quantity: null,
						isReceived: null,
						amountReceived: null,
						benefit: null,
						category: 699,
						component: 1148,
						contract: null,
						designatedAccount: null,
						expenseType: {
							id: 2053,
							name: 'Dépenses opérationnelles',
							created: '2026-01-29T15:09:24.768Z',
							modified: '2026-01-29T16:25:03.495Z',
							status: 'ACTIVE',
							entity: null,
							project: 318,
						},
						fromAccount: {
							id: 1636,
							idWbg: '000000000010021601',
							name: 'DA-A',
							num: '111080980',
							institution: "BANQUE DE LA REPUBLIQUE D'HAITI",
							type: 'DESIGNATED',
							currency: 'USD',
							created: '2026-01-29T13:35:46.971Z',
							modified: null,
							status: 'ACTIVE',
							aba: null,
							holder: null,
							isReimbursement: false,
							postcode: null,
							routeCode: null,
							sortCode: null,
							state: null,
							street: null,
							swiftCode: null,
							town: null,
							country: null,
						},
						fromEntity: 2299,
						project: 318,
						toAccount: null,
						toEntity: 3121,
						user: 2026,
						withdrawalApplication: 103,
					},
					{
						amount: 2274,
						currency: 'USD',
						payments: [
							{
								id: 16458,
								source: null,
								amount: 2274,
								currency: 'USD',
								currencyReceived: null,
								metadata: {
									tax: null,
									hash: null,
									loan: 457,
									uuid: '42700847-3f0e-4152-b0e3-929d7d7259b7',
									amount: 2274,
									source: null,
									currency: 'USD',
									metadata: null,
									projectId: 318,
									toAccount: -1,
									toAddress: '0xe838F7f9d7B414C353536414f416303fA901f5Ae',
									fromAccount: 1636,
									fromAddress: '0xF6379168Ba44cd6A7AB2E9106001Fde599a9EF08',
									transaction: 13611,
									taxEquivalent: null,
									amountReceived: null,
									blkTransaction: {
										id: null,
										status: 'STARTED',
									},
									revertedPayment: null,
									amountEquivalent: null,
									currencyReceived: null,
								},
								hash: '1a3b3ad78b8c65b5dd5d5d0ca4b07c625e9b38112050e1262ab659471b70d1eb',
								created: '2026-03-13T16:28:48.905Z',
								modified: null,
								tax: null,
								amountEquivalent: null,
								taxEquivalent: null,
								amountReceived: null,
								reimbursed: {
									amount: null,
								},
								blkTransaction: {
									id: '0x91e34330fe40644e8e04653451662b8f6dd01b1b3437418b276a8c827e409320',
									status: 'DONE',
								},
								revertedPayment: null,
								transaction: 13611,
								loan: {
									id: 457,
									idWbg: null,
									status: 'ENABLED',
									currency: 'XDR',
									amount: 38400000,
									disbursed: 730716.39,
									financier: 'IDA',
									name: 'IPF - Investment Project Financing',
									num: 'E4250',
									dateApproved: '2025-03-28T00:00:00.000Z',
									dateSigning: '2025-04-25T00:00:00.000Z',
									dateClosing: '2029-12-28T00:00:00.000Z',
									subLoanNum: null,
									created: '2026-01-29T13:35:46.971Z',
									modified: '2026-01-29T13:39:44.224Z',
									cancelled: null,
									code: 'IDAE4250',
								},
							},
						],
						tax: 0,
						total: 2274,
						id: 13611,
						status: 'COMPLETED',
						metadata: {
							uuid: '8f821646-7ede-4c40-9c87-5f22ec10af69',
							invoiceAmount: 2274,
							invoiceCurrency: 'USD',
						},
						traceability: {
							documents: {
								required: [1254, 1266],
								uploaded: [24127, 24128],
							},
							value: 100,
						},
						type: 'PAYMENT',
						date: '2026-01-21T00:00:00.000Z',
						created: '2026-03-13T16:28:48.890Z',
						modified: '2026-05-20T09:24:50.821Z',
						quantity: null,
						isReceived: null,
						amountReceived: null,
						benefit: null,
						category: 699,
						component: 1148,
						contract: null,
						designatedAccount: null,
						expenseType: {
							id: 2053,
							name: 'Dépenses opérationnelles',
							created: '2026-01-29T15:09:24.768Z',
							modified: '2026-01-29T16:25:03.495Z',
							status: 'ACTIVE',
							entity: null,
							project: 318,
						},
						fromAccount: {
							id: 1636,
							idWbg: '000000000010021601',
							name: 'DA-A',
							num: '111080980',
							institution: "BANQUE DE LA REPUBLIQUE D'HAITI",
							type: 'DESIGNATED',
							currency: 'USD',
							created: '2026-01-29T13:35:46.971Z',
							modified: null,
							status: 'ACTIVE',
							aba: null,
							holder: null,
							isReimbursement: false,
							postcode: null,
							routeCode: null,
							sortCode: null,
							state: null,
							street: null,
							swiftCode: null,
							town: null,
							country: null,
						},
						fromEntity: 2299,
						project: 318,
						toAccount: null,
						toEntity: 3121,
						user: 2026,
						withdrawalApplication: 103,
					},
				],
				value: 4954,
			},
			{
				source: 0,
				target: 23,
				transactions: [
					{
						amount: 790.7,
						currency: 'USD',
						payments: [
							{
								id: 30413,
								source: null,
								amount: 790.7,
								currency: 'USD',
								currencyReceived: null,
								metadata: {
									tax: null,
									hash: null,
									loan: 457,
									uuid: '5bc1dfca-debc-4be0-8cea-72dcef32bf96',
									amount: 790.7,
									source: null,
									currency: 'USD',
									metadata: null,
									projectId: 318,
									toAccount: -1,
									toAddress: '0x527AEDE14bBDEb1BaDE434d642197F0F268c7c3d',
									reimbursed: {
										amount: null,
									},
									fromAccount: 1636,
									fromAddress: '0xF6379168Ba44cd6A7AB2E9106001Fde599a9EF08',
									transaction: 25777,
									taxEquivalent: null,
									amountReceived: null,
									blkTransaction: {
										id: null,
										status: 'STARTED',
									},
									revertedPayment: null,
									amountEquivalent: null,
									currencyReceived: null,
								},
								hash: 'b0e64a094397e146f87cdeabfa8ed6de37ac6d708e3138b4e58ac4a26828d2d0',
								created: '2026-05-10T17:23:25.537Z',
								modified: null,
								tax: null,
								amountEquivalent: null,
								taxEquivalent: null,
								amountReceived: null,
								reimbursed: {
									amount: null,
								},
								blkTransaction: {
									id: '0x9a35a8d702eb98aaf203ab1f36083c78420c43eb288b709537d590c6de0eaa05',
									status: 'DONE',
								},
								revertedPayment: null,
								transaction: 25777,
								loan: {
									id: 457,
									idWbg: null,
									status: 'ENABLED',
									currency: 'XDR',
									amount: 38400000,
									disbursed: 730716.39,
									financier: 'IDA',
									name: 'IPF - Investment Project Financing',
									num: 'E4250',
									dateApproved: '2025-03-28T00:00:00.000Z',
									dateSigning: '2025-04-25T00:00:00.000Z',
									dateClosing: '2029-12-28T00:00:00.000Z',
									subLoanNum: null,
									created: '2026-01-29T13:35:46.971Z',
									modified: '2026-01-29T13:39:44.224Z',
									cancelled: null,
									code: 'IDAE4250',
								},
							},
						],
						tax: 0,
						total: 790.7,
						id: 25777,
						status: 'COMPLETED',
						metadata: {
							uuid: '54997d29-d061-46d0-8d3f-23022ca784db',
							invoiceAmount: 790.7,
							invoiceCurrency: 'USD',
						},
						traceability: {
							documents: {
								required: [1254, 1266],
								uploaded: [53804, 53805],
							},
							value: 100,
						},
						type: 'PAYMENT',
						date: '2026-03-26T00:00:00.000Z',
						created: '2026-05-10T17:23:25.517Z',
						modified: '2026-05-20T09:24:48.641Z',
						quantity: null,
						isReceived: null,
						amountReceived: null,
						benefit: null,
						category: 699,
						component: 1146,
						contract: null,
						designatedAccount: null,
						expenseType: {
							id: 2053,
							name: 'Dépenses opérationnelles',
							created: '2026-01-29T15:09:24.768Z',
							modified: '2026-01-29T16:25:03.495Z',
							status: 'ACTIVE',
							entity: null,
							project: 318,
						},
						fromAccount: {
							id: 1636,
							idWbg: '000000000010021601',
							name: 'DA-A',
							num: '111080980',
							institution: "BANQUE DE LA REPUBLIQUE D'HAITI",
							type: 'DESIGNATED',
							currency: 'USD',
							created: '2026-01-29T13:35:46.971Z',
							modified: null,
							status: 'ACTIVE',
							aba: null,
							holder: null,
							isReimbursement: false,
							postcode: null,
							routeCode: null,
							sortCode: null,
							state: null,
							street: null,
							swiftCode: null,
							town: null,
							country: null,
						},
						fromEntity: 2299,
						project: 318,
						toAccount: null,
						toEntity: 5687,
						user: 2026,
						withdrawalApplication: 103,
					},
				],
				value: 790.7,
			},
			{
				source: 0,
				target: 24,
				transactions: [
					{
						amount: 2139.69,
						currency: 'USD',
						payments: [
							{
								id: 30384,
								source: null,
								amount: 2139.69,
								currency: 'USD',
								currencyReceived: null,
								metadata: {
									tax: null,
									hash: null,
									loan: 457,
									uuid: 'c7e8c0d1-b66d-4150-b586-eff5dc73abb0',
									amount: 2139.69,
									source: null,
									currency: 'USD',
									metadata: null,
									projectId: 318,
									toAccount: -1,
									toAddress: '0xa290eABA17F5Db2676eCEbcd6f902Ba67cb36033',
									reimbursed: {
										amount: null,
									},
									fromAccount: 1636,
									fromAddress: '0xF6379168Ba44cd6A7AB2E9106001Fde599a9EF08',
									transaction: 25748,
									taxEquivalent: null,
									amountReceived: null,
									blkTransaction: {
										id: null,
										status: 'STARTED',
									},
									revertedPayment: null,
									amountEquivalent: null,
									currencyReceived: null,
								},
								hash: '9241dea0300312f8ff9a2c119cf23e60ffa980ddd39b1986f81a231f13810c0c',
								created: '2026-05-10T16:16:28.105Z',
								modified: null,
								tax: null,
								amountEquivalent: null,
								taxEquivalent: null,
								amountReceived: null,
								reimbursed: {
									amount: null,
								},
								blkTransaction: {
									id: '0xb672ba4cf0da082fb6dbcf414a119dbce30647702594a25cf3d98556feb0ac02',
									status: 'DONE',
								},
								revertedPayment: null,
								transaction: 25748,
								loan: {
									id: 457,
									idWbg: null,
									status: 'ENABLED',
									currency: 'XDR',
									amount: 38400000,
									disbursed: 730716.39,
									financier: 'IDA',
									name: 'IPF - Investment Project Financing',
									num: 'E4250',
									dateApproved: '2025-03-28T00:00:00.000Z',
									dateSigning: '2025-04-25T00:00:00.000Z',
									dateClosing: '2029-12-28T00:00:00.000Z',
									subLoanNum: null,
									created: '2026-01-29T13:35:46.971Z',
									modified: '2026-01-29T13:39:44.224Z',
									cancelled: null,
									code: 'IDAE4250',
								},
							},
						],
						tax: 0,
						total: 2139.69,
						id: 25748,
						status: 'COMPLETED',
						metadata: {
							uuid: '987d1eb6-f16e-4c70-95a0-f71fa014726c',
							invoiceAmount: 280000,
							invoiceCurrency: 'HTG',
						},
						traceability: {
							documents: {
								required: [1254, 1266],
								uploaded: [53764, 53766],
							},
							value: 100,
						},
						type: 'PAYMENT',
						date: '2026-03-18T00:00:00.000Z',
						created: '2026-05-10T16:16:28.090Z',
						modified: '2026-05-20T09:24:48.849Z',
						quantity: null,
						isReceived: null,
						amountReceived: null,
						benefit: null,
						category: 699,
						component: 1141,
						contract: null,
						designatedAccount: null,
						expenseType: {
							id: 2053,
							name: 'Dépenses opérationnelles',
							created: '2026-01-29T15:09:24.768Z',
							modified: '2026-01-29T16:25:03.495Z',
							status: 'ACTIVE',
							entity: null,
							project: 318,
						},
						fromAccount: {
							id: 1636,
							idWbg: '000000000010021601',
							name: 'DA-A',
							num: '111080980',
							institution: "BANQUE DE LA REPUBLIQUE D'HAITI",
							type: 'DESIGNATED',
							currency: 'USD',
							created: '2026-01-29T13:35:46.971Z',
							modified: null,
							status: 'ACTIVE',
							aba: null,
							holder: null,
							isReimbursement: false,
							postcode: null,
							routeCode: null,
							sortCode: null,
							state: null,
							street: null,
							swiftCode: null,
							town: null,
							country: null,
						},
						fromEntity: 2299,
						project: 318,
						toAccount: null,
						toEntity: 5685,
						user: 2026,
						withdrawalApplication: 103,
					},
				],
				value: 2139.69,
			},
			{
				source: 0,
				target: 25,
				transactions: [
					{
						amount: 4050,
						currency: 'USD',
						payments: [
							{
								id: 30466,
								source: null,
								amount: 4050,
								currency: 'USD',
								currencyReceived: null,
								metadata: {
									tax: null,
									hash: null,
									loan: 457,
									uuid: 'cebfa609-f28a-4dbc-a517-4fb1d459252f',
									amount: 4050,
									source: null,
									currency: 'USD',
									metadata: null,
									projectId: 318,
									toAccount: -1,
									toAddress: '0x991d40E6BC6F211Df53848283C783f79f77676ad',
									reimbursed: {
										amount: null,
									},
									fromAccount: 1636,
									fromAddress: '0xF6379168Ba44cd6A7AB2E9106001Fde599a9EF08',
									transaction: 25828,
									taxEquivalent: null,
									amountReceived: null,
									blkTransaction: {
										id: null,
										status: 'STARTED',
									},
									revertedPayment: null,
									amountEquivalent: null,
									currencyReceived: null,
								},
								hash: '5515df0631d53335a657fbaa7b9cae02da045ffc9ce49bf0b2db377cc38ea5ad',
								created: '2026-05-10T20:25:05.243Z',
								modified: null,
								tax: null,
								amountEquivalent: null,
								taxEquivalent: null,
								amountReceived: null,
								reimbursed: {
									amount: null,
								},
								blkTransaction: {
									id: '0x4334bb938feb67c7da75e7f8e2d7ac43e5ae4a917177824dfd4157dd8507df05',
									status: 'DONE',
								},
								revertedPayment: null,
								transaction: 25828,
								loan: {
									id: 457,
									idWbg: null,
									status: 'ENABLED',
									currency: 'XDR',
									amount: 38400000,
									disbursed: 730716.39,
									financier: 'IDA',
									name: 'IPF - Investment Project Financing',
									num: 'E4250',
									dateApproved: '2025-03-28T00:00:00.000Z',
									dateSigning: '2025-04-25T00:00:00.000Z',
									dateClosing: '2029-12-28T00:00:00.000Z',
									subLoanNum: null,
									created: '2026-01-29T13:35:46.971Z',
									modified: '2026-01-29T13:39:44.224Z',
									cancelled: null,
									code: 'IDAE4250',
								},
							},
						],
						tax: 0,
						total: 4050,
						id: 25828,
						status: 'COMPLETED',
						metadata: {
							uuid: '22cb3819-13b0-4c8a-8ca8-442c8b05d938',
							invoiceAmount: 4050,
							invoiceCurrency: 'USD',
						},
						traceability: {
							documents: {
								required: [1254, 1266],
								uploaded: [53883, 53884],
							},
							value: 100,
						},
						type: 'PAYMENT',
						date: '2026-03-26T00:00:00.000Z',
						created: '2026-05-10T20:25:05.232Z',
						modified: '2026-05-20T09:24:48.409Z',
						quantity: null,
						isReceived: null,
						amountReceived: null,
						benefit: null,
						category: 699,
						component: 1147,
						contract: null,
						designatedAccount: null,
						expenseType: {
							id: 2053,
							name: 'Dépenses opérationnelles',
							created: '2026-01-29T15:09:24.768Z',
							modified: '2026-01-29T16:25:03.495Z',
							status: 'ACTIVE',
							entity: null,
							project: 318,
						},
						fromAccount: {
							id: 1636,
							idWbg: '000000000010021601',
							name: 'DA-A',
							num: '111080980',
							institution: "BANQUE DE LA REPUBLIQUE D'HAITI",
							type: 'DESIGNATED',
							currency: 'USD',
							created: '2026-01-29T13:35:46.971Z',
							modified: null,
							status: 'ACTIVE',
							aba: null,
							holder: null,
							isReimbursement: false,
							postcode: null,
							routeCode: null,
							sortCode: null,
							state: null,
							street: null,
							swiftCode: null,
							town: null,
							country: null,
						},
						fromEntity: 2299,
						project: 318,
						toAccount: null,
						toEntity: 5688,
						user: 2026,
						withdrawalApplication: 103,
					},
				],
				value: 4050,
			},
			{
				source: 0,
				target: 26,
				transactions: [
					{
						amount: 2852.54,
						currency: 'USD',
						payments: [
							{
								id: 30414,
								source: null,
								amount: 2852.54,
								currency: 'USD',
								currencyReceived: null,
								metadata: {
									tax: null,
									hash: null,
									loan: 457,
									uuid: '3dd38286-1d22-4a5c-b5eb-776bfb1dc10b',
									amount: 2852.54,
									source: null,
									currency: 'USD',
									metadata: null,
									projectId: 318,
									toAccount: -1,
									toAddress: '0x350D95Aff80C1FEd24Bd8d9C2e0f1cCF2d9710C9',
									reimbursed: {
										amount: null,
									},
									fromAccount: 1636,
									fromAddress: '0xF6379168Ba44cd6A7AB2E9106001Fde599a9EF08',
									transaction: 25778,
									taxEquivalent: null,
									amountReceived: null,
									blkTransaction: {
										id: null,
										status: 'STARTED',
									},
									revertedPayment: null,
									amountEquivalent: null,
									currencyReceived: null,
								},
								hash: 'caa11e33d47ade19b5d683d7ab8ae04174f873a5d9ff2a8244fe8aeddd66e859',
								created: '2026-05-10T17:27:01.017Z',
								modified: null,
								tax: null,
								amountEquivalent: null,
								taxEquivalent: null,
								amountReceived: null,
								reimbursed: {
									amount: null,
								},
								blkTransaction: {
									id: '0x782987f5ca1ef4629ed7f8a1340192092149d0d44270ce7e26d7273dbf2e6f82',
									status: 'DONE',
								},
								revertedPayment: null,
								transaction: 25778,
								loan: {
									id: 457,
									idWbg: null,
									status: 'ENABLED',
									currency: 'XDR',
									amount: 38400000,
									disbursed: 730716.39,
									financier: 'IDA',
									name: 'IPF - Investment Project Financing',
									num: 'E4250',
									dateApproved: '2025-03-28T00:00:00.000Z',
									dateSigning: '2025-04-25T00:00:00.000Z',
									dateClosing: '2029-12-28T00:00:00.000Z',
									subLoanNum: null,
									created: '2026-01-29T13:35:46.971Z',
									modified: '2026-01-29T13:39:44.224Z',
									cancelled: null,
									code: 'IDAE4250',
								},
							},
						],
						tax: 0,
						total: 2852.54,
						id: 25778,
						status: 'COMPLETED',
						metadata: {
							uuid: '0336e55c-7578-4ce4-9911-e1cbedcc5c6b',
							invoiceAmount: 373200,
							invoiceCurrency: 'HTG',
						},
						traceability: {
							documents: {
								required: [1254, 1266],
								uploaded: [53806, 53807],
							},
							value: 100,
						},
						type: 'PAYMENT',
						date: '2026-03-26T00:00:00.000Z',
						created: '2026-05-10T17:27:01.005Z',
						modified: '2026-05-20T09:24:48.610Z',
						quantity: null,
						isReceived: null,
						amountReceived: null,
						benefit: null,
						category: 699,
						component: 1146,
						contract: null,
						designatedAccount: null,
						expenseType: {
							id: 2053,
							name: 'Dépenses opérationnelles',
							created: '2026-01-29T15:09:24.768Z',
							modified: '2026-01-29T16:25:03.495Z',
							status: 'ACTIVE',
							entity: null,
							project: 318,
						},
						fromAccount: {
							id: 1636,
							idWbg: '000000000010021601',
							name: 'DA-A',
							num: '111080980',
							institution: "BANQUE DE LA REPUBLIQUE D'HAITI",
							type: 'DESIGNATED',
							currency: 'USD',
							created: '2026-01-29T13:35:46.971Z',
							modified: null,
							status: 'ACTIVE',
							aba: null,
							holder: null,
							isReimbursement: false,
							postcode: null,
							routeCode: null,
							sortCode: null,
							state: null,
							street: null,
							swiftCode: null,
							town: null,
							country: null,
						},
						fromEntity: 2299,
						project: 318,
						toAccount: null,
						toEntity: 5686,
						user: 2026,
						withdrawalApplication: 103,
					},
					{
						amount: 764.49,
						currency: 'USD',
						payments: [
							{
								id: 30412,
								source: null,
								amount: 764.49,
								currency: 'USD',
								currencyReceived: null,
								metadata: {
									tax: null,
									hash: null,
									loan: 457,
									uuid: 'a7f4e7ee-c9c6-4ce7-a2e8-add8bc652061',
									amount: 764.49,
									source: null,
									currency: 'USD',
									metadata: null,
									projectId: 318,
									toAccount: -1,
									toAddress: '0x350D95Aff80C1FEd24Bd8d9C2e0f1cCF2d9710C9',
									reimbursed: {
										amount: null,
									},
									fromAccount: 1636,
									fromAddress: '0xF6379168Ba44cd6A7AB2E9106001Fde599a9EF08',
									transaction: 25776,
									taxEquivalent: null,
									amountReceived: null,
									blkTransaction: {
										id: null,
										status: 'STARTED',
									},
									revertedPayment: null,
									amountEquivalent: null,
									currencyReceived: null,
								},
								hash: 'c24aabcbcc090ad750c85981e39a0866e4f44d6f66ed35cb7eb7240b7c52524b',
								created: '2026-05-10T17:17:14.419Z',
								modified: null,
								tax: null,
								amountEquivalent: null,
								taxEquivalent: null,
								amountReceived: null,
								reimbursed: {
									amount: null,
								},
								blkTransaction: {
									id: '0x345892de8745b253b775862cefe8abfc58dc1458d32744539050cdfb0babf591',
									status: 'DONE',
								},
								revertedPayment: null,
								transaction: 25776,
								loan: {
									id: 457,
									idWbg: null,
									status: 'ENABLED',
									currency: 'XDR',
									amount: 38400000,
									disbursed: 730716.39,
									financier: 'IDA',
									name: 'IPF - Investment Project Financing',
									num: 'E4250',
									dateApproved: '2025-03-28T00:00:00.000Z',
									dateSigning: '2025-04-25T00:00:00.000Z',
									dateClosing: '2029-12-28T00:00:00.000Z',
									subLoanNum: null,
									created: '2026-01-29T13:35:46.971Z',
									modified: '2026-01-29T13:39:44.224Z',
									cancelled: null,
									code: 'IDAE4250',
								},
							},
						],
						tax: 0,
						total: 764.49,
						id: 25776,
						status: 'COMPLETED',
						metadata: {
							uuid: '3ffbbf80-f421-4b74-9d17-f0bb7807cd04',
							invoiceAmount: 100000,
							invoiceCurrency: 'HTG',
						},
						traceability: {
							documents: {
								required: [1254, 1266],
								uploaded: [53802, 53803],
							},
							value: 100,
						},
						type: 'PAYMENT',
						date: '2026-03-23T00:00:00.000Z',
						created: '2026-05-10T17:17:14.373Z',
						modified: '2026-05-20T09:24:48.676Z',
						quantity: null,
						isReceived: null,
						amountReceived: null,
						benefit: null,
						category: 699,
						component: 1146,
						contract: null,
						designatedAccount: null,
						expenseType: {
							id: 2053,
							name: 'Dépenses opérationnelles',
							created: '2026-01-29T15:09:24.768Z',
							modified: '2026-01-29T16:25:03.495Z',
							status: 'ACTIVE',
							entity: null,
							project: 318,
						},
						fromAccount: {
							id: 1636,
							idWbg: '000000000010021601',
							name: 'DA-A',
							num: '111080980',
							institution: "BANQUE DE LA REPUBLIQUE D'HAITI",
							type: 'DESIGNATED',
							currency: 'USD',
							created: '2026-01-29T13:35:46.971Z',
							modified: null,
							status: 'ACTIVE',
							aba: null,
							holder: null,
							isReimbursement: false,
							postcode: null,
							routeCode: null,
							sortCode: null,
							state: null,
							street: null,
							swiftCode: null,
							town: null,
							country: null,
						},
						fromEntity: 2299,
						project: 318,
						toAccount: null,
						toEntity: 5686,
						user: 2026,
						withdrawalApplication: 103,
					},
				],
				value: 3617.0299999999997,
			},
			{
				source: 0,
				target: 27,
				transactions: [
					{
						amount: 1219.42,
						currency: 'USD',
						payments: [
							{
								id: 30373,
								source: null,
								amount: 1219.42,
								currency: 'USD',
								currencyReceived: null,
								metadata: {
									tax: null,
									hash: null,
									loan: 457,
									uuid: 'e7bd04c3-47c9-4d0b-aa6f-0552011099e9',
									amount: 1219.42,
									source: null,
									currency: 'USD',
									metadata: null,
									projectId: 318,
									toAccount: -1,
									toAddress: '0x423a5b6FcfAB0B11d835497406439fD77081164C',
									reimbursed: {
										amount: null,
									},
									fromAccount: 1636,
									fromAddress: '0xF6379168Ba44cd6A7AB2E9106001Fde599a9EF08',
									transaction: 25737,
									taxEquivalent: null,
									amountReceived: null,
									blkTransaction: {
										id: null,
										status: 'STARTED',
									},
									revertedPayment: null,
									amountEquivalent: null,
									currencyReceived: null,
								},
								hash: '603e59f850bc73a66de92e480beb1c2043b71462fbb6671c7507fd631470b688',
								created: '2026-05-10T15:57:09.560Z',
								modified: null,
								tax: null,
								amountEquivalent: null,
								taxEquivalent: null,
								amountReceived: null,
								reimbursed: {
									amount: null,
								},
								blkTransaction: {
									id: '0x5f2b6e5b41a56160c6fb87486a3ad79bbc3fe9d1408d4fa788383dd88f3a23ad',
									status: 'DONE',
								},
								revertedPayment: null,
								transaction: 25737,
								loan: {
									id: 457,
									idWbg: null,
									status: 'ENABLED',
									currency: 'XDR',
									amount: 38400000,
									disbursed: 730716.39,
									financier: 'IDA',
									name: 'IPF - Investment Project Financing',
									num: 'E4250',
									dateApproved: '2025-03-28T00:00:00.000Z',
									dateSigning: '2025-04-25T00:00:00.000Z',
									dateClosing: '2029-12-28T00:00:00.000Z',
									subLoanNum: null,
									created: '2026-01-29T13:35:46.971Z',
									modified: '2026-01-29T13:39:44.224Z',
									cancelled: null,
									code: 'IDAE4250',
								},
							},
						],
						tax: 0,
						total: 1219.42,
						id: 25737,
						status: 'COMPLETED',
						metadata: {
							uuid: '311c2848-9fd0-49f5-82b9-4fe05cec63ee',
							invoiceAmount: 159600,
							invoiceCurrency: 'HTG',
						},
						traceability: {
							documents: {
								required: [1254, 1266],
								uploaded: [53747, 53748],
							},
							value: 100,
						},
						type: 'PAYMENT',
						date: '2026-03-13T00:00:00.000Z',
						created: '2026-05-10T15:57:09.548Z',
						modified: '2026-05-20T09:24:48.903Z',
						quantity: null,
						isReceived: null,
						amountReceived: null,
						benefit: null,
						category: 699,
						component: 1148,
						contract: null,
						designatedAccount: null,
						expenseType: {
							id: 2053,
							name: 'Dépenses opérationnelles',
							created: '2026-01-29T15:09:24.768Z',
							modified: '2026-01-29T16:25:03.495Z',
							status: 'ACTIVE',
							entity: null,
							project: 318,
						},
						fromAccount: {
							id: 1636,
							idWbg: '000000000010021601',
							name: 'DA-A',
							num: '111080980',
							institution: "BANQUE DE LA REPUBLIQUE D'HAITI",
							type: 'DESIGNATED',
							currency: 'USD',
							created: '2026-01-29T13:35:46.971Z',
							modified: null,
							status: 'ACTIVE',
							aba: null,
							holder: null,
							isReimbursement: false,
							postcode: null,
							routeCode: null,
							sortCode: null,
							state: null,
							street: null,
							swiftCode: null,
							town: null,
							country: null,
						},
						fromEntity: 2299,
						project: 318,
						toAccount: null,
						toEntity: 3853,
						user: 2026,
						withdrawalApplication: 103,
					},
					{
						amount: 1157.88,
						currency: 'USD',
						payments: [
							{
								id: 18741,
								source: null,
								amount: 1157.88,
								currency: 'USD',
								currencyReceived: null,
								metadata: {
									tax: null,
									hash: null,
									loan: 457,
									uuid: '1023874c-25d9-4ab1-9f4d-a836b7ade6b5',
									amount: 1157.88,
									source: null,
									currency: 'USD',
									metadata: null,
									projectId: 318,
									toAccount: -1,
									toAddress: '0x423a5b6FcfAB0B11d835497406439fD77081164C',
									reimbursed: {
										amount: null,
									},
									fromAccount: 1636,
									fromAddress: '0xF6379168Ba44cd6A7AB2E9106001Fde599a9EF08',
									transaction: 15642,
									taxEquivalent: null,
									amountReceived: null,
									blkTransaction: {
										id: null,
										status: 'STARTED',
									},
									revertedPayment: null,
									amountEquivalent: null,
									currencyReceived: null,
								},
								hash: '43e9c7f469bdb1215958f44e990ff332c2c305842e29cee64c8d41963abfccb7',
								created: '2026-03-25T17:30:06.056Z',
								modified: null,
								tax: null,
								amountEquivalent: null,
								taxEquivalent: null,
								amountReceived: null,
								reimbursed: {
									amount: null,
								},
								blkTransaction: {
									id: '0xbc5f4f1ee00d11992f081865dbbbd53029b085198e982c18a16691fdd5c8cb3d',
									status: 'DONE',
								},
								revertedPayment: null,
								transaction: 15642,
								loan: {
									id: 457,
									idWbg: null,
									status: 'ENABLED',
									currency: 'XDR',
									amount: 38400000,
									disbursed: 730716.39,
									financier: 'IDA',
									name: 'IPF - Investment Project Financing',
									num: 'E4250',
									dateApproved: '2025-03-28T00:00:00.000Z',
									dateSigning: '2025-04-25T00:00:00.000Z',
									dateClosing: '2029-12-28T00:00:00.000Z',
									subLoanNum: null,
									created: '2026-01-29T13:35:46.971Z',
									modified: '2026-01-29T13:39:44.224Z',
									cancelled: null,
									code: 'IDAE4250',
								},
							},
						],
						tax: 0,
						total: 1157.88,
						id: 15642,
						status: 'COMPLETED',
						metadata: {
							uuid: '44779319-9a02-44b3-b7ad-708154b716ce',
							invoiceAmount: 151503.75,
							invoiceCurrency: 'HTG',
						},
						traceability: {
							documents: {
								required: [1254, 1266],
								uploaded: [28803, 28804],
							},
							value: 100,
						},
						type: 'PAYMENT',
						date: '2026-02-24T00:00:00.000Z',
						created: '2026-03-25T17:30:06.040Z',
						modified: '2026-05-20T09:24:49.650Z',
						quantity: null,
						isReceived: null,
						amountReceived: null,
						benefit: null,
						category: 699,
						component: 1148,
						contract: null,
						designatedAccount: null,
						expenseType: {
							id: 2053,
							name: 'Dépenses opérationnelles',
							created: '2026-01-29T15:09:24.768Z',
							modified: '2026-01-29T16:25:03.495Z',
							status: 'ACTIVE',
							entity: null,
							project: 318,
						},
						fromAccount: {
							id: 1636,
							idWbg: '000000000010021601',
							name: 'DA-A',
							num: '111080980',
							institution: "BANQUE DE LA REPUBLIQUE D'HAITI",
							type: 'DESIGNATED',
							currency: 'USD',
							created: '2026-01-29T13:35:46.971Z',
							modified: null,
							status: 'ACTIVE',
							aba: null,
							holder: null,
							isReimbursement: false,
							postcode: null,
							routeCode: null,
							sortCode: null,
							state: null,
							street: null,
							swiftCode: null,
							town: null,
							country: null,
						},
						fromEntity: 2299,
						project: 318,
						toAccount: null,
						toEntity: 3853,
						user: 2026,
						withdrawalApplication: 103,
					},
				],
				value: 2377.3,
			},
			{
				source: 0,
				target: 28,
				transactions: [
					{
						amount: 1478.11,
						currency: 'USD',
						payments: [
							{
								id: 30371,
								source: null,
								amount: 1478.11,
								currency: 'USD',
								currencyReceived: null,
								metadata: {
									tax: null,
									hash: null,
									loan: 457,
									uuid: '09549342-4e2c-401f-801e-61000d1f7d84',
									amount: 1478.11,
									source: null,
									currency: 'USD',
									metadata: null,
									projectId: 318,
									toAccount: -1,
									toAddress: '0xc1673f49a05D363E06E2D31b74E97219484E190e',
									reimbursed: {
										amount: null,
									},
									fromAccount: 1636,
									fromAddress: '0xF6379168Ba44cd6A7AB2E9106001Fde599a9EF08',
									transaction: 25735,
									taxEquivalent: null,
									amountReceived: null,
									blkTransaction: {
										id: null,
										status: 'STARTED',
									},
									revertedPayment: null,
									amountEquivalent: null,
									currencyReceived: null,
								},
								hash: 'c96e16e03a891adc85f58448b58a51467173633b1140f3a46a52b92a2b14eb06',
								created: '2026-05-10T15:49:44.895Z',
								modified: null,
								tax: null,
								amountEquivalent: null,
								taxEquivalent: null,
								amountReceived: null,
								reimbursed: {
									amount: null,
								},
								blkTransaction: {
									id: '0x39636ad76a2283db92534d479e724224e0ec222cf90ecb66a1b02fedc68ab322',
									status: 'DONE',
								},
								revertedPayment: null,
								transaction: 25735,
								loan: {
									id: 457,
									idWbg: null,
									status: 'ENABLED',
									currency: 'XDR',
									amount: 38400000,
									disbursed: 730716.39,
									financier: 'IDA',
									name: 'IPF - Investment Project Financing',
									num: 'E4250',
									dateApproved: '2025-03-28T00:00:00.000Z',
									dateSigning: '2025-04-25T00:00:00.000Z',
									dateClosing: '2029-12-28T00:00:00.000Z',
									subLoanNum: null,
									created: '2026-01-29T13:35:46.971Z',
									modified: '2026-01-29T13:39:44.224Z',
									cancelled: null,
									code: 'IDAE4250',
								},
							},
						],
						tax: 0,
						total: 1478.11,
						id: 25735,
						status: 'COMPLETED',
						metadata: {
							uuid: '5ca8c30f-53c9-4870-abcf-0cd08b3b6a03',
							invoiceAmount: 193320,
							invoiceCurrency: 'HTG',
						},
						traceability: {
							documents: {
								required: [1254, 1266],
								uploaded: [53740, 53741],
							},
							value: 100,
						},
						type: 'PAYMENT',
						date: '2026-03-13T00:00:00.000Z',
						created: '2026-05-10T15:49:44.878Z',
						modified: '2026-05-20T09:24:48.928Z',
						quantity: null,
						isReceived: null,
						amountReceived: null,
						benefit: null,
						category: 699,
						component: 1139,
						contract: null,
						designatedAccount: null,
						expenseType: {
							id: 2053,
							name: 'Dépenses opérationnelles',
							created: '2026-01-29T15:09:24.768Z',
							modified: '2026-01-29T16:25:03.495Z',
							status: 'ACTIVE',
							entity: null,
							project: 318,
						},
						fromAccount: {
							id: 1636,
							idWbg: '000000000010021601',
							name: 'DA-A',
							num: '111080980',
							institution: "BANQUE DE LA REPUBLIQUE D'HAITI",
							type: 'DESIGNATED',
							currency: 'USD',
							created: '2026-01-29T13:35:46.971Z',
							modified: null,
							status: 'ACTIVE',
							aba: null,
							holder: null,
							isReimbursement: false,
							postcode: null,
							routeCode: null,
							sortCode: null,
							state: null,
							street: null,
							swiftCode: null,
							town: null,
							country: null,
						},
						fromEntity: 2299,
						project: 318,
						toAccount: null,
						toEntity: 5684,
						user: 2026,
						withdrawalApplication: 103,
					},
					{
						amount: 820.6,
						currency: 'USD',
						payments: [
							{
								id: 30370,
								source: null,
								amount: 820.6,
								currency: 'USD',
								currencyReceived: null,
								metadata: {
									tax: null,
									hash: null,
									loan: 457,
									uuid: 'b3815e78-ff0c-45f4-9d72-54a83bbeaef9',
									amount: 820.6,
									source: null,
									currency: 'USD',
									metadata: null,
									projectId: 318,
									toAccount: -1,
									toAddress: '0xc1673f49a05D363E06E2D31b74E97219484E190e',
									reimbursed: {
										amount: null,
									},
									fromAccount: 1636,
									fromAddress: '0xF6379168Ba44cd6A7AB2E9106001Fde599a9EF08',
									transaction: 25734,
									taxEquivalent: null,
									amountReceived: null,
									blkTransaction: {
										id: null,
										status: 'STARTED',
									},
									revertedPayment: null,
									amountEquivalent: null,
									currencyReceived: null,
								},
								hash: '1b9becfca900aa238cde504088dbda5e6a426bcc9bf6f73fa3eda44948a57f47',
								created: '2026-05-10T15:47:00.021Z',
								modified: null,
								tax: null,
								amountEquivalent: null,
								taxEquivalent: null,
								amountReceived: null,
								reimbursed: {
									amount: null,
								},
								blkTransaction: {
									id: '0x76d744d4d2e7123b98349913067250eeedd36f493fc9813c74b022d19d4557e2',
									status: 'DONE',
								},
								revertedPayment: null,
								transaction: 25734,
								loan: {
									id: 457,
									idWbg: null,
									status: 'ENABLED',
									currency: 'XDR',
									amount: 38400000,
									disbursed: 730716.39,
									financier: 'IDA',
									name: 'IPF - Investment Project Financing',
									num: 'E4250',
									dateApproved: '2025-03-28T00:00:00.000Z',
									dateSigning: '2025-04-25T00:00:00.000Z',
									dateClosing: '2029-12-28T00:00:00.000Z',
									subLoanNum: null,
									created: '2026-01-29T13:35:46.971Z',
									modified: '2026-01-29T13:39:44.224Z',
									cancelled: null,
									code: 'IDAE4250',
								},
							},
						],
						tax: 0,
						total: 820.6,
						id: 25734,
						status: 'COMPLETED',
						metadata: {
							uuid: '12fd5ac4-b171-4434-83c1-79acfc3acccd',
							invoiceAmount: 107325,
							invoiceCurrency: 'HTG',
						},
						traceability: {
							documents: {
								required: [1254, 1266],
								uploaded: [53738, 53739],
							},
							value: 100,
						},
						type: 'PAYMENT',
						date: '2026-03-12T00:00:00.000Z',
						created: '2026-05-10T15:47:00.009Z',
						modified: '2026-05-20T09:24:48.952Z',
						quantity: null,
						isReceived: null,
						amountReceived: null,
						benefit: null,
						category: 699,
						component: 1139,
						contract: null,
						designatedAccount: null,
						expenseType: {
							id: 2053,
							name: 'Dépenses opérationnelles',
							created: '2026-01-29T15:09:24.768Z',
							modified: '2026-01-29T16:25:03.495Z',
							status: 'ACTIVE',
							entity: null,
							project: 318,
						},
						fromAccount: {
							id: 1636,
							idWbg: '000000000010021601',
							name: 'DA-A',
							num: '111080980',
							institution: "BANQUE DE LA REPUBLIQUE D'HAITI",
							type: 'DESIGNATED',
							currency: 'USD',
							created: '2026-01-29T13:35:46.971Z',
							modified: null,
							status: 'ACTIVE',
							aba: null,
							holder: null,
							isReimbursement: false,
							postcode: null,
							routeCode: null,
							sortCode: null,
							state: null,
							street: null,
							swiftCode: null,
							town: null,
							country: null,
						},
						fromEntity: 2299,
						project: 318,
						toAccount: null,
						toEntity: 5684,
						user: 2026,
						withdrawalApplication: 103,
					},
				],
				value: 2298.71,
			},
			{
				source: 0,
				target: 29,
				transactions: [
					{
						amount: 15758.4,
						currency: 'USD',
						payments: [
							{
								id: 30323,
								source: null,
								amount: 15758.4,
								currency: 'USD',
								currencyReceived: null,
								metadata: {
									tax: null,
									hash: null,
									loan: 457,
									uuid: '14f9493d-d8f4-4507-8f0c-b5b8e63023b4',
									amount: 15758.4,
									source: null,
									currency: 'USD',
									metadata: null,
									projectId: 318,
									toAccount: -1,
									toAddress: '0x59de596B18D79d3Ec927AD41c96CEe7024c03eC9',
									reimbursed: {
										amount: null,
									},
									fromAccount: 1636,
									fromAddress: '0xF6379168Ba44cd6A7AB2E9106001Fde599a9EF08',
									transaction: 25688,
									taxEquivalent: null,
									amountReceived: null,
									blkTransaction: {
										id: null,
										status: 'STARTED',
									},
									revertedPayment: null,
									amountEquivalent: null,
									currencyReceived: null,
								},
								hash: 'd586f6766f8af8b6bdcb34ac5968e01d9773f871864ba103b2442284e8a47a37',
								created: '2026-05-10T14:21:22.496Z',
								modified: null,
								tax: null,
								amountEquivalent: null,
								taxEquivalent: null,
								amountReceived: null,
								reimbursed: {
									amount: null,
								},
								blkTransaction: {
									id: '0x3f35d79efcc6d8e4bf2f1ebdd0f053a2bfaf53597fec3913f4f5b7a50ea0f9f2',
									status: 'DONE',
								},
								revertedPayment: null,
								transaction: 25688,
								loan: {
									id: 457,
									idWbg: null,
									status: 'ENABLED',
									currency: 'XDR',
									amount: 38400000,
									disbursed: 730716.39,
									financier: 'IDA',
									name: 'IPF - Investment Project Financing',
									num: 'E4250',
									dateApproved: '2025-03-28T00:00:00.000Z',
									dateSigning: '2025-04-25T00:00:00.000Z',
									dateClosing: '2029-12-28T00:00:00.000Z',
									subLoanNum: null,
									created: '2026-01-29T13:35:46.971Z',
									modified: '2026-01-29T13:39:44.224Z',
									cancelled: null,
									code: 'IDAE4250',
								},
							},
						],
						tax: 0,
						total: 15758.4,
						id: 25688,
						status: 'COMPLETED',
						metadata: {
							uuid: '137e8712-12a5-4b69-8cc0-ebd812cfdc6d',
							invoiceAmount: 15758.4,
							invoiceCurrency: 'USD',
						},
						traceability: {
							documents: {
								required: [1252, 1254, 1259],
								uploaded: [53651, 53652, 53653],
							},
							value: 100,
						},
						type: 'PAYMENT',
						date: '2026-03-03T00:00:00.000Z',
						created: '2026-05-10T14:21:22.478Z',
						modified: '2026-05-20T09:24:49.397Z',
						quantity: null,
						isReceived: null,
						amountReceived: null,
						benefit: null,
						category: 699,
						component: 1137,
						contract: null,
						designatedAccount: null,
						expenseType: {
							id: 2049,
							name: 'Travaux',
							created: '2026-01-29T15:03:07.088Z',
							modified: '2026-01-29T16:25:03.543Z',
							status: 'ACTIVE',
							entity: null,
							project: 318,
						},
						fromAccount: {
							id: 1636,
							idWbg: '000000000010021601',
							name: 'DA-A',
							num: '111080980',
							institution: "BANQUE DE LA REPUBLIQUE D'HAITI",
							type: 'DESIGNATED',
							currency: 'USD',
							created: '2026-01-29T13:35:46.971Z',
							modified: null,
							status: 'ACTIVE',
							aba: null,
							holder: null,
							isReimbursement: false,
							postcode: null,
							routeCode: null,
							sortCode: null,
							state: null,
							street: null,
							swiftCode: null,
							town: null,
							country: null,
						},
						fromEntity: 2299,
						project: 318,
						toAccount: null,
						toEntity: 5680,
						user: 2026,
						withdrawalApplication: 103,
					},
				],
				value: 15758.4,
			},
			{
				source: 0,
				target: 30,
				transactions: [
					{
						amount: 1000,
						currency: 'USD',
						payments: [
							{
								id: 17654,
								source: null,
								amount: 1000,
								currency: 'USD',
								currencyReceived: null,
								metadata: {
									tax: null,
									hash: null,
									loan: 457,
									uuid: '42ae4829-bc31-4714-a82b-c69f6b875476',
									amount: 1000,
									source: null,
									currency: 'USD',
									metadata: null,
									projectId: 318,
									toAccount: -1,
									toAddress: '0xf7F72F745A4f6e6754F62D1C153175B335301E06',
									reimbursed: {
										amount: null,
									},
									fromAccount: 1636,
									fromAddress: '0xF6379168Ba44cd6A7AB2E9106001Fde599a9EF08',
									transaction: 14717,
									taxEquivalent: null,
									amountReceived: null,
									blkTransaction: {
										id: null,
										status: 'STARTED',
									},
									revertedPayment: null,
									amountEquivalent: null,
									currencyReceived: null,
								},
								hash: '7f11d39ea5bb3935a17776f63136e4c1f25bb8c1bccac01b1c729ba38441c4ad',
								created: '2026-03-21T16:23:45.555Z',
								modified: null,
								tax: null,
								amountEquivalent: null,
								taxEquivalent: null,
								amountReceived: null,
								reimbursed: {
									amount: null,
								},
								blkTransaction: {
									id: '0xd4ced996125afe15d863999771db4253717b0665ed8dffa93c8c1594e7acb2a6',
									status: 'DONE',
								},
								revertedPayment: null,
								transaction: 14717,
								loan: {
									id: 457,
									idWbg: null,
									status: 'ENABLED',
									currency: 'XDR',
									amount: 38400000,
									disbursed: 730716.39,
									financier: 'IDA',
									name: 'IPF - Investment Project Financing',
									num: 'E4250',
									dateApproved: '2025-03-28T00:00:00.000Z',
									dateSigning: '2025-04-25T00:00:00.000Z',
									dateClosing: '2029-12-28T00:00:00.000Z',
									subLoanNum: null,
									created: '2026-01-29T13:35:46.971Z',
									modified: '2026-01-29T13:39:44.224Z',
									cancelled: null,
									code: 'IDAE4250',
								},
							},
						],
						tax: 0,
						total: 1000,
						id: 14717,
						status: 'COMPLETED',
						metadata: {
							uuid: '96022c98-23cf-4a81-8071-dc05f6106bf9',
							invoiceAmount: 1000,
							invoiceCurrency: 'USD',
						},
						traceability: {
							documents: {
								required: [1254, 1266],
								uploaded: [26521, 26522],
							},
							value: 100,
						},
						type: 'PAYMENT',
						date: '2026-02-25T00:00:00.000Z',
						created: '2026-03-21T16:23:45.540Z',
						modified: '2026-05-20T09:24:49.845Z',
						quantity: null,
						isReceived: null,
						amountReceived: null,
						benefit: null,
						category: 699,
						component: 1149,
						contract: null,
						designatedAccount: null,
						expenseType: {
							id: 2053,
							name: 'Dépenses opérationnelles',
							created: '2026-01-29T15:09:24.768Z',
							modified: '2026-01-29T16:25:03.495Z',
							status: 'ACTIVE',
							entity: null,
							project: 318,
						},
						fromAccount: {
							id: 1636,
							idWbg: '000000000010021601',
							name: 'DA-A',
							num: '111080980',
							institution: "BANQUE DE LA REPUBLIQUE D'HAITI",
							type: 'DESIGNATED',
							currency: 'USD',
							created: '2026-01-29T13:35:46.971Z',
							modified: null,
							status: 'ACTIVE',
							aba: null,
							holder: null,
							isReimbursement: false,
							postcode: null,
							routeCode: null,
							sortCode: null,
							state: null,
							street: null,
							swiftCode: null,
							town: null,
							country: null,
						},
						fromEntity: 2299,
						project: 318,
						toAccount: null,
						toEntity: 3854,
						user: 2026,
						withdrawalApplication: 103,
					},
				],
				value: 1000,
			},
			{
				source: 0,
				target: 31,
				transactions: [
					{
						amount: 2291.55,
						currency: 'USD',
						payments: [
							{
								id: 17631,
								source: null,
								amount: 2291.55,
								currency: 'USD',
								currencyReceived: null,
								metadata: {
									tax: null,
									hash: null,
									loan: 457,
									uuid: '45bbc1a7-386b-48b5-a277-da4b69e98e68',
									amount: 2291.55,
									source: null,
									currency: 'USD',
									metadata: null,
									projectId: 318,
									toAccount: -1,
									toAddress: '0x8A0eCe814EbC0BA4bB96940448e9044BB6463011',
									reimbursed: {
										amount: null,
									},
									fromAccount: 1636,
									fromAddress: '0xF6379168Ba44cd6A7AB2E9106001Fde599a9EF08',
									transaction: 14701,
									taxEquivalent: null,
									amountReceived: null,
									blkTransaction: {
										id: null,
										status: 'STARTED',
									},
									revertedPayment: null,
									amountEquivalent: null,
									currencyReceived: null,
								},
								hash: 'c69578f1efa7627e5f4bd392f2b29e4f747ec152afcdf3252a42e3d1f3a49506',
								created: '2026-03-21T15:04:15.342Z',
								modified: null,
								tax: null,
								amountEquivalent: null,
								taxEquivalent: null,
								amountReceived: null,
								reimbursed: {
									amount: null,
								},
								blkTransaction: {
									id: '0x98433cddf5c644f805be11d7d480f088fc62bba011dd67b615b32e0ed606451c',
									status: 'DONE',
								},
								revertedPayment: null,
								transaction: 14701,
								loan: {
									id: 457,
									idWbg: null,
									status: 'ENABLED',
									currency: 'XDR',
									amount: 38400000,
									disbursed: 730716.39,
									financier: 'IDA',
									name: 'IPF - Investment Project Financing',
									num: 'E4250',
									dateApproved: '2025-03-28T00:00:00.000Z',
									dateSigning: '2025-04-25T00:00:00.000Z',
									dateClosing: '2029-12-28T00:00:00.000Z',
									subLoanNum: null,
									created: '2026-01-29T13:35:46.971Z',
									modified: '2026-01-29T13:39:44.224Z',
									cancelled: null,
									code: 'IDAE4250',
								},
							},
						],
						tax: 0,
						total: 2291.55,
						id: 14701,
						status: 'IN_PROGRESS',
						metadata: {
							uuid: '038f3edb-0350-4056-af34-fa6443181572',
							invoiceAmount: 300000,
							invoiceCurrency: 'HTG',
						},
						traceability: {
							documents: {
								required: [1254, 1266],
								uploaded: [26509, 26510],
							},
							value: 100,
						},
						type: 'PAYMENT',
						date: '2026-02-23T00:00:00.000Z',
						created: '2026-03-21T15:04:15.323Z',
						modified: '2026-05-20T09:24:50.014Z',
						quantity: null,
						isReceived: null,
						amountReceived: null,
						benefit: null,
						category: 699,
						component: 1141,
						contract: null,
						designatedAccount: null,
						expenseType: {
							id: 2053,
							name: 'Dépenses opérationnelles',
							created: '2026-01-29T15:09:24.768Z',
							modified: '2026-01-29T16:25:03.495Z',
							status: 'ACTIVE',
							entity: null,
							project: 318,
						},
						fromAccount: {
							id: 1636,
							idWbg: '000000000010021601',
							name: 'DA-A',
							num: '111080980',
							institution: "BANQUE DE LA REPUBLIQUE D'HAITI",
							type: 'DESIGNATED',
							currency: 'USD',
							created: '2026-01-29T13:35:46.971Z',
							modified: null,
							status: 'ACTIVE',
							aba: null,
							holder: null,
							isReimbursement: false,
							postcode: null,
							routeCode: null,
							sortCode: null,
							state: null,
							street: null,
							swiftCode: null,
							town: null,
							country: null,
						},
						fromEntity: 2299,
						project: 318,
						toAccount: null,
						toEntity: 3852,
						user: 2026,
						withdrawalApplication: 103,
					},
				],
				value: 2291.55,
			},
			{
				source: 0,
				target: 32,
				transactions: [
					{
						amount: 1185,
						currency: 'USD',
						payments: [
							{
								id: 16939,
								source: null,
								amount: 1185,
								currency: 'USD',
								currencyReceived: null,
								metadata: {
									tax: null,
									hash: null,
									loan: 457,
									uuid: 'e31cbf44-449d-4ddc-ad65-eac7bb98f74f',
									amount: 1185,
									source: null,
									currency: 'USD',
									metadata: null,
									projectId: 318,
									toAccount: -1,
									toAddress: '0x5e416Ec3aA9a75f67A3325aEC7924E6Ff38ecB32',
									reimbursed: {
										amount: null,
									},
									fromAccount: 1636,
									fromAddress: '0xF6379168Ba44cd6A7AB2E9106001Fde599a9EF08',
									transaction: 14066,
									taxEquivalent: null,
									amountReceived: null,
									blkTransaction: {
										id: null,
										status: 'STARTED',
									},
									revertedPayment: null,
									amountEquivalent: null,
									currencyReceived: null,
								},
								hash: '04f37ea25b1650ad4234e1a929b6f73733b3b234d843888009406e7eb2b1f84b',
								created: '2026-03-16T20:27:19.691Z',
								modified: null,
								tax: null,
								amountEquivalent: null,
								taxEquivalent: null,
								amountReceived: null,
								reimbursed: {
									amount: null,
								},
								blkTransaction: {
									id: '0xb7fdb12763b71b97fe0c41d82c19a62214358700b954eb94cdc978e30250e95e',
									status: 'DONE',
								},
								revertedPayment: null,
								transaction: 14066,
								loan: {
									id: 457,
									idWbg: null,
									status: 'ENABLED',
									currency: 'XDR',
									amount: 38400000,
									disbursed: 730716.39,
									financier: 'IDA',
									name: 'IPF - Investment Project Financing',
									num: 'E4250',
									dateApproved: '2025-03-28T00:00:00.000Z',
									dateSigning: '2025-04-25T00:00:00.000Z',
									dateClosing: '2029-12-28T00:00:00.000Z',
									subLoanNum: null,
									created: '2026-01-29T13:35:46.971Z',
									modified: '2026-01-29T13:39:44.224Z',
									cancelled: null,
									code: 'IDAE4250',
								},
							},
						],
						tax: 0,
						total: 1185,
						id: 14066,
						status: 'COMPLETED',
						metadata: {
							uuid: '462a4a04-3b57-47c5-8eb6-51b8c08ef305',
							invoiceAmount: 1185,
							invoiceCurrency: 'USD',
						},
						traceability: {
							documents: {
								required: [1254, 1266],
								uploaded: [24800, 24801],
							},
							value: 100,
						},
						type: 'PAYMENT',
						date: '2026-01-20T00:00:00.000Z',
						created: '2026-03-16T20:27:19.680Z',
						modified: '2026-05-20T09:24:50.417Z',
						quantity: null,
						isReceived: null,
						amountReceived: null,
						benefit: null,
						category: 699,
						component: 1146,
						contract: null,
						designatedAccount: null,
						expenseType: {
							id: 2053,
							name: 'Dépenses opérationnelles',
							created: '2026-01-29T15:09:24.768Z',
							modified: '2026-01-29T16:25:03.495Z',
							status: 'ACTIVE',
							entity: null,
							project: 318,
						},
						fromAccount: {
							id: 1636,
							idWbg: '000000000010021601',
							name: 'DA-A',
							num: '111080980',
							institution: "BANQUE DE LA REPUBLIQUE D'HAITI",
							type: 'DESIGNATED',
							currency: 'USD',
							created: '2026-01-29T13:35:46.971Z',
							modified: null,
							status: 'ACTIVE',
							aba: null,
							holder: null,
							isReimbursement: false,
							postcode: null,
							routeCode: null,
							sortCode: null,
							state: null,
							street: null,
							swiftCode: null,
							town: null,
							country: null,
						},
						fromEntity: 2299,
						project: 318,
						toAccount: null,
						toEntity: 3120,
						user: 2026,
						withdrawalApplication: 103,
					},
				],
				value: 1185,
			},
			{
				source: 0,
				target: 33,
				transactions: [
					{
						amount: 750,
						currency: 'USD',
						payments: [
							{
								id: 16938,
								source: null,
								amount: 750,
								currency: 'USD',
								currencyReceived: null,
								metadata: {
									tax: null,
									hash: null,
									loan: 457,
									uuid: '64933a07-3363-4902-a9d8-3ba2794fc7fb',
									amount: 750,
									source: null,
									currency: 'USD',
									metadata: null,
									projectId: 318,
									toAccount: -1,
									toAddress: '0x8c486C4e554D3560B855C4db93Ef64Ef1011Eed7',
									reimbursed: {
										amount: null,
									},
									fromAccount: 1636,
									fromAddress: '0xF6379168Ba44cd6A7AB2E9106001Fde599a9EF08',
									transaction: 14065,
									taxEquivalent: null,
									amountReceived: null,
									blkTransaction: {
										id: null,
										status: 'STARTED',
									},
									revertedPayment: null,
									amountEquivalent: null,
									currencyReceived: null,
								},
								hash: 'cb8c5745e60c4b8a3cc5562b3e7d81398c8a96cd3bb68ece61cf9cb6791138c7',
								created: '2026-03-16T20:21:50.342Z',
								modified: null,
								tax: null,
								amountEquivalent: null,
								taxEquivalent: null,
								amountReceived: null,
								reimbursed: {
									amount: null,
								},
								blkTransaction: {
									id: '0xeb5b26d40fc388a9a51c304ccdd90042df55c23aa2a33a769f50b4d25ebddbb6',
									status: 'DONE',
								},
								revertedPayment: null,
								transaction: 14065,
								loan: {
									id: 457,
									idWbg: null,
									status: 'ENABLED',
									currency: 'XDR',
									amount: 38400000,
									disbursed: 730716.39,
									financier: 'IDA',
									name: 'IPF - Investment Project Financing',
									num: 'E4250',
									dateApproved: '2025-03-28T00:00:00.000Z',
									dateSigning: '2025-04-25T00:00:00.000Z',
									dateClosing: '2029-12-28T00:00:00.000Z',
									subLoanNum: null,
									created: '2026-01-29T13:35:46.971Z',
									modified: '2026-01-29T13:39:44.224Z',
									cancelled: null,
									code: 'IDAE4250',
								},
							},
						],
						tax: 0,
						total: 750,
						id: 14065,
						status: 'COMPLETED',
						metadata: {
							uuid: 'a51e9dad-ced6-4c83-9666-f685ae1f755e',
							invoiceAmount: 750,
							invoiceCurrency: 'USD',
						},
						traceability: {
							documents: {
								required: [1254, 1266],
								uploaded: [24798, 24799],
							},
							value: 100,
						},
						type: 'PAYMENT',
						date: '2026-01-20T00:00:00.000Z',
						created: '2026-03-16T20:21:50.325Z',
						modified: '2026-05-20T09:24:50.442Z',
						quantity: null,
						isReceived: null,
						amountReceived: null,
						benefit: null,
						category: 699,
						component: 1147,
						contract: null,
						designatedAccount: null,
						expenseType: {
							id: 2053,
							name: 'Dépenses opérationnelles',
							created: '2026-01-29T15:09:24.768Z',
							modified: '2026-01-29T16:25:03.495Z',
							status: 'ACTIVE',
							entity: null,
							project: 318,
						},
						fromAccount: {
							id: 1636,
							idWbg: '000000000010021601',
							name: 'DA-A',
							num: '111080980',
							institution: "BANQUE DE LA REPUBLIQUE D'HAITI",
							type: 'DESIGNATED',
							currency: 'USD',
							created: '2026-01-29T13:35:46.971Z',
							modified: null,
							status: 'ACTIVE',
							aba: null,
							holder: null,
							isReimbursement: false,
							postcode: null,
							routeCode: null,
							sortCode: null,
							state: null,
							street: null,
							swiftCode: null,
							town: null,
							country: null,
						},
						fromEntity: 2299,
						project: 318,
						toAccount: null,
						toEntity: 3119,
						user: 2026,
						withdrawalApplication: 103,
					},
				],
				value: 750,
			},
			{
				source: 0,
				target: 34,
				transactions: [
					{
						amount: 12060,
						currency: 'USD',
						payments: [
							{
								id: 16732,
								source: null,
								amount: 12060,
								currency: 'USD',
								currencyReceived: null,
								metadata: {
									tax: null,
									hash: null,
									loan: 457,
									uuid: 'ef539476-d549-4773-8305-2014cb7d4724',
									amount: 12060,
									source: null,
									currency: 'USD',
									metadata: null,
									projectId: 318,
									toAccount: -1,
									toAddress: '0x942D93a15E64D05A21Cf38e3Db32Fc56F17f58d5',
									fromAccount: 1636,
									fromAddress: '0xF6379168Ba44cd6A7AB2E9106001Fde599a9EF08',
									transaction: 13866,
									taxEquivalent: null,
									amountReceived: null,
									blkTransaction: {
										id: null,
										status: 'STARTED',
									},
									revertedPayment: null,
									amountEquivalent: null,
									currencyReceived: null,
								},
								hash: '4317c03887b4648a37649fc2f466cc31a6e538e54c2d72fc86d9d1cff90821d8',
								created: '2026-03-15T23:01:26.044Z',
								modified: null,
								tax: null,
								amountEquivalent: null,
								taxEquivalent: null,
								amountReceived: null,
								reimbursed: {
									amount: null,
								},
								blkTransaction: {
									id: '0x905bffdf265796bb9cbb272eb21b82f32550999ae9a9400aa336162b50e1d809',
									status: 'DONE',
								},
								revertedPayment: null,
								transaction: 13866,
								loan: {
									id: 457,
									idWbg: null,
									status: 'ENABLED',
									currency: 'XDR',
									amount: 38400000,
									disbursed: 730716.39,
									financier: 'IDA',
									name: 'IPF - Investment Project Financing',
									num: 'E4250',
									dateApproved: '2025-03-28T00:00:00.000Z',
									dateSigning: '2025-04-25T00:00:00.000Z',
									dateClosing: '2029-12-28T00:00:00.000Z',
									subLoanNum: null,
									created: '2026-01-29T13:35:46.971Z',
									modified: '2026-01-29T13:39:44.224Z',
									cancelled: null,
									code: 'IDAE4250',
								},
							},
						],
						tax: 0,
						total: 12060,
						id: 13866,
						status: 'COMPLETED',
						metadata: {
							uuid: 'ed7c40fb-27ce-41c4-b41e-5c837791a3e6',
							invoiceAmount: 12060,
							invoiceCurrency: 'USD',
						},
						traceability: {
							documents: {
								required: [1254, 1266],
								uploaded: [24480, 24481],
							},
							value: 100,
						},
						type: 'PAYMENT',
						date: '2026-01-21T00:00:00.000Z',
						created: '2026-03-15T23:01:26.028Z',
						modified: '2026-05-20T09:24:50.612Z',
						quantity: null,
						isReceived: null,
						amountReceived: null,
						benefit: null,
						category: 699,
						component: 1149,
						contract: null,
						designatedAccount: null,
						expenseType: {
							id: 2053,
							name: 'Dépenses opérationnelles',
							created: '2026-01-29T15:09:24.768Z',
							modified: '2026-01-29T16:25:03.495Z',
							status: 'ACTIVE',
							entity: null,
							project: 318,
						},
						fromAccount: {
							id: 1636,
							idWbg: '000000000010021601',
							name: 'DA-A',
							num: '111080980',
							institution: "BANQUE DE LA REPUBLIQUE D'HAITI",
							type: 'DESIGNATED',
							currency: 'USD',
							created: '2026-01-29T13:35:46.971Z',
							modified: null,
							status: 'ACTIVE',
							aba: null,
							holder: null,
							isReimbursement: false,
							postcode: null,
							routeCode: null,
							sortCode: null,
							state: null,
							street: null,
							swiftCode: null,
							town: null,
							country: null,
						},
						fromEntity: 2299,
						project: 318,
						toAccount: null,
						toEntity: 3122,
						user: 2026,
						withdrawalApplication: 103,
					},
				],
				value: 12060,
			},
			{
				source: 0,
				target: 35,
				transactions: [
					{
						amount: 22308.91,
						currency: 'USD',
						payments: [
							{
								id: 41597,
								source: null,
								amount: 22308.91,
								currency: 'USD',
								currencyReceived: null,
								metadata: {
									tax: null,
									hash: null,
									loan: 457,
									uuid: 'c26b6f40-cd9b-492f-87fe-d285e2bb815e',
									amount: 22308.91,
									source: null,
									currency: 'USD',
									metadata: null,
									projectId: 318,
									toAccount: -1,
									toAddress: '0x70be777f2f2D4455f91753E2C290bBfd1Fa803e5',
									reimbursed: {
										amount: null,
									},
									fromAccount: 1636,
									fromAddress: '0xF6379168Ba44cd6A7AB2E9106001Fde599a9EF08',
									transaction: 35419,
									taxEquivalent: null,
									amountReceived: null,
									blkTransaction: {
										id: null,
										status: 'STARTED',
									},
									revertedPayment: null,
									amountEquivalent: null,
									currencyReceived: null,
								},
								hash: '87c7ebf9b006a69c6448f6125a8d5b0f7cc89845f973575db3eb48f99f04002e',
								created: '2026-06-02T22:20:14.221Z',
								modified: null,
								tax: null,
								amountEquivalent: null,
								taxEquivalent: null,
								amountReceived: null,
								reimbursed: {
									amount: null,
								},
								blkTransaction: {
									id: '0xeac0d42e7ab02b6d2c40e181fa554bbb4a5e8fd949be55e0cdd462a9187eddba',
									status: 'DONE',
								},
								revertedPayment: null,
								transaction: 35419,
								loan: {
									id: 457,
									idWbg: null,
									status: 'ENABLED',
									currency: 'XDR',
									amount: 38400000,
									disbursed: 730716.39,
									financier: 'IDA',
									name: 'IPF - Investment Project Financing',
									num: 'E4250',
									dateApproved: '2025-03-28T00:00:00.000Z',
									dateSigning: '2025-04-25T00:00:00.000Z',
									dateClosing: '2029-12-28T00:00:00.000Z',
									subLoanNum: null,
									created: '2026-01-29T13:35:46.971Z',
									modified: '2026-01-29T13:39:44.224Z',
									cancelled: null,
									code: 'IDAE4250',
								},
							},
						],
						tax: 0,
						total: 22308.91,
						id: 35419,
						status: 'COMPLETED',
						metadata: {
							uuid: '4cf22324-1567-4fab-8fdf-7c0a5d726e46',
							invoiceAmount: 3198000,
							invoiceCurrency: 'HTG',
						},
						traceability: {
							documents: {
								required: [1254, 1266],
								uploaded: [76448, 76449],
							},
							value: 100,
						},
						type: 'PAYMENT',
						date: '2026-03-26T00:00:00.000Z',
						created: '2026-06-02T22:20:14.206Z',
						modified: null,
						quantity: null,
						isReceived: null,
						amountReceived: null,
						benefit: null,
						category: 699,
						component: 1139,
						contract: null,
						designatedAccount: null,
						expenseType: {
							id: 2053,
							name: 'Dépenses opérationnelles',
							created: '2026-01-29T15:09:24.768Z',
							modified: '2026-01-29T16:25:03.495Z',
							status: 'ACTIVE',
							entity: null,
							project: 318,
						},
						fromAccount: {
							id: 1636,
							idWbg: '000000000010021601',
							name: 'DA-A',
							num: '111080980',
							institution: "BANQUE DE LA REPUBLIQUE D'HAITI",
							type: 'DESIGNATED',
							currency: 'USD',
							created: '2026-01-29T13:35:46.971Z',
							modified: null,
							status: 'ACTIVE',
							aba: null,
							holder: null,
							isReimbursement: false,
							postcode: null,
							routeCode: null,
							sortCode: null,
							state: null,
							street: null,
							swiftCode: null,
							town: null,
							country: null,
						},
						fromEntity: 2299,
						project: 318,
						toAccount: null,
						toEntity: 7034,
						user: 2026,
						withdrawalApplication: null,
					},
				],
				value: 22308.91,
			},
			{
				source: 0,
				target: 36,
				transactions: [
					{
						amount: 71485.75,
						currency: 'USD',
						payments: [
							{
								id: 41598,
								source: null,
								amount: 71485.75,
								currency: 'USD',
								currencyReceived: null,
								metadata: {
									tax: null,
									hash: null,
									loan: 457,
									uuid: 'e32ff82f-2d0c-4740-b962-6e88371db7b9',
									amount: 71485.75,
									source: null,
									currency: 'USD',
									metadata: null,
									projectId: 318,
									toAccount: -1,
									toAddress: '0x249d4604a511a52c21DDAb73b1f819db5564B57A',
									reimbursed: {
										amount: null,
									},
									fromAccount: 1636,
									fromAddress: '0xF6379168Ba44cd6A7AB2E9106001Fde599a9EF08',
									transaction: 35420,
									taxEquivalent: null,
									amountReceived: null,
									blkTransaction: {
										id: null,
										status: 'STARTED',
									},
									revertedPayment: null,
									amountEquivalent: null,
									currencyReceived: null,
								},
								hash: '40cf8aa67805d633965fe28b16d6d9e94f704e7c95a6cf4b2a4a996e3687702f',
								created: '2026-06-02T22:30:55.341Z',
								modified: null,
								tax: null,
								amountEquivalent: null,
								taxEquivalent: null,
								amountReceived: null,
								reimbursed: {
									amount: null,
								},
								blkTransaction: {
									id: '0x5eb4fed8e522f8bb665730b944e4382c37317c9d55b1617466742ffe7dd0f58f',
									status: 'DONE',
								},
								revertedPayment: null,
								transaction: 35420,
								loan: {
									id: 457,
									idWbg: null,
									status: 'ENABLED',
									currency: 'XDR',
									amount: 38400000,
									disbursed: 730716.39,
									financier: 'IDA',
									name: 'IPF - Investment Project Financing',
									num: 'E4250',
									dateApproved: '2025-03-28T00:00:00.000Z',
									dateSigning: '2025-04-25T00:00:00.000Z',
									dateClosing: '2029-12-28T00:00:00.000Z',
									subLoanNum: null,
									created: '2026-01-29T13:35:46.971Z',
									modified: '2026-01-29T13:39:44.224Z',
									cancelled: null,
									code: 'IDAE4250',
								},
							},
						],
						tax: 0,
						total: 71485.75,
						id: 35420,
						status: 'COMPLETED',
						metadata: {
							uuid: '730a8e45-ecc3-45bf-8191-e6a688314cf5',
						},
						traceability: {
							documents: {
								required: [1254, 1266],
								uploaded: [76450, 76451],
							},
							value: 100,
						},
						type: 'CASH_BENEFIT',
						date: '2026-03-09T00:00:00.000Z',
						created: '2026-06-02T22:30:55.317Z',
						modified: null,
						quantity: null,
						isReceived: null,
						amountReceived: null,
						benefit: null,
						category: 699,
						component: 1142,
						contract: null,
						designatedAccount: null,
						expenseType: {
							id: 2053,
							name: 'Dépenses opérationnelles',
							created: '2026-01-29T15:09:24.768Z',
							modified: '2026-01-29T16:25:03.495Z',
							status: 'ACTIVE',
							entity: null,
							project: 318,
						},
						fromAccount: {
							id: 1636,
							idWbg: '000000000010021601',
							name: 'DA-A',
							num: '111080980',
							institution: "BANQUE DE LA REPUBLIQUE D'HAITI",
							type: 'DESIGNATED',
							currency: 'USD',
							created: '2026-01-29T13:35:46.971Z',
							modified: null,
							status: 'ACTIVE',
							aba: null,
							holder: null,
							isReimbursement: false,
							postcode: null,
							routeCode: null,
							sortCode: null,
							state: null,
							street: null,
							swiftCode: null,
							town: null,
							country: null,
						},
						fromEntity: 2299,
						project: 318,
						toAccount: null,
						toEntity: 7036,
						user: 2026,
						withdrawalApplication: null,
					},
					{
						amount: 1530.34,
						currency: 'USD',
						payments: [
							{
								id: 42882,
								source: null,
								amount: 1530.34,
								currency: 'USD',
								currencyReceived: null,
								metadata: {
									tax: null,
									hash: null,
									loan: 457,
									uuid: '2bbe58f2-52e2-4ab1-b762-465083e9fa91',
									amount: 1530.34,
									source: null,
									currency: 'USD',
									metadata: null,
									projectId: 318,
									toAccount: -1,
									toAddress: '0x249d4604a511a52c21DDAb73b1f819db5564B57A',
									reimbursed: {
										amount: null,
									},
									fromAccount: 1636,
									fromAddress: '0xF6379168Ba44cd6A7AB2E9106001Fde599a9EF08',
									transaction: 36569,
									taxEquivalent: null,
									amountReceived: null,
									blkTransaction: {
										id: null,
										status: 'STARTED',
									},
									revertedPayment: null,
									amountEquivalent: null,
									currencyReceived: null,
								},
								hash: '981dc3b888105e1350f4966a3e5354c24889746ccb628f8afc078937804b0b2a',
								created: '2026-06-04T14:13:22.916Z',
								modified: null,
								tax: null,
								amountEquivalent: null,
								taxEquivalent: null,
								amountReceived: null,
								reimbursed: {
									amount: null,
								},
								blkTransaction: {
									id: '0x67826184e3ff442d688f1a588014a2238c3abec61575f3d9533e6bb1e313046e',
									status: 'DONE',
								},
								revertedPayment: null,
								transaction: 36569,
								loan: {
									id: 457,
									idWbg: null,
									status: 'ENABLED',
									currency: 'XDR',
									amount: 38400000,
									disbursed: 730716.39,
									financier: 'IDA',
									name: 'IPF - Investment Project Financing',
									num: 'E4250',
									dateApproved: '2025-03-28T00:00:00.000Z',
									dateSigning: '2025-04-25T00:00:00.000Z',
									dateClosing: '2029-12-28T00:00:00.000Z',
									subLoanNum: null,
									created: '2026-01-29T13:35:46.971Z',
									modified: '2026-01-29T13:39:44.224Z',
									cancelled: null,
									code: 'IDAE4250',
								},
							},
						],
						tax: 0,
						total: 1530.34,
						id: 36569,
						status: 'COMPLETED',
						metadata: {
							uuid: 'ab75491e-caec-4077-84a3-9364f088ffed',
						},
						traceability: {
							documents: {
								required: [1254, 1266],
								uploaded: [79253, 79254],
							},
							value: 100,
						},
						type: 'CASH_BENEFIT',
						date: '2026-04-08T00:00:00.000Z',
						created: '2026-06-04T14:13:22.668Z',
						modified: null,
						quantity: null,
						isReceived: null,
						amountReceived: null,
						benefit: null,
						category: 699,
						component: 1142,
						contract: null,
						designatedAccount: null,
						expenseType: {
							id: 2053,
							name: 'Dépenses opérationnelles',
							created: '2026-01-29T15:09:24.768Z',
							modified: '2026-01-29T16:25:03.495Z',
							status: 'ACTIVE',
							entity: null,
							project: 318,
						},
						fromAccount: {
							id: 1636,
							idWbg: '000000000010021601',
							name: 'DA-A',
							num: '111080980',
							institution: "BANQUE DE LA REPUBLIQUE D'HAITI",
							type: 'DESIGNATED',
							currency: 'USD',
							created: '2026-01-29T13:35:46.971Z',
							modified: null,
							status: 'ACTIVE',
							aba: null,
							holder: null,
							isReimbursement: false,
							postcode: null,
							routeCode: null,
							sortCode: null,
							state: null,
							street: null,
							swiftCode: null,
							town: null,
							country: null,
						},
						fromEntity: 2299,
						project: 318,
						toAccount: null,
						toEntity: 7036,
						user: 2026,
						withdrawalApplication: null,
					},
				],
				value: 73016.09,
			},
		],
		nodes: [
			{
				id: 2299,
				name: "MINISTERE DE L'AGRICULTURE DES RES. NATURALES ET DU DEV. RURAL",
				type: 'PIU',
				wallet: {
					id: 2301,
					address: '0xF6379168Ba44cd6A7AB2E9106001Fde599a9EF08',
				},
			},
			{
				id: 2305,
				name: 'UGP Staff',
				type: 'SUPPLIER',
				wallet: {
					id: 2307,
					address: '0x8eC014ccccb81084CC90B8DFf5De93Fa5c9439a3',
				},
			},
			{
				id: 2980,
				name: 'NATIONAL TELECOM SA',
				type: 'SUPPLIER',
				wallet: {
					id: 2982,
					address: '0x362A16eD794C148Bb2277BF72002c92B36dFB1C2',
				},
			},
			{
				id: 2976,
				name: 'AIC',
				type: 'SUPPLIER',
				wallet: {
					id: 2978,
					address: '0xCF878dC0e180A51bD30A5881505298B31d0Ef575',
				},
			},
			{
				id: 2975,
				name: 'DGI',
				type: 'SUPPLIER',
				wallet: {
					id: 2977,
					address: '0x4e9d128E791dd47dE57BB2014986038D67826721',
				},
			},
			{
				id: 2977,
				name: 'OFFICE STAR S.A',
				type: 'SUPPLIER',
				wallet: {
					id: 2979,
					address: '0x424bdB1Fe8E96309Af8f41Cc5effa098df0776fe',
				},
			},
			{
				id: 2978,
				name: 'LE NOUVELLISTE',
				type: 'SUPPLIER',
				wallet: {
					id: 2980,
					address: '0xaE33a84414a8Db4Aacf4E7242F790400D19Ad6e0',
				},
			},
			{
				id: 2979,
				name: 'ALO COMMUNICATION SA',
				type: 'SUPPLIER',
				wallet: {
					id: 2981,
					address: '0x16BBae4f89bB47671D59A746A35199ea95f227aE',
				},
			},
			{
				id: null,
				name: 'World Bank Group',
				type: null,
				wallet: {
					id: 1,
					address: '0x0c2f45F3d0822945e787FE461C3257119B8532F1',
				},
			},
			{
				id: 3106,
				name: 'BRH',
				type: 'SUPPLIER',
				wallet: {
					id: 3108,
					address: '0x10b711fBd5ee7dC1d74dAd8aE05a18A2F6D2b18b',
				},
			},
			{
				id: 3117,
				name: 'DAZORAH BAR RESTO SERVICE TRAITEUR',
				type: 'SUPPLIER',
				wallet: {
					id: 3119,
					address: '0xf321Aee8618304774435176a4E14644E7f316888',
				},
			},
			{
				id: 3118,
				name: 'EXPLORE CARIBBEAN',
				type: 'SUPPLIER',
				wallet: {
					id: 3120,
					address: '0x08072413203829f835F3aFe3060A73D0890851D7',
				},
			},
			{
				id: 3123,
				name: 'AGRIDEC',
				type: 'SUPPLIER',
				wallet: {
					id: 3125,
					address: '0x88fc29Ca7A39F1A5cF3350A92FB18b6c5A7Be56a',
				},
			},
			{
				id: 3851,
				name: 'DINASA',
				type: 'SUPPLIER',
				wallet: {
					id: 3853,
					address: '0x4d4502Aee5150078624DDdc5965EA96ad470e595',
				},
			},
			{
				id: 3850,
				name: 'FED GARAGE',
				type: 'SUPPLIER',
				wallet: {
					id: 3852,
					address: '0x607dfDda192b61D5a4338250FDf9E9BcFd36a179',
				},
			},
			{
				id: 3124,
				name: 'Autres fournisseurs',
				type: 'SUPPLIER',
				wallet: {
					id: 3126,
					address: '0x2a11F568F292EA1489Fc577cD445A81150F60cDd',
				},
			},
			{
				id: 3848,
				name: 'Mecanique - car wash - Transport Materiaux (Renel Dorvillier)',
				type: 'SUPPLIER',
				wallet: {
					id: 3850,
					address: '0xE20090573077604ba30d0E317BB5B02840e27FeE',
				},
			},
			{
				id: 3849,
				name: 'KERNIZAN PIERRE ANDRE',
				type: 'SUPPLIER',
				wallet: {
					id: 3851,
					address: '0x5D152746ccB2585Ca0937728129bC26870BdCC0F',
				},
			},
			{
				id: 5681,
				name: 'Michelet DUKELLY',
				type: 'SUPPLIER',
				wallet: {
					id: 5683,
					address: '0xBfa893024ed2881630be2F2B9dAe4b920ACd147e',
				},
			},
			{
				id: 5689,
				name: 'JOB PAW',
				type: 'SUPPLIER',
				wallet: {
					id: 5691,
					address: '0xa6a4192527B874F3Aec5e42a67f20986D8CA5b1B',
				},
			},
			{
				id: 5683,
				name: 'Prucien CLAUDE',
				type: 'SUPPLIER',
				wallet: {
					id: 5685,
					address: '0x311C8f7c133B12c3A05aFAFBdBA5d46A644Be4DD',
				},
			},
			{
				id: 5682,
				name: 'Djonny MONDESIR',
				type: 'SUPPLIER',
				wallet: {
					id: 5684,
					address: '0x91eE5E2d4ce3cc8a0448d3Be5C3Ba279EE8e2BDc',
				},
			},
			{
				id: 3121,
				name: 'SUNRISE AIRWAYS',
				type: 'SUPPLIER',
				wallet: {
					id: 3123,
					address: '0xe838F7f9d7B414C353536414f416303fA901f5Ae',
				},
			},
			{
				id: 5687,
				name: 'Access Haiti',
				type: 'SUPPLIER',
				wallet: {
					id: 5689,
					address: '0x527AEDE14bBDEb1BaDE434d642197F0F268c7c3d',
				},
			},
			{
				id: 5685,
				name: 'M&F SERVICE TRAITEUR ET DECOR',
				type: 'SUPPLIER',
				wallet: {
					id: 5687,
					address: '0xa290eABA17F5Db2676eCEbcd6f902Ba67cb36033',
				},
			},
			{
				id: 5688,
				name: 'COSMOS SOLUTION',
				type: 'SUPPLIER',
				wallet: {
					id: 5690,
					address: '0x991d40E6BC6F211Df53848283C783f79f77676ad',
				},
			},
			{
				id: 5686,
				name: 'PAVILLON EXPRESS',
				type: 'SUPPLIER',
				wallet: {
					id: 5688,
					address: '0x350D95Aff80C1FEd24Bd8d9C2e0f1cCF2d9710C9',
				},
			},
			{
				id: 3853,
				name: "EL SHADAI STATION D'ESSENCE (STANLEY PIERRE)",
				type: 'SUPPLIER',
				wallet: {
					id: 3855,
					address: '0x423a5b6FcfAB0B11d835497406439fD77081164C',
				},
			},
			{
				id: 5684,
				name: 'THOMPSON ELECTRONICS SA',
				type: 'SUPPLIER',
				wallet: {
					id: 5686,
					address: '0xc1673f49a05D363E06E2D31b74E97219484E190e',
				},
			},
			{
				id: 5680,
				name: 'R&N FERME AGRICOLE',
				type: 'SUPPLIER',
				wallet: {
					id: 5682,
					address: '0x59de596B18D79d3Ec927AD41c96CEe7024c03eC9',
				},
			},
			{
				id: 3854,
				name: 'PC HAITI SA',
				type: 'SUPPLIER',
				wallet: {
					id: 3856,
					address: '0xf7F72F745A4f6e6754F62D1C153175B335301E06',
				},
			},
			{
				id: 3852,
				name: 'SECRET DE LA FEMME SERVICE TRAITEUR',
				type: 'SUPPLIER',
				wallet: {
					id: 3854,
					address: '0x8A0eCe814EbC0BA4bB96940448e9044BB6463011',
				},
			},
			{
				id: 3120,
				name: 'NEWTECH CENTRE DE TECHNOLOGIE',
				type: 'SUPPLIER',
				wallet: {
					id: 3122,
					address: '0x5e416Ec3aA9a75f67A3325aEC7924E6Ff38ecB32',
				},
			},
			{
				id: 3119,
				name: 'Timo Centre de Distribution Commerciale',
				type: 'SUPPLIER',
				wallet: {
					id: 3121,
					address: '0x8c486C4e554D3560B855C4db93Ef64Ef1011Eed7',
				},
			},
			{
				id: 3122,
				name: 'Top Electro SA',
				type: 'SUPPLIER',
				wallet: {
					id: 3124,
					address: '0x942D93a15E64D05A21Cf38e3Db32Fc56F17f58d5',
				},
			},
			{
				id: 7034,
				name: 'Enqueteurs',
				type: 'SUPPLIER',
				wallet: {
					id: 7037,
					address: '0x70be777f2f2D4455f91753E2C290bBfd1Fa803e5',
				},
			},
			{
				id: 7036,
				name: 'ACTIVITES GENERATRICES DE REVENUS (AGR) ',
				type: 'BENEFICIARY',
				wallet: {
					id: 7039,
					address: '0x249d4604a511a52c21DDAb73b1f819db5564B57A',
				},
			},
		],
	},
};
